[
  {
    "codigo": 1100015,
    "nome": "Alta Floresta D'Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1100023,
    "nome": "Ariquemes",
    "uf": "RO"
  },
  {
    "codigo": 1100031,
    "nome": "Cabixi",
    "uf": "RO"
  },
  {
    "codigo": 1100049,
    "nome": "Cacoal",
    "uf": "RO"
  },
  {
    "codigo": 1100056,
    "nome": "Cerejeiras",
    "uf": "RO"
  },
  {
    "codigo": 1100064,
    "nome": "Colorado do Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1100072,
    "nome": "Corumbiara",
    "uf": "RO"
  },
  {
    "codigo": 1100080,
    "nome": "Costa Marques",
    "uf": "RO"
  },
  {
    "codigo": 1100098,
    "nome": "Espigão D'Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1100106,
    "nome": "Guajará-Mirim",
    "uf": "RO"
  },
  {
    "codigo": 1100114,
    "nome": "Jaru",
    "uf": "RO"
  },
  {
    "codigo": 1100122,
    "nome": "Ji-Paraná",
    "uf": "RO"
  },
  {
    "codigo": 1100130,
    "nome": "Machadinho D'Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1100148,
    "nome": "Nova Brasilândia D'Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1100155,
    "nome": "Ouro Preto do Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1100189,
    "nome": "Pimenta Bueno",
    "uf": "RO"
  },
  {
    "codigo": 1100205,
    "nome": "Porto Velho",
    "uf": "RO"
  },
  {
    "codigo": 1100254,
    "nome": "Presidente Médici",
    "uf": "RO"
  },
  {
    "codigo": 1100262,
    "nome": "Rio Crespo",
    "uf": "RO"
  },
  {
    "codigo": 1100288,
    "nome": "Rolim de Moura",
    "uf": "RO"
  },
  {
    "codigo": 1100296,
    "nome": "Santa Luzia D'Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1100304,
    "nome": "Vilhena",
    "uf": "RO"
  },
  {
    "codigo": 1100320,
    "nome": "São Miguel do Guaporé",
    "uf": "RO"
  },
  {
    "codigo": 1100338,
    "nome": "Nova Mamoré",
    "uf": "RO"
  },
  {
    "codigo": 1100346,
    "nome": "Alvorada D'Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1100379,
    "nome": "Alto Alegre dos Parecis",
    "uf": "RO"
  },
  {
    "codigo": 1100403,
    "nome": "Alto Paraíso",
    "uf": "RO"
  },
  {
    "codigo": 1100452,
    "nome": "Buritis",
    "uf": "RO"
  },
  {
    "codigo": 1100502,
    "nome": "Novo Horizonte do Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1100601,
    "nome": "Cacaulândia",
    "uf": "RO"
  },
  {
    "codigo": 1100700,
    "nome": "Campo Novo de Rondônia",
    "uf": "RO"
  },
  {
    "codigo": 1100809,
    "nome": "Candeias do Jamari",
    "uf": "RO"
  },
  {
    "codigo": 1100908,
    "nome": "Castanheiras",
    "uf": "RO"
  },
  {
    "codigo": 1100924,
    "nome": "Chupinguaia",
    "uf": "RO"
  },
  {
    "codigo": 1100940,
    "nome": "Cujubim",
    "uf": "RO"
  },
  {
    "codigo": 1101005,
    "nome": "Governador Jorge Teixeira",
    "uf": "RO"
  },
  {
    "codigo": 1101104,
    "nome": "Itapuã do Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1101203,
    "nome": "Ministro Andreazza",
    "uf": "RO"
  },
  {
    "codigo": 1101302,
    "nome": "Mirante da Serra",
    "uf": "RO"
  },
  {
    "codigo": 1101401,
    "nome": "Monte Negro",
    "uf": "RO"
  },
  {
    "codigo": 1101435,
    "nome": "Nova União",
    "uf": "RO"
  },
  {
    "codigo": 1101450,
    "nome": "Parecis",
    "uf": "RO"
  },
  {
    "codigo": 1101468,
    "nome": "Pimenteiras do Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1101476,
    "nome": "Primavera de Rondônia",
    "uf": "RO"
  },
  {
    "codigo": 1101484,
    "nome": "São Felipe D'Oeste",
    "uf": "RO"
  },
  {
    "codigo": 1101492,
    "nome": "São Francisco do Guaporé",
    "uf": "RO"
  },
  {
    "codigo": 1101500,
    "nome": "Seringueiras",
    "uf": "RO"
  },
  {
    "codigo": 1101559,
    "nome": "Teixeirópolis",
    "uf": "RO"
  },
  {
    "codigo": 1101609,
    "nome": "Theobroma",
    "uf": "RO"
  },
  {
    "codigo": 1101708,
    "nome": "Urupá",
    "uf": "RO"
  },
  {
    "codigo": 1101757,
    "nome": "Vale do Anari",
    "uf": "RO"
  },
  {
    "codigo": 1101807,
    "nome": "Vale do Paraíso",
    "uf": "RO"
  },
  {
    "codigo": 1200013,
    "nome": "Acrelândia",
    "uf": "AC"
  },
  {
    "codigo": 1200054,
    "nome": "Assis Brasil",
    "uf": "AC"
  },
  {
    "codigo": 1200104,
    "nome": "Brasiléia",
    "uf": "AC"
  },
  {
    "codigo": 1200138,
    "nome": "Bujari",
    "uf": "AC"
  },
  {
    "codigo": 1200179,
    "nome": "Capixaba",
    "uf": "AC"
  },
  {
    "codigo": 1200203,
    "nome": "Cruzeiro do Sul",
    "uf": "AC"
  },
  {
    "codigo": 1200252,
    "nome": "Epitaciolândia",
    "uf": "AC"
  },
  {
    "codigo": 1200302,
    "nome": "Feijó",
    "uf": "AC"
  },
  {
    "codigo": 1200328,
    "nome": "Jordão",
    "uf": "AC"
  },
  {
    "codigo": 1200336,
    "nome": "Mâncio Lima",
    "uf": "AC"
  },
  {
    "codigo": 1200344,
    "nome": "Manoel Urbano",
    "uf": "AC"
  },
  {
    "codigo": 1200351,
    "nome": "Marechal Thaumaturgo",
    "uf": "AC"
  },
  {
    "codigo": 1200385,
    "nome": "Plácido de Castro",
    "uf": "AC"
  },
  {
    "codigo": 1200393,
    "nome": "Porto Walter",
    "uf": "AC"
  },
  {
    "codigo": 1200401,
    "nome": "Rio Branco",
    "uf": "AC"
  },
  {
    "codigo": 1200427,
    "nome": "Rodrigues Alves",
    "uf": "AC"
  },
  {
    "codigo": 1200435,
    "nome": "Santa Rosa do Purus",
    "uf": "AC"
  },
  {
    "codigo": 1200450,
    "nome": "Senador Guiomard",
    "uf": "AC"
  },
  {
    "codigo": 1200500,
    "nome": "Sena Madureira",
    "uf": "AC"
  },
  {
    "codigo": 1200609,
    "nome": "Tarauacá",
    "uf": "AC"
  },
  {
    "codigo": 1200708,
    "nome": "Xapuri",
    "uf": "AC"
  },
  {
    "codigo": 1200807,
    "nome": "Porto Acre",
    "uf": "AC"
  },
  {
    "codigo": 1300029,
    "nome": "Alvarães",
    "uf": "AM"
  },
  {
    "codigo": 1300060,
    "nome": "Amaturá",
    "uf": "AM"
  },
  {
    "codigo": 1300086,
    "nome": "Anamã",
    "uf": "AM"
  },
  {
    "codigo": 1300102,
    "nome": "Anori",
    "uf": "AM"
  },
  {
    "codigo": 1300144,
    "nome": "Apuí",
    "uf": "AM"
  },
  {
    "codigo": 1300201,
    "nome": "Atalaia do Norte",
    "uf": "AM"
  },
  {
    "codigo": 1300300,
    "nome": "Autazes",
    "uf": "AM"
  },
  {
    "codigo": 1300409,
    "nome": "Barcelos",
    "uf": "AM"
  },
  {
    "codigo": 1300508,
    "nome": "Barreirinha",
    "uf": "AM"
  },
  {
    "codigo": 1300607,
    "nome": "Benjamin Constant",
    "uf": "AM"
  },
  {
    "codigo": 1300631,
    "nome": "Beruri",
    "uf": "AM"
  },
  {
    "codigo": 1300680,
    "nome": "Boa Vista do Ramos",
    "uf": "AM"
  },
  {
    "codigo": 1300706,
    "nome": "Boca do Acre",
    "uf": "AM"
  },
  {
    "codigo": 1300805,
    "nome": "Borba",
    "uf": "AM"
  },
  {
    "codigo": 1300839,
    "nome": "Caapiranga",
    "uf": "AM"
  },
  {
    "codigo": 1300904,
    "nome": "Canutama",
    "uf": "AM"
  },
  {
    "codigo": 1301001,
    "nome": "Carauari",
    "uf": "AM"
  },
  {
    "codigo": 1301100,
    "nome": "Careiro",
    "uf": "AM"
  },
  {
    "codigo": 1301159,
    "nome": "Careiro da Várzea",
    "uf": "AM"
  },
  {
    "codigo": 1301209,
    "nome": "Coari",
    "uf": "AM"
  },
  {
    "codigo": 1301308,
    "nome": "Codajás",
    "uf": "AM"
  },
  {
    "codigo": 1301407,
    "nome": "Eirunepé",
    "uf": "AM"
  },
  {
    "codigo": 1301506,
    "nome": "Envira",
    "uf": "AM"
  },
  {
    "codigo": 1301605,
    "nome": "Fonte Boa",
    "uf": "AM"
  },
  {
    "codigo": 1301654,
    "nome": "Guajará",
    "uf": "AM"
  },
  {
    "codigo": 1301704,
    "nome": "Humaitá",
    "uf": "AM"
  },
  {
    "codigo": 1301803,
    "nome": "Ipixuna",
    "uf": "AM"
  },
  {
    "codigo": 1301852,
    "nome": "Iranduba",
    "uf": "AM"
  },
  {
    "codigo": 1301902,
    "nome": "Itacoatiara",
    "uf": "AM"
  },
  {
    "codigo": 1301951,
    "nome": "Itamarati",
    "uf": "AM"
  },
  {
    "codigo": 1302009,
    "nome": "Itapiranga",
    "uf": "AM"
  },
  {
    "codigo": 1302108,
    "nome": "Japurá",
    "uf": "AM"
  },
  {
    "codigo": 1302207,
    "nome": "Juruá",
    "uf": "AM"
  },
  {
    "codigo": 1302306,
    "nome": "Jutaí",
    "uf": "AM"
  },
  {
    "codigo": 1302405,
    "nome": "Lábrea",
    "uf": "AM"
  },
  {
    "codigo": 1302504,
    "nome": "Manacapuru",
    "uf": "AM"
  },
  {
    "codigo": 1302553,
    "nome": "Manaquiri",
    "uf": "AM"
  },
  {
    "codigo": 1302603,
    "nome": "Manaus",
    "uf": "AM"
  },
  {
    "codigo": 1302702,
    "nome": "Manicoré",
    "uf": "AM"
  },
  {
    "codigo": 1302801,
    "nome": "Maraã",
    "uf": "AM"
  },
  {
    "codigo": 1302900,
    "nome": "Maués",
    "uf": "AM"
  },
  {
    "codigo": 1303007,
    "nome": "Nhamundá",
    "uf": "AM"
  },
  {
    "codigo": 1303106,
    "nome": "Nova Olinda do Norte",
    "uf": "AM"
  },
  {
    "codigo": 1303205,
    "nome": "Novo Airão",
    "uf": "AM"
  },
  {
    "codigo": 1303304,
    "nome": "Novo Aripuanã",
    "uf": "AM"
  },
  {
    "codigo": 1303403,
    "nome": "Parintins",
    "uf": "AM"
  },
  {
    "codigo": 1303502,
    "nome": "Pauini",
    "uf": "AM"
  },
  {
    "codigo": 1303536,
    "nome": "Presidente Figueiredo",
    "uf": "AM"
  },
  {
    "codigo": 1303569,
    "nome": "Rio Preto da Eva",
    "uf": "AM"
  },
  {
    "codigo": 1303601,
    "nome": "Santa Isabel do Rio Negro",
    "uf": "AM"
  },
  {
    "codigo": 1303700,
    "nome": "Santo Antônio do Içá",
    "uf": "AM"
  },
  {
    "codigo": 1303809,
    "nome": "São Gabriel da Cachoeira",
    "uf": "AM"
  },
  {
    "codigo": 1303908,
    "nome": "São Paulo de Olivença",
    "uf": "AM"
  },
  {
    "codigo": 1303957,
    "nome": "São Sebastião do Uatumã",
    "uf": "AM"
  },
  {
    "codigo": 1304005,
    "nome": "Silves",
    "uf": "AM"
  },
  {
    "codigo": 1304062,
    "nome": "Tabatinga",
    "uf": "AM"
  },
  {
    "codigo": 1304104,
    "nome": "Tapauá",
    "uf": "AM"
  },
  {
    "codigo": 1304203,
    "nome": "Tefé",
    "uf": "AM"
  },
  {
    "codigo": 1304237,
    "nome": "Tonantins",
    "uf": "AM"
  },
  {
    "codigo": 1304260,
    "nome": "Uarini",
    "uf": "AM"
  },
  {
    "codigo": 1304302,
    "nome": "Urucará",
    "uf": "AM"
  },
  {
    "codigo": 1304401,
    "nome": "Urucurituba",
    "uf": "AM"
  },
  {
    "codigo": 1400027,
    "nome": "Amajari",
    "uf": "RR"
  },
  {
    "codigo": 1400050,
    "nome": "Alto Alegre",
    "uf": "RR"
  },
  {
    "codigo": 1400100,
    "nome": "Boa Vista",
    "uf": "RR"
  },
  {
    "codigo": 1400159,
    "nome": "Bonfim",
    "uf": "RR"
  },
  {
    "codigo": 1400175,
    "nome": "Cantá",
    "uf": "RR"
  },
  {
    "codigo": 1400209,
    "nome": "Caracaraí",
    "uf": "RR"
  },
  {
    "codigo": 1400233,
    "nome": "Caroebe",
    "uf": "RR"
  },
  {
    "codigo": 1400282,
    "nome": "Iracema",
    "uf": "RR"
  },
  {
    "codigo": 1400308,
    "nome": "Mucajaí",
    "uf": "RR"
  },
  {
    "codigo": 1400407,
    "nome": "Normandia",
    "uf": "RR"
  },
  {
    "codigo": 1400456,
    "nome": "Pacaraima",
    "uf": "RR"
  },
  {
    "codigo": 1400472,
    "nome": "Rorainópolis",
    "uf": "RR"
  },
  {
    "codigo": 1400506,
    "nome": "São João da Baliza",
    "uf": "RR"
  },
  {
    "codigo": 1400605,
    "nome": "São Luiz do Anauá",
    "uf": "RR"
  },
  {
    "codigo": 1400704,
    "nome": "Uiramutã",
    "uf": "RR"
  },
  {
    "codigo": 1500107,
    "nome": "Abaetetuba",
    "uf": "PA"
  },
  {
    "codigo": 1500131,
    "nome": "Abel Figueiredo",
    "uf": "PA"
  },
  {
    "codigo": 1500206,
    "nome": "Acará",
    "uf": "PA"
  },
  {
    "codigo": 1500305,
    "nome": "Afuá",
    "uf": "PA"
  },
  {
    "codigo": 1500347,
    "nome": "Água Azul do Norte",
    "uf": "PA"
  },
  {
    "codigo": 1500404,
    "nome": "Alenquer",
    "uf": "PA"
  },
  {
    "codigo": 1500503,
    "nome": "Almeirim",
    "uf": "PA"
  },
  {
    "codigo": 1500602,
    "nome": "Altamira",
    "uf": "PA"
  },
  {
    "codigo": 1500701,
    "nome": "Anajás",
    "uf": "PA"
  },
  {
    "codigo": 1500800,
    "nome": "Ananindeua",
    "uf": "PA"
  },
  {
    "codigo": 1500859,
    "nome": "Anapu",
    "uf": "PA"
  },
  {
    "codigo": 1500909,
    "nome": "Augusto Corrêa",
    "uf": "PA"
  },
  {
    "codigo": 1500958,
    "nome": "Aurora do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1501006,
    "nome": "Aveiro",
    "uf": "PA"
  },
  {
    "codigo": 1501105,
    "nome": "Bagre",
    "uf": "PA"
  },
  {
    "codigo": 1501204,
    "nome": "Baião",
    "uf": "PA"
  },
  {
    "codigo": 1501253,
    "nome": "Bannach",
    "uf": "PA"
  },
  {
    "codigo": 1501303,
    "nome": "Barcarena",
    "uf": "PA"
  },
  {
    "codigo": 1501402,
    "nome": "Belém",
    "uf": "PA"
  },
  {
    "codigo": 1501451,
    "nome": "Belterra",
    "uf": "PA"
  },
  {
    "codigo": 1501501,
    "nome": "Benevides",
    "uf": "PA"
  },
  {
    "codigo": 1501576,
    "nome": "Bom Jesus do Tocantins",
    "uf": "PA"
  },
  {
    "codigo": 1501600,
    "nome": "Bonito",
    "uf": "PA"
  },
  {
    "codigo": 1501709,
    "nome": "Bragança",
    "uf": "PA"
  },
  {
    "codigo": 1501725,
    "nome": "Brasil Novo",
    "uf": "PA"
  },
  {
    "codigo": 1501758,
    "nome": "Brejo Grande do Araguaia",
    "uf": "PA"
  },
  {
    "codigo": 1501782,
    "nome": "Breu Branco",
    "uf": "PA"
  },
  {
    "codigo": 1501808,
    "nome": "Breves",
    "uf": "PA"
  },
  {
    "codigo": 1501907,
    "nome": "Bujaru",
    "uf": "PA"
  },
  {
    "codigo": 1501956,
    "nome": "Cachoeira do Piriá",
    "uf": "PA"
  },
  {
    "codigo": 1502004,
    "nome": "Cachoeira do Arari",
    "uf": "PA"
  },
  {
    "codigo": 1502103,
    "nome": "Cametá",
    "uf": "PA"
  },
  {
    "codigo": 1502152,
    "nome": "Canaã dos Carajás",
    "uf": "PA"
  },
  {
    "codigo": 1502202,
    "nome": "Capanema",
    "uf": "PA"
  },
  {
    "codigo": 1502301,
    "nome": "Capitão Poço",
    "uf": "PA"
  },
  {
    "codigo": 1502400,
    "nome": "Castanhal",
    "uf": "PA"
  },
  {
    "codigo": 1502509,
    "nome": "Chaves",
    "uf": "PA"
  },
  {
    "codigo": 1502608,
    "nome": "Colares",
    "uf": "PA"
  },
  {
    "codigo": 1502707,
    "nome": "Conceição do Araguaia",
    "uf": "PA"
  },
  {
    "codigo": 1502756,
    "nome": "Concórdia do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1502764,
    "nome": "Cumaru do Norte",
    "uf": "PA"
  },
  {
    "codigo": 1502772,
    "nome": "Curionópolis",
    "uf": "PA"
  },
  {
    "codigo": 1502806,
    "nome": "Curralinho",
    "uf": "PA"
  },
  {
    "codigo": 1502855,
    "nome": "Curuá",
    "uf": "PA"
  },
  {
    "codigo": 1502905,
    "nome": "Curuçá",
    "uf": "PA"
  },
  {
    "codigo": 1502939,
    "nome": "Dom Eliseu",
    "uf": "PA"
  },
  {
    "codigo": 1502954,
    "nome": "Eldorado do Carajás",
    "uf": "PA"
  },
  {
    "codigo": 1503002,
    "nome": "Faro",
    "uf": "PA"
  },
  {
    "codigo": 1503044,
    "nome": "Floresta do Araguaia",
    "uf": "PA"
  },
  {
    "codigo": 1503077,
    "nome": "Garrafão do Norte",
    "uf": "PA"
  },
  {
    "codigo": 1503093,
    "nome": "Goianésia do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1503101,
    "nome": "Gurupá",
    "uf": "PA"
  },
  {
    "codigo": 1503200,
    "nome": "Igarapé-Açu",
    "uf": "PA"
  },
  {
    "codigo": 1503309,
    "nome": "Igarapé-Miri",
    "uf": "PA"
  },
  {
    "codigo": 1503408,
    "nome": "Inhangapi",
    "uf": "PA"
  },
  {
    "codigo": 1503457,
    "nome": "Ipixuna do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1503507,
    "nome": "Irituia",
    "uf": "PA"
  },
  {
    "codigo": 1503606,
    "nome": "Itaituba",
    "uf": "PA"
  },
  {
    "codigo": 1503705,
    "nome": "Itupiranga",
    "uf": "PA"
  },
  {
    "codigo": 1503754,
    "nome": "Jacareacanga",
    "uf": "PA"
  },
  {
    "codigo": 1503804,
    "nome": "Jacundá",
    "uf": "PA"
  },
  {
    "codigo": 1503903,
    "nome": "Juruti",
    "uf": "PA"
  },
  {
    "codigo": 1504000,
    "nome": "Limoeiro do Ajuru",
    "uf": "PA"
  },
  {
    "codigo": 1504059,
    "nome": "Mãe do Rio",
    "uf": "PA"
  },
  {
    "codigo": 1504109,
    "nome": "Magalhães Barata",
    "uf": "PA"
  },
  {
    "codigo": 1504208,
    "nome": "Marabá",
    "uf": "PA"
  },
  {
    "codigo": 1504307,
    "nome": "Maracanã",
    "uf": "PA"
  },
  {
    "codigo": 1504406,
    "nome": "Marapanim",
    "uf": "PA"
  },
  {
    "codigo": 1504422,
    "nome": "Marituba",
    "uf": "PA"
  },
  {
    "codigo": 1504455,
    "nome": "Medicilândia",
    "uf": "PA"
  },
  {
    "codigo": 1504505,
    "nome": "Melgaço",
    "uf": "PA"
  },
  {
    "codigo": 1504604,
    "nome": "Mocajuba",
    "uf": "PA"
  },
  {
    "codigo": 1504703,
    "nome": "Moju",
    "uf": "PA"
  },
  {
    "codigo": 1504752,
    "nome": "Mojuí dos Campos",
    "uf": "PA"
  },
  {
    "codigo": 1504802,
    "nome": "Monte Alegre",
    "uf": "PA"
  },
  {
    "codigo": 1504901,
    "nome": "Muaná",
    "uf": "PA"
  },
  {
    "codigo": 1504950,
    "nome": "Nova Esperança do Piriá",
    "uf": "PA"
  },
  {
    "codigo": 1504976,
    "nome": "Nova Ipixuna",
    "uf": "PA"
  },
  {
    "codigo": 1505007,
    "nome": "Nova Timboteua",
    "uf": "PA"
  },
  {
    "codigo": 1505031,
    "nome": "Novo Progresso",
    "uf": "PA"
  },
  {
    "codigo": 1505064,
    "nome": "Novo Repartimento",
    "uf": "PA"
  },
  {
    "codigo": 1505106,
    "nome": "Óbidos",
    "uf": "PA"
  },
  {
    "codigo": 1505205,
    "nome": "Oeiras do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1505304,
    "nome": "Oriximiná",
    "uf": "PA"
  },
  {
    "codigo": 1505403,
    "nome": "Ourém",
    "uf": "PA"
  },
  {
    "codigo": 1505437,
    "nome": "Ourilândia do Norte",
    "uf": "PA"
  },
  {
    "codigo": 1505486,
    "nome": "Pacajá",
    "uf": "PA"
  },
  {
    "codigo": 1505494,
    "nome": "Palestina do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1505502,
    "nome": "Paragominas",
    "uf": "PA"
  },
  {
    "codigo": 1505536,
    "nome": "Parauapebas",
    "uf": "PA"
  },
  {
    "codigo": 1505551,
    "nome": "Pau D'Arco",
    "uf": "PA"
  },
  {
    "codigo": 1505601,
    "nome": "Peixe-Boi",
    "uf": "PA"
  },
  {
    "codigo": 1505635,
    "nome": "Piçarra",
    "uf": "PA"
  },
  {
    "codigo": 1505650,
    "nome": "Placas",
    "uf": "PA"
  },
  {
    "codigo": 1505700,
    "nome": "Ponta de Pedras",
    "uf": "PA"
  },
  {
    "codigo": 1505809,
    "nome": "Portel",
    "uf": "PA"
  },
  {
    "codigo": 1505908,
    "nome": "Porto de Moz",
    "uf": "PA"
  },
  {
    "codigo": 1506005,
    "nome": "Prainha",
    "uf": "PA"
  },
  {
    "codigo": 1506104,
    "nome": "Primavera",
    "uf": "PA"
  },
  {
    "codigo": 1506112,
    "nome": "Quatipuru",
    "uf": "PA"
  },
  {
    "codigo": 1506138,
    "nome": "Redenção",
    "uf": "PA"
  },
  {
    "codigo": 1506161,
    "nome": "Rio Maria",
    "uf": "PA"
  },
  {
    "codigo": 1506187,
    "nome": "Rondon do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1506195,
    "nome": "Rurópolis",
    "uf": "PA"
  },
  {
    "codigo": 1506203,
    "nome": "Salinópolis",
    "uf": "PA"
  },
  {
    "codigo": 1506302,
    "nome": "Salvaterra",
    "uf": "PA"
  },
  {
    "codigo": 1506351,
    "nome": "Santa Bárbara do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1506401,
    "nome": "Santa Cruz do Arari",
    "uf": "PA"
  },
  {
    "codigo": 1506500,
    "nome": "Santa Izabel do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1506559,
    "nome": "Santa Luzia do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1506583,
    "nome": "Santa Maria das Barreiras",
    "uf": "PA"
  },
  {
    "codigo": 1506609,
    "nome": "Santa Maria do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1506708,
    "nome": "Santana do Araguaia",
    "uf": "PA"
  },
  {
    "codigo": 1506807,
    "nome": "Santarém",
    "uf": "PA"
  },
  {
    "codigo": 1506906,
    "nome": "Santarém Novo",
    "uf": "PA"
  },
  {
    "codigo": 1507003,
    "nome": "Santo Antônio do Tauá",
    "uf": "PA"
  },
  {
    "codigo": 1507102,
    "nome": "São Caetano de Odivelas",
    "uf": "PA"
  },
  {
    "codigo": 1507151,
    "nome": "São Domingos do Araguaia",
    "uf": "PA"
  },
  {
    "codigo": 1507201,
    "nome": "São Domingos do Capim",
    "uf": "PA"
  },
  {
    "codigo": 1507300,
    "nome": "São Félix do Xingu",
    "uf": "PA"
  },
  {
    "codigo": 1507409,
    "nome": "São Francisco do Pará",
    "uf": "PA"
  },
  {
    "codigo": 1507458,
    "nome": "São Geraldo do Araguaia",
    "uf": "PA"
  },
  {
    "codigo": 1507466,
    "nome": "São João da Ponta",
    "uf": "PA"
  },
  {
    "codigo": 1507474,
    "nome": "São João de Pirabas",
    "uf": "PA"
  },
  {
    "codigo": 1507508,
    "nome": "São João do Araguaia",
    "uf": "PA"
  },
  {
    "codigo": 1507607,
    "nome": "São Miguel do Guamá",
    "uf": "PA"
  },
  {
    "codigo": 1507706,
    "nome": "São Sebastião da Boa Vista",
    "uf": "PA"
  },
  {
    "codigo": 1507755,
    "nome": "Sapucaia",
    "uf": "PA"
  },
  {
    "codigo": 1507805,
    "nome": "Senador José Porfírio",
    "uf": "PA"
  },
  {
    "codigo": 1507904,
    "nome": "Soure",
    "uf": "PA"
  },
  {
    "codigo": 1507953,
    "nome": "Tailândia",
    "uf": "PA"
  },
  {
    "codigo": 1507961,
    "nome": "Terra Alta",
    "uf": "PA"
  },
  {
    "codigo": 1507979,
    "nome": "Terra Santa",
    "uf": "PA"
  },
  {
    "codigo": 1508001,
    "nome": "Tomé-Açu",
    "uf": "PA"
  },
  {
    "codigo": 1508035,
    "nome": "Tracuateua",
    "uf": "PA"
  },
  {
    "codigo": 1508050,
    "nome": "Trairão",
    "uf": "PA"
  },
  {
    "codigo": 1508084,
    "nome": "Tucumã",
    "uf": "PA"
  },
  {
    "codigo": 1508100,
    "nome": "Tucuruí",
    "uf": "PA"
  },
  {
    "codigo": 1508126,
    "nome": "Ulianópolis",
    "uf": "PA"
  },
  {
    "codigo": 1508159,
    "nome": "Uruará",
    "uf": "PA"
  },
  {
    "codigo": 1508209,
    "nome": "Vigia",
    "uf": "PA"
  },
  {
    "codigo": 1508308,
    "nome": "Viseu",
    "uf": "PA"
  },
  {
    "codigo": 1508357,
    "nome": "Vitória do Xingu",
    "uf": "PA"
  },
  {
    "codigo": 1508407,
    "nome": "Xinguara",
    "uf": "PA"
  },
  {
    "codigo": 1600055,
    "nome": "Serra do Navio",
    "uf": "AP"
  },
  {
    "codigo": 1600105,
    "nome": "Amapá",
    "uf": "AP"
  },
  {
    "codigo": 1600154,
    "nome": "Pedra Branca do Amapari",
    "uf": "AP"
  },
  {
    "codigo": 1600204,
    "nome": "Calçoene",
    "uf": "AP"
  },
  {
    "codigo": 1600212,
    "nome": "Cutias",
    "uf": "AP"
  },
  {
    "codigo": 1600238,
    "nome": "Ferreira Gomes",
    "uf": "AP"
  },
  {
    "codigo": 1600253,
    "nome": "Itaubal",
    "uf": "AP"
  },
  {
    "codigo": 1600279,
    "nome": "Laranjal do Jari",
    "uf": "AP"
  },
  {
    "codigo": 1600303,
    "nome": "Macapá",
    "uf": "AP"
  },
  {
    "codigo": 1600402,
    "nome": "Mazagão",
    "uf": "AP"
  },
  {
    "codigo": 1600501,
    "nome": "Oiapoque",
    "uf": "AP"
  },
  {
    "codigo": 1600535,
    "nome": "Porto Grande",
    "uf": "AP"
  },
  {
    "codigo": 1600550,
    "nome": "Pracuúba",
    "uf": "AP"
  },
  {
    "codigo": 1600600,
    "nome": "Santana",
    "uf": "AP"
  },
  {
    "codigo": 1600709,
    "nome": "Tartarugalzinho",
    "uf": "AP"
  },
  {
    "codigo": 1600808,
    "nome": "Vitória do Jari",
    "uf": "AP"
  },
  {
    "codigo": 1700251,
    "nome": "Abreulândia",
    "uf": "TO"
  },
  {
    "codigo": 1700301,
    "nome": "Aguiarnópolis",
    "uf": "TO"
  },
  {
    "codigo": 1700350,
    "nome": "Aliança do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1700400,
    "nome": "Almas",
    "uf": "TO"
  },
  {
    "codigo": 1700707,
    "nome": "Alvorada",
    "uf": "TO"
  },
  {
    "codigo": 1701002,
    "nome": "Ananás",
    "uf": "TO"
  },
  {
    "codigo": 1701051,
    "nome": "Angico",
    "uf": "TO"
  },
  {
    "codigo": 1701101,
    "nome": "Aparecida do Rio Negro",
    "uf": "TO"
  },
  {
    "codigo": 1701309,
    "nome": "Aragominas",
    "uf": "TO"
  },
  {
    "codigo": 1701903,
    "nome": "Araguacema",
    "uf": "TO"
  },
  {
    "codigo": 1702000,
    "nome": "Araguaçu",
    "uf": "TO"
  },
  {
    "codigo": 1702109,
    "nome": "Araguaína",
    "uf": "TO"
  },
  {
    "codigo": 1702158,
    "nome": "Araguanã",
    "uf": "TO"
  },
  {
    "codigo": 1702208,
    "nome": "Araguatins",
    "uf": "TO"
  },
  {
    "codigo": 1702307,
    "nome": "Arapoema",
    "uf": "TO"
  },
  {
    "codigo": 1702406,
    "nome": "Arraias",
    "uf": "TO"
  },
  {
    "codigo": 1702554,
    "nome": "Augustinópolis",
    "uf": "TO"
  },
  {
    "codigo": 1702703,
    "nome": "Aurora do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1702901,
    "nome": "Axixá do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1703008,
    "nome": "Babaçulândia",
    "uf": "TO"
  },
  {
    "codigo": 1703057,
    "nome": "Bandeirantes do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1703073,
    "nome": "Barra do Ouro",
    "uf": "TO"
  },
  {
    "codigo": 1703107,
    "nome": "Barrolândia",
    "uf": "TO"
  },
  {
    "codigo": 1703206,
    "nome": "Bernardo Sayão",
    "uf": "TO"
  },
  {
    "codigo": 1703305,
    "nome": "Bom Jesus do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1703602,
    "nome": "Brasilândia do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1703701,
    "nome": "Brejinho de Nazaré",
    "uf": "TO"
  },
  {
    "codigo": 1703800,
    "nome": "Buriti do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1703826,
    "nome": "Cachoeirinha",
    "uf": "TO"
  },
  {
    "codigo": 1703842,
    "nome": "Campos Lindos",
    "uf": "TO"
  },
  {
    "codigo": 1703867,
    "nome": "Cariri do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1703883,
    "nome": "Carmolândia",
    "uf": "TO"
  },
  {
    "codigo": 1703891,
    "nome": "Carrasco Bonito",
    "uf": "TO"
  },
  {
    "codigo": 1703909,
    "nome": "Caseara",
    "uf": "TO"
  },
  {
    "codigo": 1704105,
    "nome": "Centenário",
    "uf": "TO"
  },
  {
    "codigo": 1704600,
    "nome": "Chapada de Areia",
    "uf": "TO"
  },
  {
    "codigo": 1705102,
    "nome": "Chapada da Natividade",
    "uf": "TO"
  },
  {
    "codigo": 1705508,
    "nome": "Colinas do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1705557,
    "nome": "Combinado",
    "uf": "TO"
  },
  {
    "codigo": 1705607,
    "nome": "Conceição do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1706001,
    "nome": "Couto Magalhães",
    "uf": "TO"
  },
  {
    "codigo": 1706100,
    "nome": "Cristalândia",
    "uf": "TO"
  },
  {
    "codigo": 1706258,
    "nome": "Crixás do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1706506,
    "nome": "Darcinópolis",
    "uf": "TO"
  },
  {
    "codigo": 1707009,
    "nome": "Dianópolis",
    "uf": "TO"
  },
  {
    "codigo": 1707108,
    "nome": "Divinópolis do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1707207,
    "nome": "Dois Irmãos do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1707306,
    "nome": "Dueré",
    "uf": "TO"
  },
  {
    "codigo": 1707405,
    "nome": "Esperantina",
    "uf": "TO"
  },
  {
    "codigo": 1707553,
    "nome": "Fátima",
    "uf": "TO"
  },
  {
    "codigo": 1707652,
    "nome": "Figueirópolis",
    "uf": "TO"
  },
  {
    "codigo": 1707702,
    "nome": "Filadélfia",
    "uf": "TO"
  },
  {
    "codigo": 1708205,
    "nome": "Formoso do Araguaia",
    "uf": "TO"
  },
  {
    "codigo": 1708254,
    "nome": "Tabocão",
    "uf": "TO"
  },
  {
    "codigo": 1708304,
    "nome": "Goianorte",
    "uf": "TO"
  },
  {
    "codigo": 1709005,
    "nome": "Goiatins",
    "uf": "TO"
  },
  {
    "codigo": 1709302,
    "nome": "Guaraí",
    "uf": "TO"
  },
  {
    "codigo": 1709500,
    "nome": "Gurupi",
    "uf": "TO"
  },
  {
    "codigo": 1709807,
    "nome": "Ipueiras",
    "uf": "TO"
  },
  {
    "codigo": 1710508,
    "nome": "Itacajá",
    "uf": "TO"
  },
  {
    "codigo": 1710706,
    "nome": "Itaguatins",
    "uf": "TO"
  },
  {
    "codigo": 1710904,
    "nome": "Itapiratins",
    "uf": "TO"
  },
  {
    "codigo": 1711100,
    "nome": "Itaporã do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1711506,
    "nome": "Jaú do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1711803,
    "nome": "Juarina",
    "uf": "TO"
  },
  {
    "codigo": 1711902,
    "nome": "Lagoa da Confusão",
    "uf": "TO"
  },
  {
    "codigo": 1711951,
    "nome": "Lagoa do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1712009,
    "nome": "Lajeado",
    "uf": "TO"
  },
  {
    "codigo": 1712157,
    "nome": "Lavandeira",
    "uf": "TO"
  },
  {
    "codigo": 1712405,
    "nome": "Lizarda",
    "uf": "TO"
  },
  {
    "codigo": 1712454,
    "nome": "Luzinópolis",
    "uf": "TO"
  },
  {
    "codigo": 1712504,
    "nome": "Marianópolis do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1712702,
    "nome": "Mateiros",
    "uf": "TO"
  },
  {
    "codigo": 1712801,
    "nome": "Maurilândia do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1713205,
    "nome": "Miracema do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1713304,
    "nome": "Miranorte",
    "uf": "TO"
  },
  {
    "codigo": 1713601,
    "nome": "Monte do Carmo",
    "uf": "TO"
  },
  {
    "codigo": 1713700,
    "nome": "Monte Santo do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1713809,
    "nome": "Palmeiras do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1713957,
    "nome": "Muricilândia",
    "uf": "TO"
  },
  {
    "codigo": 1714203,
    "nome": "Natividade",
    "uf": "TO"
  },
  {
    "codigo": 1714302,
    "nome": "Nazaré",
    "uf": "TO"
  },
  {
    "codigo": 1714880,
    "nome": "Nova Olinda",
    "uf": "TO"
  },
  {
    "codigo": 1715002,
    "nome": "Nova Rosalândia",
    "uf": "TO"
  },
  {
    "codigo": 1715101,
    "nome": "Novo Acordo",
    "uf": "TO"
  },
  {
    "codigo": 1715150,
    "nome": "Novo Alegre",
    "uf": "TO"
  },
  {
    "codigo": 1715259,
    "nome": "Novo Jardim",
    "uf": "TO"
  },
  {
    "codigo": 1715507,
    "nome": "Oliveira de Fátima",
    "uf": "TO"
  },
  {
    "codigo": 1715705,
    "nome": "Palmeirante",
    "uf": "TO"
  },
  {
    "codigo": 1715754,
    "nome": "Palmeirópolis",
    "uf": "TO"
  },
  {
    "codigo": 1716109,
    "nome": "Paraíso do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1716208,
    "nome": "Paranã",
    "uf": "TO"
  },
  {
    "codigo": 1716307,
    "nome": "Pau D'Arco",
    "uf": "TO"
  },
  {
    "codigo": 1716505,
    "nome": "Pedro Afonso",
    "uf": "TO"
  },
  {
    "codigo": 1716604,
    "nome": "Peixe",
    "uf": "TO"
  },
  {
    "codigo": 1716653,
    "nome": "Pequizeiro",
    "uf": "TO"
  },
  {
    "codigo": 1716703,
    "nome": "Colméia",
    "uf": "TO"
  },
  {
    "codigo": 1717008,
    "nome": "Pindorama do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1717206,
    "nome": "Piraquê",
    "uf": "TO"
  },
  {
    "codigo": 1717503,
    "nome": "Pium",
    "uf": "TO"
  },
  {
    "codigo": 1717800,
    "nome": "Ponte Alta do Bom Jesus",
    "uf": "TO"
  },
  {
    "codigo": 1717909,
    "nome": "Ponte Alta do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1718006,
    "nome": "Porto Alegre do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1718204,
    "nome": "Porto Nacional",
    "uf": "TO"
  },
  {
    "codigo": 1718303,
    "nome": "Praia Norte",
    "uf": "TO"
  },
  {
    "codigo": 1718402,
    "nome": "Presidente Kennedy",
    "uf": "TO"
  },
  {
    "codigo": 1718451,
    "nome": "Pugmil",
    "uf": "TO"
  },
  {
    "codigo": 1718501,
    "nome": "Recursolândia",
    "uf": "TO"
  },
  {
    "codigo": 1718550,
    "nome": "Riachinho",
    "uf": "TO"
  },
  {
    "codigo": 1718659,
    "nome": "Rio da Conceição",
    "uf": "TO"
  },
  {
    "codigo": 1718709,
    "nome": "Rio dos Bois",
    "uf": "TO"
  },
  {
    "codigo": 1718758,
    "nome": "Rio Sono",
    "uf": "TO"
  },
  {
    "codigo": 1718808,
    "nome": "Sampaio",
    "uf": "TO"
  },
  {
    "codigo": 1718840,
    "nome": "Sandolândia",
    "uf": "TO"
  },
  {
    "codigo": 1718865,
    "nome": "Santa Fé do Araguaia",
    "uf": "TO"
  },
  {
    "codigo": 1718881,
    "nome": "Santa Maria do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1718899,
    "nome": "Santa Rita do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1718907,
    "nome": "Santa Rosa do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1719004,
    "nome": "Santa Tereza do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1720002,
    "nome": "Santa Terezinha do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1720101,
    "nome": "São Bento do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1720150,
    "nome": "São Félix do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1720200,
    "nome": "São Miguel do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1720259,
    "nome": "São Salvador do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1720309,
    "nome": "São Sebastião do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1720499,
    "nome": "São Valério",
    "uf": "TO"
  },
  {
    "codigo": 1720655,
    "nome": "Silvanópolis",
    "uf": "TO"
  },
  {
    "codigo": 1720804,
    "nome": "Sítio Novo do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1720853,
    "nome": "Sucupira",
    "uf": "TO"
  },
  {
    "codigo": 1720903,
    "nome": "Taguatinga",
    "uf": "TO"
  },
  {
    "codigo": 1720937,
    "nome": "Taipas do Tocantins",
    "uf": "TO"
  },
  {
    "codigo": 1720978,
    "nome": "Talismã",
    "uf": "TO"
  },
  {
    "codigo": 1721000,
    "nome": "Palmas",
    "uf": "TO"
  },
  {
    "codigo": 1721109,
    "nome": "Tocantínia",
    "uf": "TO"
  },
  {
    "codigo": 1721208,
    "nome": "Tocantinópolis",
    "uf": "TO"
  },
  {
    "codigo": 1721257,
    "nome": "Tupirama",
    "uf": "TO"
  },
  {
    "codigo": 1721307,
    "nome": "Tupiratins",
    "uf": "TO"
  },
  {
    "codigo": 1722081,
    "nome": "Wanderlândia",
    "uf": "TO"
  },
  {
    "codigo": 1722107,
    "nome": "Xambioá",
    "uf": "TO"
  },
  {
    "codigo": 2100055,
    "nome": "Açailândia",
    "uf": "MA"
  },
  {
    "codigo": 2100105,
    "nome": "Afonso Cunha",
    "uf": "MA"
  },
  {
    "codigo": 2100154,
    "nome": "Água Doce do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2100204,
    "nome": "Alcântara",
    "uf": "MA"
  },
  {
    "codigo": 2100303,
    "nome": "Aldeias Altas",
    "uf": "MA"
  },
  {
    "codigo": 2100402,
    "nome": "Altamira do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2100436,
    "nome": "Alto Alegre do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2100477,
    "nome": "Alto Alegre do Pindaré",
    "uf": "MA"
  },
  {
    "codigo": 2100501,
    "nome": "Alto Parnaíba",
    "uf": "MA"
  },
  {
    "codigo": 2100550,
    "nome": "Amapá do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2100600,
    "nome": "Amarante do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2100709,
    "nome": "Anajatuba",
    "uf": "MA"
  },
  {
    "codigo": 2100808,
    "nome": "Anapurus",
    "uf": "MA"
  },
  {
    "codigo": 2100832,
    "nome": "Apicum-Açu",
    "uf": "MA"
  },
  {
    "codigo": 2100873,
    "nome": "Araguanã",
    "uf": "MA"
  },
  {
    "codigo": 2100907,
    "nome": "Araioses",
    "uf": "MA"
  },
  {
    "codigo": 2100956,
    "nome": "Arame",
    "uf": "MA"
  },
  {
    "codigo": 2101004,
    "nome": "Arari",
    "uf": "MA"
  },
  {
    "codigo": 2101103,
    "nome": "Axixá",
    "uf": "MA"
  },
  {
    "codigo": 2101202,
    "nome": "Bacabal",
    "uf": "MA"
  },
  {
    "codigo": 2101251,
    "nome": "Bacabeira",
    "uf": "MA"
  },
  {
    "codigo": 2101301,
    "nome": "Bacuri",
    "uf": "MA"
  },
  {
    "codigo": 2101350,
    "nome": "Bacurituba",
    "uf": "MA"
  },
  {
    "codigo": 2101400,
    "nome": "Balsas",
    "uf": "MA"
  },
  {
    "codigo": 2101509,
    "nome": "Barão de Grajaú",
    "uf": "MA"
  },
  {
    "codigo": 2101608,
    "nome": "Barra do Corda",
    "uf": "MA"
  },
  {
    "codigo": 2101707,
    "nome": "Barreirinhas",
    "uf": "MA"
  },
  {
    "codigo": 2101731,
    "nome": "Belágua",
    "uf": "MA"
  },
  {
    "codigo": 2101772,
    "nome": "Bela Vista do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2101806,
    "nome": "Benedito Leite",
    "uf": "MA"
  },
  {
    "codigo": 2101905,
    "nome": "Bequimão",
    "uf": "MA"
  },
  {
    "codigo": 2101939,
    "nome": "Bernardo do Mearim",
    "uf": "MA"
  },
  {
    "codigo": 2101970,
    "nome": "Boa Vista do Gurupi",
    "uf": "MA"
  },
  {
    "codigo": 2102002,
    "nome": "Bom Jardim",
    "uf": "MA"
  },
  {
    "codigo": 2102036,
    "nome": "Bom Jesus das Selvas",
    "uf": "MA"
  },
  {
    "codigo": 2102077,
    "nome": "Bom Lugar",
    "uf": "MA"
  },
  {
    "codigo": 2102101,
    "nome": "Brejo",
    "uf": "MA"
  },
  {
    "codigo": 2102150,
    "nome": "Brejo de Areia",
    "uf": "MA"
  },
  {
    "codigo": 2102200,
    "nome": "Buriti",
    "uf": "MA"
  },
  {
    "codigo": 2102309,
    "nome": "Buriti Bravo",
    "uf": "MA"
  },
  {
    "codigo": 2102325,
    "nome": "Buriticupu",
    "uf": "MA"
  },
  {
    "codigo": 2102358,
    "nome": "Buritirana",
    "uf": "MA"
  },
  {
    "codigo": 2102374,
    "nome": "Cachoeira Grande",
    "uf": "MA"
  },
  {
    "codigo": 2102408,
    "nome": "Cajapió",
    "uf": "MA"
  },
  {
    "codigo": 2102507,
    "nome": "Cajari",
    "uf": "MA"
  },
  {
    "codigo": 2102556,
    "nome": "Campestre do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2102606,
    "nome": "Cândido Mendes",
    "uf": "MA"
  },
  {
    "codigo": 2102705,
    "nome": "Cantanhede",
    "uf": "MA"
  },
  {
    "codigo": 2102754,
    "nome": "Capinzal do Norte",
    "uf": "MA"
  },
  {
    "codigo": 2102804,
    "nome": "Carolina",
    "uf": "MA"
  },
  {
    "codigo": 2102903,
    "nome": "Carutapera",
    "uf": "MA"
  },
  {
    "codigo": 2103000,
    "nome": "Caxias",
    "uf": "MA"
  },
  {
    "codigo": 2103109,
    "nome": "Cedral",
    "uf": "MA"
  },
  {
    "codigo": 2103125,
    "nome": "Central do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2103158,
    "nome": "Centro do Guilherme",
    "uf": "MA"
  },
  {
    "codigo": 2103174,
    "nome": "Centro Novo do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2103208,
    "nome": "Chapadinha",
    "uf": "MA"
  },
  {
    "codigo": 2103257,
    "nome": "Cidelândia",
    "uf": "MA"
  },
  {
    "codigo": 2103307,
    "nome": "Codó",
    "uf": "MA"
  },
  {
    "codigo": 2103406,
    "nome": "Coelho Neto",
    "uf": "MA"
  },
  {
    "codigo": 2103505,
    "nome": "Colinas",
    "uf": "MA"
  },
  {
    "codigo": 2103554,
    "nome": "Conceição do Lago-Açu",
    "uf": "MA"
  },
  {
    "codigo": 2103604,
    "nome": "Coroatá",
    "uf": "MA"
  },
  {
    "codigo": 2103703,
    "nome": "Cururupu",
    "uf": "MA"
  },
  {
    "codigo": 2103752,
    "nome": "Davinópolis",
    "uf": "MA"
  },
  {
    "codigo": 2103802,
    "nome": "Dom Pedro",
    "uf": "MA"
  },
  {
    "codigo": 2103901,
    "nome": "Duque Bacelar",
    "uf": "MA"
  },
  {
    "codigo": 2104008,
    "nome": "Esperantinópolis",
    "uf": "MA"
  },
  {
    "codigo": 2104057,
    "nome": "Estreito",
    "uf": "MA"
  },
  {
    "codigo": 2104073,
    "nome": "Feira Nova do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2104081,
    "nome": "Fernando Falcão",
    "uf": "MA"
  },
  {
    "codigo": 2104099,
    "nome": "Formosa da Serra Negra",
    "uf": "MA"
  },
  {
    "codigo": 2104107,
    "nome": "Fortaleza dos Nogueiras",
    "uf": "MA"
  },
  {
    "codigo": 2104206,
    "nome": "Fortuna",
    "uf": "MA"
  },
  {
    "codigo": 2104305,
    "nome": "Godofredo Viana",
    "uf": "MA"
  },
  {
    "codigo": 2104404,
    "nome": "Gonçalves Dias",
    "uf": "MA"
  },
  {
    "codigo": 2104503,
    "nome": "Governador Archer",
    "uf": "MA"
  },
  {
    "codigo": 2104552,
    "nome": "Governador Edison Lobão",
    "uf": "MA"
  },
  {
    "codigo": 2104602,
    "nome": "Governador Eugênio Barros",
    "uf": "MA"
  },
  {
    "codigo": 2104628,
    "nome": "Governador Luiz Rocha",
    "uf": "MA"
  },
  {
    "codigo": 2104651,
    "nome": "Governador Newton Bello",
    "uf": "MA"
  },
  {
    "codigo": 2104677,
    "nome": "Governador Nunes Freire",
    "uf": "MA"
  },
  {
    "codigo": 2104701,
    "nome": "Graça Aranha",
    "uf": "MA"
  },
  {
    "codigo": 2104800,
    "nome": "Grajaú",
    "uf": "MA"
  },
  {
    "codigo": 2104909,
    "nome": "Guimarães",
    "uf": "MA"
  },
  {
    "codigo": 2105005,
    "nome": "Humberto de Campos",
    "uf": "MA"
  },
  {
    "codigo": 2105104,
    "nome": "Icatu",
    "uf": "MA"
  },
  {
    "codigo": 2105153,
    "nome": "Igarapé do Meio",
    "uf": "MA"
  },
  {
    "codigo": 2105203,
    "nome": "Igarapé Grande",
    "uf": "MA"
  },
  {
    "codigo": 2105302,
    "nome": "Imperatriz",
    "uf": "MA"
  },
  {
    "codigo": 2105351,
    "nome": "Itaipava do Grajaú",
    "uf": "MA"
  },
  {
    "codigo": 2105401,
    "nome": "Itapecuru Mirim",
    "uf": "MA"
  },
  {
    "codigo": 2105427,
    "nome": "Itinga do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2105450,
    "nome": "Jatobá",
    "uf": "MA"
  },
  {
    "codigo": 2105476,
    "nome": "Jenipapo dos Vieiras",
    "uf": "MA"
  },
  {
    "codigo": 2105500,
    "nome": "João Lisboa",
    "uf": "MA"
  },
  {
    "codigo": 2105609,
    "nome": "Joselândia",
    "uf": "MA"
  },
  {
    "codigo": 2105658,
    "nome": "Junco do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2105708,
    "nome": "Lago da Pedra",
    "uf": "MA"
  },
  {
    "codigo": 2105807,
    "nome": "Lago do Junco",
    "uf": "MA"
  },
  {
    "codigo": 2105906,
    "nome": "Lago Verde",
    "uf": "MA"
  },
  {
    "codigo": 2105922,
    "nome": "Lagoa do Mato",
    "uf": "MA"
  },
  {
    "codigo": 2105948,
    "nome": "Lago dos Rodrigues",
    "uf": "MA"
  },
  {
    "codigo": 2105963,
    "nome": "Lagoa Grande do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2105989,
    "nome": "Lajeado Novo",
    "uf": "MA"
  },
  {
    "codigo": 2106003,
    "nome": "Lima Campos",
    "uf": "MA"
  },
  {
    "codigo": 2106102,
    "nome": "Loreto",
    "uf": "MA"
  },
  {
    "codigo": 2106201,
    "nome": "Luís Domingues",
    "uf": "MA"
  },
  {
    "codigo": 2106300,
    "nome": "Magalhães de Almeida",
    "uf": "MA"
  },
  {
    "codigo": 2106326,
    "nome": "Maracaçumé",
    "uf": "MA"
  },
  {
    "codigo": 2106359,
    "nome": "Marajá do Sena",
    "uf": "MA"
  },
  {
    "codigo": 2106375,
    "nome": "Maranhãozinho",
    "uf": "MA"
  },
  {
    "codigo": 2106409,
    "nome": "Mata Roma",
    "uf": "MA"
  },
  {
    "codigo": 2106508,
    "nome": "Matinha",
    "uf": "MA"
  },
  {
    "codigo": 2106607,
    "nome": "Matões",
    "uf": "MA"
  },
  {
    "codigo": 2106631,
    "nome": "Matões do Norte",
    "uf": "MA"
  },
  {
    "codigo": 2106672,
    "nome": "Milagres do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2106706,
    "nome": "Mirador",
    "uf": "MA"
  },
  {
    "codigo": 2106755,
    "nome": "Miranda do Norte",
    "uf": "MA"
  },
  {
    "codigo": 2106805,
    "nome": "Mirinzal",
    "uf": "MA"
  },
  {
    "codigo": 2106904,
    "nome": "Monção",
    "uf": "MA"
  },
  {
    "codigo": 2107001,
    "nome": "Montes Altos",
    "uf": "MA"
  },
  {
    "codigo": 2107100,
    "nome": "Morros",
    "uf": "MA"
  },
  {
    "codigo": 2107209,
    "nome": "Nina Rodrigues",
    "uf": "MA"
  },
  {
    "codigo": 2107258,
    "nome": "Nova Colinas",
    "uf": "MA"
  },
  {
    "codigo": 2107308,
    "nome": "Nova Iorque",
    "uf": "MA"
  },
  {
    "codigo": 2107357,
    "nome": "Nova Olinda do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2107407,
    "nome": "Olho d'Água das Cunhãs",
    "uf": "MA"
  },
  {
    "codigo": 2107456,
    "nome": "Olinda Nova do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2107506,
    "nome": "Paço do Lumiar",
    "uf": "MA"
  },
  {
    "codigo": 2107605,
    "nome": "Palmeirândia",
    "uf": "MA"
  },
  {
    "codigo": 2107704,
    "nome": "Paraibano",
    "uf": "MA"
  },
  {
    "codigo": 2107803,
    "nome": "Parnarama",
    "uf": "MA"
  },
  {
    "codigo": 2107902,
    "nome": "Passagem Franca",
    "uf": "MA"
  },
  {
    "codigo": 2108009,
    "nome": "Pastos Bons",
    "uf": "MA"
  },
  {
    "codigo": 2108058,
    "nome": "Paulino Neves",
    "uf": "MA"
  },
  {
    "codigo": 2108108,
    "nome": "Paulo Ramos",
    "uf": "MA"
  },
  {
    "codigo": 2108207,
    "nome": "Pedreiras",
    "uf": "MA"
  },
  {
    "codigo": 2108256,
    "nome": "Pedro do Rosário",
    "uf": "MA"
  },
  {
    "codigo": 2108306,
    "nome": "Penalva",
    "uf": "MA"
  },
  {
    "codigo": 2108405,
    "nome": "Peri Mirim",
    "uf": "MA"
  },
  {
    "codigo": 2108454,
    "nome": "Peritoró",
    "uf": "MA"
  },
  {
    "codigo": 2108504,
    "nome": "Pindaré-Mirim",
    "uf": "MA"
  },
  {
    "codigo": 2108603,
    "nome": "Pinheiro",
    "uf": "MA"
  },
  {
    "codigo": 2108702,
    "nome": "Pio XII",
    "uf": "MA"
  },
  {
    "codigo": 2108801,
    "nome": "Pirapemas",
    "uf": "MA"
  },
  {
    "codigo": 2108900,
    "nome": "Poção de Pedras",
    "uf": "MA"
  },
  {
    "codigo": 2109007,
    "nome": "Porto Franco",
    "uf": "MA"
  },
  {
    "codigo": 2109056,
    "nome": "Porto Rico do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2109106,
    "nome": "Presidente Dutra",
    "uf": "MA"
  },
  {
    "codigo": 2109205,
    "nome": "Presidente Juscelino",
    "uf": "MA"
  },
  {
    "codigo": 2109239,
    "nome": "Presidente Médici",
    "uf": "MA"
  },
  {
    "codigo": 2109270,
    "nome": "Presidente Sarney",
    "uf": "MA"
  },
  {
    "codigo": 2109304,
    "nome": "Presidente Vargas",
    "uf": "MA"
  },
  {
    "codigo": 2109403,
    "nome": "Primeira Cruz",
    "uf": "MA"
  },
  {
    "codigo": 2109452,
    "nome": "Raposa",
    "uf": "MA"
  },
  {
    "codigo": 2109502,
    "nome": "Riachão",
    "uf": "MA"
  },
  {
    "codigo": 2109551,
    "nome": "Ribamar Fiquene",
    "uf": "MA"
  },
  {
    "codigo": 2109601,
    "nome": "Rosário",
    "uf": "MA"
  },
  {
    "codigo": 2109700,
    "nome": "Sambaíba",
    "uf": "MA"
  },
  {
    "codigo": 2109759,
    "nome": "Santa Filomena do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2109809,
    "nome": "Santa Helena",
    "uf": "MA"
  },
  {
    "codigo": 2109908,
    "nome": "Santa Inês",
    "uf": "MA"
  },
  {
    "codigo": 2110005,
    "nome": "Santa Luzia",
    "uf": "MA"
  },
  {
    "codigo": 2110039,
    "nome": "Santa Luzia do Paruá",
    "uf": "MA"
  },
  {
    "codigo": 2110104,
    "nome": "Santa Quitéria do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2110203,
    "nome": "Santa Rita",
    "uf": "MA"
  },
  {
    "codigo": 2110237,
    "nome": "Santana do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2110278,
    "nome": "Santo Amaro do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2110302,
    "nome": "Santo Antônio dos Lopes",
    "uf": "MA"
  },
  {
    "codigo": 2110401,
    "nome": "São Benedito do Rio Preto",
    "uf": "MA"
  },
  {
    "codigo": 2110500,
    "nome": "São Bento",
    "uf": "MA"
  },
  {
    "codigo": 2110609,
    "nome": "São Bernardo",
    "uf": "MA"
  },
  {
    "codigo": 2110658,
    "nome": "São Domingos do Azeitão",
    "uf": "MA"
  },
  {
    "codigo": 2110708,
    "nome": "São Domingos do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2110807,
    "nome": "São Félix de Balsas",
    "uf": "MA"
  },
  {
    "codigo": 2110856,
    "nome": "São Francisco do Brejão",
    "uf": "MA"
  },
  {
    "codigo": 2110906,
    "nome": "São Francisco do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2111003,
    "nome": "São João Batista",
    "uf": "MA"
  },
  {
    "codigo": 2111029,
    "nome": "São João do Carú",
    "uf": "MA"
  },
  {
    "codigo": 2111052,
    "nome": "São João do Paraíso",
    "uf": "MA"
  },
  {
    "codigo": 2111078,
    "nome": "São João do Soter",
    "uf": "MA"
  },
  {
    "codigo": 2111102,
    "nome": "São João dos Patos",
    "uf": "MA"
  },
  {
    "codigo": 2111201,
    "nome": "São José de Ribamar",
    "uf": "MA"
  },
  {
    "codigo": 2111250,
    "nome": "São José dos Basílios",
    "uf": "MA"
  },
  {
    "codigo": 2111300,
    "nome": "São Luís",
    "uf": "MA"
  },
  {
    "codigo": 2111409,
    "nome": "São Luís Gonzaga do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2111508,
    "nome": "São Mateus do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2111532,
    "nome": "São Pedro da Água Branca",
    "uf": "MA"
  },
  {
    "codigo": 2111573,
    "nome": "São Pedro dos Crentes",
    "uf": "MA"
  },
  {
    "codigo": 2111607,
    "nome": "São Raimundo das Mangabeiras",
    "uf": "MA"
  },
  {
    "codigo": 2111631,
    "nome": "São Raimundo do Doca Bezerra",
    "uf": "MA"
  },
  {
    "codigo": 2111672,
    "nome": "São Roberto",
    "uf": "MA"
  },
  {
    "codigo": 2111706,
    "nome": "São Vicente Ferrer",
    "uf": "MA"
  },
  {
    "codigo": 2111722,
    "nome": "Satubinha",
    "uf": "MA"
  },
  {
    "codigo": 2111748,
    "nome": "Senador Alexandre Costa",
    "uf": "MA"
  },
  {
    "codigo": 2111763,
    "nome": "Senador La Rocque",
    "uf": "MA"
  },
  {
    "codigo": 2111789,
    "nome": "Serrano do Maranhão",
    "uf": "MA"
  },
  {
    "codigo": 2111805,
    "nome": "Sítio Novo",
    "uf": "MA"
  },
  {
    "codigo": 2111904,
    "nome": "Sucupira do Norte",
    "uf": "MA"
  },
  {
    "codigo": 2111953,
    "nome": "Sucupira do Riachão",
    "uf": "MA"
  },
  {
    "codigo": 2112001,
    "nome": "Tasso Fragoso",
    "uf": "MA"
  },
  {
    "codigo": 2112100,
    "nome": "Timbiras",
    "uf": "MA"
  },
  {
    "codigo": 2112209,
    "nome": "Timon",
    "uf": "MA"
  },
  {
    "codigo": 2112233,
    "nome": "Trizidela do Vale",
    "uf": "MA"
  },
  {
    "codigo": 2112274,
    "nome": "Tufilândia",
    "uf": "MA"
  },
  {
    "codigo": 2112308,
    "nome": "Tuntum",
    "uf": "MA"
  },
  {
    "codigo": 2112407,
    "nome": "Turiaçu",
    "uf": "MA"
  },
  {
    "codigo": 2112456,
    "nome": "Turilândia",
    "uf": "MA"
  },
  {
    "codigo": 2112506,
    "nome": "Tutóia",
    "uf": "MA"
  },
  {
    "codigo": 2112605,
    "nome": "Urbano Santos",
    "uf": "MA"
  },
  {
    "codigo": 2112704,
    "nome": "Vargem Grande",
    "uf": "MA"
  },
  {
    "codigo": 2112803,
    "nome": "Viana",
    "uf": "MA"
  },
  {
    "codigo": 2112852,
    "nome": "Vila Nova dos Martírios",
    "uf": "MA"
  },
  {
    "codigo": 2112902,
    "nome": "Vitória do Mearim",
    "uf": "MA"
  },
  {
    "codigo": 2113009,
    "nome": "Vitorino Freire",
    "uf": "MA"
  },
  {
    "codigo": 2114007,
    "nome": "Zé Doca",
    "uf": "MA"
  },
  {
    "codigo": 2200053,
    "nome": "Acauã",
    "uf": "PI"
  },
  {
    "codigo": 2200103,
    "nome": "Agricolândia",
    "uf": "PI"
  },
  {
    "codigo": 2200202,
    "nome": "Água Branca",
    "uf": "PI"
  },
  {
    "codigo": 2200251,
    "nome": "Alagoinha do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2200277,
    "nome": "Alegrete do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2200301,
    "nome": "Alto Longá",
    "uf": "PI"
  },
  {
    "codigo": 2200400,
    "nome": "Altos",
    "uf": "PI"
  },
  {
    "codigo": 2200459,
    "nome": "Alvorada do Gurguéia",
    "uf": "PI"
  },
  {
    "codigo": 2200509,
    "nome": "Amarante",
    "uf": "PI"
  },
  {
    "codigo": 2200608,
    "nome": "Angical do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2200707,
    "nome": "Anísio de Abreu",
    "uf": "PI"
  },
  {
    "codigo": 2200806,
    "nome": "Antônio Almeida",
    "uf": "PI"
  },
  {
    "codigo": 2200905,
    "nome": "Aroazes",
    "uf": "PI"
  },
  {
    "codigo": 2200954,
    "nome": "Aroeiras do Itaim",
    "uf": "PI"
  },
  {
    "codigo": 2201002,
    "nome": "Arraial",
    "uf": "PI"
  },
  {
    "codigo": 2201051,
    "nome": "Assunção do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2201101,
    "nome": "Avelino Lopes",
    "uf": "PI"
  },
  {
    "codigo": 2201150,
    "nome": "Baixa Grande do Ribeiro",
    "uf": "PI"
  },
  {
    "codigo": 2201176,
    "nome": "Barra D'Alcântara",
    "uf": "PI"
  },
  {
    "codigo": 2201200,
    "nome": "Barras",
    "uf": "PI"
  },
  {
    "codigo": 2201309,
    "nome": "Barreiras do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2201408,
    "nome": "Barro Duro",
    "uf": "PI"
  },
  {
    "codigo": 2201507,
    "nome": "Batalha",
    "uf": "PI"
  },
  {
    "codigo": 2201556,
    "nome": "Bela Vista do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2201572,
    "nome": "Belém do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2201606,
    "nome": "Beneditinos",
    "uf": "PI"
  },
  {
    "codigo": 2201705,
    "nome": "Bertolínia",
    "uf": "PI"
  },
  {
    "codigo": 2201739,
    "nome": "Betânia do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2201770,
    "nome": "Boa Hora",
    "uf": "PI"
  },
  {
    "codigo": 2201804,
    "nome": "Bocaina",
    "uf": "PI"
  },
  {
    "codigo": 2201903,
    "nome": "Bom Jesus",
    "uf": "PI"
  },
  {
    "codigo": 2201919,
    "nome": "Bom Princípio do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2201929,
    "nome": "Bonfim do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2201945,
    "nome": "Boqueirão do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2201960,
    "nome": "Brasileira",
    "uf": "PI"
  },
  {
    "codigo": 2201988,
    "nome": "Brejo do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202000,
    "nome": "Buriti dos Lopes",
    "uf": "PI"
  },
  {
    "codigo": 2202026,
    "nome": "Buriti dos Montes",
    "uf": "PI"
  },
  {
    "codigo": 2202059,
    "nome": "Cabeceiras do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202075,
    "nome": "Cajazeiras do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202083,
    "nome": "Cajueiro da Praia",
    "uf": "PI"
  },
  {
    "codigo": 2202091,
    "nome": "Caldeirão Grande do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202109,
    "nome": "Campinas do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202117,
    "nome": "Campo Alegre do Fidalgo",
    "uf": "PI"
  },
  {
    "codigo": 2202133,
    "nome": "Campo Grande do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202174,
    "nome": "Campo Largo do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202208,
    "nome": "Campo Maior",
    "uf": "PI"
  },
  {
    "codigo": 2202251,
    "nome": "Canavieira",
    "uf": "PI"
  },
  {
    "codigo": 2202307,
    "nome": "Canto do Buriti",
    "uf": "PI"
  },
  {
    "codigo": 2202406,
    "nome": "Capitão de Campos",
    "uf": "PI"
  },
  {
    "codigo": 2202455,
    "nome": "Capitão Gervásio Oliveira",
    "uf": "PI"
  },
  {
    "codigo": 2202505,
    "nome": "Caracol",
    "uf": "PI"
  },
  {
    "codigo": 2202539,
    "nome": "Caraúbas do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202554,
    "nome": "Caridade do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202604,
    "nome": "Castelo do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202653,
    "nome": "Caxingó",
    "uf": "PI"
  },
  {
    "codigo": 2202703,
    "nome": "Cocal",
    "uf": "PI"
  },
  {
    "codigo": 2202711,
    "nome": "Cocal de Telha",
    "uf": "PI"
  },
  {
    "codigo": 2202729,
    "nome": "Cocal dos Alves",
    "uf": "PI"
  },
  {
    "codigo": 2202737,
    "nome": "Coivaras",
    "uf": "PI"
  },
  {
    "codigo": 2202752,
    "nome": "Colônia do Gurguéia",
    "uf": "PI"
  },
  {
    "codigo": 2202778,
    "nome": "Colônia do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2202802,
    "nome": "Conceição do Canindé",
    "uf": "PI"
  },
  {
    "codigo": 2202851,
    "nome": "Coronel José Dias",
    "uf": "PI"
  },
  {
    "codigo": 2202901,
    "nome": "Corrente",
    "uf": "PI"
  },
  {
    "codigo": 2203008,
    "nome": "Cristalândia do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2203107,
    "nome": "Cristino Castro",
    "uf": "PI"
  },
  {
    "codigo": 2203206,
    "nome": "Curimatá",
    "uf": "PI"
  },
  {
    "codigo": 2203230,
    "nome": "Currais",
    "uf": "PI"
  },
  {
    "codigo": 2203255,
    "nome": "Curralinhos",
    "uf": "PI"
  },
  {
    "codigo": 2203271,
    "nome": "Curral Novo do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2203305,
    "nome": "Demerval Lobão",
    "uf": "PI"
  },
  {
    "codigo": 2203354,
    "nome": "Dirceu Arcoverde",
    "uf": "PI"
  },
  {
    "codigo": 2203404,
    "nome": "Dom Expedito Lopes",
    "uf": "PI"
  },
  {
    "codigo": 2203420,
    "nome": "Domingos Mourão",
    "uf": "PI"
  },
  {
    "codigo": 2203453,
    "nome": "Dom Inocêncio",
    "uf": "PI"
  },
  {
    "codigo": 2203503,
    "nome": "Elesbão Veloso",
    "uf": "PI"
  },
  {
    "codigo": 2203602,
    "nome": "Eliseu Martins",
    "uf": "PI"
  },
  {
    "codigo": 2203701,
    "nome": "Esperantina",
    "uf": "PI"
  },
  {
    "codigo": 2203750,
    "nome": "Fartura do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2203800,
    "nome": "Flores do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2203859,
    "nome": "Floresta do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2203909,
    "nome": "Floriano",
    "uf": "PI"
  },
  {
    "codigo": 2204006,
    "nome": "Francinópolis",
    "uf": "PI"
  },
  {
    "codigo": 2204105,
    "nome": "Francisco Ayres",
    "uf": "PI"
  },
  {
    "codigo": 2204154,
    "nome": "Francisco Macedo",
    "uf": "PI"
  },
  {
    "codigo": 2204204,
    "nome": "Francisco Santos",
    "uf": "PI"
  },
  {
    "codigo": 2204303,
    "nome": "Fronteiras",
    "uf": "PI"
  },
  {
    "codigo": 2204352,
    "nome": "Geminiano",
    "uf": "PI"
  },
  {
    "codigo": 2204402,
    "nome": "Gilbués",
    "uf": "PI"
  },
  {
    "codigo": 2204501,
    "nome": "Guadalupe",
    "uf": "PI"
  },
  {
    "codigo": 2204550,
    "nome": "Guaribas",
    "uf": "PI"
  },
  {
    "codigo": 2204600,
    "nome": "Hugo Napoleão",
    "uf": "PI"
  },
  {
    "codigo": 2204659,
    "nome": "Ilha Grande",
    "uf": "PI"
  },
  {
    "codigo": 2204709,
    "nome": "Inhuma",
    "uf": "PI"
  },
  {
    "codigo": 2204808,
    "nome": "Ipiranga do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2204907,
    "nome": "Isaías Coelho",
    "uf": "PI"
  },
  {
    "codigo": 2205003,
    "nome": "Itainópolis",
    "uf": "PI"
  },
  {
    "codigo": 2205102,
    "nome": "Itaueira",
    "uf": "PI"
  },
  {
    "codigo": 2205151,
    "nome": "Jacobina do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2205201,
    "nome": "Jaicós",
    "uf": "PI"
  },
  {
    "codigo": 2205250,
    "nome": "Jardim do Mulato",
    "uf": "PI"
  },
  {
    "codigo": 2205276,
    "nome": "Jatobá do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2205300,
    "nome": "Jerumenha",
    "uf": "PI"
  },
  {
    "codigo": 2205359,
    "nome": "João Costa",
    "uf": "PI"
  },
  {
    "codigo": 2205409,
    "nome": "Joaquim Pires",
    "uf": "PI"
  },
  {
    "codigo": 2205458,
    "nome": "Joca Marques",
    "uf": "PI"
  },
  {
    "codigo": 2205508,
    "nome": "José de Freitas",
    "uf": "PI"
  },
  {
    "codigo": 2205516,
    "nome": "Juazeiro do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2205524,
    "nome": "Júlio Borges",
    "uf": "PI"
  },
  {
    "codigo": 2205532,
    "nome": "Jurema",
    "uf": "PI"
  },
  {
    "codigo": 2205540,
    "nome": "Lagoinha do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2205557,
    "nome": "Lagoa Alegre",
    "uf": "PI"
  },
  {
    "codigo": 2205565,
    "nome": "Lagoa do Barro do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2205573,
    "nome": "Lagoa de São Francisco",
    "uf": "PI"
  },
  {
    "codigo": 2205581,
    "nome": "Lagoa do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2205599,
    "nome": "Lagoa do Sítio",
    "uf": "PI"
  },
  {
    "codigo": 2205607,
    "nome": "Landri Sales",
    "uf": "PI"
  },
  {
    "codigo": 2205706,
    "nome": "Luís Correia",
    "uf": "PI"
  },
  {
    "codigo": 2205805,
    "nome": "Luzilândia",
    "uf": "PI"
  },
  {
    "codigo": 2205854,
    "nome": "Madeiro",
    "uf": "PI"
  },
  {
    "codigo": 2205904,
    "nome": "Manoel Emídio",
    "uf": "PI"
  },
  {
    "codigo": 2205953,
    "nome": "Marcolândia",
    "uf": "PI"
  },
  {
    "codigo": 2206001,
    "nome": "Marcos Parente",
    "uf": "PI"
  },
  {
    "codigo": 2206050,
    "nome": "Massapê do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2206100,
    "nome": "Matias Olímpio",
    "uf": "PI"
  },
  {
    "codigo": 2206209,
    "nome": "Miguel Alves",
    "uf": "PI"
  },
  {
    "codigo": 2206308,
    "nome": "Miguel Leão",
    "uf": "PI"
  },
  {
    "codigo": 2206357,
    "nome": "Milton Brandão",
    "uf": "PI"
  },
  {
    "codigo": 2206407,
    "nome": "Monsenhor Gil",
    "uf": "PI"
  },
  {
    "codigo": 2206506,
    "nome": "Monsenhor Hipólito",
    "uf": "PI"
  },
  {
    "codigo": 2206605,
    "nome": "Monte Alegre do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2206654,
    "nome": "Morro Cabeça no Tempo",
    "uf": "PI"
  },
  {
    "codigo": 2206670,
    "nome": "Morro do Chapéu do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2206696,
    "nome": "Murici dos Portelas",
    "uf": "PI"
  },
  {
    "codigo": 2206704,
    "nome": "Nazaré do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2206720,
    "nome": "Nazária",
    "uf": "PI"
  },
  {
    "codigo": 2206753,
    "nome": "Nossa Senhora de Nazaré",
    "uf": "PI"
  },
  {
    "codigo": 2206803,
    "nome": "Nossa Senhora dos Remédios",
    "uf": "PI"
  },
  {
    "codigo": 2206902,
    "nome": "Novo Oriente do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2206951,
    "nome": "Novo Santo Antônio",
    "uf": "PI"
  },
  {
    "codigo": 2207009,
    "nome": "Oeiras",
    "uf": "PI"
  },
  {
    "codigo": 2207108,
    "nome": "Olho D'Água do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2207207,
    "nome": "Padre Marcos",
    "uf": "PI"
  },
  {
    "codigo": 2207306,
    "nome": "Paes Landim",
    "uf": "PI"
  },
  {
    "codigo": 2207355,
    "nome": "Pajeú do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2207405,
    "nome": "Palmeira do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2207504,
    "nome": "Palmeirais",
    "uf": "PI"
  },
  {
    "codigo": 2207553,
    "nome": "Paquetá",
    "uf": "PI"
  },
  {
    "codigo": 2207603,
    "nome": "Parnaguá",
    "uf": "PI"
  },
  {
    "codigo": 2207702,
    "nome": "Parnaíba",
    "uf": "PI"
  },
  {
    "codigo": 2207751,
    "nome": "Passagem Franca do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2207777,
    "nome": "Patos do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2207793,
    "nome": "Pau D'Arco do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2207801,
    "nome": "Paulistana",
    "uf": "PI"
  },
  {
    "codigo": 2207850,
    "nome": "Pavussu",
    "uf": "PI"
  },
  {
    "codigo": 2207900,
    "nome": "Pedro II",
    "uf": "PI"
  },
  {
    "codigo": 2207934,
    "nome": "Pedro Laurentino",
    "uf": "PI"
  },
  {
    "codigo": 2207959,
    "nome": "Nova Santa Rita",
    "uf": "PI"
  },
  {
    "codigo": 2208007,
    "nome": "Picos",
    "uf": "PI"
  },
  {
    "codigo": 2208106,
    "nome": "Pimenteiras",
    "uf": "PI"
  },
  {
    "codigo": 2208205,
    "nome": "Pio IX",
    "uf": "PI"
  },
  {
    "codigo": 2208304,
    "nome": "Piracuruca",
    "uf": "PI"
  },
  {
    "codigo": 2208403,
    "nome": "Piripiri",
    "uf": "PI"
  },
  {
    "codigo": 2208502,
    "nome": "Porto",
    "uf": "PI"
  },
  {
    "codigo": 2208551,
    "nome": "Porto Alegre do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2208601,
    "nome": "Prata do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2208650,
    "nome": "Queimada Nova",
    "uf": "PI"
  },
  {
    "codigo": 2208700,
    "nome": "Redenção do Gurguéia",
    "uf": "PI"
  },
  {
    "codigo": 2208809,
    "nome": "Regeneração",
    "uf": "PI"
  },
  {
    "codigo": 2208858,
    "nome": "Riacho Frio",
    "uf": "PI"
  },
  {
    "codigo": 2208874,
    "nome": "Ribeira do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2208908,
    "nome": "Ribeiro Gonçalves",
    "uf": "PI"
  },
  {
    "codigo": 2209005,
    "nome": "Rio Grande do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2209104,
    "nome": "Santa Cruz do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2209153,
    "nome": "Santa Cruz dos Milagres",
    "uf": "PI"
  },
  {
    "codigo": 2209203,
    "nome": "Santa Filomena",
    "uf": "PI"
  },
  {
    "codigo": 2209302,
    "nome": "Santa Luz",
    "uf": "PI"
  },
  {
    "codigo": 2209351,
    "nome": "Santana do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2209377,
    "nome": "Santa Rosa do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2209401,
    "nome": "Santo Antônio de Lisboa",
    "uf": "PI"
  },
  {
    "codigo": 2209450,
    "nome": "Santo Antônio dos Milagres",
    "uf": "PI"
  },
  {
    "codigo": 2209500,
    "nome": "Santo Inácio do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2209559,
    "nome": "São Braz do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2209609,
    "nome": "São Félix do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2209658,
    "nome": "São Francisco de Assis do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2209708,
    "nome": "São Francisco do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2209757,
    "nome": "São Gonçalo do Gurguéia",
    "uf": "PI"
  },
  {
    "codigo": 2209807,
    "nome": "São Gonçalo do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2209856,
    "nome": "São João da Canabrava",
    "uf": "PI"
  },
  {
    "codigo": 2209872,
    "nome": "São João da Fronteira",
    "uf": "PI"
  },
  {
    "codigo": 2209906,
    "nome": "São João da Serra",
    "uf": "PI"
  },
  {
    "codigo": 2209955,
    "nome": "São João da Varjota",
    "uf": "PI"
  },
  {
    "codigo": 2209971,
    "nome": "São João do Arraial",
    "uf": "PI"
  },
  {
    "codigo": 2210003,
    "nome": "São João do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2210052,
    "nome": "São José do Divino",
    "uf": "PI"
  },
  {
    "codigo": 2210102,
    "nome": "São José do Peixe",
    "uf": "PI"
  },
  {
    "codigo": 2210201,
    "nome": "São José do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2210300,
    "nome": "São Julião",
    "uf": "PI"
  },
  {
    "codigo": 2210359,
    "nome": "São Lourenço do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2210375,
    "nome": "São Luis do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2210383,
    "nome": "São Miguel da Baixa Grande",
    "uf": "PI"
  },
  {
    "codigo": 2210391,
    "nome": "São Miguel do Fidalgo",
    "uf": "PI"
  },
  {
    "codigo": 2210409,
    "nome": "São Miguel do Tapuio",
    "uf": "PI"
  },
  {
    "codigo": 2210508,
    "nome": "São Pedro do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2210607,
    "nome": "São Raimundo Nonato",
    "uf": "PI"
  },
  {
    "codigo": 2210623,
    "nome": "Sebastião Barros",
    "uf": "PI"
  },
  {
    "codigo": 2210631,
    "nome": "Sebastião Leal",
    "uf": "PI"
  },
  {
    "codigo": 2210656,
    "nome": "Sigefredo Pacheco",
    "uf": "PI"
  },
  {
    "codigo": 2210706,
    "nome": "Simões",
    "uf": "PI"
  },
  {
    "codigo": 2210805,
    "nome": "Simplício Mendes",
    "uf": "PI"
  },
  {
    "codigo": 2210904,
    "nome": "Socorro do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2210938,
    "nome": "Sussuapara",
    "uf": "PI"
  },
  {
    "codigo": 2210953,
    "nome": "Tamboril do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2210979,
    "nome": "Tanque do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2211001,
    "nome": "Teresina",
    "uf": "PI"
  },
  {
    "codigo": 2211100,
    "nome": "União",
    "uf": "PI"
  },
  {
    "codigo": 2211209,
    "nome": "Uruçuí",
    "uf": "PI"
  },
  {
    "codigo": 2211308,
    "nome": "Valença do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2211357,
    "nome": "Várzea Branca",
    "uf": "PI"
  },
  {
    "codigo": 2211407,
    "nome": "Várzea Grande",
    "uf": "PI"
  },
  {
    "codigo": 2211506,
    "nome": "Vera Mendes",
    "uf": "PI"
  },
  {
    "codigo": 2211605,
    "nome": "Vila Nova do Piauí",
    "uf": "PI"
  },
  {
    "codigo": 2211704,
    "nome": "Wall Ferraz",
    "uf": "PI"
  },
  {
    "codigo": 2300101,
    "nome": "Abaiara",
    "uf": "CE"
  },
  {
    "codigo": 2300150,
    "nome": "Acarape",
    "uf": "CE"
  },
  {
    "codigo": 2300200,
    "nome": "Acaraú",
    "uf": "CE"
  },
  {
    "codigo": 2300309,
    "nome": "Acopiara",
    "uf": "CE"
  },
  {
    "codigo": 2300408,
    "nome": "Aiuaba",
    "uf": "CE"
  },
  {
    "codigo": 2300507,
    "nome": "Alcântaras",
    "uf": "CE"
  },
  {
    "codigo": 2300606,
    "nome": "Altaneira",
    "uf": "CE"
  },
  {
    "codigo": 2300705,
    "nome": "Alto Santo",
    "uf": "CE"
  },
  {
    "codigo": 2300754,
    "nome": "Amontada",
    "uf": "CE"
  },
  {
    "codigo": 2300804,
    "nome": "Antonina do Norte",
    "uf": "CE"
  },
  {
    "codigo": 2300903,
    "nome": "Apuiarés",
    "uf": "CE"
  },
  {
    "codigo": 2301000,
    "nome": "Aquiraz",
    "uf": "CE"
  },
  {
    "codigo": 2301109,
    "nome": "Aracati",
    "uf": "CE"
  },
  {
    "codigo": 2301208,
    "nome": "Aracoiaba",
    "uf": "CE"
  },
  {
    "codigo": 2301257,
    "nome": "Ararendá",
    "uf": "CE"
  },
  {
    "codigo": 2301307,
    "nome": "Araripe",
    "uf": "CE"
  },
  {
    "codigo": 2301406,
    "nome": "Aratuba",
    "uf": "CE"
  },
  {
    "codigo": 2301505,
    "nome": "Arneiroz",
    "uf": "CE"
  },
  {
    "codigo": 2301604,
    "nome": "Assaré",
    "uf": "CE"
  },
  {
    "codigo": 2301703,
    "nome": "Aurora",
    "uf": "CE"
  },
  {
    "codigo": 2301802,
    "nome": "Baixio",
    "uf": "CE"
  },
  {
    "codigo": 2301851,
    "nome": "Banabuiú",
    "uf": "CE"
  },
  {
    "codigo": 2301901,
    "nome": "Barbalha",
    "uf": "CE"
  },
  {
    "codigo": 2301950,
    "nome": "Barreira",
    "uf": "CE"
  },
  {
    "codigo": 2302008,
    "nome": "Barro",
    "uf": "CE"
  },
  {
    "codigo": 2302057,
    "nome": "Barroquinha",
    "uf": "CE"
  },
  {
    "codigo": 2302107,
    "nome": "Baturité",
    "uf": "CE"
  },
  {
    "codigo": 2302206,
    "nome": "Beberibe",
    "uf": "CE"
  },
  {
    "codigo": 2302305,
    "nome": "Bela Cruz",
    "uf": "CE"
  },
  {
    "codigo": 2302404,
    "nome": "Boa Viagem",
    "uf": "CE"
  },
  {
    "codigo": 2302503,
    "nome": "Brejo Santo",
    "uf": "CE"
  },
  {
    "codigo": 2302602,
    "nome": "Camocim",
    "uf": "CE"
  },
  {
    "codigo": 2302701,
    "nome": "Campos Sales",
    "uf": "CE"
  },
  {
    "codigo": 2302800,
    "nome": "Canindé",
    "uf": "CE"
  },
  {
    "codigo": 2302909,
    "nome": "Capistrano",
    "uf": "CE"
  },
  {
    "codigo": 2303006,
    "nome": "Caridade",
    "uf": "CE"
  },
  {
    "codigo": 2303105,
    "nome": "Cariré",
    "uf": "CE"
  },
  {
    "codigo": 2303204,
    "nome": "Caririaçu",
    "uf": "CE"
  },
  {
    "codigo": 2303303,
    "nome": "Cariús",
    "uf": "CE"
  },
  {
    "codigo": 2303402,
    "nome": "Carnaubal",
    "uf": "CE"
  },
  {
    "codigo": 2303501,
    "nome": "Cascavel",
    "uf": "CE"
  },
  {
    "codigo": 2303600,
    "nome": "Catarina",
    "uf": "CE"
  },
  {
    "codigo": 2303659,
    "nome": "Catunda",
    "uf": "CE"
  },
  {
    "codigo": 2303709,
    "nome": "Caucaia",
    "uf": "CE"
  },
  {
    "codigo": 2303808,
    "nome": "Cedro",
    "uf": "CE"
  },
  {
    "codigo": 2303907,
    "nome": "Chaval",
    "uf": "CE"
  },
  {
    "codigo": 2303931,
    "nome": "Choró",
    "uf": "CE"
  },
  {
    "codigo": 2303956,
    "nome": "Chorozinho",
    "uf": "CE"
  },
  {
    "codigo": 2304004,
    "nome": "Coreaú",
    "uf": "CE"
  },
  {
    "codigo": 2304103,
    "nome": "Crateús",
    "uf": "CE"
  },
  {
    "codigo": 2304202,
    "nome": "Crato",
    "uf": "CE"
  },
  {
    "codigo": 2304236,
    "nome": "Croatá",
    "uf": "CE"
  },
  {
    "codigo": 2304251,
    "nome": "Cruz",
    "uf": "CE"
  },
  {
    "codigo": 2304269,
    "nome": "Deputado Irapuan Pinheiro",
    "uf": "CE"
  },
  {
    "codigo": 2304277,
    "nome": "Ereré",
    "uf": "CE"
  },
  {
    "codigo": 2304285,
    "nome": "Eusébio",
    "uf": "CE"
  },
  {
    "codigo": 2304301,
    "nome": "Farias Brito",
    "uf": "CE"
  },
  {
    "codigo": 2304350,
    "nome": "Forquilha",
    "uf": "CE"
  },
  {
    "codigo": 2304400,
    "nome": "Fortaleza",
    "uf": "CE"
  },
  {
    "codigo": 2304459,
    "nome": "Fortim",
    "uf": "CE"
  },
  {
    "codigo": 2304509,
    "nome": "Frecheirinha",
    "uf": "CE"
  },
  {
    "codigo": 2304608,
    "nome": "General Sampaio",
    "uf": "CE"
  },
  {
    "codigo": 2304657,
    "nome": "Graça",
    "uf": "CE"
  },
  {
    "codigo": 2304707,
    "nome": "Granja",
    "uf": "CE"
  },
  {
    "codigo": 2304806,
    "nome": "Granjeiro",
    "uf": "CE"
  },
  {
    "codigo": 2304905,
    "nome": "Groaíras",
    "uf": "CE"
  },
  {
    "codigo": 2304954,
    "nome": "Guaiúba",
    "uf": "CE"
  },
  {
    "codigo": 2305001,
    "nome": "Guaraciaba do Norte",
    "uf": "CE"
  },
  {
    "codigo": 2305100,
    "nome": "Guaramiranga",
    "uf": "CE"
  },
  {
    "codigo": 2305209,
    "nome": "Hidrolândia",
    "uf": "CE"
  },
  {
    "codigo": 2305233,
    "nome": "Horizonte",
    "uf": "CE"
  },
  {
    "codigo": 2305266,
    "nome": "Ibaretama",
    "uf": "CE"
  },
  {
    "codigo": 2305308,
    "nome": "Ibiapina",
    "uf": "CE"
  },
  {
    "codigo": 2305332,
    "nome": "Ibicuitinga",
    "uf": "CE"
  },
  {
    "codigo": 2305357,
    "nome": "Icapuí",
    "uf": "CE"
  },
  {
    "codigo": 2305407,
    "nome": "Icó",
    "uf": "CE"
  },
  {
    "codigo": 2305506,
    "nome": "Iguatu",
    "uf": "CE"
  },
  {
    "codigo": 2305605,
    "nome": "Independência",
    "uf": "CE"
  },
  {
    "codigo": 2305654,
    "nome": "Ipaporanga",
    "uf": "CE"
  },
  {
    "codigo": 2305704,
    "nome": "Ipaumirim",
    "uf": "CE"
  },
  {
    "codigo": 2305803,
    "nome": "Ipu",
    "uf": "CE"
  },
  {
    "codigo": 2305902,
    "nome": "Ipueiras",
    "uf": "CE"
  },
  {
    "codigo": 2306009,
    "nome": "Iracema",
    "uf": "CE"
  },
  {
    "codigo": 2306108,
    "nome": "Irauçuba",
    "uf": "CE"
  },
  {
    "codigo": 2306207,
    "nome": "Itaiçaba",
    "uf": "CE"
  },
  {
    "codigo": 2306256,
    "nome": "Itaitinga",
    "uf": "CE"
  },
  {
    "codigo": 2306306,
    "nome": "Itapajé",
    "uf": "CE"
  },
  {
    "codigo": 2306405,
    "nome": "Itapipoca",
    "uf": "CE"
  },
  {
    "codigo": 2306504,
    "nome": "Itapiúna",
    "uf": "CE"
  },
  {
    "codigo": 2306553,
    "nome": "Itarema",
    "uf": "CE"
  },
  {
    "codigo": 2306603,
    "nome": "Itatira",
    "uf": "CE"
  },
  {
    "codigo": 2306702,
    "nome": "Jaguaretama",
    "uf": "CE"
  },
  {
    "codigo": 2306801,
    "nome": "Jaguaribara",
    "uf": "CE"
  },
  {
    "codigo": 2306900,
    "nome": "Jaguaribe",
    "uf": "CE"
  },
  {
    "codigo": 2307007,
    "nome": "Jaguaruana",
    "uf": "CE"
  },
  {
    "codigo": 2307106,
    "nome": "Jardim",
    "uf": "CE"
  },
  {
    "codigo": 2307205,
    "nome": "Jati",
    "uf": "CE"
  },
  {
    "codigo": 2307254,
    "nome": "Jijoca de Jericoacoara",
    "uf": "CE"
  },
  {
    "codigo": 2307304,
    "nome": "Juazeiro do Norte",
    "uf": "CE"
  },
  {
    "codigo": 2307403,
    "nome": "Jucás",
    "uf": "CE"
  },
  {
    "codigo": 2307502,
    "nome": "Lavras da Mangabeira",
    "uf": "CE"
  },
  {
    "codigo": 2307601,
    "nome": "Limoeiro do Norte",
    "uf": "CE"
  },
  {
    "codigo": 2307635,
    "nome": "Madalena",
    "uf": "CE"
  },
  {
    "codigo": 2307650,
    "nome": "Maracanaú",
    "uf": "CE"
  },
  {
    "codigo": 2307700,
    "nome": "Maranguape",
    "uf": "CE"
  },
  {
    "codigo": 2307809,
    "nome": "Marco",
    "uf": "CE"
  },
  {
    "codigo": 2307908,
    "nome": "Martinópole",
    "uf": "CE"
  },
  {
    "codigo": 2308005,
    "nome": "Massapê",
    "uf": "CE"
  },
  {
    "codigo": 2308104,
    "nome": "Mauriti",
    "uf": "CE"
  },
  {
    "codigo": 2308203,
    "nome": "Meruoca",
    "uf": "CE"
  },
  {
    "codigo": 2308302,
    "nome": "Milagres",
    "uf": "CE"
  },
  {
    "codigo": 2308351,
    "nome": "Milhã",
    "uf": "CE"
  },
  {
    "codigo": 2308377,
    "nome": "Miraíma",
    "uf": "CE"
  },
  {
    "codigo": 2308401,
    "nome": "Missão Velha",
    "uf": "CE"
  },
  {
    "codigo": 2308500,
    "nome": "Mombaça",
    "uf": "CE"
  },
  {
    "codigo": 2308609,
    "nome": "Monsenhor Tabosa",
    "uf": "CE"
  },
  {
    "codigo": 2308708,
    "nome": "Morada Nova",
    "uf": "CE"
  },
  {
    "codigo": 2308807,
    "nome": "Moraújo",
    "uf": "CE"
  },
  {
    "codigo": 2308906,
    "nome": "Morrinhos",
    "uf": "CE"
  },
  {
    "codigo": 2309003,
    "nome": "Mucambo",
    "uf": "CE"
  },
  {
    "codigo": 2309102,
    "nome": "Mulungu",
    "uf": "CE"
  },
  {
    "codigo": 2309201,
    "nome": "Nova Olinda",
    "uf": "CE"
  },
  {
    "codigo": 2309300,
    "nome": "Nova Russas",
    "uf": "CE"
  },
  {
    "codigo": 2309409,
    "nome": "Novo Oriente",
    "uf": "CE"
  },
  {
    "codigo": 2309458,
    "nome": "Ocara",
    "uf": "CE"
  },
  {
    "codigo": 2309508,
    "nome": "Orós",
    "uf": "CE"
  },
  {
    "codigo": 2309607,
    "nome": "Pacajus",
    "uf": "CE"
  },
  {
    "codigo": 2309706,
    "nome": "Pacatuba",
    "uf": "CE"
  },
  {
    "codigo": 2309805,
    "nome": "Pacoti",
    "uf": "CE"
  },
  {
    "codigo": 2309904,
    "nome": "Pacujá",
    "uf": "CE"
  },
  {
    "codigo": 2310001,
    "nome": "Palhano",
    "uf": "CE"
  },
  {
    "codigo": 2310100,
    "nome": "Palmácia",
    "uf": "CE"
  },
  {
    "codigo": 2310209,
    "nome": "Paracuru",
    "uf": "CE"
  },
  {
    "codigo": 2310258,
    "nome": "Paraipaba",
    "uf": "CE"
  },
  {
    "codigo": 2310308,
    "nome": "Parambu",
    "uf": "CE"
  },
  {
    "codigo": 2310407,
    "nome": "Paramoti",
    "uf": "CE"
  },
  {
    "codigo": 2310506,
    "nome": "Pedra Branca",
    "uf": "CE"
  },
  {
    "codigo": 2310605,
    "nome": "Penaforte",
    "uf": "CE"
  },
  {
    "codigo": 2310704,
    "nome": "Pentecoste",
    "uf": "CE"
  },
  {
    "codigo": 2310803,
    "nome": "Pereiro",
    "uf": "CE"
  },
  {
    "codigo": 2310852,
    "nome": "Pindoretama",
    "uf": "CE"
  },
  {
    "codigo": 2310902,
    "nome": "Piquet Carneiro",
    "uf": "CE"
  },
  {
    "codigo": 2310951,
    "nome": "Pires Ferreira",
    "uf": "CE"
  },
  {
    "codigo": 2311009,
    "nome": "Poranga",
    "uf": "CE"
  },
  {
    "codigo": 2311108,
    "nome": "Porteiras",
    "uf": "CE"
  },
  {
    "codigo": 2311207,
    "nome": "Potengi",
    "uf": "CE"
  },
  {
    "codigo": 2311231,
    "nome": "Potiretama",
    "uf": "CE"
  },
  {
    "codigo": 2311264,
    "nome": "Quiterianópolis",
    "uf": "CE"
  },
  {
    "codigo": 2311306,
    "nome": "Quixadá",
    "uf": "CE"
  },
  {
    "codigo": 2311355,
    "nome": "Quixelô",
    "uf": "CE"
  },
  {
    "codigo": 2311405,
    "nome": "Quixeramobim",
    "uf": "CE"
  },
  {
    "codigo": 2311504,
    "nome": "Quixeré",
    "uf": "CE"
  },
  {
    "codigo": 2311603,
    "nome": "Redenção",
    "uf": "CE"
  },
  {
    "codigo": 2311702,
    "nome": "Reriutaba",
    "uf": "CE"
  },
  {
    "codigo": 2311801,
    "nome": "Russas",
    "uf": "CE"
  },
  {
    "codigo": 2311900,
    "nome": "Saboeiro",
    "uf": "CE"
  },
  {
    "codigo": 2311959,
    "nome": "Salitre",
    "uf": "CE"
  },
  {
    "codigo": 2312007,
    "nome": "Santana do Acaraú",
    "uf": "CE"
  },
  {
    "codigo": 2312106,
    "nome": "Santana do Cariri",
    "uf": "CE"
  },
  {
    "codigo": 2312205,
    "nome": "Santa Quitéria",
    "uf": "CE"
  },
  {
    "codigo": 2312304,
    "nome": "São Benedito",
    "uf": "CE"
  },
  {
    "codigo": 2312403,
    "nome": "São Gonçalo do Amarante",
    "uf": "CE"
  },
  {
    "codigo": 2312502,
    "nome": "São João do Jaguaribe",
    "uf": "CE"
  },
  {
    "codigo": 2312601,
    "nome": "São Luís do Curu",
    "uf": "CE"
  },
  {
    "codigo": 2312700,
    "nome": "Senador Pompeu",
    "uf": "CE"
  },
  {
    "codigo": 2312809,
    "nome": "Senador Sá",
    "uf": "CE"
  },
  {
    "codigo": 2312908,
    "nome": "Sobral",
    "uf": "CE"
  },
  {
    "codigo": 2313005,
    "nome": "Solonópole",
    "uf": "CE"
  },
  {
    "codigo": 2313104,
    "nome": "Tabuleiro do Norte",
    "uf": "CE"
  },
  {
    "codigo": 2313203,
    "nome": "Tamboril",
    "uf": "CE"
  },
  {
    "codigo": 2313252,
    "nome": "Tarrafas",
    "uf": "CE"
  },
  {
    "codigo": 2313302,
    "nome": "Tauá",
    "uf": "CE"
  },
  {
    "codigo": 2313351,
    "nome": "Tejuçuoca",
    "uf": "CE"
  },
  {
    "codigo": 2313401,
    "nome": "Tianguá",
    "uf": "CE"
  },
  {
    "codigo": 2313500,
    "nome": "Trairi",
    "uf": "CE"
  },
  {
    "codigo": 2313559,
    "nome": "Tururu",
    "uf": "CE"
  },
  {
    "codigo": 2313609,
    "nome": "Ubajara",
    "uf": "CE"
  },
  {
    "codigo": 2313708,
    "nome": "Umari",
    "uf": "CE"
  },
  {
    "codigo": 2313757,
    "nome": "Umirim",
    "uf": "CE"
  },
  {
    "codigo": 2313807,
    "nome": "Uruburetama",
    "uf": "CE"
  },
  {
    "codigo": 2313906,
    "nome": "Uruoca",
    "uf": "CE"
  },
  {
    "codigo": 2313955,
    "nome": "Varjota",
    "uf": "CE"
  },
  {
    "codigo": 2314003,
    "nome": "Várzea Alegre",
    "uf": "CE"
  },
  {
    "codigo": 2314102,
    "nome": "Viçosa do Ceará",
    "uf": "CE"
  },
  {
    "codigo": 2400109,
    "nome": "Acari",
    "uf": "RN"
  },
  {
    "codigo": 2400208,
    "nome": "Assú",
    "uf": "RN"
  },
  {
    "codigo": 2400307,
    "nome": "Afonso Bezerra",
    "uf": "RN"
  },
  {
    "codigo": 2400406,
    "nome": "Água Nova",
    "uf": "RN"
  },
  {
    "codigo": 2400505,
    "nome": "Alexandria",
    "uf": "RN"
  },
  {
    "codigo": 2400604,
    "nome": "Almino Afonso",
    "uf": "RN"
  },
  {
    "codigo": 2400703,
    "nome": "Alto do Rodrigues",
    "uf": "RN"
  },
  {
    "codigo": 2400802,
    "nome": "Angicos",
    "uf": "RN"
  },
  {
    "codigo": 2400901,
    "nome": "Antônio Martins",
    "uf": "RN"
  },
  {
    "codigo": 2401008,
    "nome": "Apodi",
    "uf": "RN"
  },
  {
    "codigo": 2401107,
    "nome": "Areia Branca",
    "uf": "RN"
  },
  {
    "codigo": 2401206,
    "nome": "Arez",
    "uf": "RN"
  },
  {
    "codigo": 2401305,
    "nome": "Campo Grande",
    "uf": "RN"
  },
  {
    "codigo": 2401404,
    "nome": "Baía Formosa",
    "uf": "RN"
  },
  {
    "codigo": 2401453,
    "nome": "Baraúna",
    "uf": "RN"
  },
  {
    "codigo": 2401503,
    "nome": "Barcelona",
    "uf": "RN"
  },
  {
    "codigo": 2401602,
    "nome": "Bento Fernandes",
    "uf": "RN"
  },
  {
    "codigo": 2401651,
    "nome": "Bodó",
    "uf": "RN"
  },
  {
    "codigo": 2401701,
    "nome": "Bom Jesus",
    "uf": "RN"
  },
  {
    "codigo": 2401800,
    "nome": "Brejinho",
    "uf": "RN"
  },
  {
    "codigo": 2401859,
    "nome": "Caiçara do Norte",
    "uf": "RN"
  },
  {
    "codigo": 2401909,
    "nome": "Caiçara do Rio do Vento",
    "uf": "RN"
  },
  {
    "codigo": 2402006,
    "nome": "Caicó",
    "uf": "RN"
  },
  {
    "codigo": 2402105,
    "nome": "Campo Redondo",
    "uf": "RN"
  },
  {
    "codigo": 2402204,
    "nome": "Canguaretama",
    "uf": "RN"
  },
  {
    "codigo": 2402303,
    "nome": "Caraúbas",
    "uf": "RN"
  },
  {
    "codigo": 2402402,
    "nome": "Carnaúba dos Dantas",
    "uf": "RN"
  },
  {
    "codigo": 2402501,
    "nome": "Carnaubais",
    "uf": "RN"
  },
  {
    "codigo": 2402600,
    "nome": "Ceará-Mirim",
    "uf": "RN"
  },
  {
    "codigo": 2402709,
    "nome": "Cerro Corá",
    "uf": "RN"
  },
  {
    "codigo": 2402808,
    "nome": "Coronel Ezequiel",
    "uf": "RN"
  },
  {
    "codigo": 2402907,
    "nome": "Coronel João Pessoa",
    "uf": "RN"
  },
  {
    "codigo": 2403004,
    "nome": "Cruzeta",
    "uf": "RN"
  },
  {
    "codigo": 2403103,
    "nome": "Currais Novos",
    "uf": "RN"
  },
  {
    "codigo": 2403202,
    "nome": "Doutor Severiano",
    "uf": "RN"
  },
  {
    "codigo": 2403251,
    "nome": "Parnamirim",
    "uf": "RN"
  },
  {
    "codigo": 2403301,
    "nome": "Encanto",
    "uf": "RN"
  },
  {
    "codigo": 2403400,
    "nome": "Equador",
    "uf": "RN"
  },
  {
    "codigo": 2403509,
    "nome": "Espírito Santo",
    "uf": "RN"
  },
  {
    "codigo": 2403608,
    "nome": "Extremoz",
    "uf": "RN"
  },
  {
    "codigo": 2403707,
    "nome": "Felipe Guerra",
    "uf": "RN"
  },
  {
    "codigo": 2403756,
    "nome": "Fernando Pedroza",
    "uf": "RN"
  },
  {
    "codigo": 2403806,
    "nome": "Florânia",
    "uf": "RN"
  },
  {
    "codigo": 2403905,
    "nome": "Francisco Dantas",
    "uf": "RN"
  },
  {
    "codigo": 2404002,
    "nome": "Frutuoso Gomes",
    "uf": "RN"
  },
  {
    "codigo": 2404101,
    "nome": "Galinhos",
    "uf": "RN"
  },
  {
    "codigo": 2404200,
    "nome": "Goianinha",
    "uf": "RN"
  },
  {
    "codigo": 2404309,
    "nome": "Governador Dix-Sept Rosado",
    "uf": "RN"
  },
  {
    "codigo": 2404408,
    "nome": "Grossos",
    "uf": "RN"
  },
  {
    "codigo": 2404507,
    "nome": "Guamaré",
    "uf": "RN"
  },
  {
    "codigo": 2404606,
    "nome": "Ielmo Marinho",
    "uf": "RN"
  },
  {
    "codigo": 2404705,
    "nome": "Ipanguaçu",
    "uf": "RN"
  },
  {
    "codigo": 2404804,
    "nome": "Ipueira",
    "uf": "RN"
  },
  {
    "codigo": 2404853,
    "nome": "Itajá",
    "uf": "RN"
  },
  {
    "codigo": 2404903,
    "nome": "Itaú",
    "uf": "RN"
  },
  {
    "codigo": 2405009,
    "nome": "Jaçanã",
    "uf": "RN"
  },
  {
    "codigo": 2405108,
    "nome": "Jandaíra",
    "uf": "RN"
  },
  {
    "codigo": 2405207,
    "nome": "Janduís",
    "uf": "RN"
  },
  {
    "codigo": 2405306,
    "nome": "Januário Cicco",
    "uf": "RN"
  },
  {
    "codigo": 2405405,
    "nome": "Japi",
    "uf": "RN"
  },
  {
    "codigo": 2405504,
    "nome": "Jardim de Angicos",
    "uf": "RN"
  },
  {
    "codigo": 2405603,
    "nome": "Jardim de Piranhas",
    "uf": "RN"
  },
  {
    "codigo": 2405702,
    "nome": "Jardim do Seridó",
    "uf": "RN"
  },
  {
    "codigo": 2405801,
    "nome": "João Câmara",
    "uf": "RN"
  },
  {
    "codigo": 2405900,
    "nome": "João Dias",
    "uf": "RN"
  },
  {
    "codigo": 2406007,
    "nome": "José da Penha",
    "uf": "RN"
  },
  {
    "codigo": 2406106,
    "nome": "Jucurutu",
    "uf": "RN"
  },
  {
    "codigo": 2406155,
    "nome": "Jundiá",
    "uf": "RN"
  },
  {
    "codigo": 2406205,
    "nome": "Lagoa d'Anta",
    "uf": "RN"
  },
  {
    "codigo": 2406304,
    "nome": "Lagoa de Pedras",
    "uf": "RN"
  },
  {
    "codigo": 2406403,
    "nome": "Lagoa de Velhos",
    "uf": "RN"
  },
  {
    "codigo": 2406502,
    "nome": "Lagoa Nova",
    "uf": "RN"
  },
  {
    "codigo": 2406601,
    "nome": "Lagoa Salgada",
    "uf": "RN"
  },
  {
    "codigo": 2406700,
    "nome": "Lajes",
    "uf": "RN"
  },
  {
    "codigo": 2406809,
    "nome": "Lajes Pintadas",
    "uf": "RN"
  },
  {
    "codigo": 2406908,
    "nome": "Lucrécia",
    "uf": "RN"
  },
  {
    "codigo": 2407005,
    "nome": "Luís Gomes",
    "uf": "RN"
  },
  {
    "codigo": 2407104,
    "nome": "Macaíba",
    "uf": "RN"
  },
  {
    "codigo": 2407203,
    "nome": "Macau",
    "uf": "RN"
  },
  {
    "codigo": 2407252,
    "nome": "Major Sales",
    "uf": "RN"
  },
  {
    "codigo": 2407302,
    "nome": "Marcelino Vieira",
    "uf": "RN"
  },
  {
    "codigo": 2407401,
    "nome": "Martins",
    "uf": "RN"
  },
  {
    "codigo": 2407500,
    "nome": "Maxaranguape",
    "uf": "RN"
  },
  {
    "codigo": 2407609,
    "nome": "Messias Targino",
    "uf": "RN"
  },
  {
    "codigo": 2407708,
    "nome": "Montanhas",
    "uf": "RN"
  },
  {
    "codigo": 2407807,
    "nome": "Monte Alegre",
    "uf": "RN"
  },
  {
    "codigo": 2407906,
    "nome": "Monte das Gameleiras",
    "uf": "RN"
  },
  {
    "codigo": 2408003,
    "nome": "Mossoró",
    "uf": "RN"
  },
  {
    "codigo": 2408102,
    "nome": "Natal",
    "uf": "RN"
  },
  {
    "codigo": 2408201,
    "nome": "Nísia Floresta",
    "uf": "RN"
  },
  {
    "codigo": 2408300,
    "nome": "Nova Cruz",
    "uf": "RN"
  },
  {
    "codigo": 2408409,
    "nome": "Olho d'Água do Borges",
    "uf": "RN"
  },
  {
    "codigo": 2408508,
    "nome": "Ouro Branco",
    "uf": "RN"
  },
  {
    "codigo": 2408607,
    "nome": "Paraná",
    "uf": "RN"
  },
  {
    "codigo": 2408706,
    "nome": "Paraú",
    "uf": "RN"
  },
  {
    "codigo": 2408805,
    "nome": "Parazinho",
    "uf": "RN"
  },
  {
    "codigo": 2408904,
    "nome": "Parelhas",
    "uf": "RN"
  },
  {
    "codigo": 2408953,
    "nome": "Rio do Fogo",
    "uf": "RN"
  },
  {
    "codigo": 2409100,
    "nome": "Passa e Fica",
    "uf": "RN"
  },
  {
    "codigo": 2409209,
    "nome": "Passagem",
    "uf": "RN"
  },
  {
    "codigo": 2409308,
    "nome": "Patu",
    "uf": "RN"
  },
  {
    "codigo": 2409332,
    "nome": "Santa Maria",
    "uf": "RN"
  },
  {
    "codigo": 2409407,
    "nome": "Pau dos Ferros",
    "uf": "RN"
  },
  {
    "codigo": 2409506,
    "nome": "Pedra Grande",
    "uf": "RN"
  },
  {
    "codigo": 2409605,
    "nome": "Pedra Preta",
    "uf": "RN"
  },
  {
    "codigo": 2409704,
    "nome": "Pedro Avelino",
    "uf": "RN"
  },
  {
    "codigo": 2409803,
    "nome": "Pedro Velho",
    "uf": "RN"
  },
  {
    "codigo": 2409902,
    "nome": "Pendências",
    "uf": "RN"
  },
  {
    "codigo": 2410009,
    "nome": "Pilões",
    "uf": "RN"
  },
  {
    "codigo": 2410108,
    "nome": "Poço Branco",
    "uf": "RN"
  },
  {
    "codigo": 2410207,
    "nome": "Portalegre",
    "uf": "RN"
  },
  {
    "codigo": 2410256,
    "nome": "Porto do Mangue",
    "uf": "RN"
  },
  {
    "codigo": 2410306,
    "nome": "Serra Caiada",
    "uf": "RN"
  },
  {
    "codigo": 2410405,
    "nome": "Pureza",
    "uf": "RN"
  },
  {
    "codigo": 2410504,
    "nome": "Rafael Fernandes",
    "uf": "RN"
  },
  {
    "codigo": 2410603,
    "nome": "Rafael Godeiro",
    "uf": "RN"
  },
  {
    "codigo": 2410702,
    "nome": "Riacho da Cruz",
    "uf": "RN"
  },
  {
    "codigo": 2410801,
    "nome": "Riacho de Santana",
    "uf": "RN"
  },
  {
    "codigo": 2410900,
    "nome": "Riachuelo",
    "uf": "RN"
  },
  {
    "codigo": 2411007,
    "nome": "Rodolfo Fernandes",
    "uf": "RN"
  },
  {
    "codigo": 2411056,
    "nome": "Tibau",
    "uf": "RN"
  },
  {
    "codigo": 2411106,
    "nome": "Ruy Barbosa",
    "uf": "RN"
  },
  {
    "codigo": 2411205,
    "nome": "Santa Cruz",
    "uf": "RN"
  },
  {
    "codigo": 2411403,
    "nome": "Santana do Matos",
    "uf": "RN"
  },
  {
    "codigo": 2411429,
    "nome": "Santana do Seridó",
    "uf": "RN"
  },
  {
    "codigo": 2411502,
    "nome": "Santo Antônio",
    "uf": "RN"
  },
  {
    "codigo": 2411601,
    "nome": "São Bento do Norte",
    "uf": "RN"
  },
  {
    "codigo": 2411700,
    "nome": "São Bento do Trairí",
    "uf": "RN"
  },
  {
    "codigo": 2411809,
    "nome": "São Fernando",
    "uf": "RN"
  },
  {
    "codigo": 2411908,
    "nome": "São Francisco do Oeste",
    "uf": "RN"
  },
  {
    "codigo": 2412005,
    "nome": "São Gonçalo do Amarante",
    "uf": "RN"
  },
  {
    "codigo": 2412104,
    "nome": "São João do Sabugi",
    "uf": "RN"
  },
  {
    "codigo": 2412203,
    "nome": "São José de Mipibu",
    "uf": "RN"
  },
  {
    "codigo": 2412302,
    "nome": "São José do Campestre",
    "uf": "RN"
  },
  {
    "codigo": 2412401,
    "nome": "São José do Seridó",
    "uf": "RN"
  },
  {
    "codigo": 2412500,
    "nome": "São Miguel",
    "uf": "RN"
  },
  {
    "codigo": 2412559,
    "nome": "São Miguel do Gostoso",
    "uf": "RN"
  },
  {
    "codigo": 2412609,
    "nome": "São Paulo do Potengi",
    "uf": "RN"
  },
  {
    "codigo": 2412708,
    "nome": "São Pedro",
    "uf": "RN"
  },
  {
    "codigo": 2412807,
    "nome": "São Rafael",
    "uf": "RN"
  },
  {
    "codigo": 2412906,
    "nome": "São Tomé",
    "uf": "RN"
  },
  {
    "codigo": 2413003,
    "nome": "São Vicente",
    "uf": "RN"
  },
  {
    "codigo": 2413102,
    "nome": "Senador Elói de Souza",
    "uf": "RN"
  },
  {
    "codigo": 2413201,
    "nome": "Senador Georgino Avelino",
    "uf": "RN"
  },
  {
    "codigo": 2413300,
    "nome": "Serra de São Bento",
    "uf": "RN"
  },
  {
    "codigo": 2413359,
    "nome": "Serra do Mel",
    "uf": "RN"
  },
  {
    "codigo": 2413409,
    "nome": "Serra Negra do Norte",
    "uf": "RN"
  },
  {
    "codigo": 2413508,
    "nome": "Serrinha",
    "uf": "RN"
  },
  {
    "codigo": 2413557,
    "nome": "Serrinha dos Pintos",
    "uf": "RN"
  },
  {
    "codigo": 2413607,
    "nome": "Severiano Melo",
    "uf": "RN"
  },
  {
    "codigo": 2413706,
    "nome": "Sítio Novo",
    "uf": "RN"
  },
  {
    "codigo": 2413805,
    "nome": "Taboleiro Grande",
    "uf": "RN"
  },
  {
    "codigo": 2413904,
    "nome": "Taipu",
    "uf": "RN"
  },
  {
    "codigo": 2414001,
    "nome": "Tangará",
    "uf": "RN"
  },
  {
    "codigo": 2414100,
    "nome": "Tenente Ananias",
    "uf": "RN"
  },
  {
    "codigo": 2414159,
    "nome": "Tenente Laurentino Cruz",
    "uf": "RN"
  },
  {
    "codigo": 2414209,
    "nome": "Tibau do Sul",
    "uf": "RN"
  },
  {
    "codigo": 2414308,
    "nome": "Timbaúba dos Batistas",
    "uf": "RN"
  },
  {
    "codigo": 2414407,
    "nome": "Touros",
    "uf": "RN"
  },
  {
    "codigo": 2414456,
    "nome": "Triunfo Potiguar",
    "uf": "RN"
  },
  {
    "codigo": 2414506,
    "nome": "Umarizal",
    "uf": "RN"
  },
  {
    "codigo": 2414605,
    "nome": "Upanema",
    "uf": "RN"
  },
  {
    "codigo": 2414704,
    "nome": "Várzea",
    "uf": "RN"
  },
  {
    "codigo": 2414753,
    "nome": "Venha-Ver",
    "uf": "RN"
  },
  {
    "codigo": 2414803,
    "nome": "Vera Cruz",
    "uf": "RN"
  },
  {
    "codigo": 2414902,
    "nome": "Viçosa",
    "uf": "RN"
  },
  {
    "codigo": 2415008,
    "nome": "Vila Flor",
    "uf": "RN"
  },
  {
    "codigo": 2500106,
    "nome": "Água Branca",
    "uf": "PB"
  },
  {
    "codigo": 2500205,
    "nome": "Aguiar",
    "uf": "PB"
  },
  {
    "codigo": 2500304,
    "nome": "Alagoa Grande",
    "uf": "PB"
  },
  {
    "codigo": 2500403,
    "nome": "Alagoa Nova",
    "uf": "PB"
  },
  {
    "codigo": 2500502,
    "nome": "Alagoinha",
    "uf": "PB"
  },
  {
    "codigo": 2500536,
    "nome": "Alcantil",
    "uf": "PB"
  },
  {
    "codigo": 2500577,
    "nome": "Algodão de Jandaíra",
    "uf": "PB"
  },
  {
    "codigo": 2500601,
    "nome": "Alhandra",
    "uf": "PB"
  },
  {
    "codigo": 2500700,
    "nome": "São João do Rio do Peixe",
    "uf": "PB"
  },
  {
    "codigo": 2500734,
    "nome": "Amparo",
    "uf": "PB"
  },
  {
    "codigo": 2500775,
    "nome": "Aparecida",
    "uf": "PB"
  },
  {
    "codigo": 2500809,
    "nome": "Araçagi",
    "uf": "PB"
  },
  {
    "codigo": 2500908,
    "nome": "Arara",
    "uf": "PB"
  },
  {
    "codigo": 2501005,
    "nome": "Araruna",
    "uf": "PB"
  },
  {
    "codigo": 2501104,
    "nome": "Areia",
    "uf": "PB"
  },
  {
    "codigo": 2501153,
    "nome": "Areia de Baraúnas",
    "uf": "PB"
  },
  {
    "codigo": 2501203,
    "nome": "Areial",
    "uf": "PB"
  },
  {
    "codigo": 2501302,
    "nome": "Aroeiras",
    "uf": "PB"
  },
  {
    "codigo": 2501351,
    "nome": "Assunção",
    "uf": "PB"
  },
  {
    "codigo": 2501401,
    "nome": "Baía da Traição",
    "uf": "PB"
  },
  {
    "codigo": 2501500,
    "nome": "Bananeiras",
    "uf": "PB"
  },
  {
    "codigo": 2501534,
    "nome": "Baraúna",
    "uf": "PB"
  },
  {
    "codigo": 2501575,
    "nome": "Barra de Santana",
    "uf": "PB"
  },
  {
    "codigo": 2501609,
    "nome": "Barra de Santa Rosa",
    "uf": "PB"
  },
  {
    "codigo": 2501708,
    "nome": "Barra de São Miguel",
    "uf": "PB"
  },
  {
    "codigo": 2501807,
    "nome": "Bayeux",
    "uf": "PB"
  },
  {
    "codigo": 2501906,
    "nome": "Belém",
    "uf": "PB"
  },
  {
    "codigo": 2502003,
    "nome": "Belém do Brejo do Cruz",
    "uf": "PB"
  },
  {
    "codigo": 2502052,
    "nome": "Bernardino Batista",
    "uf": "PB"
  },
  {
    "codigo": 2502102,
    "nome": "Boa Ventura",
    "uf": "PB"
  },
  {
    "codigo": 2502151,
    "nome": "Boa Vista",
    "uf": "PB"
  },
  {
    "codigo": 2502201,
    "nome": "Bom Jesus",
    "uf": "PB"
  },
  {
    "codigo": 2502300,
    "nome": "Bom Sucesso",
    "uf": "PB"
  },
  {
    "codigo": 2502409,
    "nome": "Bonito de Santa Fé",
    "uf": "PB"
  },
  {
    "codigo": 2502508,
    "nome": "Boqueirão",
    "uf": "PB"
  },
  {
    "codigo": 2502607,
    "nome": "Igaracy",
    "uf": "PB"
  },
  {
    "codigo": 2502706,
    "nome": "Borborema",
    "uf": "PB"
  },
  {
    "codigo": 2502805,
    "nome": "Brejo do Cruz",
    "uf": "PB"
  },
  {
    "codigo": 2502904,
    "nome": "Brejo dos Santos",
    "uf": "PB"
  },
  {
    "codigo": 2503001,
    "nome": "Caaporã",
    "uf": "PB"
  },
  {
    "codigo": 2503100,
    "nome": "Cabaceiras",
    "uf": "PB"
  },
  {
    "codigo": 2503209,
    "nome": "Cabedelo",
    "uf": "PB"
  },
  {
    "codigo": 2503308,
    "nome": "Cachoeira dos Índios",
    "uf": "PB"
  },
  {
    "codigo": 2503407,
    "nome": "Cacimba de Areia",
    "uf": "PB"
  },
  {
    "codigo": 2503506,
    "nome": "Cacimba de Dentro",
    "uf": "PB"
  },
  {
    "codigo": 2503555,
    "nome": "Cacimbas",
    "uf": "PB"
  },
  {
    "codigo": 2503605,
    "nome": "Caiçara",
    "uf": "PB"
  },
  {
    "codigo": 2503704,
    "nome": "Cajazeiras",
    "uf": "PB"
  },
  {
    "codigo": 2503753,
    "nome": "Cajazeirinhas",
    "uf": "PB"
  },
  {
    "codigo": 2503803,
    "nome": "Caldas Brandão",
    "uf": "PB"
  },
  {
    "codigo": 2503902,
    "nome": "Camalaú",
    "uf": "PB"
  },
  {
    "codigo": 2504009,
    "nome": "Campina Grande",
    "uf": "PB"
  },
  {
    "codigo": 2504033,
    "nome": "Capim",
    "uf": "PB"
  },
  {
    "codigo": 2504074,
    "nome": "Caraúbas",
    "uf": "PB"
  },
  {
    "codigo": 2504108,
    "nome": "Carrapateira",
    "uf": "PB"
  },
  {
    "codigo": 2504157,
    "nome": "Casserengue",
    "uf": "PB"
  },
  {
    "codigo": 2504207,
    "nome": "Catingueira",
    "uf": "PB"
  },
  {
    "codigo": 2504306,
    "nome": "Catolé do Rocha",
    "uf": "PB"
  },
  {
    "codigo": 2504355,
    "nome": "Caturité",
    "uf": "PB"
  },
  {
    "codigo": 2504405,
    "nome": "Conceição",
    "uf": "PB"
  },
  {
    "codigo": 2504504,
    "nome": "Condado",
    "uf": "PB"
  },
  {
    "codigo": 2504603,
    "nome": "Conde",
    "uf": "PB"
  },
  {
    "codigo": 2504702,
    "nome": "Congo",
    "uf": "PB"
  },
  {
    "codigo": 2504801,
    "nome": "Coremas",
    "uf": "PB"
  },
  {
    "codigo": 2504850,
    "nome": "Coxixola",
    "uf": "PB"
  },
  {
    "codigo": 2504900,
    "nome": "Cruz do Espírito Santo",
    "uf": "PB"
  },
  {
    "codigo": 2505006,
    "nome": "Cubati",
    "uf": "PB"
  },
  {
    "codigo": 2505105,
    "nome": "Cuité",
    "uf": "PB"
  },
  {
    "codigo": 2505204,
    "nome": "Cuitegi",
    "uf": "PB"
  },
  {
    "codigo": 2505238,
    "nome": "Cuité de Mamanguape",
    "uf": "PB"
  },
  {
    "codigo": 2505279,
    "nome": "Curral de Cima",
    "uf": "PB"
  },
  {
    "codigo": 2505303,
    "nome": "Curral Velho",
    "uf": "PB"
  },
  {
    "codigo": 2505352,
    "nome": "Damião",
    "uf": "PB"
  },
  {
    "codigo": 2505402,
    "nome": "Desterro",
    "uf": "PB"
  },
  {
    "codigo": 2505501,
    "nome": "Vista Serrana",
    "uf": "PB"
  },
  {
    "codigo": 2505600,
    "nome": "Diamante",
    "uf": "PB"
  },
  {
    "codigo": 2505709,
    "nome": "Dona Inês",
    "uf": "PB"
  },
  {
    "codigo": 2505808,
    "nome": "Duas Estradas",
    "uf": "PB"
  },
  {
    "codigo": 2505907,
    "nome": "Emas",
    "uf": "PB"
  },
  {
    "codigo": 2506004,
    "nome": "Esperança",
    "uf": "PB"
  },
  {
    "codigo": 2506103,
    "nome": "Fagundes",
    "uf": "PB"
  },
  {
    "codigo": 2506202,
    "nome": "Frei Martinho",
    "uf": "PB"
  },
  {
    "codigo": 2506251,
    "nome": "Gado Bravo",
    "uf": "PB"
  },
  {
    "codigo": 2506301,
    "nome": "Guarabira",
    "uf": "PB"
  },
  {
    "codigo": 2506400,
    "nome": "Gurinhém",
    "uf": "PB"
  },
  {
    "codigo": 2506509,
    "nome": "Gurjão",
    "uf": "PB"
  },
  {
    "codigo": 2506608,
    "nome": "Ibiara",
    "uf": "PB"
  },
  {
    "codigo": 2506707,
    "nome": "Imaculada",
    "uf": "PB"
  },
  {
    "codigo": 2506806,
    "nome": "Ingá",
    "uf": "PB"
  },
  {
    "codigo": 2506905,
    "nome": "Itabaiana",
    "uf": "PB"
  },
  {
    "codigo": 2507002,
    "nome": "Itaporanga",
    "uf": "PB"
  },
  {
    "codigo": 2507101,
    "nome": "Itapororoca",
    "uf": "PB"
  },
  {
    "codigo": 2507200,
    "nome": "Itatuba",
    "uf": "PB"
  },
  {
    "codigo": 2507309,
    "nome": "Jacaraú",
    "uf": "PB"
  },
  {
    "codigo": 2507408,
    "nome": "Jericó",
    "uf": "PB"
  },
  {
    "codigo": 2507507,
    "nome": "João Pessoa",
    "uf": "PB"
  },
  {
    "codigo": 2507606,
    "nome": "Juarez Távora",
    "uf": "PB"
  },
  {
    "codigo": 2507705,
    "nome": "Juazeirinho",
    "uf": "PB"
  },
  {
    "codigo": 2507804,
    "nome": "Junco do Seridó",
    "uf": "PB"
  },
  {
    "codigo": 2507903,
    "nome": "Juripiranga",
    "uf": "PB"
  },
  {
    "codigo": 2508000,
    "nome": "Juru",
    "uf": "PB"
  },
  {
    "codigo": 2508109,
    "nome": "Lagoa",
    "uf": "PB"
  },
  {
    "codigo": 2508208,
    "nome": "Lagoa de Dentro",
    "uf": "PB"
  },
  {
    "codigo": 2508307,
    "nome": "Lagoa Seca",
    "uf": "PB"
  },
  {
    "codigo": 2508406,
    "nome": "Lastro",
    "uf": "PB"
  },
  {
    "codigo": 2508505,
    "nome": "Livramento",
    "uf": "PB"
  },
  {
    "codigo": 2508554,
    "nome": "Logradouro",
    "uf": "PB"
  },
  {
    "codigo": 2508604,
    "nome": "Lucena",
    "uf": "PB"
  },
  {
    "codigo": 2508703,
    "nome": "Mãe d'Água",
    "uf": "PB"
  },
  {
    "codigo": 2508802,
    "nome": "Malta",
    "uf": "PB"
  },
  {
    "codigo": 2508901,
    "nome": "Mamanguape",
    "uf": "PB"
  },
  {
    "codigo": 2509008,
    "nome": "Manaíra",
    "uf": "PB"
  },
  {
    "codigo": 2509057,
    "nome": "Marcação",
    "uf": "PB"
  },
  {
    "codigo": 2509107,
    "nome": "Mari",
    "uf": "PB"
  },
  {
    "codigo": 2509156,
    "nome": "Marizópolis",
    "uf": "PB"
  },
  {
    "codigo": 2509206,
    "nome": "Massaranduba",
    "uf": "PB"
  },
  {
    "codigo": 2509305,
    "nome": "Mataraca",
    "uf": "PB"
  },
  {
    "codigo": 2509339,
    "nome": "Matinhas",
    "uf": "PB"
  },
  {
    "codigo": 2509370,
    "nome": "Mato Grosso",
    "uf": "PB"
  },
  {
    "codigo": 2509396,
    "nome": "Maturéia",
    "uf": "PB"
  },
  {
    "codigo": 2509404,
    "nome": "Mogeiro",
    "uf": "PB"
  },
  {
    "codigo": 2509503,
    "nome": "Montadas",
    "uf": "PB"
  },
  {
    "codigo": 2509602,
    "nome": "Monte Horebe",
    "uf": "PB"
  },
  {
    "codigo": 2509701,
    "nome": "Monteiro",
    "uf": "PB"
  },
  {
    "codigo": 2509800,
    "nome": "Mulungu",
    "uf": "PB"
  },
  {
    "codigo": 2509909,
    "nome": "Natuba",
    "uf": "PB"
  },
  {
    "codigo": 2510006,
    "nome": "Nazarezinho",
    "uf": "PB"
  },
  {
    "codigo": 2510105,
    "nome": "Nova Floresta",
    "uf": "PB"
  },
  {
    "codigo": 2510204,
    "nome": "Nova Olinda",
    "uf": "PB"
  },
  {
    "codigo": 2510303,
    "nome": "Nova Palmeira",
    "uf": "PB"
  },
  {
    "codigo": 2510402,
    "nome": "Olho d'Água",
    "uf": "PB"
  },
  {
    "codigo": 2510501,
    "nome": "Olivedos",
    "uf": "PB"
  },
  {
    "codigo": 2510600,
    "nome": "Ouro Velho",
    "uf": "PB"
  },
  {
    "codigo": 2510659,
    "nome": "Parari",
    "uf": "PB"
  },
  {
    "codigo": 2510709,
    "nome": "Passagem",
    "uf": "PB"
  },
  {
    "codigo": 2510808,
    "nome": "Patos",
    "uf": "PB"
  },
  {
    "codigo": 2510907,
    "nome": "Paulista",
    "uf": "PB"
  },
  {
    "codigo": 2511004,
    "nome": "Pedra Branca",
    "uf": "PB"
  },
  {
    "codigo": 2511103,
    "nome": "Pedra Lavrada",
    "uf": "PB"
  },
  {
    "codigo": 2511202,
    "nome": "Pedras de Fogo",
    "uf": "PB"
  },
  {
    "codigo": 2511301,
    "nome": "Piancó",
    "uf": "PB"
  },
  {
    "codigo": 2511400,
    "nome": "Picuí",
    "uf": "PB"
  },
  {
    "codigo": 2511509,
    "nome": "Pilar",
    "uf": "PB"
  },
  {
    "codigo": 2511608,
    "nome": "Pilões",
    "uf": "PB"
  },
  {
    "codigo": 2511707,
    "nome": "Pilõezinhos",
    "uf": "PB"
  },
  {
    "codigo": 2511806,
    "nome": "Pirpirituba",
    "uf": "PB"
  },
  {
    "codigo": 2511905,
    "nome": "Pitimbu",
    "uf": "PB"
  },
  {
    "codigo": 2512002,
    "nome": "Pocinhos",
    "uf": "PB"
  },
  {
    "codigo": 2512036,
    "nome": "Poço Dantas",
    "uf": "PB"
  },
  {
    "codigo": 2512077,
    "nome": "Poço de José de Moura",
    "uf": "PB"
  },
  {
    "codigo": 2512101,
    "nome": "Pombal",
    "uf": "PB"
  },
  {
    "codigo": 2512200,
    "nome": "Prata",
    "uf": "PB"
  },
  {
    "codigo": 2512309,
    "nome": "Princesa Isabel",
    "uf": "PB"
  },
  {
    "codigo": 2512408,
    "nome": "Puxinanã",
    "uf": "PB"
  },
  {
    "codigo": 2512507,
    "nome": "Queimadas",
    "uf": "PB"
  },
  {
    "codigo": 2512606,
    "nome": "Quixaba",
    "uf": "PB"
  },
  {
    "codigo": 2512705,
    "nome": "Remígio",
    "uf": "PB"
  },
  {
    "codigo": 2512721,
    "nome": "Pedro Régis",
    "uf": "PB"
  },
  {
    "codigo": 2512747,
    "nome": "Riachão",
    "uf": "PB"
  },
  {
    "codigo": 2512754,
    "nome": "Riachão do Bacamarte",
    "uf": "PB"
  },
  {
    "codigo": 2512762,
    "nome": "Riachão do Poço",
    "uf": "PB"
  },
  {
    "codigo": 2512788,
    "nome": "Riacho de Santo Antônio",
    "uf": "PB"
  },
  {
    "codigo": 2512804,
    "nome": "Riacho dos Cavalos",
    "uf": "PB"
  },
  {
    "codigo": 2512903,
    "nome": "Rio Tinto",
    "uf": "PB"
  },
  {
    "codigo": 2513000,
    "nome": "Salgadinho",
    "uf": "PB"
  },
  {
    "codigo": 2513109,
    "nome": "Salgado de São Félix",
    "uf": "PB"
  },
  {
    "codigo": 2513158,
    "nome": "Santa Cecília",
    "uf": "PB"
  },
  {
    "codigo": 2513208,
    "nome": "Santa Cruz",
    "uf": "PB"
  },
  {
    "codigo": 2513307,
    "nome": "Santa Helena",
    "uf": "PB"
  },
  {
    "codigo": 2513356,
    "nome": "Santa Inês",
    "uf": "PB"
  },
  {
    "codigo": 2513406,
    "nome": "Santa Luzia",
    "uf": "PB"
  },
  {
    "codigo": 2513505,
    "nome": "Santana de Mangueira",
    "uf": "PB"
  },
  {
    "codigo": 2513604,
    "nome": "Santana dos Garrotes",
    "uf": "PB"
  },
  {
    "codigo": 2513653,
    "nome": "Joca Claudino",
    "uf": "PB"
  },
  {
    "codigo": 2513703,
    "nome": "Santa Rita",
    "uf": "PB"
  },
  {
    "codigo": 2513802,
    "nome": "Santa Teresinha",
    "uf": "PB"
  },
  {
    "codigo": 2513851,
    "nome": "Santo André",
    "uf": "PB"
  },
  {
    "codigo": 2513901,
    "nome": "São Bento",
    "uf": "PB"
  },
  {
    "codigo": 2513927,
    "nome": "São Bentinho",
    "uf": "PB"
  },
  {
    "codigo": 2513943,
    "nome": "São Domingos do Cariri",
    "uf": "PB"
  },
  {
    "codigo": 2513968,
    "nome": "São Domingos",
    "uf": "PB"
  },
  {
    "codigo": 2513984,
    "nome": "São Francisco",
    "uf": "PB"
  },
  {
    "codigo": 2514008,
    "nome": "São João do Cariri",
    "uf": "PB"
  },
  {
    "codigo": 2514107,
    "nome": "São João do Tigre",
    "uf": "PB"
  },
  {
    "codigo": 2514206,
    "nome": "São José da Lagoa Tapada",
    "uf": "PB"
  },
  {
    "codigo": 2514305,
    "nome": "São José de Caiana",
    "uf": "PB"
  },
  {
    "codigo": 2514404,
    "nome": "São José de Espinharas",
    "uf": "PB"
  },
  {
    "codigo": 2514453,
    "nome": "São José dos Ramos",
    "uf": "PB"
  },
  {
    "codigo": 2514503,
    "nome": "São José de Piranhas",
    "uf": "PB"
  },
  {
    "codigo": 2514552,
    "nome": "São José de Princesa",
    "uf": "PB"
  },
  {
    "codigo": 2514602,
    "nome": "São José do Bonfim",
    "uf": "PB"
  },
  {
    "codigo": 2514651,
    "nome": "São José do Brejo do Cruz",
    "uf": "PB"
  },
  {
    "codigo": 2514701,
    "nome": "São José do Sabugi",
    "uf": "PB"
  },
  {
    "codigo": 2514800,
    "nome": "São José dos Cordeiros",
    "uf": "PB"
  },
  {
    "codigo": 2514909,
    "nome": "São Mamede",
    "uf": "PB"
  },
  {
    "codigo": 2515005,
    "nome": "São Miguel de Taipu",
    "uf": "PB"
  },
  {
    "codigo": 2515104,
    "nome": "São Sebastião de Lagoa de Roça",
    "uf": "PB"
  },
  {
    "codigo": 2515203,
    "nome": "São Sebastião do Umbuzeiro",
    "uf": "PB"
  },
  {
    "codigo": 2515302,
    "nome": "Sapé",
    "uf": "PB"
  },
  {
    "codigo": 2515401,
    "nome": "São Vicente do Seridó",
    "uf": "PB"
  },
  {
    "codigo": 2515500,
    "nome": "Serra Branca",
    "uf": "PB"
  },
  {
    "codigo": 2515609,
    "nome": "Serra da Raiz",
    "uf": "PB"
  },
  {
    "codigo": 2515708,
    "nome": "Serra Grande",
    "uf": "PB"
  },
  {
    "codigo": 2515807,
    "nome": "Serra Redonda",
    "uf": "PB"
  },
  {
    "codigo": 2515906,
    "nome": "Serraria",
    "uf": "PB"
  },
  {
    "codigo": 2515930,
    "nome": "Sertãozinho",
    "uf": "PB"
  },
  {
    "codigo": 2515971,
    "nome": "Sobrado",
    "uf": "PB"
  },
  {
    "codigo": 2516003,
    "nome": "Solânea",
    "uf": "PB"
  },
  {
    "codigo": 2516102,
    "nome": "Soledade",
    "uf": "PB"
  },
  {
    "codigo": 2516151,
    "nome": "Sossêgo",
    "uf": "PB"
  },
  {
    "codigo": 2516201,
    "nome": "Sousa",
    "uf": "PB"
  },
  {
    "codigo": 2516300,
    "nome": "Sumé",
    "uf": "PB"
  },
  {
    "codigo": 2516409,
    "nome": "Tacima",
    "uf": "PB"
  },
  {
    "codigo": 2516508,
    "nome": "Taperoá",
    "uf": "PB"
  },
  {
    "codigo": 2516607,
    "nome": "Tavares",
    "uf": "PB"
  },
  {
    "codigo": 2516706,
    "nome": "Teixeira",
    "uf": "PB"
  },
  {
    "codigo": 2516755,
    "nome": "Tenório",
    "uf": "PB"
  },
  {
    "codigo": 2516805,
    "nome": "Triunfo",
    "uf": "PB"
  },
  {
    "codigo": 2516904,
    "nome": "Uiraúna",
    "uf": "PB"
  },
  {
    "codigo": 2517001,
    "nome": "Umbuzeiro",
    "uf": "PB"
  },
  {
    "codigo": 2517100,
    "nome": "Várzea",
    "uf": "PB"
  },
  {
    "codigo": 2517209,
    "nome": "Vieirópolis",
    "uf": "PB"
  },
  {
    "codigo": 2517407,
    "nome": "Zabelê",
    "uf": "PB"
  },
  {
    "codigo": 2600054,
    "nome": "Abreu e Lima",
    "uf": "PE"
  },
  {
    "codigo": 2600104,
    "nome": "Afogados da Ingazeira",
    "uf": "PE"
  },
  {
    "codigo": 2600203,
    "nome": "Afrânio",
    "uf": "PE"
  },
  {
    "codigo": 2600302,
    "nome": "Agrestina",
    "uf": "PE"
  },
  {
    "codigo": 2600401,
    "nome": "Água Preta",
    "uf": "PE"
  },
  {
    "codigo": 2600500,
    "nome": "Águas Belas",
    "uf": "PE"
  },
  {
    "codigo": 2600609,
    "nome": "Alagoinha",
    "uf": "PE"
  },
  {
    "codigo": 2600708,
    "nome": "Aliança",
    "uf": "PE"
  },
  {
    "codigo": 2600807,
    "nome": "Altinho",
    "uf": "PE"
  },
  {
    "codigo": 2600906,
    "nome": "Amaraji",
    "uf": "PE"
  },
  {
    "codigo": 2601003,
    "nome": "Angelim",
    "uf": "PE"
  },
  {
    "codigo": 2601052,
    "nome": "Araçoiaba",
    "uf": "PE"
  },
  {
    "codigo": 2601102,
    "nome": "Araripina",
    "uf": "PE"
  },
  {
    "codigo": 2601201,
    "nome": "Arcoverde",
    "uf": "PE"
  },
  {
    "codigo": 2601300,
    "nome": "Barra de Guabiraba",
    "uf": "PE"
  },
  {
    "codigo": 2601409,
    "nome": "Barreiros",
    "uf": "PE"
  },
  {
    "codigo": 2601508,
    "nome": "Belém de Maria",
    "uf": "PE"
  },
  {
    "codigo": 2601607,
    "nome": "Belém do São Francisco",
    "uf": "PE"
  },
  {
    "codigo": 2601706,
    "nome": "Belo Jardim",
    "uf": "PE"
  },
  {
    "codigo": 2601805,
    "nome": "Betânia",
    "uf": "PE"
  },
  {
    "codigo": 2601904,
    "nome": "Bezerros",
    "uf": "PE"
  },
  {
    "codigo": 2602001,
    "nome": "Bodocó",
    "uf": "PE"
  },
  {
    "codigo": 2602100,
    "nome": "Bom Conselho",
    "uf": "PE"
  },
  {
    "codigo": 2602209,
    "nome": "Bom Jardim",
    "uf": "PE"
  },
  {
    "codigo": 2602308,
    "nome": "Bonito",
    "uf": "PE"
  },
  {
    "codigo": 2602407,
    "nome": "Brejão",
    "uf": "PE"
  },
  {
    "codigo": 2602506,
    "nome": "Brejinho",
    "uf": "PE"
  },
  {
    "codigo": 2602605,
    "nome": "Brejo da Madre de Deus",
    "uf": "PE"
  },
  {
    "codigo": 2602704,
    "nome": "Buenos Aires",
    "uf": "PE"
  },
  {
    "codigo": 2602803,
    "nome": "Buíque",
    "uf": "PE"
  },
  {
    "codigo": 2602902,
    "nome": "Cabo de Santo Agostinho",
    "uf": "PE"
  },
  {
    "codigo": 2603009,
    "nome": "Cabrobó",
    "uf": "PE"
  },
  {
    "codigo": 2603108,
    "nome": "Cachoeirinha",
    "uf": "PE"
  },
  {
    "codigo": 2603207,
    "nome": "Caetés",
    "uf": "PE"
  },
  {
    "codigo": 2603306,
    "nome": "Calçado",
    "uf": "PE"
  },
  {
    "codigo": 2603405,
    "nome": "Calumbi",
    "uf": "PE"
  },
  {
    "codigo": 2603454,
    "nome": "Camaragibe",
    "uf": "PE"
  },
  {
    "codigo": 2603504,
    "nome": "Camocim de São Félix",
    "uf": "PE"
  },
  {
    "codigo": 2603603,
    "nome": "Camutanga",
    "uf": "PE"
  },
  {
    "codigo": 2603702,
    "nome": "Canhotinho",
    "uf": "PE"
  },
  {
    "codigo": 2603801,
    "nome": "Capoeiras",
    "uf": "PE"
  },
  {
    "codigo": 2603900,
    "nome": "Carnaíba",
    "uf": "PE"
  },
  {
    "codigo": 2603926,
    "nome": "Carnaubeira da Penha",
    "uf": "PE"
  },
  {
    "codigo": 2604007,
    "nome": "Carpina",
    "uf": "PE"
  },
  {
    "codigo": 2604106,
    "nome": "Caruaru",
    "uf": "PE"
  },
  {
    "codigo": 2604155,
    "nome": "Casinhas",
    "uf": "PE"
  },
  {
    "codigo": 2604205,
    "nome": "Catende",
    "uf": "PE"
  },
  {
    "codigo": 2604304,
    "nome": "Cedro",
    "uf": "PE"
  },
  {
    "codigo": 2604403,
    "nome": "Chã de Alegria",
    "uf": "PE"
  },
  {
    "codigo": 2604502,
    "nome": "Chã Grande",
    "uf": "PE"
  },
  {
    "codigo": 2604601,
    "nome": "Condado",
    "uf": "PE"
  },
  {
    "codigo": 2604700,
    "nome": "Correntes",
    "uf": "PE"
  },
  {
    "codigo": 2604809,
    "nome": "Cortês",
    "uf": "PE"
  },
  {
    "codigo": 2604908,
    "nome": "Cumaru",
    "uf": "PE"
  },
  {
    "codigo": 2605004,
    "nome": "Cupira",
    "uf": "PE"
  },
  {
    "codigo": 2605103,
    "nome": "Custódia",
    "uf": "PE"
  },
  {
    "codigo": 2605152,
    "nome": "Dormentes",
    "uf": "PE"
  },
  {
    "codigo": 2605202,
    "nome": "Escada",
    "uf": "PE"
  },
  {
    "codigo": 2605301,
    "nome": "Exu",
    "uf": "PE"
  },
  {
    "codigo": 2605400,
    "nome": "Feira Nova",
    "uf": "PE"
  },
  {
    "codigo": 2605459,
    "nome": "Fernando de Noronha",
    "uf": "PE"
  },
  {
    "codigo": 2605509,
    "nome": "Ferreiros",
    "uf": "PE"
  },
  {
    "codigo": 2605608,
    "nome": "Flores",
    "uf": "PE"
  },
  {
    "codigo": 2605707,
    "nome": "Floresta",
    "uf": "PE"
  },
  {
    "codigo": 2605806,
    "nome": "Frei Miguelinho",
    "uf": "PE"
  },
  {
    "codigo": 2605905,
    "nome": "Gameleira",
    "uf": "PE"
  },
  {
    "codigo": 2606002,
    "nome": "Garanhuns",
    "uf": "PE"
  },
  {
    "codigo": 2606101,
    "nome": "Glória do Goitá",
    "uf": "PE"
  },
  {
    "codigo": 2606200,
    "nome": "Goiana",
    "uf": "PE"
  },
  {
    "codigo": 2606309,
    "nome": "Granito",
    "uf": "PE"
  },
  {
    "codigo": 2606408,
    "nome": "Gravatá",
    "uf": "PE"
  },
  {
    "codigo": 2606507,
    "nome": "Iati",
    "uf": "PE"
  },
  {
    "codigo": 2606606,
    "nome": "Ibimirim",
    "uf": "PE"
  },
  {
    "codigo": 2606705,
    "nome": "Ibirajuba",
    "uf": "PE"
  },
  {
    "codigo": 2606804,
    "nome": "Igarassu",
    "uf": "PE"
  },
  {
    "codigo": 2606903,
    "nome": "Iguaracy",
    "uf": "PE"
  },
  {
    "codigo": 2607000,
    "nome": "Inajá",
    "uf": "PE"
  },
  {
    "codigo": 2607109,
    "nome": "Ingazeira",
    "uf": "PE"
  },
  {
    "codigo": 2607208,
    "nome": "Ipojuca",
    "uf": "PE"
  },
  {
    "codigo": 2607307,
    "nome": "Ipubi",
    "uf": "PE"
  },
  {
    "codigo": 2607406,
    "nome": "Itacuruba",
    "uf": "PE"
  },
  {
    "codigo": 2607505,
    "nome": "Itaíba",
    "uf": "PE"
  },
  {
    "codigo": 2607604,
    "nome": "Ilha de Itamaracá",
    "uf": "PE"
  },
  {
    "codigo": 2607653,
    "nome": "Itambé",
    "uf": "PE"
  },
  {
    "codigo": 2607703,
    "nome": "Itapetim",
    "uf": "PE"
  },
  {
    "codigo": 2607752,
    "nome": "Itapissuma",
    "uf": "PE"
  },
  {
    "codigo": 2607802,
    "nome": "Itaquitinga",
    "uf": "PE"
  },
  {
    "codigo": 2607901,
    "nome": "Jaboatão dos Guararapes",
    "uf": "PE"
  },
  {
    "codigo": 2607950,
    "nome": "Jaqueira",
    "uf": "PE"
  },
  {
    "codigo": 2608008,
    "nome": "Jataúba",
    "uf": "PE"
  },
  {
    "codigo": 2608057,
    "nome": "Jatobá",
    "uf": "PE"
  },
  {
    "codigo": 2608107,
    "nome": "João Alfredo",
    "uf": "PE"
  },
  {
    "codigo": 2608206,
    "nome": "Joaquim Nabuco",
    "uf": "PE"
  },
  {
    "codigo": 2608255,
    "nome": "Jucati",
    "uf": "PE"
  },
  {
    "codigo": 2608305,
    "nome": "Jupi",
    "uf": "PE"
  },
  {
    "codigo": 2608404,
    "nome": "Jurema",
    "uf": "PE"
  },
  {
    "codigo": 2608453,
    "nome": "Lagoa do Carro",
    "uf": "PE"
  },
  {
    "codigo": 2608503,
    "nome": "Lagoa de Itaenga",
    "uf": "PE"
  },
  {
    "codigo": 2608602,
    "nome": "Lagoa do Ouro",
    "uf": "PE"
  },
  {
    "codigo": 2608701,
    "nome": "Lagoa dos Gatos",
    "uf": "PE"
  },
  {
    "codigo": 2608750,
    "nome": "Lagoa Grande",
    "uf": "PE"
  },
  {
    "codigo": 2608800,
    "nome": "Lajedo",
    "uf": "PE"
  },
  {
    "codigo": 2608909,
    "nome": "Limoeiro",
    "uf": "PE"
  },
  {
    "codigo": 2609006,
    "nome": "Macaparana",
    "uf": "PE"
  },
  {
    "codigo": 2609105,
    "nome": "Machados",
    "uf": "PE"
  },
  {
    "codigo": 2609154,
    "nome": "Manari",
    "uf": "PE"
  },
  {
    "codigo": 2609204,
    "nome": "Maraial",
    "uf": "PE"
  },
  {
    "codigo": 2609303,
    "nome": "Mirandiba",
    "uf": "PE"
  },
  {
    "codigo": 2609402,
    "nome": "Moreno",
    "uf": "PE"
  },
  {
    "codigo": 2609501,
    "nome": "Nazaré da Mata",
    "uf": "PE"
  },
  {
    "codigo": 2609600,
    "nome": "Olinda",
    "uf": "PE"
  },
  {
    "codigo": 2609709,
    "nome": "Orobó",
    "uf": "PE"
  },
  {
    "codigo": 2609808,
    "nome": "Orocó",
    "uf": "PE"
  },
  {
    "codigo": 2609907,
    "nome": "Ouricuri",
    "uf": "PE"
  },
  {
    "codigo": 2610004,
    "nome": "Palmares",
    "uf": "PE"
  },
  {
    "codigo": 2610103,
    "nome": "Palmeirina",
    "uf": "PE"
  },
  {
    "codigo": 2610202,
    "nome": "Panelas",
    "uf": "PE"
  },
  {
    "codigo": 2610301,
    "nome": "Paranatama",
    "uf": "PE"
  },
  {
    "codigo": 2610400,
    "nome": "Parnamirim",
    "uf": "PE"
  },
  {
    "codigo": 2610509,
    "nome": "Passira",
    "uf": "PE"
  },
  {
    "codigo": 2610608,
    "nome": "Paudalho",
    "uf": "PE"
  },
  {
    "codigo": 2610707,
    "nome": "Paulista",
    "uf": "PE"
  },
  {
    "codigo": 2610806,
    "nome": "Pedra",
    "uf": "PE"
  },
  {
    "codigo": 2610905,
    "nome": "Pesqueira",
    "uf": "PE"
  },
  {
    "codigo": 2611002,
    "nome": "Petrolândia",
    "uf": "PE"
  },
  {
    "codigo": 2611101,
    "nome": "Petrolina",
    "uf": "PE"
  },
  {
    "codigo": 2611200,
    "nome": "Poção",
    "uf": "PE"
  },
  {
    "codigo": 2611309,
    "nome": "Pombos",
    "uf": "PE"
  },
  {
    "codigo": 2611408,
    "nome": "Primavera",
    "uf": "PE"
  },
  {
    "codigo": 2611507,
    "nome": "Quipapá",
    "uf": "PE"
  },
  {
    "codigo": 2611533,
    "nome": "Quixaba",
    "uf": "PE"
  },
  {
    "codigo": 2611606,
    "nome": "Recife",
    "uf": "PE"
  },
  {
    "codigo": 2611705,
    "nome": "Riacho das Almas",
    "uf": "PE"
  },
  {
    "codigo": 2611804,
    "nome": "Ribeirão",
    "uf": "PE"
  },
  {
    "codigo": 2611903,
    "nome": "Rio Formoso",
    "uf": "PE"
  },
  {
    "codigo": 2612000,
    "nome": "Sairé",
    "uf": "PE"
  },
  {
    "codigo": 2612109,
    "nome": "Salgadinho",
    "uf": "PE"
  },
  {
    "codigo": 2612208,
    "nome": "Salgueiro",
    "uf": "PE"
  },
  {
    "codigo": 2612307,
    "nome": "Saloá",
    "uf": "PE"
  },
  {
    "codigo": 2612406,
    "nome": "Sanharó",
    "uf": "PE"
  },
  {
    "codigo": 2612455,
    "nome": "Santa Cruz",
    "uf": "PE"
  },
  {
    "codigo": 2612471,
    "nome": "Santa Cruz da Baixa Verde",
    "uf": "PE"
  },
  {
    "codigo": 2612505,
    "nome": "Santa Cruz do Capibaribe",
    "uf": "PE"
  },
  {
    "codigo": 2612554,
    "nome": "Santa Filomena",
    "uf": "PE"
  },
  {
    "codigo": 2612604,
    "nome": "Santa Maria da Boa Vista",
    "uf": "PE"
  },
  {
    "codigo": 2612703,
    "nome": "Santa Maria do Cambucá",
    "uf": "PE"
  },
  {
    "codigo": 2612802,
    "nome": "Santa Terezinha",
    "uf": "PE"
  },
  {
    "codigo": 2612901,
    "nome": "São Benedito do Sul",
    "uf": "PE"
  },
  {
    "codigo": 2613008,
    "nome": "São Bento do Una",
    "uf": "PE"
  },
  {
    "codigo": 2613107,
    "nome": "São Caitano",
    "uf": "PE"
  },
  {
    "codigo": 2613206,
    "nome": "São João",
    "uf": "PE"
  },
  {
    "codigo": 2613305,
    "nome": "São Joaquim do Monte",
    "uf": "PE"
  },
  {
    "codigo": 2613404,
    "nome": "São José da Coroa Grande",
    "uf": "PE"
  },
  {
    "codigo": 2613503,
    "nome": "São José do Belmonte",
    "uf": "PE"
  },
  {
    "codigo": 2613602,
    "nome": "São José do Egito",
    "uf": "PE"
  },
  {
    "codigo": 2613701,
    "nome": "São Lourenço da Mata",
    "uf": "PE"
  },
  {
    "codigo": 2613800,
    "nome": "São Vicente Férrer",
    "uf": "PE"
  },
  {
    "codigo": 2613909,
    "nome": "Serra Talhada",
    "uf": "PE"
  },
  {
    "codigo": 2614006,
    "nome": "Serrita",
    "uf": "PE"
  },
  {
    "codigo": 2614105,
    "nome": "Sertânia",
    "uf": "PE"
  },
  {
    "codigo": 2614204,
    "nome": "Sirinhaém",
    "uf": "PE"
  },
  {
    "codigo": 2614303,
    "nome": "Moreilândia",
    "uf": "PE"
  },
  {
    "codigo": 2614402,
    "nome": "Solidão",
    "uf": "PE"
  },
  {
    "codigo": 2614501,
    "nome": "Surubim",
    "uf": "PE"
  },
  {
    "codigo": 2614600,
    "nome": "Tabira",
    "uf": "PE"
  },
  {
    "codigo": 2614709,
    "nome": "Tacaimbó",
    "uf": "PE"
  },
  {
    "codigo": 2614808,
    "nome": "Tacaratu",
    "uf": "PE"
  },
  {
    "codigo": 2614857,
    "nome": "Tamandaré",
    "uf": "PE"
  },
  {
    "codigo": 2615003,
    "nome": "Taquaritinga do Norte",
    "uf": "PE"
  },
  {
    "codigo": 2615102,
    "nome": "Terezinha",
    "uf": "PE"
  },
  {
    "codigo": 2615201,
    "nome": "Terra Nova",
    "uf": "PE"
  },
  {
    "codigo": 2615300,
    "nome": "Timbaúba",
    "uf": "PE"
  },
  {
    "codigo": 2615409,
    "nome": "Toritama",
    "uf": "PE"
  },
  {
    "codigo": 2615508,
    "nome": "Tracunhaém",
    "uf": "PE"
  },
  {
    "codigo": 2615607,
    "nome": "Trindade",
    "uf": "PE"
  },
  {
    "codigo": 2615706,
    "nome": "Triunfo",
    "uf": "PE"
  },
  {
    "codigo": 2615805,
    "nome": "Tupanatinga",
    "uf": "PE"
  },
  {
    "codigo": 2615904,
    "nome": "Tuparetama",
    "uf": "PE"
  },
  {
    "codigo": 2616001,
    "nome": "Venturosa",
    "uf": "PE"
  },
  {
    "codigo": 2616100,
    "nome": "Verdejante",
    "uf": "PE"
  },
  {
    "codigo": 2616183,
    "nome": "Vertente do Lério",
    "uf": "PE"
  },
  {
    "codigo": 2616209,
    "nome": "Vertentes",
    "uf": "PE"
  },
  {
    "codigo": 2616308,
    "nome": "Vicência",
    "uf": "PE"
  },
  {
    "codigo": 2616407,
    "nome": "Vitória de Santo Antão",
    "uf": "PE"
  },
  {
    "codigo": 2616506,
    "nome": "Xexéu",
    "uf": "PE"
  },
  {
    "codigo": 2700102,
    "nome": "Água Branca",
    "uf": "AL"
  },
  {
    "codigo": 2700201,
    "nome": "Anadia",
    "uf": "AL"
  },
  {
    "codigo": 2700300,
    "nome": "Arapiraca",
    "uf": "AL"
  },
  {
    "codigo": 2700409,
    "nome": "Atalaia",
    "uf": "AL"
  },
  {
    "codigo": 2700508,
    "nome": "Barra de Santo Antônio",
    "uf": "AL"
  },
  {
    "codigo": 2700607,
    "nome": "Barra de São Miguel",
    "uf": "AL"
  },
  {
    "codigo": 2700706,
    "nome": "Batalha",
    "uf": "AL"
  },
  {
    "codigo": 2700805,
    "nome": "Belém",
    "uf": "AL"
  },
  {
    "codigo": 2700904,
    "nome": "Belo Monte",
    "uf": "AL"
  },
  {
    "codigo": 2701001,
    "nome": "Boca da Mata",
    "uf": "AL"
  },
  {
    "codigo": 2701100,
    "nome": "Branquinha",
    "uf": "AL"
  },
  {
    "codigo": 2701209,
    "nome": "Cacimbinhas",
    "uf": "AL"
  },
  {
    "codigo": 2701308,
    "nome": "Cajueiro",
    "uf": "AL"
  },
  {
    "codigo": 2701357,
    "nome": "Campestre",
    "uf": "AL"
  },
  {
    "codigo": 2701407,
    "nome": "Campo Alegre",
    "uf": "AL"
  },
  {
    "codigo": 2701506,
    "nome": "Campo Grande",
    "uf": "AL"
  },
  {
    "codigo": 2701605,
    "nome": "Canapi",
    "uf": "AL"
  },
  {
    "codigo": 2701704,
    "nome": "Capela",
    "uf": "AL"
  },
  {
    "codigo": 2701803,
    "nome": "Carneiros",
    "uf": "AL"
  },
  {
    "codigo": 2701902,
    "nome": "Chã Preta",
    "uf": "AL"
  },
  {
    "codigo": 2702009,
    "nome": "Coité do Nóia",
    "uf": "AL"
  },
  {
    "codigo": 2702108,
    "nome": "Colônia Leopoldina",
    "uf": "AL"
  },
  {
    "codigo": 2702207,
    "nome": "Coqueiro Seco",
    "uf": "AL"
  },
  {
    "codigo": 2702306,
    "nome": "Coruripe",
    "uf": "AL"
  },
  {
    "codigo": 2702355,
    "nome": "Craíbas",
    "uf": "AL"
  },
  {
    "codigo": 2702405,
    "nome": "Delmiro Gouveia",
    "uf": "AL"
  },
  {
    "codigo": 2702504,
    "nome": "Dois Riachos",
    "uf": "AL"
  },
  {
    "codigo": 2702553,
    "nome": "Estrela de Alagoas",
    "uf": "AL"
  },
  {
    "codigo": 2702603,
    "nome": "Feira Grande",
    "uf": "AL"
  },
  {
    "codigo": 2702702,
    "nome": "Feliz Deserto",
    "uf": "AL"
  },
  {
    "codigo": 2702801,
    "nome": "Flexeiras",
    "uf": "AL"
  },
  {
    "codigo": 2702900,
    "nome": "Girau do Ponciano",
    "uf": "AL"
  },
  {
    "codigo": 2703007,
    "nome": "Ibateguara",
    "uf": "AL"
  },
  {
    "codigo": 2703106,
    "nome": "Igaci",
    "uf": "AL"
  },
  {
    "codigo": 2703205,
    "nome": "Igreja Nova",
    "uf": "AL"
  },
  {
    "codigo": 2703304,
    "nome": "Inhapi",
    "uf": "AL"
  },
  {
    "codigo": 2703403,
    "nome": "Jacaré dos Homens",
    "uf": "AL"
  },
  {
    "codigo": 2703502,
    "nome": "Jacuípe",
    "uf": "AL"
  },
  {
    "codigo": 2703601,
    "nome": "Japaratinga",
    "uf": "AL"
  },
  {
    "codigo": 2703700,
    "nome": "Jaramataia",
    "uf": "AL"
  },
  {
    "codigo": 2703759,
    "nome": "Jequiá da Praia",
    "uf": "AL"
  },
  {
    "codigo": 2703809,
    "nome": "Joaquim Gomes",
    "uf": "AL"
  },
  {
    "codigo": 2703908,
    "nome": "Jundiá",
    "uf": "AL"
  },
  {
    "codigo": 2704005,
    "nome": "Junqueiro",
    "uf": "AL"
  },
  {
    "codigo": 2704104,
    "nome": "Lagoa da Canoa",
    "uf": "AL"
  },
  {
    "codigo": 2704203,
    "nome": "Limoeiro de Anadia",
    "uf": "AL"
  },
  {
    "codigo": 2704302,
    "nome": "Maceió",
    "uf": "AL"
  },
  {
    "codigo": 2704401,
    "nome": "Major Isidoro",
    "uf": "AL"
  },
  {
    "codigo": 2704500,
    "nome": "Maragogi",
    "uf": "AL"
  },
  {
    "codigo": 2704609,
    "nome": "Maravilha",
    "uf": "AL"
  },
  {
    "codigo": 2704708,
    "nome": "Marechal Deodoro",
    "uf": "AL"
  },
  {
    "codigo": 2704807,
    "nome": "Maribondo",
    "uf": "AL"
  },
  {
    "codigo": 2704906,
    "nome": "Mar Vermelho",
    "uf": "AL"
  },
  {
    "codigo": 2705002,
    "nome": "Mata Grande",
    "uf": "AL"
  },
  {
    "codigo": 2705101,
    "nome": "Matriz de Camaragibe",
    "uf": "AL"
  },
  {
    "codigo": 2705200,
    "nome": "Messias",
    "uf": "AL"
  },
  {
    "codigo": 2705309,
    "nome": "Minador do Negrão",
    "uf": "AL"
  },
  {
    "codigo": 2705408,
    "nome": "Monteirópolis",
    "uf": "AL"
  },
  {
    "codigo": 2705507,
    "nome": "Murici",
    "uf": "AL"
  },
  {
    "codigo": 2705606,
    "nome": "Novo Lino",
    "uf": "AL"
  },
  {
    "codigo": 2705705,
    "nome": "Olho d'Água das Flores",
    "uf": "AL"
  },
  {
    "codigo": 2705804,
    "nome": "Olho d'Água do Casado",
    "uf": "AL"
  },
  {
    "codigo": 2705903,
    "nome": "Olho d'Água Grande",
    "uf": "AL"
  },
  {
    "codigo": 2706000,
    "nome": "Olivença",
    "uf": "AL"
  },
  {
    "codigo": 2706109,
    "nome": "Ouro Branco",
    "uf": "AL"
  },
  {
    "codigo": 2706208,
    "nome": "Palestina",
    "uf": "AL"
  },
  {
    "codigo": 2706307,
    "nome": "Palmeira dos Índios",
    "uf": "AL"
  },
  {
    "codigo": 2706406,
    "nome": "Pão de Açúcar",
    "uf": "AL"
  },
  {
    "codigo": 2706422,
    "nome": "Pariconha",
    "uf": "AL"
  },
  {
    "codigo": 2706448,
    "nome": "Paripueira",
    "uf": "AL"
  },
  {
    "codigo": 2706505,
    "nome": "Passo de Camaragibe",
    "uf": "AL"
  },
  {
    "codigo": 2706604,
    "nome": "Paulo Jacinto",
    "uf": "AL"
  },
  {
    "codigo": 2706703,
    "nome": "Penedo",
    "uf": "AL"
  },
  {
    "codigo": 2706802,
    "nome": "Piaçabuçu",
    "uf": "AL"
  },
  {
    "codigo": 2706901,
    "nome": "Pilar",
    "uf": "AL"
  },
  {
    "codigo": 2707008,
    "nome": "Pindoba",
    "uf": "AL"
  },
  {
    "codigo": 2707107,
    "nome": "Piranhas",
    "uf": "AL"
  },
  {
    "codigo": 2707206,
    "nome": "Poço das Trincheiras",
    "uf": "AL"
  },
  {
    "codigo": 2707305,
    "nome": "Porto Calvo",
    "uf": "AL"
  },
  {
    "codigo": 2707404,
    "nome": "Porto de Pedras",
    "uf": "AL"
  },
  {
    "codigo": 2707503,
    "nome": "Porto Real do Colégio",
    "uf": "AL"
  },
  {
    "codigo": 2707602,
    "nome": "Quebrangulo",
    "uf": "AL"
  },
  {
    "codigo": 2707701,
    "nome": "Rio Largo",
    "uf": "AL"
  },
  {
    "codigo": 2707800,
    "nome": "Roteiro",
    "uf": "AL"
  },
  {
    "codigo": 2707909,
    "nome": "Santa Luzia do Norte",
    "uf": "AL"
  },
  {
    "codigo": 2708006,
    "nome": "Santana do Ipanema",
    "uf": "AL"
  },
  {
    "codigo": 2708105,
    "nome": "Santana do Mundaú",
    "uf": "AL"
  },
  {
    "codigo": 2708204,
    "nome": "São Brás",
    "uf": "AL"
  },
  {
    "codigo": 2708303,
    "nome": "São José da Laje",
    "uf": "AL"
  },
  {
    "codigo": 2708402,
    "nome": "São José da Tapera",
    "uf": "AL"
  },
  {
    "codigo": 2708501,
    "nome": "São Luís do Quitunde",
    "uf": "AL"
  },
  {
    "codigo": 2708600,
    "nome": "São Miguel dos Campos",
    "uf": "AL"
  },
  {
    "codigo": 2708709,
    "nome": "São Miguel dos Milagres",
    "uf": "AL"
  },
  {
    "codigo": 2708808,
    "nome": "São Sebastião",
    "uf": "AL"
  },
  {
    "codigo": 2708907,
    "nome": "Satuba",
    "uf": "AL"
  },
  {
    "codigo": 2708956,
    "nome": "Senador Rui Palmeira",
    "uf": "AL"
  },
  {
    "codigo": 2709004,
    "nome": "Tanque d'Arca",
    "uf": "AL"
  },
  {
    "codigo": 2709103,
    "nome": "Taquarana",
    "uf": "AL"
  },
  {
    "codigo": 2709152,
    "nome": "Teotônio Vilela",
    "uf": "AL"
  },
  {
    "codigo": 2709202,
    "nome": "Traipu",
    "uf": "AL"
  },
  {
    "codigo": 2709301,
    "nome": "União dos Palmares",
    "uf": "AL"
  },
  {
    "codigo": 2709400,
    "nome": "Viçosa",
    "uf": "AL"
  },
  {
    "codigo": 2800100,
    "nome": "Amparo do São Francisco",
    "uf": "SE"
  },
  {
    "codigo": 2800209,
    "nome": "Aquidabã",
    "uf": "SE"
  },
  {
    "codigo": 2800308,
    "nome": "Aracaju",
    "uf": "SE"
  },
  {
    "codigo": 2800407,
    "nome": "Arauá",
    "uf": "SE"
  },
  {
    "codigo": 2800506,
    "nome": "Areia Branca",
    "uf": "SE"
  },
  {
    "codigo": 2800605,
    "nome": "Barra dos Coqueiros",
    "uf": "SE"
  },
  {
    "codigo": 2800670,
    "nome": "Boquim",
    "uf": "SE"
  },
  {
    "codigo": 2800704,
    "nome": "Brejo Grande",
    "uf": "SE"
  },
  {
    "codigo": 2801009,
    "nome": "Campo do Brito",
    "uf": "SE"
  },
  {
    "codigo": 2801108,
    "nome": "Canhoba",
    "uf": "SE"
  },
  {
    "codigo": 2801207,
    "nome": "Canindé de São Francisco",
    "uf": "SE"
  },
  {
    "codigo": 2801306,
    "nome": "Capela",
    "uf": "SE"
  },
  {
    "codigo": 2801405,
    "nome": "Carira",
    "uf": "SE"
  },
  {
    "codigo": 2801504,
    "nome": "Carmópolis",
    "uf": "SE"
  },
  {
    "codigo": 2801603,
    "nome": "Cedro de São João",
    "uf": "SE"
  },
  {
    "codigo": 2801702,
    "nome": "Cristinápolis",
    "uf": "SE"
  },
  {
    "codigo": 2801900,
    "nome": "Cumbe",
    "uf": "SE"
  },
  {
    "codigo": 2802007,
    "nome": "Divina Pastora",
    "uf": "SE"
  },
  {
    "codigo": 2802106,
    "nome": "Estância",
    "uf": "SE"
  },
  {
    "codigo": 2802205,
    "nome": "Feira Nova",
    "uf": "SE"
  },
  {
    "codigo": 2802304,
    "nome": "Frei Paulo",
    "uf": "SE"
  },
  {
    "codigo": 2802403,
    "nome": "Gararu",
    "uf": "SE"
  },
  {
    "codigo": 2802502,
    "nome": "General Maynard",
    "uf": "SE"
  },
  {
    "codigo": 2802601,
    "nome": "Graccho Cardoso",
    "uf": "SE"
  },
  {
    "codigo": 2802700,
    "nome": "Ilha das Flores",
    "uf": "SE"
  },
  {
    "codigo": 2802809,
    "nome": "Indiaroba",
    "uf": "SE"
  },
  {
    "codigo": 2802908,
    "nome": "Itabaiana",
    "uf": "SE"
  },
  {
    "codigo": 2803005,
    "nome": "Itabaianinha",
    "uf": "SE"
  },
  {
    "codigo": 2803104,
    "nome": "Itabi",
    "uf": "SE"
  },
  {
    "codigo": 2803203,
    "nome": "Itaporanga d'Ajuda",
    "uf": "SE"
  },
  {
    "codigo": 2803302,
    "nome": "Japaratuba",
    "uf": "SE"
  },
  {
    "codigo": 2803401,
    "nome": "Japoatã",
    "uf": "SE"
  },
  {
    "codigo": 2803500,
    "nome": "Lagarto",
    "uf": "SE"
  },
  {
    "codigo": 2803609,
    "nome": "Laranjeiras",
    "uf": "SE"
  },
  {
    "codigo": 2803708,
    "nome": "Macambira",
    "uf": "SE"
  },
  {
    "codigo": 2803807,
    "nome": "Malhada dos Bois",
    "uf": "SE"
  },
  {
    "codigo": 2803906,
    "nome": "Malhador",
    "uf": "SE"
  },
  {
    "codigo": 2804003,
    "nome": "Maruim",
    "uf": "SE"
  },
  {
    "codigo": 2804102,
    "nome": "Moita Bonita",
    "uf": "SE"
  },
  {
    "codigo": 2804201,
    "nome": "Monte Alegre de Sergipe",
    "uf": "SE"
  },
  {
    "codigo": 2804300,
    "nome": "Muribeca",
    "uf": "SE"
  },
  {
    "codigo": 2804409,
    "nome": "Neópolis",
    "uf": "SE"
  },
  {
    "codigo": 2804458,
    "nome": "Nossa Senhora Aparecida",
    "uf": "SE"
  },
  {
    "codigo": 2804508,
    "nome": "Nossa Senhora da Glória",
    "uf": "SE"
  },
  {
    "codigo": 2804607,
    "nome": "Nossa Senhora das Dores",
    "uf": "SE"
  },
  {
    "codigo": 2804706,
    "nome": "Nossa Senhora de Lourdes",
    "uf": "SE"
  },
  {
    "codigo": 2804805,
    "nome": "Nossa Senhora do Socorro",
    "uf": "SE"
  },
  {
    "codigo": 2804904,
    "nome": "Pacatuba",
    "uf": "SE"
  },
  {
    "codigo": 2805000,
    "nome": "Pedra Mole",
    "uf": "SE"
  },
  {
    "codigo": 2805109,
    "nome": "Pedrinhas",
    "uf": "SE"
  },
  {
    "codigo": 2805208,
    "nome": "Pinhão",
    "uf": "SE"
  },
  {
    "codigo": 2805307,
    "nome": "Pirambu",
    "uf": "SE"
  },
  {
    "codigo": 2805406,
    "nome": "Poço Redondo",
    "uf": "SE"
  },
  {
    "codigo": 2805505,
    "nome": "Poço Verde",
    "uf": "SE"
  },
  {
    "codigo": 2805604,
    "nome": "Porto da Folha",
    "uf": "SE"
  },
  {
    "codigo": 2805703,
    "nome": "Propriá",
    "uf": "SE"
  },
  {
    "codigo": 2805802,
    "nome": "Riachão do Dantas",
    "uf": "SE"
  },
  {
    "codigo": 2805901,
    "nome": "Riachuelo",
    "uf": "SE"
  },
  {
    "codigo": 2806008,
    "nome": "Ribeirópolis",
    "uf": "SE"
  },
  {
    "codigo": 2806107,
    "nome": "Rosário do Catete",
    "uf": "SE"
  },
  {
    "codigo": 2806206,
    "nome": "Salgado",
    "uf": "SE"
  },
  {
    "codigo": 2806305,
    "nome": "Santa Luzia do Itanhy",
    "uf": "SE"
  },
  {
    "codigo": 2806404,
    "nome": "Santana do São Francisco",
    "uf": "SE"
  },
  {
    "codigo": 2806503,
    "nome": "Santa Rosa de Lima",
    "uf": "SE"
  },
  {
    "codigo": 2806602,
    "nome": "Santo Amaro das Brotas",
    "uf": "SE"
  },
  {
    "codigo": 2806701,
    "nome": "São Cristóvão",
    "uf": "SE"
  },
  {
    "codigo": 2806800,
    "nome": "São Domingos",
    "uf": "SE"
  },
  {
    "codigo": 2806909,
    "nome": "São Francisco",
    "uf": "SE"
  },
  {
    "codigo": 2807006,
    "nome": "São Miguel do Aleixo",
    "uf": "SE"
  },
  {
    "codigo": 2807105,
    "nome": "Simão Dias",
    "uf": "SE"
  },
  {
    "codigo": 2807204,
    "nome": "Siriri",
    "uf": "SE"
  },
  {
    "codigo": 2807303,
    "nome": "Telha",
    "uf": "SE"
  },
  {
    "codigo": 2807402,
    "nome": "Tobias Barreto",
    "uf": "SE"
  },
  {
    "codigo": 2807501,
    "nome": "Tomar do Geru",
    "uf": "SE"
  },
  {
    "codigo": 2807600,
    "nome": "Umbaúba",
    "uf": "SE"
  },
  {
    "codigo": 2900108,
    "nome": "Abaíra",
    "uf": "BA"
  },
  {
    "codigo": 2900207,
    "nome": "Abaré",
    "uf": "BA"
  },
  {
    "codigo": 2900306,
    "nome": "Acajutiba",
    "uf": "BA"
  },
  {
    "codigo": 2900355,
    "nome": "Adustina",
    "uf": "BA"
  },
  {
    "codigo": 2900405,
    "nome": "Água Fria",
    "uf": "BA"
  },
  {
    "codigo": 2900504,
    "nome": "Érico Cardoso",
    "uf": "BA"
  },
  {
    "codigo": 2900603,
    "nome": "Aiquara",
    "uf": "BA"
  },
  {
    "codigo": 2900702,
    "nome": "Alagoinhas",
    "uf": "BA"
  },
  {
    "codigo": 2900801,
    "nome": "Alcobaça",
    "uf": "BA"
  },
  {
    "codigo": 2900900,
    "nome": "Almadina",
    "uf": "BA"
  },
  {
    "codigo": 2901007,
    "nome": "Amargosa",
    "uf": "BA"
  },
  {
    "codigo": 2901106,
    "nome": "Amélia Rodrigues",
    "uf": "BA"
  },
  {
    "codigo": 2901155,
    "nome": "América Dourada",
    "uf": "BA"
  },
  {
    "codigo": 2901205,
    "nome": "Anagé",
    "uf": "BA"
  },
  {
    "codigo": 2901304,
    "nome": "Andaraí",
    "uf": "BA"
  },
  {
    "codigo": 2901353,
    "nome": "Andorinha",
    "uf": "BA"
  },
  {
    "codigo": 2901403,
    "nome": "Angical",
    "uf": "BA"
  },
  {
    "codigo": 2901502,
    "nome": "Anguera",
    "uf": "BA"
  },
  {
    "codigo": 2901601,
    "nome": "Antas",
    "uf": "BA"
  },
  {
    "codigo": 2901700,
    "nome": "Antônio Cardoso",
    "uf": "BA"
  },
  {
    "codigo": 2901809,
    "nome": "Antônio Gonçalves",
    "uf": "BA"
  },
  {
    "codigo": 2901908,
    "nome": "Aporá",
    "uf": "BA"
  },
  {
    "codigo": 2901957,
    "nome": "Apuarema",
    "uf": "BA"
  },
  {
    "codigo": 2902005,
    "nome": "Aracatu",
    "uf": "BA"
  },
  {
    "codigo": 2902054,
    "nome": "Araçás",
    "uf": "BA"
  },
  {
    "codigo": 2902104,
    "nome": "Araci",
    "uf": "BA"
  },
  {
    "codigo": 2902203,
    "nome": "Aramari",
    "uf": "BA"
  },
  {
    "codigo": 2902252,
    "nome": "Arataca",
    "uf": "BA"
  },
  {
    "codigo": 2902302,
    "nome": "Aratuípe",
    "uf": "BA"
  },
  {
    "codigo": 2902401,
    "nome": "Aurelino Leal",
    "uf": "BA"
  },
  {
    "codigo": 2902500,
    "nome": "Baianópolis",
    "uf": "BA"
  },
  {
    "codigo": 2902609,
    "nome": "Baixa Grande",
    "uf": "BA"
  },
  {
    "codigo": 2902658,
    "nome": "Banzaê",
    "uf": "BA"
  },
  {
    "codigo": 2902708,
    "nome": "Barra",
    "uf": "BA"
  },
  {
    "codigo": 2902807,
    "nome": "Barra da Estiva",
    "uf": "BA"
  },
  {
    "codigo": 2902906,
    "nome": "Barra do Choça",
    "uf": "BA"
  },
  {
    "codigo": 2903003,
    "nome": "Barra do Mendes",
    "uf": "BA"
  },
  {
    "codigo": 2903102,
    "nome": "Barra do Rocha",
    "uf": "BA"
  },
  {
    "codigo": 2903201,
    "nome": "Barreiras",
    "uf": "BA"
  },
  {
    "codigo": 2903235,
    "nome": "Barro Alto",
    "uf": "BA"
  },
  {
    "codigo": 2903276,
    "nome": "Barrocas",
    "uf": "BA"
  },
  {
    "codigo": 2903300,
    "nome": "Barro Preto",
    "uf": "BA"
  },
  {
    "codigo": 2903409,
    "nome": "Belmonte",
    "uf": "BA"
  },
  {
    "codigo": 2903508,
    "nome": "Belo Campo",
    "uf": "BA"
  },
  {
    "codigo": 2903607,
    "nome": "Biritinga",
    "uf": "BA"
  },
  {
    "codigo": 2903706,
    "nome": "Boa Nova",
    "uf": "BA"
  },
  {
    "codigo": 2903805,
    "nome": "Boa Vista do Tupim",
    "uf": "BA"
  },
  {
    "codigo": 2903904,
    "nome": "Bom Jesus da Lapa",
    "uf": "BA"
  },
  {
    "codigo": 2903953,
    "nome": "Bom Jesus da Serra",
    "uf": "BA"
  },
  {
    "codigo": 2904001,
    "nome": "Boninal",
    "uf": "BA"
  },
  {
    "codigo": 2904050,
    "nome": "Bonito",
    "uf": "BA"
  },
  {
    "codigo": 2904100,
    "nome": "Boquira",
    "uf": "BA"
  },
  {
    "codigo": 2904209,
    "nome": "Botuporã",
    "uf": "BA"
  },
  {
    "codigo": 2904308,
    "nome": "Brejões",
    "uf": "BA"
  },
  {
    "codigo": 2904407,
    "nome": "Brejolândia",
    "uf": "BA"
  },
  {
    "codigo": 2904506,
    "nome": "Brotas de Macaúbas",
    "uf": "BA"
  },
  {
    "codigo": 2904605,
    "nome": "Brumado",
    "uf": "BA"
  },
  {
    "codigo": 2904704,
    "nome": "Buerarema",
    "uf": "BA"
  },
  {
    "codigo": 2904753,
    "nome": "Buritirama",
    "uf": "BA"
  },
  {
    "codigo": 2904803,
    "nome": "Caatiba",
    "uf": "BA"
  },
  {
    "codigo": 2904852,
    "nome": "Cabaceiras do Paraguaçu",
    "uf": "BA"
  },
  {
    "codigo": 2904902,
    "nome": "Cachoeira",
    "uf": "BA"
  },
  {
    "codigo": 2905008,
    "nome": "Caculé",
    "uf": "BA"
  },
  {
    "codigo": 2905107,
    "nome": "Caém",
    "uf": "BA"
  },
  {
    "codigo": 2905156,
    "nome": "Caetanos",
    "uf": "BA"
  },
  {
    "codigo": 2905206,
    "nome": "Caetité",
    "uf": "BA"
  },
  {
    "codigo": 2905305,
    "nome": "Cafarnaum",
    "uf": "BA"
  },
  {
    "codigo": 2905404,
    "nome": "Cairu",
    "uf": "BA"
  },
  {
    "codigo": 2905503,
    "nome": "Caldeirão Grande",
    "uf": "BA"
  },
  {
    "codigo": 2905602,
    "nome": "Camacan",
    "uf": "BA"
  },
  {
    "codigo": 2905701,
    "nome": "Camaçari",
    "uf": "BA"
  },
  {
    "codigo": 2905800,
    "nome": "Camamu",
    "uf": "BA"
  },
  {
    "codigo": 2905909,
    "nome": "Campo Alegre de Lourdes",
    "uf": "BA"
  },
  {
    "codigo": 2906006,
    "nome": "Campo Formoso",
    "uf": "BA"
  },
  {
    "codigo": 2906105,
    "nome": "Canápolis",
    "uf": "BA"
  },
  {
    "codigo": 2906204,
    "nome": "Canarana",
    "uf": "BA"
  },
  {
    "codigo": 2906303,
    "nome": "Canavieiras",
    "uf": "BA"
  },
  {
    "codigo": 2906402,
    "nome": "Candeal",
    "uf": "BA"
  },
  {
    "codigo": 2906501,
    "nome": "Candeias",
    "uf": "BA"
  },
  {
    "codigo": 2906600,
    "nome": "Candiba",
    "uf": "BA"
  },
  {
    "codigo": 2906709,
    "nome": "Cândido Sales",
    "uf": "BA"
  },
  {
    "codigo": 2906808,
    "nome": "Cansanção",
    "uf": "BA"
  },
  {
    "codigo": 2906824,
    "nome": "Canudos",
    "uf": "BA"
  },
  {
    "codigo": 2906857,
    "nome": "Capela do Alto Alegre",
    "uf": "BA"
  },
  {
    "codigo": 2906873,
    "nome": "Capim Grosso",
    "uf": "BA"
  },
  {
    "codigo": 2906899,
    "nome": "Caraíbas",
    "uf": "BA"
  },
  {
    "codigo": 2906907,
    "nome": "Caravelas",
    "uf": "BA"
  },
  {
    "codigo": 2907004,
    "nome": "Cardeal da Silva",
    "uf": "BA"
  },
  {
    "codigo": 2907103,
    "nome": "Carinhanha",
    "uf": "BA"
  },
  {
    "codigo": 2907202,
    "nome": "Casa Nova",
    "uf": "BA"
  },
  {
    "codigo": 2907301,
    "nome": "Castro Alves",
    "uf": "BA"
  },
  {
    "codigo": 2907400,
    "nome": "Catolândia",
    "uf": "BA"
  },
  {
    "codigo": 2907509,
    "nome": "Catu",
    "uf": "BA"
  },
  {
    "codigo": 2907558,
    "nome": "Caturama",
    "uf": "BA"
  },
  {
    "codigo": 2907608,
    "nome": "Central",
    "uf": "BA"
  },
  {
    "codigo": 2907707,
    "nome": "Chorrochó",
    "uf": "BA"
  },
  {
    "codigo": 2907806,
    "nome": "Cícero Dantas",
    "uf": "BA"
  },
  {
    "codigo": 2907905,
    "nome": "Cipó",
    "uf": "BA"
  },
  {
    "codigo": 2908002,
    "nome": "Coaraci",
    "uf": "BA"
  },
  {
    "codigo": 2908101,
    "nome": "Cocos",
    "uf": "BA"
  },
  {
    "codigo": 2908200,
    "nome": "Conceição da Feira",
    "uf": "BA"
  },
  {
    "codigo": 2908309,
    "nome": "Conceição do Almeida",
    "uf": "BA"
  },
  {
    "codigo": 2908408,
    "nome": "Conceição do Coité",
    "uf": "BA"
  },
  {
    "codigo": 2908507,
    "nome": "Conceição do Jacuípe",
    "uf": "BA"
  },
  {
    "codigo": 2908606,
    "nome": "Conde",
    "uf": "BA"
  },
  {
    "codigo": 2908705,
    "nome": "Condeúba",
    "uf": "BA"
  },
  {
    "codigo": 2908804,
    "nome": "Contendas do Sincorá",
    "uf": "BA"
  },
  {
    "codigo": 2908903,
    "nome": "Coração de Maria",
    "uf": "BA"
  },
  {
    "codigo": 2909000,
    "nome": "Cordeiros",
    "uf": "BA"
  },
  {
    "codigo": 2909109,
    "nome": "Coribe",
    "uf": "BA"
  },
  {
    "codigo": 2909208,
    "nome": "Coronel João Sá",
    "uf": "BA"
  },
  {
    "codigo": 2909307,
    "nome": "Correntina",
    "uf": "BA"
  },
  {
    "codigo": 2909406,
    "nome": "Cotegipe",
    "uf": "BA"
  },
  {
    "codigo": 2909505,
    "nome": "Cravolândia",
    "uf": "BA"
  },
  {
    "codigo": 2909604,
    "nome": "Crisópolis",
    "uf": "BA"
  },
  {
    "codigo": 2909703,
    "nome": "Cristópolis",
    "uf": "BA"
  },
  {
    "codigo": 2909802,
    "nome": "Cruz das Almas",
    "uf": "BA"
  },
  {
    "codigo": 2909901,
    "nome": "Curaçá",
    "uf": "BA"
  },
  {
    "codigo": 2910008,
    "nome": "Dário Meira",
    "uf": "BA"
  },
  {
    "codigo": 2910057,
    "nome": "Dias d'Ávila",
    "uf": "BA"
  },
  {
    "codigo": 2910107,
    "nome": "Dom Basílio",
    "uf": "BA"
  },
  {
    "codigo": 2910206,
    "nome": "Dom Macedo Costa",
    "uf": "BA"
  },
  {
    "codigo": 2910305,
    "nome": "Elísio Medrado",
    "uf": "BA"
  },
  {
    "codigo": 2910404,
    "nome": "Encruzilhada",
    "uf": "BA"
  },
  {
    "codigo": 2910503,
    "nome": "Entre Rios",
    "uf": "BA"
  },
  {
    "codigo": 2910602,
    "nome": "Esplanada",
    "uf": "BA"
  },
  {
    "codigo": 2910701,
    "nome": "Euclides da Cunha",
    "uf": "BA"
  },
  {
    "codigo": 2910727,
    "nome": "Eunápolis",
    "uf": "BA"
  },
  {
    "codigo": 2910750,
    "nome": "Fátima",
    "uf": "BA"
  },
  {
    "codigo": 2910776,
    "nome": "Feira da Mata",
    "uf": "BA"
  },
  {
    "codigo": 2910800,
    "nome": "Feira de Santana",
    "uf": "BA"
  },
  {
    "codigo": 2910859,
    "nome": "Filadélfia",
    "uf": "BA"
  },
  {
    "codigo": 2910909,
    "nome": "Firmino Alves",
    "uf": "BA"
  },
  {
    "codigo": 2911006,
    "nome": "Floresta Azul",
    "uf": "BA"
  },
  {
    "codigo": 2911105,
    "nome": "Formosa do Rio Preto",
    "uf": "BA"
  },
  {
    "codigo": 2911204,
    "nome": "Gandu",
    "uf": "BA"
  },
  {
    "codigo": 2911253,
    "nome": "Gavião",
    "uf": "BA"
  },
  {
    "codigo": 2911303,
    "nome": "Gentio do Ouro",
    "uf": "BA"
  },
  {
    "codigo": 2911402,
    "nome": "Glória",
    "uf": "BA"
  },
  {
    "codigo": 2911501,
    "nome": "Gongogi",
    "uf": "BA"
  },
  {
    "codigo": 2911600,
    "nome": "Governador Mangabeira",
    "uf": "BA"
  },
  {
    "codigo": 2911659,
    "nome": "Guajeru",
    "uf": "BA"
  },
  {
    "codigo": 2911709,
    "nome": "Guanambi",
    "uf": "BA"
  },
  {
    "codigo": 2911808,
    "nome": "Guaratinga",
    "uf": "BA"
  },
  {
    "codigo": 2911857,
    "nome": "Heliópolis",
    "uf": "BA"
  },
  {
    "codigo": 2911907,
    "nome": "Iaçu",
    "uf": "BA"
  },
  {
    "codigo": 2912004,
    "nome": "Ibiassucê",
    "uf": "BA"
  },
  {
    "codigo": 2912103,
    "nome": "Ibicaraí",
    "uf": "BA"
  },
  {
    "codigo": 2912202,
    "nome": "Ibicoara",
    "uf": "BA"
  },
  {
    "codigo": 2912301,
    "nome": "Ibicuí",
    "uf": "BA"
  },
  {
    "codigo": 2912400,
    "nome": "Ibipeba",
    "uf": "BA"
  },
  {
    "codigo": 2912509,
    "nome": "Ibipitanga",
    "uf": "BA"
  },
  {
    "codigo": 2912608,
    "nome": "Ibiquera",
    "uf": "BA"
  },
  {
    "codigo": 2912707,
    "nome": "Ibirapitanga",
    "uf": "BA"
  },
  {
    "codigo": 2912806,
    "nome": "Ibirapuã",
    "uf": "BA"
  },
  {
    "codigo": 2912905,
    "nome": "Ibirataia",
    "uf": "BA"
  },
  {
    "codigo": 2913002,
    "nome": "Ibitiara",
    "uf": "BA"
  },
  {
    "codigo": 2913101,
    "nome": "Ibititá",
    "uf": "BA"
  },
  {
    "codigo": 2913200,
    "nome": "Ibotirama",
    "uf": "BA"
  },
  {
    "codigo": 2913309,
    "nome": "Ichu",
    "uf": "BA"
  },
  {
    "codigo": 2913408,
    "nome": "Igaporã",
    "uf": "BA"
  },
  {
    "codigo": 2913457,
    "nome": "Igrapiúna",
    "uf": "BA"
  },
  {
    "codigo": 2913507,
    "nome": "Iguaí",
    "uf": "BA"
  },
  {
    "codigo": 2913606,
    "nome": "Ilhéus",
    "uf": "BA"
  },
  {
    "codigo": 2913705,
    "nome": "Inhambupe",
    "uf": "BA"
  },
  {
    "codigo": 2913804,
    "nome": "Ipecaetá",
    "uf": "BA"
  },
  {
    "codigo": 2913903,
    "nome": "Ipiaú",
    "uf": "BA"
  },
  {
    "codigo": 2914000,
    "nome": "Ipirá",
    "uf": "BA"
  },
  {
    "codigo": 2914109,
    "nome": "Ipupiara",
    "uf": "BA"
  },
  {
    "codigo": 2914208,
    "nome": "Irajuba",
    "uf": "BA"
  },
  {
    "codigo": 2914307,
    "nome": "Iramaia",
    "uf": "BA"
  },
  {
    "codigo": 2914406,
    "nome": "Iraquara",
    "uf": "BA"
  },
  {
    "codigo": 2914505,
    "nome": "Irará",
    "uf": "BA"
  },
  {
    "codigo": 2914604,
    "nome": "Irecê",
    "uf": "BA"
  },
  {
    "codigo": 2914653,
    "nome": "Itabela",
    "uf": "BA"
  },
  {
    "codigo": 2914703,
    "nome": "Itaberaba",
    "uf": "BA"
  },
  {
    "codigo": 2914802,
    "nome": "Itabuna",
    "uf": "BA"
  },
  {
    "codigo": 2914901,
    "nome": "Itacaré",
    "uf": "BA"
  },
  {
    "codigo": 2915007,
    "nome": "Itaeté",
    "uf": "BA"
  },
  {
    "codigo": 2915106,
    "nome": "Itagi",
    "uf": "BA"
  },
  {
    "codigo": 2915205,
    "nome": "Itagibá",
    "uf": "BA"
  },
  {
    "codigo": 2915304,
    "nome": "Itagimirim",
    "uf": "BA"
  },
  {
    "codigo": 2915353,
    "nome": "Itaguaçu da Bahia",
    "uf": "BA"
  },
  {
    "codigo": 2915403,
    "nome": "Itaju do Colônia",
    "uf": "BA"
  },
  {
    "codigo": 2915502,
    "nome": "Itajuípe",
    "uf": "BA"
  },
  {
    "codigo": 2915601,
    "nome": "Itamaraju",
    "uf": "BA"
  },
  {
    "codigo": 2915700,
    "nome": "Itamari",
    "uf": "BA"
  },
  {
    "codigo": 2915809,
    "nome": "Itambé",
    "uf": "BA"
  },
  {
    "codigo": 2915908,
    "nome": "Itanagra",
    "uf": "BA"
  },
  {
    "codigo": 2916005,
    "nome": "Itanhém",
    "uf": "BA"
  },
  {
    "codigo": 2916104,
    "nome": "Itaparica",
    "uf": "BA"
  },
  {
    "codigo": 2916203,
    "nome": "Itapé",
    "uf": "BA"
  },
  {
    "codigo": 2916302,
    "nome": "Itapebi",
    "uf": "BA"
  },
  {
    "codigo": 2916401,
    "nome": "Itapetinga",
    "uf": "BA"
  },
  {
    "codigo": 2916500,
    "nome": "Itapicuru",
    "uf": "BA"
  },
  {
    "codigo": 2916609,
    "nome": "Itapitanga",
    "uf": "BA"
  },
  {
    "codigo": 2916708,
    "nome": "Itaquara",
    "uf": "BA"
  },
  {
    "codigo": 2916807,
    "nome": "Itarantim",
    "uf": "BA"
  },
  {
    "codigo": 2916856,
    "nome": "Itatim",
    "uf": "BA"
  },
  {
    "codigo": 2916906,
    "nome": "Itiruçu",
    "uf": "BA"
  },
  {
    "codigo": 2917003,
    "nome": "Itiúba",
    "uf": "BA"
  },
  {
    "codigo": 2917102,
    "nome": "Itororó",
    "uf": "BA"
  },
  {
    "codigo": 2917201,
    "nome": "Ituaçu",
    "uf": "BA"
  },
  {
    "codigo": 2917300,
    "nome": "Ituberá",
    "uf": "BA"
  },
  {
    "codigo": 2917334,
    "nome": "Iuiu",
    "uf": "BA"
  },
  {
    "codigo": 2917359,
    "nome": "Jaborandi",
    "uf": "BA"
  },
  {
    "codigo": 2917409,
    "nome": "Jacaraci",
    "uf": "BA"
  },
  {
    "codigo": 2917508,
    "nome": "Jacobina",
    "uf": "BA"
  },
  {
    "codigo": 2917607,
    "nome": "Jaguaquara",
    "uf": "BA"
  },
  {
    "codigo": 2917706,
    "nome": "Jaguarari",
    "uf": "BA"
  },
  {
    "codigo": 2917805,
    "nome": "Jaguaripe",
    "uf": "BA"
  },
  {
    "codigo": 2917904,
    "nome": "Jandaíra",
    "uf": "BA"
  },
  {
    "codigo": 2918001,
    "nome": "Jequié",
    "uf": "BA"
  },
  {
    "codigo": 2918100,
    "nome": "Jeremoabo",
    "uf": "BA"
  },
  {
    "codigo": 2918209,
    "nome": "Jiquiriçá",
    "uf": "BA"
  },
  {
    "codigo": 2918308,
    "nome": "Jitaúna",
    "uf": "BA"
  },
  {
    "codigo": 2918357,
    "nome": "João Dourado",
    "uf": "BA"
  },
  {
    "codigo": 2918407,
    "nome": "Juazeiro",
    "uf": "BA"
  },
  {
    "codigo": 2918456,
    "nome": "Jucuruçu",
    "uf": "BA"
  },
  {
    "codigo": 2918506,
    "nome": "Jussara",
    "uf": "BA"
  },
  {
    "codigo": 2918555,
    "nome": "Jussari",
    "uf": "BA"
  },
  {
    "codigo": 2918605,
    "nome": "Jussiape",
    "uf": "BA"
  },
  {
    "codigo": 2918704,
    "nome": "Lafaiete Coutinho",
    "uf": "BA"
  },
  {
    "codigo": 2918753,
    "nome": "Lagoa Real",
    "uf": "BA"
  },
  {
    "codigo": 2918803,
    "nome": "Laje",
    "uf": "BA"
  },
  {
    "codigo": 2918902,
    "nome": "Lajedão",
    "uf": "BA"
  },
  {
    "codigo": 2919009,
    "nome": "Lajedinho",
    "uf": "BA"
  },
  {
    "codigo": 2919058,
    "nome": "Lajedo do Tabocal",
    "uf": "BA"
  },
  {
    "codigo": 2919108,
    "nome": "Lamarão",
    "uf": "BA"
  },
  {
    "codigo": 2919157,
    "nome": "Lapão",
    "uf": "BA"
  },
  {
    "codigo": 2919207,
    "nome": "Lauro de Freitas",
    "uf": "BA"
  },
  {
    "codigo": 2919306,
    "nome": "Lençóis",
    "uf": "BA"
  },
  {
    "codigo": 2919405,
    "nome": "Licínio de Almeida",
    "uf": "BA"
  },
  {
    "codigo": 2919504,
    "nome": "Livramento de Nossa Senhora",
    "uf": "BA"
  },
  {
    "codigo": 2919553,
    "nome": "Luís Eduardo Magalhães",
    "uf": "BA"
  },
  {
    "codigo": 2919603,
    "nome": "Macajuba",
    "uf": "BA"
  },
  {
    "codigo": 2919702,
    "nome": "Macarani",
    "uf": "BA"
  },
  {
    "codigo": 2919801,
    "nome": "Macaúbas",
    "uf": "BA"
  },
  {
    "codigo": 2919900,
    "nome": "Macururé",
    "uf": "BA"
  },
  {
    "codigo": 2919926,
    "nome": "Madre de Deus",
    "uf": "BA"
  },
  {
    "codigo": 2919959,
    "nome": "Maetinga",
    "uf": "BA"
  },
  {
    "codigo": 2920007,
    "nome": "Maiquinique",
    "uf": "BA"
  },
  {
    "codigo": 2920106,
    "nome": "Mairi",
    "uf": "BA"
  },
  {
    "codigo": 2920205,
    "nome": "Malhada",
    "uf": "BA"
  },
  {
    "codigo": 2920304,
    "nome": "Malhada de Pedras",
    "uf": "BA"
  },
  {
    "codigo": 2920403,
    "nome": "Manoel Vitorino",
    "uf": "BA"
  },
  {
    "codigo": 2920452,
    "nome": "Mansidão",
    "uf": "BA"
  },
  {
    "codigo": 2920502,
    "nome": "Maracás",
    "uf": "BA"
  },
  {
    "codigo": 2920601,
    "nome": "Maragogipe",
    "uf": "BA"
  },
  {
    "codigo": 2920700,
    "nome": "Maraú",
    "uf": "BA"
  },
  {
    "codigo": 2920809,
    "nome": "Marcionílio Souza",
    "uf": "BA"
  },
  {
    "codigo": 2920908,
    "nome": "Mascote",
    "uf": "BA"
  },
  {
    "codigo": 2921005,
    "nome": "Mata de São João",
    "uf": "BA"
  },
  {
    "codigo": 2921054,
    "nome": "Matina",
    "uf": "BA"
  },
  {
    "codigo": 2921104,
    "nome": "Medeiros Neto",
    "uf": "BA"
  },
  {
    "codigo": 2921203,
    "nome": "Miguel Calmon",
    "uf": "BA"
  },
  {
    "codigo": 2921302,
    "nome": "Milagres",
    "uf": "BA"
  },
  {
    "codigo": 2921401,
    "nome": "Mirangaba",
    "uf": "BA"
  },
  {
    "codigo": 2921450,
    "nome": "Mirante",
    "uf": "BA"
  },
  {
    "codigo": 2921500,
    "nome": "Monte Santo",
    "uf": "BA"
  },
  {
    "codigo": 2921609,
    "nome": "Morpará",
    "uf": "BA"
  },
  {
    "codigo": 2921708,
    "nome": "Morro do Chapéu",
    "uf": "BA"
  },
  {
    "codigo": 2921807,
    "nome": "Mortugaba",
    "uf": "BA"
  },
  {
    "codigo": 2921906,
    "nome": "Mucugê",
    "uf": "BA"
  },
  {
    "codigo": 2922003,
    "nome": "Mucuri",
    "uf": "BA"
  },
  {
    "codigo": 2922052,
    "nome": "Mulungu do Morro",
    "uf": "BA"
  },
  {
    "codigo": 2922102,
    "nome": "Mundo Novo",
    "uf": "BA"
  },
  {
    "codigo": 2922201,
    "nome": "Muniz Ferreira",
    "uf": "BA"
  },
  {
    "codigo": 2922250,
    "nome": "Muquém do São Francisco",
    "uf": "BA"
  },
  {
    "codigo": 2922300,
    "nome": "Muritiba",
    "uf": "BA"
  },
  {
    "codigo": 2922409,
    "nome": "Mutuípe",
    "uf": "BA"
  },
  {
    "codigo": 2922508,
    "nome": "Nazaré",
    "uf": "BA"
  },
  {
    "codigo": 2922607,
    "nome": "Nilo Peçanha",
    "uf": "BA"
  },
  {
    "codigo": 2922656,
    "nome": "Nordestina",
    "uf": "BA"
  },
  {
    "codigo": 2922706,
    "nome": "Nova Canaã",
    "uf": "BA"
  },
  {
    "codigo": 2922730,
    "nome": "Nova Fátima",
    "uf": "BA"
  },
  {
    "codigo": 2922755,
    "nome": "Nova Ibiá",
    "uf": "BA"
  },
  {
    "codigo": 2922805,
    "nome": "Nova Itarana",
    "uf": "BA"
  },
  {
    "codigo": 2922854,
    "nome": "Nova Redenção",
    "uf": "BA"
  },
  {
    "codigo": 2922904,
    "nome": "Nova Soure",
    "uf": "BA"
  },
  {
    "codigo": 2923001,
    "nome": "Nova Viçosa",
    "uf": "BA"
  },
  {
    "codigo": 2923035,
    "nome": "Novo Horizonte",
    "uf": "BA"
  },
  {
    "codigo": 2923050,
    "nome": "Novo Triunfo",
    "uf": "BA"
  },
  {
    "codigo": 2923100,
    "nome": "Olindina",
    "uf": "BA"
  },
  {
    "codigo": 2923209,
    "nome": "Oliveira dos Brejinhos",
    "uf": "BA"
  },
  {
    "codigo": 2923308,
    "nome": "Ouriçangas",
    "uf": "BA"
  },
  {
    "codigo": 2923357,
    "nome": "Ourolândia",
    "uf": "BA"
  },
  {
    "codigo": 2923407,
    "nome": "Palmas de Monte Alto",
    "uf": "BA"
  },
  {
    "codigo": 2923506,
    "nome": "Palmeiras",
    "uf": "BA"
  },
  {
    "codigo": 2923605,
    "nome": "Paramirim",
    "uf": "BA"
  },
  {
    "codigo": 2923704,
    "nome": "Paratinga",
    "uf": "BA"
  },
  {
    "codigo": 2923803,
    "nome": "Paripiranga",
    "uf": "BA"
  },
  {
    "codigo": 2923902,
    "nome": "Pau Brasil",
    "uf": "BA"
  },
  {
    "codigo": 2924009,
    "nome": "Paulo Afonso",
    "uf": "BA"
  },
  {
    "codigo": 2924058,
    "nome": "Pé de Serra",
    "uf": "BA"
  },
  {
    "codigo": 2924108,
    "nome": "Pedrão",
    "uf": "BA"
  },
  {
    "codigo": 2924207,
    "nome": "Pedro Alexandre",
    "uf": "BA"
  },
  {
    "codigo": 2924306,
    "nome": "Piatã",
    "uf": "BA"
  },
  {
    "codigo": 2924405,
    "nome": "Pilão Arcado",
    "uf": "BA"
  },
  {
    "codigo": 2924504,
    "nome": "Pindaí",
    "uf": "BA"
  },
  {
    "codigo": 2924603,
    "nome": "Pindobaçu",
    "uf": "BA"
  },
  {
    "codigo": 2924652,
    "nome": "Pintadas",
    "uf": "BA"
  },
  {
    "codigo": 2924678,
    "nome": "Piraí do Norte",
    "uf": "BA"
  },
  {
    "codigo": 2924702,
    "nome": "Piripá",
    "uf": "BA"
  },
  {
    "codigo": 2924801,
    "nome": "Piritiba",
    "uf": "BA"
  },
  {
    "codigo": 2924900,
    "nome": "Planaltino",
    "uf": "BA"
  },
  {
    "codigo": 2925006,
    "nome": "Planalto",
    "uf": "BA"
  },
  {
    "codigo": 2925105,
    "nome": "Poções",
    "uf": "BA"
  },
  {
    "codigo": 2925204,
    "nome": "Pojuca",
    "uf": "BA"
  },
  {
    "codigo": 2925253,
    "nome": "Ponto Novo",
    "uf": "BA"
  },
  {
    "codigo": 2925303,
    "nome": "Porto Seguro",
    "uf": "BA"
  },
  {
    "codigo": 2925402,
    "nome": "Potiraguá",
    "uf": "BA"
  },
  {
    "codigo": 2925501,
    "nome": "Prado",
    "uf": "BA"
  },
  {
    "codigo": 2925600,
    "nome": "Presidente Dutra",
    "uf": "BA"
  },
  {
    "codigo": 2925709,
    "nome": "Presidente Jânio Quadros",
    "uf": "BA"
  },
  {
    "codigo": 2925758,
    "nome": "Presidente Tancredo Neves",
    "uf": "BA"
  },
  {
    "codigo": 2925808,
    "nome": "Queimadas",
    "uf": "BA"
  },
  {
    "codigo": 2925907,
    "nome": "Quijingue",
    "uf": "BA"
  },
  {
    "codigo": 2925931,
    "nome": "Quixabeira",
    "uf": "BA"
  },
  {
    "codigo": 2925956,
    "nome": "Rafael Jambeiro",
    "uf": "BA"
  },
  {
    "codigo": 2926004,
    "nome": "Remanso",
    "uf": "BA"
  },
  {
    "codigo": 2926103,
    "nome": "Retirolândia",
    "uf": "BA"
  },
  {
    "codigo": 2926202,
    "nome": "Riachão das Neves",
    "uf": "BA"
  },
  {
    "codigo": 2926301,
    "nome": "Riachão do Jacuípe",
    "uf": "BA"
  },
  {
    "codigo": 2926400,
    "nome": "Riacho de Santana",
    "uf": "BA"
  },
  {
    "codigo": 2926509,
    "nome": "Ribeira do Amparo",
    "uf": "BA"
  },
  {
    "codigo": 2926608,
    "nome": "Ribeira do Pombal",
    "uf": "BA"
  },
  {
    "codigo": 2926657,
    "nome": "Ribeirão do Largo",
    "uf": "BA"
  },
  {
    "codigo": 2926707,
    "nome": "Rio de Contas",
    "uf": "BA"
  },
  {
    "codigo": 2926806,
    "nome": "Rio do Antônio",
    "uf": "BA"
  },
  {
    "codigo": 2926905,
    "nome": "Rio do Pires",
    "uf": "BA"
  },
  {
    "codigo": 2927002,
    "nome": "Rio Real",
    "uf": "BA"
  },
  {
    "codigo": 2927101,
    "nome": "Rodelas",
    "uf": "BA"
  },
  {
    "codigo": 2927200,
    "nome": "Ruy Barbosa",
    "uf": "BA"
  },
  {
    "codigo": 2927309,
    "nome": "Salinas da Margarida",
    "uf": "BA"
  },
  {
    "codigo": 2927408,
    "nome": "Salvador",
    "uf": "BA"
  },
  {
    "codigo": 2927507,
    "nome": "Santa Bárbara",
    "uf": "BA"
  },
  {
    "codigo": 2927606,
    "nome": "Santa Brígida",
    "uf": "BA"
  },
  {
    "codigo": 2927705,
    "nome": "Santa Cruz Cabrália",
    "uf": "BA"
  },
  {
    "codigo": 2927804,
    "nome": "Santa Cruz da Vitória",
    "uf": "BA"
  },
  {
    "codigo": 2927903,
    "nome": "Santa Inês",
    "uf": "BA"
  },
  {
    "codigo": 2928000,
    "nome": "Santaluz",
    "uf": "BA"
  },
  {
    "codigo": 2928059,
    "nome": "Santa Luzia",
    "uf": "BA"
  },
  {
    "codigo": 2928109,
    "nome": "Santa Maria da Vitória",
    "uf": "BA"
  },
  {
    "codigo": 2928208,
    "nome": "Santana",
    "uf": "BA"
  },
  {
    "codigo": 2928307,
    "nome": "Santanópolis",
    "uf": "BA"
  },
  {
    "codigo": 2928406,
    "nome": "Santa Rita de Cássia",
    "uf": "BA"
  },
  {
    "codigo": 2928505,
    "nome": "Santa Terezinha",
    "uf": "BA"
  },
  {
    "codigo": 2928604,
    "nome": "Santo Amaro",
    "uf": "BA"
  },
  {
    "codigo": 2928703,
    "nome": "Santo Antônio de Jesus",
    "uf": "BA"
  },
  {
    "codigo": 2928802,
    "nome": "Santo Estêvão",
    "uf": "BA"
  },
  {
    "codigo": 2928901,
    "nome": "São Desidério",
    "uf": "BA"
  },
  {
    "codigo": 2928950,
    "nome": "São Domingos",
    "uf": "BA"
  },
  {
    "codigo": 2929008,
    "nome": "São Félix",
    "uf": "BA"
  },
  {
    "codigo": 2929057,
    "nome": "São Félix do Coribe",
    "uf": "BA"
  },
  {
    "codigo": 2929107,
    "nome": "São Felipe",
    "uf": "BA"
  },
  {
    "codigo": 2929206,
    "nome": "São Francisco do Conde",
    "uf": "BA"
  },
  {
    "codigo": 2929255,
    "nome": "São Gabriel",
    "uf": "BA"
  },
  {
    "codigo": 2929305,
    "nome": "São Gonçalo dos Campos",
    "uf": "BA"
  },
  {
    "codigo": 2929354,
    "nome": "São José da Vitória",
    "uf": "BA"
  },
  {
    "codigo": 2929370,
    "nome": "São José do Jacuípe",
    "uf": "BA"
  },
  {
    "codigo": 2929404,
    "nome": "São Miguel das Matas",
    "uf": "BA"
  },
  {
    "codigo": 2929503,
    "nome": "São Sebastião do Passé",
    "uf": "BA"
  },
  {
    "codigo": 2929602,
    "nome": "Sapeaçu",
    "uf": "BA"
  },
  {
    "codigo": 2929701,
    "nome": "Sátiro Dias",
    "uf": "BA"
  },
  {
    "codigo": 2929750,
    "nome": "Saubara",
    "uf": "BA"
  },
  {
    "codigo": 2929800,
    "nome": "Saúde",
    "uf": "BA"
  },
  {
    "codigo": 2929909,
    "nome": "Seabra",
    "uf": "BA"
  },
  {
    "codigo": 2930006,
    "nome": "Sebastião Laranjeiras",
    "uf": "BA"
  },
  {
    "codigo": 2930105,
    "nome": "Senhor do Bonfim",
    "uf": "BA"
  },
  {
    "codigo": 2930154,
    "nome": "Serra do Ramalho",
    "uf": "BA"
  },
  {
    "codigo": 2930204,
    "nome": "Sento Sé",
    "uf": "BA"
  },
  {
    "codigo": 2930303,
    "nome": "Serra Dourada",
    "uf": "BA"
  },
  {
    "codigo": 2930402,
    "nome": "Serra Preta",
    "uf": "BA"
  },
  {
    "codigo": 2930501,
    "nome": "Serrinha",
    "uf": "BA"
  },
  {
    "codigo": 2930600,
    "nome": "Serrolândia",
    "uf": "BA"
  },
  {
    "codigo": 2930709,
    "nome": "Simões Filho",
    "uf": "BA"
  },
  {
    "codigo": 2930758,
    "nome": "Sítio do Mato",
    "uf": "BA"
  },
  {
    "codigo": 2930766,
    "nome": "Sítio do Quinto",
    "uf": "BA"
  },
  {
    "codigo": 2930774,
    "nome": "Sobradinho",
    "uf": "BA"
  },
  {
    "codigo": 2930808,
    "nome": "Souto Soares",
    "uf": "BA"
  },
  {
    "codigo": 2930907,
    "nome": "Tabocas do Brejo Velho",
    "uf": "BA"
  },
  {
    "codigo": 2931004,
    "nome": "Tanhaçu",
    "uf": "BA"
  },
  {
    "codigo": 2931053,
    "nome": "Tanque Novo",
    "uf": "BA"
  },
  {
    "codigo": 2931103,
    "nome": "Tanquinho",
    "uf": "BA"
  },
  {
    "codigo": 2931202,
    "nome": "Taperoá",
    "uf": "BA"
  },
  {
    "codigo": 2931301,
    "nome": "Tapiramutá",
    "uf": "BA"
  },
  {
    "codigo": 2931350,
    "nome": "Teixeira de Freitas",
    "uf": "BA"
  },
  {
    "codigo": 2931400,
    "nome": "Teodoro Sampaio",
    "uf": "BA"
  },
  {
    "codigo": 2931509,
    "nome": "Teofilândia",
    "uf": "BA"
  },
  {
    "codigo": 2931608,
    "nome": "Teolândia",
    "uf": "BA"
  },
  {
    "codigo": 2931707,
    "nome": "Terra Nova",
    "uf": "BA"
  },
  {
    "codigo": 2931806,
    "nome": "Tremedal",
    "uf": "BA"
  },
  {
    "codigo": 2931905,
    "nome": "Tucano",
    "uf": "BA"
  },
  {
    "codigo": 2932002,
    "nome": "Uauá",
    "uf": "BA"
  },
  {
    "codigo": 2932101,
    "nome": "Ubaíra",
    "uf": "BA"
  },
  {
    "codigo": 2932200,
    "nome": "Ubaitaba",
    "uf": "BA"
  },
  {
    "codigo": 2932309,
    "nome": "Ubatã",
    "uf": "BA"
  },
  {
    "codigo": 2932408,
    "nome": "Uibaí",
    "uf": "BA"
  },
  {
    "codigo": 2932457,
    "nome": "Umburanas",
    "uf": "BA"
  },
  {
    "codigo": 2932507,
    "nome": "Una",
    "uf": "BA"
  },
  {
    "codigo": 2932606,
    "nome": "Urandi",
    "uf": "BA"
  },
  {
    "codigo": 2932705,
    "nome": "Uruçuca",
    "uf": "BA"
  },
  {
    "codigo": 2932804,
    "nome": "Utinga",
    "uf": "BA"
  },
  {
    "codigo": 2932903,
    "nome": "Valença",
    "uf": "BA"
  },
  {
    "codigo": 2933000,
    "nome": "Valente",
    "uf": "BA"
  },
  {
    "codigo": 2933059,
    "nome": "Várzea da Roça",
    "uf": "BA"
  },
  {
    "codigo": 2933109,
    "nome": "Várzea do Poço",
    "uf": "BA"
  },
  {
    "codigo": 2933158,
    "nome": "Várzea Nova",
    "uf": "BA"
  },
  {
    "codigo": 2933174,
    "nome": "Varzedo",
    "uf": "BA"
  },
  {
    "codigo": 2933208,
    "nome": "Vera Cruz",
    "uf": "BA"
  },
  {
    "codigo": 2933257,
    "nome": "Vereda",
    "uf": "BA"
  },
  {
    "codigo": 2933307,
    "nome": "Vitória da Conquista",
    "uf": "BA"
  },
  {
    "codigo": 2933406,
    "nome": "Wagner",
    "uf": "BA"
  },
  {
    "codigo": 2933455,
    "nome": "Wanderley",
    "uf": "BA"
  },
  {
    "codigo": 2933505,
    "nome": "Wenceslau Guimarães",
    "uf": "BA"
  },
  {
    "codigo": 2933604,
    "nome": "Xique-Xique",
    "uf": "BA"
  },
  {
    "codigo": 3100104,
    "nome": "Abadia dos Dourados",
    "uf": "MG"
  },
  {
    "codigo": 3100203,
    "nome": "Abaeté",
    "uf": "MG"
  },
  {
    "codigo": 3100302,
    "nome": "Abre Campo",
    "uf": "MG"
  },
  {
    "codigo": 3100401,
    "nome": "Acaiaca",
    "uf": "MG"
  },
  {
    "codigo": 3100500,
    "nome": "Açucena",
    "uf": "MG"
  },
  {
    "codigo": 3100609,
    "nome": "Água Boa",
    "uf": "MG"
  },
  {
    "codigo": 3100708,
    "nome": "Água Comprida",
    "uf": "MG"
  },
  {
    "codigo": 3100807,
    "nome": "Aguanil",
    "uf": "MG"
  },
  {
    "codigo": 3100906,
    "nome": "Águas Formosas",
    "uf": "MG"
  },
  {
    "codigo": 3101003,
    "nome": "Águas Vermelhas",
    "uf": "MG"
  },
  {
    "codigo": 3101102,
    "nome": "Aimorés",
    "uf": "MG"
  },
  {
    "codigo": 3101201,
    "nome": "Aiuruoca",
    "uf": "MG"
  },
  {
    "codigo": 3101300,
    "nome": "Alagoa",
    "uf": "MG"
  },
  {
    "codigo": 3101409,
    "nome": "Albertina",
    "uf": "MG"
  },
  {
    "codigo": 3101508,
    "nome": "Além Paraíba",
    "uf": "MG"
  },
  {
    "codigo": 3101607,
    "nome": "Alfenas",
    "uf": "MG"
  },
  {
    "codigo": 3101631,
    "nome": "Alfredo Vasconcelos",
    "uf": "MG"
  },
  {
    "codigo": 3101706,
    "nome": "Almenara",
    "uf": "MG"
  },
  {
    "codigo": 3101805,
    "nome": "Alpercata",
    "uf": "MG"
  },
  {
    "codigo": 3101904,
    "nome": "Alpinópolis",
    "uf": "MG"
  },
  {
    "codigo": 3102001,
    "nome": "Alterosa",
    "uf": "MG"
  },
  {
    "codigo": 3102050,
    "nome": "Alto Caparaó",
    "uf": "MG"
  },
  {
    "codigo": 3102100,
    "nome": "Alto Rio Doce",
    "uf": "MG"
  },
  {
    "codigo": 3102209,
    "nome": "Alvarenga",
    "uf": "MG"
  },
  {
    "codigo": 3102308,
    "nome": "Alvinópolis",
    "uf": "MG"
  },
  {
    "codigo": 3102407,
    "nome": "Alvorada de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3102506,
    "nome": "Amparo do Serra",
    "uf": "MG"
  },
  {
    "codigo": 3102605,
    "nome": "Andradas",
    "uf": "MG"
  },
  {
    "codigo": 3102704,
    "nome": "Cachoeira de Pajeú",
    "uf": "MG"
  },
  {
    "codigo": 3102803,
    "nome": "Andrelândia",
    "uf": "MG"
  },
  {
    "codigo": 3102852,
    "nome": "Angelândia",
    "uf": "MG"
  },
  {
    "codigo": 3102902,
    "nome": "Antônio Carlos",
    "uf": "MG"
  },
  {
    "codigo": 3103009,
    "nome": "Antônio Dias",
    "uf": "MG"
  },
  {
    "codigo": 3103108,
    "nome": "Antônio Prado de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3103207,
    "nome": "Araçaí",
    "uf": "MG"
  },
  {
    "codigo": 3103306,
    "nome": "Aracitaba",
    "uf": "MG"
  },
  {
    "codigo": 3103405,
    "nome": "Araçuaí",
    "uf": "MG"
  },
  {
    "codigo": 3103504,
    "nome": "Araguari",
    "uf": "MG"
  },
  {
    "codigo": 3103603,
    "nome": "Arantina",
    "uf": "MG"
  },
  {
    "codigo": 3103702,
    "nome": "Araponga",
    "uf": "MG"
  },
  {
    "codigo": 3103751,
    "nome": "Araporã",
    "uf": "MG"
  },
  {
    "codigo": 3103801,
    "nome": "Arapuá",
    "uf": "MG"
  },
  {
    "codigo": 3103900,
    "nome": "Araújos",
    "uf": "MG"
  },
  {
    "codigo": 3104007,
    "nome": "Araxá",
    "uf": "MG"
  },
  {
    "codigo": 3104106,
    "nome": "Arceburgo",
    "uf": "MG"
  },
  {
    "codigo": 3104205,
    "nome": "Arcos",
    "uf": "MG"
  },
  {
    "codigo": 3104304,
    "nome": "Areado",
    "uf": "MG"
  },
  {
    "codigo": 3104403,
    "nome": "Argirita",
    "uf": "MG"
  },
  {
    "codigo": 3104452,
    "nome": "Aricanduva",
    "uf": "MG"
  },
  {
    "codigo": 3104502,
    "nome": "Arinos",
    "uf": "MG"
  },
  {
    "codigo": 3104601,
    "nome": "Astolfo Dutra",
    "uf": "MG"
  },
  {
    "codigo": 3104700,
    "nome": "Ataléia",
    "uf": "MG"
  },
  {
    "codigo": 3104809,
    "nome": "Augusto de Lima",
    "uf": "MG"
  },
  {
    "codigo": 3104908,
    "nome": "Baependi",
    "uf": "MG"
  },
  {
    "codigo": 3105004,
    "nome": "Baldim",
    "uf": "MG"
  },
  {
    "codigo": 3105103,
    "nome": "Bambuí",
    "uf": "MG"
  },
  {
    "codigo": 3105202,
    "nome": "Bandeira",
    "uf": "MG"
  },
  {
    "codigo": 3105301,
    "nome": "Bandeira do Sul",
    "uf": "MG"
  },
  {
    "codigo": 3105400,
    "nome": "Barão de Cocais",
    "uf": "MG"
  },
  {
    "codigo": 3105509,
    "nome": "Barão do Monte Alto",
    "uf": "MG"
  },
  {
    "codigo": 3105608,
    "nome": "Barbacena",
    "uf": "MG"
  },
  {
    "codigo": 3105707,
    "nome": "Barra Longa",
    "uf": "MG"
  },
  {
    "codigo": 3105905,
    "nome": "Barroso",
    "uf": "MG"
  },
  {
    "codigo": 3106002,
    "nome": "Bela Vista de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3106101,
    "nome": "Belmiro Braga",
    "uf": "MG"
  },
  {
    "codigo": 3106200,
    "nome": "Belo Horizonte",
    "uf": "MG"
  },
  {
    "codigo": 3106309,
    "nome": "Belo Oriente",
    "uf": "MG"
  },
  {
    "codigo": 3106408,
    "nome": "Belo Vale",
    "uf": "MG"
  },
  {
    "codigo": 3106507,
    "nome": "Berilo",
    "uf": "MG"
  },
  {
    "codigo": 3106606,
    "nome": "Bertópolis",
    "uf": "MG"
  },
  {
    "codigo": 3106655,
    "nome": "Berizal",
    "uf": "MG"
  },
  {
    "codigo": 3106705,
    "nome": "Betim",
    "uf": "MG"
  },
  {
    "codigo": 3106804,
    "nome": "Bias Fortes",
    "uf": "MG"
  },
  {
    "codigo": 3106903,
    "nome": "Bicas",
    "uf": "MG"
  },
  {
    "codigo": 3107000,
    "nome": "Biquinhas",
    "uf": "MG"
  },
  {
    "codigo": 3107109,
    "nome": "Boa Esperança",
    "uf": "MG"
  },
  {
    "codigo": 3107208,
    "nome": "Bocaina de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3107307,
    "nome": "Bocaiúva",
    "uf": "MG"
  },
  {
    "codigo": 3107406,
    "nome": "Bom Despacho",
    "uf": "MG"
  },
  {
    "codigo": 3107505,
    "nome": "Bom Jardim de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3107604,
    "nome": "Bom Jesus da Penha",
    "uf": "MG"
  },
  {
    "codigo": 3107703,
    "nome": "Bom Jesus do Amparo",
    "uf": "MG"
  },
  {
    "codigo": 3107802,
    "nome": "Bom Jesus do Galho",
    "uf": "MG"
  },
  {
    "codigo": 3107901,
    "nome": "Bom Repouso",
    "uf": "MG"
  },
  {
    "codigo": 3108008,
    "nome": "Bom Sucesso",
    "uf": "MG"
  },
  {
    "codigo": 3108107,
    "nome": "Bonfim",
    "uf": "MG"
  },
  {
    "codigo": 3108206,
    "nome": "Bonfinópolis de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3108255,
    "nome": "Bonito de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3108305,
    "nome": "Borda da Mata",
    "uf": "MG"
  },
  {
    "codigo": 3108404,
    "nome": "Botelhos",
    "uf": "MG"
  },
  {
    "codigo": 3108503,
    "nome": "Botumirim",
    "uf": "MG"
  },
  {
    "codigo": 3108552,
    "nome": "Brasilândia de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3108602,
    "nome": "Brasília de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3108701,
    "nome": "Brás Pires",
    "uf": "MG"
  },
  {
    "codigo": 3108800,
    "nome": "Braúnas",
    "uf": "MG"
  },
  {
    "codigo": 3108909,
    "nome": "Brazópolis",
    "uf": "MG"
  },
  {
    "codigo": 3109006,
    "nome": "Brumadinho",
    "uf": "MG"
  },
  {
    "codigo": 3109105,
    "nome": "Bueno Brandão",
    "uf": "MG"
  },
  {
    "codigo": 3109204,
    "nome": "Buenópolis",
    "uf": "MG"
  },
  {
    "codigo": 3109253,
    "nome": "Bugre",
    "uf": "MG"
  },
  {
    "codigo": 3109303,
    "nome": "Buritis",
    "uf": "MG"
  },
  {
    "codigo": 3109402,
    "nome": "Buritizeiro",
    "uf": "MG"
  },
  {
    "codigo": 3109451,
    "nome": "Cabeceira Grande",
    "uf": "MG"
  },
  {
    "codigo": 3109501,
    "nome": "Cabo Verde",
    "uf": "MG"
  },
  {
    "codigo": 3109600,
    "nome": "Cachoeira da Prata",
    "uf": "MG"
  },
  {
    "codigo": 3109709,
    "nome": "Cachoeira de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3109808,
    "nome": "Cachoeira Dourada",
    "uf": "MG"
  },
  {
    "codigo": 3109907,
    "nome": "Caetanópolis",
    "uf": "MG"
  },
  {
    "codigo": 3110004,
    "nome": "Caeté",
    "uf": "MG"
  },
  {
    "codigo": 3110103,
    "nome": "Caiana",
    "uf": "MG"
  },
  {
    "codigo": 3110202,
    "nome": "Cajuri",
    "uf": "MG"
  },
  {
    "codigo": 3110301,
    "nome": "Caldas",
    "uf": "MG"
  },
  {
    "codigo": 3110400,
    "nome": "Camacho",
    "uf": "MG"
  },
  {
    "codigo": 3110509,
    "nome": "Camanducaia",
    "uf": "MG"
  },
  {
    "codigo": 3110608,
    "nome": "Cambuí",
    "uf": "MG"
  },
  {
    "codigo": 3110707,
    "nome": "Cambuquira",
    "uf": "MG"
  },
  {
    "codigo": 3110806,
    "nome": "Campanário",
    "uf": "MG"
  },
  {
    "codigo": 3110905,
    "nome": "Campanha",
    "uf": "MG"
  },
  {
    "codigo": 3111002,
    "nome": "Campestre",
    "uf": "MG"
  },
  {
    "codigo": 3111101,
    "nome": "Campina Verde",
    "uf": "MG"
  },
  {
    "codigo": 3111150,
    "nome": "Campo Azul",
    "uf": "MG"
  },
  {
    "codigo": 3111200,
    "nome": "Campo Belo",
    "uf": "MG"
  },
  {
    "codigo": 3111309,
    "nome": "Campo do Meio",
    "uf": "MG"
  },
  {
    "codigo": 3111408,
    "nome": "Campo Florido",
    "uf": "MG"
  },
  {
    "codigo": 3111507,
    "nome": "Campos Altos",
    "uf": "MG"
  },
  {
    "codigo": 3111606,
    "nome": "Campos Gerais",
    "uf": "MG"
  },
  {
    "codigo": 3111705,
    "nome": "Canaã",
    "uf": "MG"
  },
  {
    "codigo": 3111804,
    "nome": "Canápolis",
    "uf": "MG"
  },
  {
    "codigo": 3111903,
    "nome": "Cana Verde",
    "uf": "MG"
  },
  {
    "codigo": 3112000,
    "nome": "Candeias",
    "uf": "MG"
  },
  {
    "codigo": 3112059,
    "nome": "Cantagalo",
    "uf": "MG"
  },
  {
    "codigo": 3112109,
    "nome": "Caparaó",
    "uf": "MG"
  },
  {
    "codigo": 3112208,
    "nome": "Capela Nova",
    "uf": "MG"
  },
  {
    "codigo": 3112307,
    "nome": "Capelinha",
    "uf": "MG"
  },
  {
    "codigo": 3112406,
    "nome": "Capetinga",
    "uf": "MG"
  },
  {
    "codigo": 3112505,
    "nome": "Capim Branco",
    "uf": "MG"
  },
  {
    "codigo": 3112604,
    "nome": "Capinópolis",
    "uf": "MG"
  },
  {
    "codigo": 3112653,
    "nome": "Capitão Andrade",
    "uf": "MG"
  },
  {
    "codigo": 3112703,
    "nome": "Capitão Enéas",
    "uf": "MG"
  },
  {
    "codigo": 3112802,
    "nome": "Capitólio",
    "uf": "MG"
  },
  {
    "codigo": 3112901,
    "nome": "Caputira",
    "uf": "MG"
  },
  {
    "codigo": 3113008,
    "nome": "Caraí",
    "uf": "MG"
  },
  {
    "codigo": 3113107,
    "nome": "Caranaíba",
    "uf": "MG"
  },
  {
    "codigo": 3113206,
    "nome": "Carandaí",
    "uf": "MG"
  },
  {
    "codigo": 3113305,
    "nome": "Carangola",
    "uf": "MG"
  },
  {
    "codigo": 3113404,
    "nome": "Caratinga",
    "uf": "MG"
  },
  {
    "codigo": 3113503,
    "nome": "Carbonita",
    "uf": "MG"
  },
  {
    "codigo": 3113602,
    "nome": "Careaçu",
    "uf": "MG"
  },
  {
    "codigo": 3113701,
    "nome": "Carlos Chagas",
    "uf": "MG"
  },
  {
    "codigo": 3113800,
    "nome": "Carmésia",
    "uf": "MG"
  },
  {
    "codigo": 3113909,
    "nome": "Carmo da Cachoeira",
    "uf": "MG"
  },
  {
    "codigo": 3114006,
    "nome": "Carmo da Mata",
    "uf": "MG"
  },
  {
    "codigo": 3114105,
    "nome": "Carmo de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3114204,
    "nome": "Carmo do Cajuru",
    "uf": "MG"
  },
  {
    "codigo": 3114303,
    "nome": "Carmo do Paranaíba",
    "uf": "MG"
  },
  {
    "codigo": 3114402,
    "nome": "Carmo do Rio Claro",
    "uf": "MG"
  },
  {
    "codigo": 3114501,
    "nome": "Carmópolis de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3114550,
    "nome": "Carneirinho",
    "uf": "MG"
  },
  {
    "codigo": 3114600,
    "nome": "Carrancas",
    "uf": "MG"
  },
  {
    "codigo": 3114709,
    "nome": "Carvalhópolis",
    "uf": "MG"
  },
  {
    "codigo": 3114808,
    "nome": "Carvalhos",
    "uf": "MG"
  },
  {
    "codigo": 3114907,
    "nome": "Casa Grande",
    "uf": "MG"
  },
  {
    "codigo": 3115003,
    "nome": "Cascalho Rico",
    "uf": "MG"
  },
  {
    "codigo": 3115102,
    "nome": "Cássia",
    "uf": "MG"
  },
  {
    "codigo": 3115201,
    "nome": "Conceição da Barra de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3115300,
    "nome": "Cataguases",
    "uf": "MG"
  },
  {
    "codigo": 3115359,
    "nome": "Catas Altas",
    "uf": "MG"
  },
  {
    "codigo": 3115409,
    "nome": "Catas Altas da Noruega",
    "uf": "MG"
  },
  {
    "codigo": 3115458,
    "nome": "Catuji",
    "uf": "MG"
  },
  {
    "codigo": 3115474,
    "nome": "Catuti",
    "uf": "MG"
  },
  {
    "codigo": 3115508,
    "nome": "Caxambu",
    "uf": "MG"
  },
  {
    "codigo": 3115607,
    "nome": "Cedro do Abaeté",
    "uf": "MG"
  },
  {
    "codigo": 3115706,
    "nome": "Central de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3115805,
    "nome": "Centralina",
    "uf": "MG"
  },
  {
    "codigo": 3115904,
    "nome": "Chácara",
    "uf": "MG"
  },
  {
    "codigo": 3116001,
    "nome": "Chalé",
    "uf": "MG"
  },
  {
    "codigo": 3116100,
    "nome": "Chapada do Norte",
    "uf": "MG"
  },
  {
    "codigo": 3116159,
    "nome": "Chapada Gaúcha",
    "uf": "MG"
  },
  {
    "codigo": 3116209,
    "nome": "Chiador",
    "uf": "MG"
  },
  {
    "codigo": 3116308,
    "nome": "Cipotânea",
    "uf": "MG"
  },
  {
    "codigo": 3116407,
    "nome": "Claraval",
    "uf": "MG"
  },
  {
    "codigo": 3116506,
    "nome": "Claro dos Poções",
    "uf": "MG"
  },
  {
    "codigo": 3116605,
    "nome": "Cláudio",
    "uf": "MG"
  },
  {
    "codigo": 3116704,
    "nome": "Coimbra",
    "uf": "MG"
  },
  {
    "codigo": 3116803,
    "nome": "Coluna",
    "uf": "MG"
  },
  {
    "codigo": 3116902,
    "nome": "Comendador Gomes",
    "uf": "MG"
  },
  {
    "codigo": 3117009,
    "nome": "Comercinho",
    "uf": "MG"
  },
  {
    "codigo": 3117108,
    "nome": "Conceição da Aparecida",
    "uf": "MG"
  },
  {
    "codigo": 3117207,
    "nome": "Conceição das Pedras",
    "uf": "MG"
  },
  {
    "codigo": 3117306,
    "nome": "Conceição das Alagoas",
    "uf": "MG"
  },
  {
    "codigo": 3117405,
    "nome": "Conceição de Ipanema",
    "uf": "MG"
  },
  {
    "codigo": 3117504,
    "nome": "Conceição do Mato Dentro",
    "uf": "MG"
  },
  {
    "codigo": 3117603,
    "nome": "Conceição do Pará",
    "uf": "MG"
  },
  {
    "codigo": 3117702,
    "nome": "Conceição do Rio Verde",
    "uf": "MG"
  },
  {
    "codigo": 3117801,
    "nome": "Conceição dos Ouros",
    "uf": "MG"
  },
  {
    "codigo": 3117836,
    "nome": "Cônego Marinho",
    "uf": "MG"
  },
  {
    "codigo": 3117876,
    "nome": "Confins",
    "uf": "MG"
  },
  {
    "codigo": 3117900,
    "nome": "Congonhal",
    "uf": "MG"
  },
  {
    "codigo": 3118007,
    "nome": "Congonhas",
    "uf": "MG"
  },
  {
    "codigo": 3118106,
    "nome": "Congonhas do Norte",
    "uf": "MG"
  },
  {
    "codigo": 3118205,
    "nome": "Conquista",
    "uf": "MG"
  },
  {
    "codigo": 3118304,
    "nome": "Conselheiro Lafaiete",
    "uf": "MG"
  },
  {
    "codigo": 3118403,
    "nome": "Conselheiro Pena",
    "uf": "MG"
  },
  {
    "codigo": 3118502,
    "nome": "Consolação",
    "uf": "MG"
  },
  {
    "codigo": 3118601,
    "nome": "Contagem",
    "uf": "MG"
  },
  {
    "codigo": 3118700,
    "nome": "Coqueiral",
    "uf": "MG"
  },
  {
    "codigo": 3118809,
    "nome": "Coração de Jesus",
    "uf": "MG"
  },
  {
    "codigo": 3118908,
    "nome": "Cordisburgo",
    "uf": "MG"
  },
  {
    "codigo": 3119005,
    "nome": "Cordislândia",
    "uf": "MG"
  },
  {
    "codigo": 3119104,
    "nome": "Corinto",
    "uf": "MG"
  },
  {
    "codigo": 3119203,
    "nome": "Coroaci",
    "uf": "MG"
  },
  {
    "codigo": 3119302,
    "nome": "Coromandel",
    "uf": "MG"
  },
  {
    "codigo": 3119401,
    "nome": "Coronel Fabriciano",
    "uf": "MG"
  },
  {
    "codigo": 3119500,
    "nome": "Coronel Murta",
    "uf": "MG"
  },
  {
    "codigo": 3119609,
    "nome": "Coronel Pacheco",
    "uf": "MG"
  },
  {
    "codigo": 3119708,
    "nome": "Coronel Xavier Chaves",
    "uf": "MG"
  },
  {
    "codigo": 3119807,
    "nome": "Córrego Danta",
    "uf": "MG"
  },
  {
    "codigo": 3119906,
    "nome": "Córrego do Bom Jesus",
    "uf": "MG"
  },
  {
    "codigo": 3119955,
    "nome": "Córrego Fundo",
    "uf": "MG"
  },
  {
    "codigo": 3120003,
    "nome": "Córrego Novo",
    "uf": "MG"
  },
  {
    "codigo": 3120102,
    "nome": "Couto de Magalhães de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3120151,
    "nome": "Crisólita",
    "uf": "MG"
  },
  {
    "codigo": 3120201,
    "nome": "Cristais",
    "uf": "MG"
  },
  {
    "codigo": 3120300,
    "nome": "Cristália",
    "uf": "MG"
  },
  {
    "codigo": 3120409,
    "nome": "Cristiano Otoni",
    "uf": "MG"
  },
  {
    "codigo": 3120508,
    "nome": "Cristina",
    "uf": "MG"
  },
  {
    "codigo": 3120607,
    "nome": "Crucilândia",
    "uf": "MG"
  },
  {
    "codigo": 3120706,
    "nome": "Cruzeiro da Fortaleza",
    "uf": "MG"
  },
  {
    "codigo": 3120805,
    "nome": "Cruzília",
    "uf": "MG"
  },
  {
    "codigo": 3120839,
    "nome": "Cuparaque",
    "uf": "MG"
  },
  {
    "codigo": 3120870,
    "nome": "Curral de Dentro",
    "uf": "MG"
  },
  {
    "codigo": 3120904,
    "nome": "Curvelo",
    "uf": "MG"
  },
  {
    "codigo": 3121001,
    "nome": "Datas",
    "uf": "MG"
  },
  {
    "codigo": 3121100,
    "nome": "Delfim Moreira",
    "uf": "MG"
  },
  {
    "codigo": 3121209,
    "nome": "Delfinópolis",
    "uf": "MG"
  },
  {
    "codigo": 3121258,
    "nome": "Delta",
    "uf": "MG"
  },
  {
    "codigo": 3121308,
    "nome": "Descoberto",
    "uf": "MG"
  },
  {
    "codigo": 3121407,
    "nome": "Desterro de Entre Rios",
    "uf": "MG"
  },
  {
    "codigo": 3121506,
    "nome": "Desterro do Melo",
    "uf": "MG"
  },
  {
    "codigo": 3121605,
    "nome": "Diamantina",
    "uf": "MG"
  },
  {
    "codigo": 3121704,
    "nome": "Diogo de Vasconcelos",
    "uf": "MG"
  },
  {
    "codigo": 3121803,
    "nome": "Dionísio",
    "uf": "MG"
  },
  {
    "codigo": 3121902,
    "nome": "Divinésia",
    "uf": "MG"
  },
  {
    "codigo": 3122009,
    "nome": "Divino",
    "uf": "MG"
  },
  {
    "codigo": 3122108,
    "nome": "Divino das Laranjeiras",
    "uf": "MG"
  },
  {
    "codigo": 3122207,
    "nome": "Divinolândia de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3122306,
    "nome": "Divinópolis",
    "uf": "MG"
  },
  {
    "codigo": 3122355,
    "nome": "Divisa Alegre",
    "uf": "MG"
  },
  {
    "codigo": 3122405,
    "nome": "Divisa Nova",
    "uf": "MG"
  },
  {
    "codigo": 3122454,
    "nome": "Divisópolis",
    "uf": "MG"
  },
  {
    "codigo": 3122470,
    "nome": "Dom Bosco",
    "uf": "MG"
  },
  {
    "codigo": 3122504,
    "nome": "Dom Cavati",
    "uf": "MG"
  },
  {
    "codigo": 3122603,
    "nome": "Dom Joaquim",
    "uf": "MG"
  },
  {
    "codigo": 3122702,
    "nome": "Dom Silvério",
    "uf": "MG"
  },
  {
    "codigo": 3122801,
    "nome": "Dom Viçoso",
    "uf": "MG"
  },
  {
    "codigo": 3122900,
    "nome": "Dona Euzébia",
    "uf": "MG"
  },
  {
    "codigo": 3123007,
    "nome": "Dores de Campos",
    "uf": "MG"
  },
  {
    "codigo": 3123106,
    "nome": "Dores de Guanhães",
    "uf": "MG"
  },
  {
    "codigo": 3123205,
    "nome": "Dores do Indaiá",
    "uf": "MG"
  },
  {
    "codigo": 3123304,
    "nome": "Dores do Turvo",
    "uf": "MG"
  },
  {
    "codigo": 3123403,
    "nome": "Doresópolis",
    "uf": "MG"
  },
  {
    "codigo": 3123502,
    "nome": "Douradoquara",
    "uf": "MG"
  },
  {
    "codigo": 3123528,
    "nome": "Durandé",
    "uf": "MG"
  },
  {
    "codigo": 3123601,
    "nome": "Elói Mendes",
    "uf": "MG"
  },
  {
    "codigo": 3123700,
    "nome": "Engenheiro Caldas",
    "uf": "MG"
  },
  {
    "codigo": 3123809,
    "nome": "Engenheiro Navarro",
    "uf": "MG"
  },
  {
    "codigo": 3123858,
    "nome": "Entre Folhas",
    "uf": "MG"
  },
  {
    "codigo": 3123908,
    "nome": "Entre Rios de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3124005,
    "nome": "Ervália",
    "uf": "MG"
  },
  {
    "codigo": 3124104,
    "nome": "Esmeraldas",
    "uf": "MG"
  },
  {
    "codigo": 3124203,
    "nome": "Espera Feliz",
    "uf": "MG"
  },
  {
    "codigo": 3124302,
    "nome": "Espinosa",
    "uf": "MG"
  },
  {
    "codigo": 3124401,
    "nome": "Espírito Santo do Dourado",
    "uf": "MG"
  },
  {
    "codigo": 3124500,
    "nome": "Estiva",
    "uf": "MG"
  },
  {
    "codigo": 3124609,
    "nome": "Estrela Dalva",
    "uf": "MG"
  },
  {
    "codigo": 3124708,
    "nome": "Estrela do Indaiá",
    "uf": "MG"
  },
  {
    "codigo": 3124807,
    "nome": "Estrela do Sul",
    "uf": "MG"
  },
  {
    "codigo": 3124906,
    "nome": "Eugenópolis",
    "uf": "MG"
  },
  {
    "codigo": 3125002,
    "nome": "Ewbank da Câmara",
    "uf": "MG"
  },
  {
    "codigo": 3125101,
    "nome": "Extrema",
    "uf": "MG"
  },
  {
    "codigo": 3125200,
    "nome": "Fama",
    "uf": "MG"
  },
  {
    "codigo": 3125309,
    "nome": "Faria Lemos",
    "uf": "MG"
  },
  {
    "codigo": 3125408,
    "nome": "Felício dos Santos",
    "uf": "MG"
  },
  {
    "codigo": 3125507,
    "nome": "São Gonçalo do Rio Preto",
    "uf": "MG"
  },
  {
    "codigo": 3125606,
    "nome": "Felisburgo",
    "uf": "MG"
  },
  {
    "codigo": 3125705,
    "nome": "Felixlândia",
    "uf": "MG"
  },
  {
    "codigo": 3125804,
    "nome": "Fernandes Tourinho",
    "uf": "MG"
  },
  {
    "codigo": 3125903,
    "nome": "Ferros",
    "uf": "MG"
  },
  {
    "codigo": 3125952,
    "nome": "Fervedouro",
    "uf": "MG"
  },
  {
    "codigo": 3126000,
    "nome": "Florestal",
    "uf": "MG"
  },
  {
    "codigo": 3126109,
    "nome": "Formiga",
    "uf": "MG"
  },
  {
    "codigo": 3126208,
    "nome": "Formoso",
    "uf": "MG"
  },
  {
    "codigo": 3126307,
    "nome": "Fortaleza de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3126406,
    "nome": "Fortuna de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3126505,
    "nome": "Francisco Badaró",
    "uf": "MG"
  },
  {
    "codigo": 3126604,
    "nome": "Francisco Dumont",
    "uf": "MG"
  },
  {
    "codigo": 3126703,
    "nome": "Francisco Sá",
    "uf": "MG"
  },
  {
    "codigo": 3126752,
    "nome": "Franciscópolis",
    "uf": "MG"
  },
  {
    "codigo": 3126802,
    "nome": "Frei Gaspar",
    "uf": "MG"
  },
  {
    "codigo": 3126901,
    "nome": "Frei Inocêncio",
    "uf": "MG"
  },
  {
    "codigo": 3126950,
    "nome": "Frei Lagonegro",
    "uf": "MG"
  },
  {
    "codigo": 3127008,
    "nome": "Fronteira",
    "uf": "MG"
  },
  {
    "codigo": 3127057,
    "nome": "Fronteira dos Vales",
    "uf": "MG"
  },
  {
    "codigo": 3127073,
    "nome": "Fruta de Leite",
    "uf": "MG"
  },
  {
    "codigo": 3127107,
    "nome": "Frutal",
    "uf": "MG"
  },
  {
    "codigo": 3127206,
    "nome": "Funilândia",
    "uf": "MG"
  },
  {
    "codigo": 3127305,
    "nome": "Galiléia",
    "uf": "MG"
  },
  {
    "codigo": 3127339,
    "nome": "Gameleiras",
    "uf": "MG"
  },
  {
    "codigo": 3127354,
    "nome": "Glaucilândia",
    "uf": "MG"
  },
  {
    "codigo": 3127370,
    "nome": "Goiabeira",
    "uf": "MG"
  },
  {
    "codigo": 3127388,
    "nome": "Goianá",
    "uf": "MG"
  },
  {
    "codigo": 3127404,
    "nome": "Gonçalves",
    "uf": "MG"
  },
  {
    "codigo": 3127503,
    "nome": "Gonzaga",
    "uf": "MG"
  },
  {
    "codigo": 3127602,
    "nome": "Gouveia",
    "uf": "MG"
  },
  {
    "codigo": 3127701,
    "nome": "Governador Valadares",
    "uf": "MG"
  },
  {
    "codigo": 3127800,
    "nome": "Grão Mogol",
    "uf": "MG"
  },
  {
    "codigo": 3127909,
    "nome": "Grupiara",
    "uf": "MG"
  },
  {
    "codigo": 3128006,
    "nome": "Guanhães",
    "uf": "MG"
  },
  {
    "codigo": 3128105,
    "nome": "Guapé",
    "uf": "MG"
  },
  {
    "codigo": 3128204,
    "nome": "Guaraciaba",
    "uf": "MG"
  },
  {
    "codigo": 3128253,
    "nome": "Guaraciama",
    "uf": "MG"
  },
  {
    "codigo": 3128303,
    "nome": "Guaranésia",
    "uf": "MG"
  },
  {
    "codigo": 3128402,
    "nome": "Guarani",
    "uf": "MG"
  },
  {
    "codigo": 3128501,
    "nome": "Guarará",
    "uf": "MG"
  },
  {
    "codigo": 3128600,
    "nome": "Guarda-Mor",
    "uf": "MG"
  },
  {
    "codigo": 3128709,
    "nome": "Guaxupé",
    "uf": "MG"
  },
  {
    "codigo": 3128808,
    "nome": "Guidoval",
    "uf": "MG"
  },
  {
    "codigo": 3128907,
    "nome": "Guimarânia",
    "uf": "MG"
  },
  {
    "codigo": 3129004,
    "nome": "Guiricema",
    "uf": "MG"
  },
  {
    "codigo": 3129103,
    "nome": "Gurinhatã",
    "uf": "MG"
  },
  {
    "codigo": 3129202,
    "nome": "Heliodora",
    "uf": "MG"
  },
  {
    "codigo": 3129301,
    "nome": "Iapu",
    "uf": "MG"
  },
  {
    "codigo": 3129400,
    "nome": "Ibertioga",
    "uf": "MG"
  },
  {
    "codigo": 3129509,
    "nome": "Ibiá",
    "uf": "MG"
  },
  {
    "codigo": 3129608,
    "nome": "Ibiaí",
    "uf": "MG"
  },
  {
    "codigo": 3129657,
    "nome": "Ibiracatu",
    "uf": "MG"
  },
  {
    "codigo": 3129707,
    "nome": "Ibiraci",
    "uf": "MG"
  },
  {
    "codigo": 3129806,
    "nome": "Ibirité",
    "uf": "MG"
  },
  {
    "codigo": 3129905,
    "nome": "Ibitiúra de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3130002,
    "nome": "Ibituruna",
    "uf": "MG"
  },
  {
    "codigo": 3130051,
    "nome": "Icaraí de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3130101,
    "nome": "Igarapé",
    "uf": "MG"
  },
  {
    "codigo": 3130200,
    "nome": "Igaratinga",
    "uf": "MG"
  },
  {
    "codigo": 3130309,
    "nome": "Iguatama",
    "uf": "MG"
  },
  {
    "codigo": 3130408,
    "nome": "Ijaci",
    "uf": "MG"
  },
  {
    "codigo": 3130507,
    "nome": "Ilicínea",
    "uf": "MG"
  },
  {
    "codigo": 3130556,
    "nome": "Imbé de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3130606,
    "nome": "Inconfidentes",
    "uf": "MG"
  },
  {
    "codigo": 3130655,
    "nome": "Indaiabira",
    "uf": "MG"
  },
  {
    "codigo": 3130705,
    "nome": "Indianópolis",
    "uf": "MG"
  },
  {
    "codigo": 3130804,
    "nome": "Ingaí",
    "uf": "MG"
  },
  {
    "codigo": 3130903,
    "nome": "Inhapim",
    "uf": "MG"
  },
  {
    "codigo": 3131000,
    "nome": "Inhaúma",
    "uf": "MG"
  },
  {
    "codigo": 3131109,
    "nome": "Inimutaba",
    "uf": "MG"
  },
  {
    "codigo": 3131158,
    "nome": "Ipaba",
    "uf": "MG"
  },
  {
    "codigo": 3131208,
    "nome": "Ipanema",
    "uf": "MG"
  },
  {
    "codigo": 3131307,
    "nome": "Ipatinga",
    "uf": "MG"
  },
  {
    "codigo": 3131406,
    "nome": "Ipiaçu",
    "uf": "MG"
  },
  {
    "codigo": 3131505,
    "nome": "Ipuiúna",
    "uf": "MG"
  },
  {
    "codigo": 3131604,
    "nome": "Iraí de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3131703,
    "nome": "Itabira",
    "uf": "MG"
  },
  {
    "codigo": 3131802,
    "nome": "Itabirinha",
    "uf": "MG"
  },
  {
    "codigo": 3131901,
    "nome": "Itabirito",
    "uf": "MG"
  },
  {
    "codigo": 3132008,
    "nome": "Itacambira",
    "uf": "MG"
  },
  {
    "codigo": 3132107,
    "nome": "Itacarambi",
    "uf": "MG"
  },
  {
    "codigo": 3132206,
    "nome": "Itaguara",
    "uf": "MG"
  },
  {
    "codigo": 3132305,
    "nome": "Itaipé",
    "uf": "MG"
  },
  {
    "codigo": 3132404,
    "nome": "Itajubá",
    "uf": "MG"
  },
  {
    "codigo": 3132503,
    "nome": "Itamarandiba",
    "uf": "MG"
  },
  {
    "codigo": 3132602,
    "nome": "Itamarati de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3132701,
    "nome": "Itambacuri",
    "uf": "MG"
  },
  {
    "codigo": 3132800,
    "nome": "Itambé do Mato Dentro",
    "uf": "MG"
  },
  {
    "codigo": 3132909,
    "nome": "Itamogi",
    "uf": "MG"
  },
  {
    "codigo": 3133006,
    "nome": "Itamonte",
    "uf": "MG"
  },
  {
    "codigo": 3133105,
    "nome": "Itanhandu",
    "uf": "MG"
  },
  {
    "codigo": 3133204,
    "nome": "Itanhomi",
    "uf": "MG"
  },
  {
    "codigo": 3133303,
    "nome": "Itaobim",
    "uf": "MG"
  },
  {
    "codigo": 3133402,
    "nome": "Itapagipe",
    "uf": "MG"
  },
  {
    "codigo": 3133501,
    "nome": "Itapecerica",
    "uf": "MG"
  },
  {
    "codigo": 3133600,
    "nome": "Itapeva",
    "uf": "MG"
  },
  {
    "codigo": 3133709,
    "nome": "Itatiaiuçu",
    "uf": "MG"
  },
  {
    "codigo": 3133758,
    "nome": "Itaú de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3133808,
    "nome": "Itaúna",
    "uf": "MG"
  },
  {
    "codigo": 3133907,
    "nome": "Itaverava",
    "uf": "MG"
  },
  {
    "codigo": 3134004,
    "nome": "Itinga",
    "uf": "MG"
  },
  {
    "codigo": 3134103,
    "nome": "Itueta",
    "uf": "MG"
  },
  {
    "codigo": 3134202,
    "nome": "Ituiutaba",
    "uf": "MG"
  },
  {
    "codigo": 3134301,
    "nome": "Itumirim",
    "uf": "MG"
  },
  {
    "codigo": 3134400,
    "nome": "Iturama",
    "uf": "MG"
  },
  {
    "codigo": 3134509,
    "nome": "Itutinga",
    "uf": "MG"
  },
  {
    "codigo": 3134608,
    "nome": "Jaboticatubas",
    "uf": "MG"
  },
  {
    "codigo": 3134707,
    "nome": "Jacinto",
    "uf": "MG"
  },
  {
    "codigo": 3134806,
    "nome": "Jacuí",
    "uf": "MG"
  },
  {
    "codigo": 3134905,
    "nome": "Jacutinga",
    "uf": "MG"
  },
  {
    "codigo": 3135001,
    "nome": "Jaguaraçu",
    "uf": "MG"
  },
  {
    "codigo": 3135050,
    "nome": "Jaíba",
    "uf": "MG"
  },
  {
    "codigo": 3135076,
    "nome": "Jampruca",
    "uf": "MG"
  },
  {
    "codigo": 3135100,
    "nome": "Janaúba",
    "uf": "MG"
  },
  {
    "codigo": 3135209,
    "nome": "Januária",
    "uf": "MG"
  },
  {
    "codigo": 3135308,
    "nome": "Japaraíba",
    "uf": "MG"
  },
  {
    "codigo": 3135357,
    "nome": "Japonvar",
    "uf": "MG"
  },
  {
    "codigo": 3135407,
    "nome": "Jeceaba",
    "uf": "MG"
  },
  {
    "codigo": 3135456,
    "nome": "Jenipapo de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3135506,
    "nome": "Jequeri",
    "uf": "MG"
  },
  {
    "codigo": 3135605,
    "nome": "Jequitaí",
    "uf": "MG"
  },
  {
    "codigo": 3135704,
    "nome": "Jequitibá",
    "uf": "MG"
  },
  {
    "codigo": 3135803,
    "nome": "Jequitinhonha",
    "uf": "MG"
  },
  {
    "codigo": 3135902,
    "nome": "Jesuânia",
    "uf": "MG"
  },
  {
    "codigo": 3136009,
    "nome": "Joaíma",
    "uf": "MG"
  },
  {
    "codigo": 3136108,
    "nome": "Joanésia",
    "uf": "MG"
  },
  {
    "codigo": 3136207,
    "nome": "João Monlevade",
    "uf": "MG"
  },
  {
    "codigo": 3136306,
    "nome": "João Pinheiro",
    "uf": "MG"
  },
  {
    "codigo": 3136405,
    "nome": "Joaquim Felício",
    "uf": "MG"
  },
  {
    "codigo": 3136504,
    "nome": "Jordânia",
    "uf": "MG"
  },
  {
    "codigo": 3136520,
    "nome": "José Gonçalves de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3136553,
    "nome": "José Raydan",
    "uf": "MG"
  },
  {
    "codigo": 3136579,
    "nome": "Josenópolis",
    "uf": "MG"
  },
  {
    "codigo": 3136603,
    "nome": "Nova União",
    "uf": "MG"
  },
  {
    "codigo": 3136652,
    "nome": "Juatuba",
    "uf": "MG"
  },
  {
    "codigo": 3136702,
    "nome": "Juiz de Fora",
    "uf": "MG"
  },
  {
    "codigo": 3136801,
    "nome": "Juramento",
    "uf": "MG"
  },
  {
    "codigo": 3136900,
    "nome": "Juruaia",
    "uf": "MG"
  },
  {
    "codigo": 3136959,
    "nome": "Juvenília",
    "uf": "MG"
  },
  {
    "codigo": 3137007,
    "nome": "Ladainha",
    "uf": "MG"
  },
  {
    "codigo": 3137106,
    "nome": "Lagamar",
    "uf": "MG"
  },
  {
    "codigo": 3137205,
    "nome": "Lagoa da Prata",
    "uf": "MG"
  },
  {
    "codigo": 3137304,
    "nome": "Lagoa dos Patos",
    "uf": "MG"
  },
  {
    "codigo": 3137403,
    "nome": "Lagoa Dourada",
    "uf": "MG"
  },
  {
    "codigo": 3137502,
    "nome": "Lagoa Formosa",
    "uf": "MG"
  },
  {
    "codigo": 3137536,
    "nome": "Lagoa Grande",
    "uf": "MG"
  },
  {
    "codigo": 3137601,
    "nome": "Lagoa Santa",
    "uf": "MG"
  },
  {
    "codigo": 3137700,
    "nome": "Lajinha",
    "uf": "MG"
  },
  {
    "codigo": 3137809,
    "nome": "Lambari",
    "uf": "MG"
  },
  {
    "codigo": 3137908,
    "nome": "Lamim",
    "uf": "MG"
  },
  {
    "codigo": 3138005,
    "nome": "Laranjal",
    "uf": "MG"
  },
  {
    "codigo": 3138104,
    "nome": "Lassance",
    "uf": "MG"
  },
  {
    "codigo": 3138203,
    "nome": "Lavras",
    "uf": "MG"
  },
  {
    "codigo": 3138302,
    "nome": "Leandro Ferreira",
    "uf": "MG"
  },
  {
    "codigo": 3138351,
    "nome": "Leme do Prado",
    "uf": "MG"
  },
  {
    "codigo": 3138401,
    "nome": "Leopoldina",
    "uf": "MG"
  },
  {
    "codigo": 3138500,
    "nome": "Liberdade",
    "uf": "MG"
  },
  {
    "codigo": 3138609,
    "nome": "Lima Duarte",
    "uf": "MG"
  },
  {
    "codigo": 3138625,
    "nome": "Limeira do Oeste",
    "uf": "MG"
  },
  {
    "codigo": 3138658,
    "nome": "Lontra",
    "uf": "MG"
  },
  {
    "codigo": 3138674,
    "nome": "Luisburgo",
    "uf": "MG"
  },
  {
    "codigo": 3138682,
    "nome": "Luislândia",
    "uf": "MG"
  },
  {
    "codigo": 3138708,
    "nome": "Luminárias",
    "uf": "MG"
  },
  {
    "codigo": 3138807,
    "nome": "Luz",
    "uf": "MG"
  },
  {
    "codigo": 3138906,
    "nome": "Machacalis",
    "uf": "MG"
  },
  {
    "codigo": 3139003,
    "nome": "Machado",
    "uf": "MG"
  },
  {
    "codigo": 3139102,
    "nome": "Madre de Deus de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3139201,
    "nome": "Malacacheta",
    "uf": "MG"
  },
  {
    "codigo": 3139250,
    "nome": "Mamonas",
    "uf": "MG"
  },
  {
    "codigo": 3139300,
    "nome": "Manga",
    "uf": "MG"
  },
  {
    "codigo": 3139409,
    "nome": "Manhuaçu",
    "uf": "MG"
  },
  {
    "codigo": 3139508,
    "nome": "Manhumirim",
    "uf": "MG"
  },
  {
    "codigo": 3139607,
    "nome": "Mantena",
    "uf": "MG"
  },
  {
    "codigo": 3139706,
    "nome": "Maravilhas",
    "uf": "MG"
  },
  {
    "codigo": 3139805,
    "nome": "Mar de Espanha",
    "uf": "MG"
  },
  {
    "codigo": 3139904,
    "nome": "Maria da Fé",
    "uf": "MG"
  },
  {
    "codigo": 3140001,
    "nome": "Mariana",
    "uf": "MG"
  },
  {
    "codigo": 3140100,
    "nome": "Marilac",
    "uf": "MG"
  },
  {
    "codigo": 3140159,
    "nome": "Mário Campos",
    "uf": "MG"
  },
  {
    "codigo": 3140209,
    "nome": "Maripá de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3140308,
    "nome": "Marliéria",
    "uf": "MG"
  },
  {
    "codigo": 3140407,
    "nome": "Marmelópolis",
    "uf": "MG"
  },
  {
    "codigo": 3140506,
    "nome": "Martinho Campos",
    "uf": "MG"
  },
  {
    "codigo": 3140530,
    "nome": "Martins Soares",
    "uf": "MG"
  },
  {
    "codigo": 3140555,
    "nome": "Mata Verde",
    "uf": "MG"
  },
  {
    "codigo": 3140605,
    "nome": "Materlândia",
    "uf": "MG"
  },
  {
    "codigo": 3140704,
    "nome": "Mateus Leme",
    "uf": "MG"
  },
  {
    "codigo": 3140803,
    "nome": "Matias Barbosa",
    "uf": "MG"
  },
  {
    "codigo": 3140852,
    "nome": "Matias Cardoso",
    "uf": "MG"
  },
  {
    "codigo": 3140902,
    "nome": "Matipó",
    "uf": "MG"
  },
  {
    "codigo": 3141009,
    "nome": "Mato Verde",
    "uf": "MG"
  },
  {
    "codigo": 3141108,
    "nome": "Matozinhos",
    "uf": "MG"
  },
  {
    "codigo": 3141207,
    "nome": "Matutina",
    "uf": "MG"
  },
  {
    "codigo": 3141306,
    "nome": "Medeiros",
    "uf": "MG"
  },
  {
    "codigo": 3141405,
    "nome": "Medina",
    "uf": "MG"
  },
  {
    "codigo": 3141504,
    "nome": "Mendes Pimentel",
    "uf": "MG"
  },
  {
    "codigo": 3141603,
    "nome": "Mercês",
    "uf": "MG"
  },
  {
    "codigo": 3141702,
    "nome": "Mesquita",
    "uf": "MG"
  },
  {
    "codigo": 3141801,
    "nome": "Minas Novas",
    "uf": "MG"
  },
  {
    "codigo": 3141900,
    "nome": "Minduri",
    "uf": "MG"
  },
  {
    "codigo": 3142007,
    "nome": "Mirabela",
    "uf": "MG"
  },
  {
    "codigo": 3142106,
    "nome": "Miradouro",
    "uf": "MG"
  },
  {
    "codigo": 3142205,
    "nome": "Miraí",
    "uf": "MG"
  },
  {
    "codigo": 3142254,
    "nome": "Miravânia",
    "uf": "MG"
  },
  {
    "codigo": 3142304,
    "nome": "Moeda",
    "uf": "MG"
  },
  {
    "codigo": 3142403,
    "nome": "Moema",
    "uf": "MG"
  },
  {
    "codigo": 3142502,
    "nome": "Monjolos",
    "uf": "MG"
  },
  {
    "codigo": 3142601,
    "nome": "Monsenhor Paulo",
    "uf": "MG"
  },
  {
    "codigo": 3142700,
    "nome": "Montalvânia",
    "uf": "MG"
  },
  {
    "codigo": 3142809,
    "nome": "Monte Alegre de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3142908,
    "nome": "Monte Azul",
    "uf": "MG"
  },
  {
    "codigo": 3143005,
    "nome": "Monte Belo",
    "uf": "MG"
  },
  {
    "codigo": 3143104,
    "nome": "Monte Carmelo",
    "uf": "MG"
  },
  {
    "codigo": 3143153,
    "nome": "Monte Formoso",
    "uf": "MG"
  },
  {
    "codigo": 3143203,
    "nome": "Monte Santo de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3143302,
    "nome": "Montes Claros",
    "uf": "MG"
  },
  {
    "codigo": 3143401,
    "nome": "Monte Sião",
    "uf": "MG"
  },
  {
    "codigo": 3143450,
    "nome": "Montezuma",
    "uf": "MG"
  },
  {
    "codigo": 3143500,
    "nome": "Morada Nova de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3143609,
    "nome": "Morro da Garça",
    "uf": "MG"
  },
  {
    "codigo": 3143708,
    "nome": "Morro do Pilar",
    "uf": "MG"
  },
  {
    "codigo": 3143807,
    "nome": "Munhoz",
    "uf": "MG"
  },
  {
    "codigo": 3143906,
    "nome": "Muriaé",
    "uf": "MG"
  },
  {
    "codigo": 3144003,
    "nome": "Mutum",
    "uf": "MG"
  },
  {
    "codigo": 3144102,
    "nome": "Muzambinho",
    "uf": "MG"
  },
  {
    "codigo": 3144201,
    "nome": "Nacip Raydan",
    "uf": "MG"
  },
  {
    "codigo": 3144300,
    "nome": "Nanuque",
    "uf": "MG"
  },
  {
    "codigo": 3144359,
    "nome": "Naque",
    "uf": "MG"
  },
  {
    "codigo": 3144375,
    "nome": "Natalândia",
    "uf": "MG"
  },
  {
    "codigo": 3144409,
    "nome": "Natércia",
    "uf": "MG"
  },
  {
    "codigo": 3144508,
    "nome": "Nazareno",
    "uf": "MG"
  },
  {
    "codigo": 3144607,
    "nome": "Nepomuceno",
    "uf": "MG"
  },
  {
    "codigo": 3144656,
    "nome": "Ninheira",
    "uf": "MG"
  },
  {
    "codigo": 3144672,
    "nome": "Nova Belém",
    "uf": "MG"
  },
  {
    "codigo": 3144706,
    "nome": "Nova Era",
    "uf": "MG"
  },
  {
    "codigo": 3144805,
    "nome": "Nova Lima",
    "uf": "MG"
  },
  {
    "codigo": 3144904,
    "nome": "Nova Módica",
    "uf": "MG"
  },
  {
    "codigo": 3145000,
    "nome": "Nova Ponte",
    "uf": "MG"
  },
  {
    "codigo": 3145059,
    "nome": "Nova Porteirinha",
    "uf": "MG"
  },
  {
    "codigo": 3145109,
    "nome": "Nova Resende",
    "uf": "MG"
  },
  {
    "codigo": 3145208,
    "nome": "Nova Serrana",
    "uf": "MG"
  },
  {
    "codigo": 3145307,
    "nome": "Novo Cruzeiro",
    "uf": "MG"
  },
  {
    "codigo": 3145356,
    "nome": "Novo Oriente de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3145372,
    "nome": "Novorizonte",
    "uf": "MG"
  },
  {
    "codigo": 3145406,
    "nome": "Olaria",
    "uf": "MG"
  },
  {
    "codigo": 3145455,
    "nome": "Olhos-d'Água",
    "uf": "MG"
  },
  {
    "codigo": 3145505,
    "nome": "Olímpio Noronha",
    "uf": "MG"
  },
  {
    "codigo": 3145604,
    "nome": "Oliveira",
    "uf": "MG"
  },
  {
    "codigo": 3145703,
    "nome": "Oliveira Fortes",
    "uf": "MG"
  },
  {
    "codigo": 3145802,
    "nome": "Onça de Pitangui",
    "uf": "MG"
  },
  {
    "codigo": 3145851,
    "nome": "Oratórios",
    "uf": "MG"
  },
  {
    "codigo": 3145877,
    "nome": "Orizânia",
    "uf": "MG"
  },
  {
    "codigo": 3145901,
    "nome": "Ouro Branco",
    "uf": "MG"
  },
  {
    "codigo": 3146008,
    "nome": "Ouro Fino",
    "uf": "MG"
  },
  {
    "codigo": 3146107,
    "nome": "Ouro Preto",
    "uf": "MG"
  },
  {
    "codigo": 3146206,
    "nome": "Ouro Verde de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3146255,
    "nome": "Padre Carvalho",
    "uf": "MG"
  },
  {
    "codigo": 3146305,
    "nome": "Padre Paraíso",
    "uf": "MG"
  },
  {
    "codigo": 3146404,
    "nome": "Paineiras",
    "uf": "MG"
  },
  {
    "codigo": 3146503,
    "nome": "Pains",
    "uf": "MG"
  },
  {
    "codigo": 3146552,
    "nome": "Pai Pedro",
    "uf": "MG"
  },
  {
    "codigo": 3146602,
    "nome": "Paiva",
    "uf": "MG"
  },
  {
    "codigo": 3146701,
    "nome": "Palma",
    "uf": "MG"
  },
  {
    "codigo": 3146750,
    "nome": "Palmópolis",
    "uf": "MG"
  },
  {
    "codigo": 3146909,
    "nome": "Papagaios",
    "uf": "MG"
  },
  {
    "codigo": 3147006,
    "nome": "Paracatu",
    "uf": "MG"
  },
  {
    "codigo": 3147105,
    "nome": "Pará de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3147204,
    "nome": "Paraguaçu",
    "uf": "MG"
  },
  {
    "codigo": 3147303,
    "nome": "Paraisópolis",
    "uf": "MG"
  },
  {
    "codigo": 3147402,
    "nome": "Paraopeba",
    "uf": "MG"
  },
  {
    "codigo": 3147501,
    "nome": "Passabém",
    "uf": "MG"
  },
  {
    "codigo": 3147600,
    "nome": "Passa Quatro",
    "uf": "MG"
  },
  {
    "codigo": 3147709,
    "nome": "Passa Tempo",
    "uf": "MG"
  },
  {
    "codigo": 3147808,
    "nome": "Passa Vinte",
    "uf": "MG"
  },
  {
    "codigo": 3147907,
    "nome": "Passos",
    "uf": "MG"
  },
  {
    "codigo": 3147956,
    "nome": "Patis",
    "uf": "MG"
  },
  {
    "codigo": 3148004,
    "nome": "Patos de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3148103,
    "nome": "Patrocínio",
    "uf": "MG"
  },
  {
    "codigo": 3148202,
    "nome": "Patrocínio do Muriaé",
    "uf": "MG"
  },
  {
    "codigo": 3148301,
    "nome": "Paula Cândido",
    "uf": "MG"
  },
  {
    "codigo": 3148400,
    "nome": "Paulistas",
    "uf": "MG"
  },
  {
    "codigo": 3148509,
    "nome": "Pavão",
    "uf": "MG"
  },
  {
    "codigo": 3148608,
    "nome": "Peçanha",
    "uf": "MG"
  },
  {
    "codigo": 3148707,
    "nome": "Pedra Azul",
    "uf": "MG"
  },
  {
    "codigo": 3148756,
    "nome": "Pedra Bonita",
    "uf": "MG"
  },
  {
    "codigo": 3148806,
    "nome": "Pedra do Anta",
    "uf": "MG"
  },
  {
    "codigo": 3148905,
    "nome": "Pedra do Indaiá",
    "uf": "MG"
  },
  {
    "codigo": 3149002,
    "nome": "Pedra Dourada",
    "uf": "MG"
  },
  {
    "codigo": 3149101,
    "nome": "Pedralva",
    "uf": "MG"
  },
  {
    "codigo": 3149150,
    "nome": "Pedras de Maria da Cruz",
    "uf": "MG"
  },
  {
    "codigo": 3149200,
    "nome": "Pedrinópolis",
    "uf": "MG"
  },
  {
    "codigo": 3149309,
    "nome": "Pedro Leopoldo",
    "uf": "MG"
  },
  {
    "codigo": 3149408,
    "nome": "Pedro Teixeira",
    "uf": "MG"
  },
  {
    "codigo": 3149507,
    "nome": "Pequeri",
    "uf": "MG"
  },
  {
    "codigo": 3149606,
    "nome": "Pequi",
    "uf": "MG"
  },
  {
    "codigo": 3149705,
    "nome": "Perdigão",
    "uf": "MG"
  },
  {
    "codigo": 3149804,
    "nome": "Perdizes",
    "uf": "MG"
  },
  {
    "codigo": 3149903,
    "nome": "Perdões",
    "uf": "MG"
  },
  {
    "codigo": 3149952,
    "nome": "Periquito",
    "uf": "MG"
  },
  {
    "codigo": 3150000,
    "nome": "Pescador",
    "uf": "MG"
  },
  {
    "codigo": 3150109,
    "nome": "Piau",
    "uf": "MG"
  },
  {
    "codigo": 3150158,
    "nome": "Piedade de Caratinga",
    "uf": "MG"
  },
  {
    "codigo": 3150208,
    "nome": "Piedade de Ponte Nova",
    "uf": "MG"
  },
  {
    "codigo": 3150307,
    "nome": "Piedade do Rio Grande",
    "uf": "MG"
  },
  {
    "codigo": 3150406,
    "nome": "Piedade dos Gerais",
    "uf": "MG"
  },
  {
    "codigo": 3150505,
    "nome": "Pimenta",
    "uf": "MG"
  },
  {
    "codigo": 3150539,
    "nome": "Pingo-d'Água",
    "uf": "MG"
  },
  {
    "codigo": 3150570,
    "nome": "Pintópolis",
    "uf": "MG"
  },
  {
    "codigo": 3150604,
    "nome": "Piracema",
    "uf": "MG"
  },
  {
    "codigo": 3150703,
    "nome": "Pirajuba",
    "uf": "MG"
  },
  {
    "codigo": 3150802,
    "nome": "Piranga",
    "uf": "MG"
  },
  {
    "codigo": 3150901,
    "nome": "Piranguçu",
    "uf": "MG"
  },
  {
    "codigo": 3151008,
    "nome": "Piranguinho",
    "uf": "MG"
  },
  {
    "codigo": 3151107,
    "nome": "Pirapetinga",
    "uf": "MG"
  },
  {
    "codigo": 3151206,
    "nome": "Pirapora",
    "uf": "MG"
  },
  {
    "codigo": 3151305,
    "nome": "Piraúba",
    "uf": "MG"
  },
  {
    "codigo": 3151404,
    "nome": "Pitangui",
    "uf": "MG"
  },
  {
    "codigo": 3151503,
    "nome": "Piumhi",
    "uf": "MG"
  },
  {
    "codigo": 3151602,
    "nome": "Planura",
    "uf": "MG"
  },
  {
    "codigo": 3151701,
    "nome": "Poço Fundo",
    "uf": "MG"
  },
  {
    "codigo": 3151800,
    "nome": "Poços de Caldas",
    "uf": "MG"
  },
  {
    "codigo": 3151909,
    "nome": "Pocrane",
    "uf": "MG"
  },
  {
    "codigo": 3152006,
    "nome": "Pompéu",
    "uf": "MG"
  },
  {
    "codigo": 3152105,
    "nome": "Ponte Nova",
    "uf": "MG"
  },
  {
    "codigo": 3152131,
    "nome": "Ponto Chique",
    "uf": "MG"
  },
  {
    "codigo": 3152170,
    "nome": "Ponto dos Volantes",
    "uf": "MG"
  },
  {
    "codigo": 3152204,
    "nome": "Porteirinha",
    "uf": "MG"
  },
  {
    "codigo": 3152303,
    "nome": "Porto Firme",
    "uf": "MG"
  },
  {
    "codigo": 3152402,
    "nome": "Poté",
    "uf": "MG"
  },
  {
    "codigo": 3152501,
    "nome": "Pouso Alegre",
    "uf": "MG"
  },
  {
    "codigo": 3152600,
    "nome": "Pouso Alto",
    "uf": "MG"
  },
  {
    "codigo": 3152709,
    "nome": "Prados",
    "uf": "MG"
  },
  {
    "codigo": 3152808,
    "nome": "Prata",
    "uf": "MG"
  },
  {
    "codigo": 3152907,
    "nome": "Pratápolis",
    "uf": "MG"
  },
  {
    "codigo": 3153004,
    "nome": "Pratinha",
    "uf": "MG"
  },
  {
    "codigo": 3153103,
    "nome": "Presidente Bernardes",
    "uf": "MG"
  },
  {
    "codigo": 3153202,
    "nome": "Presidente Juscelino",
    "uf": "MG"
  },
  {
    "codigo": 3153301,
    "nome": "Presidente Kubitschek",
    "uf": "MG"
  },
  {
    "codigo": 3153400,
    "nome": "Presidente Olegário",
    "uf": "MG"
  },
  {
    "codigo": 3153509,
    "nome": "Alto Jequitibá",
    "uf": "MG"
  },
  {
    "codigo": 3153608,
    "nome": "Prudente de Morais",
    "uf": "MG"
  },
  {
    "codigo": 3153707,
    "nome": "Quartel Geral",
    "uf": "MG"
  },
  {
    "codigo": 3153806,
    "nome": "Queluzito",
    "uf": "MG"
  },
  {
    "codigo": 3153905,
    "nome": "Raposos",
    "uf": "MG"
  },
  {
    "codigo": 3154002,
    "nome": "Raul Soares",
    "uf": "MG"
  },
  {
    "codigo": 3154101,
    "nome": "Recreio",
    "uf": "MG"
  },
  {
    "codigo": 3154150,
    "nome": "Reduto",
    "uf": "MG"
  },
  {
    "codigo": 3154200,
    "nome": "Resende Costa",
    "uf": "MG"
  },
  {
    "codigo": 3154309,
    "nome": "Resplendor",
    "uf": "MG"
  },
  {
    "codigo": 3154408,
    "nome": "Ressaquinha",
    "uf": "MG"
  },
  {
    "codigo": 3154457,
    "nome": "Riachinho",
    "uf": "MG"
  },
  {
    "codigo": 3154507,
    "nome": "Riacho dos Machados",
    "uf": "MG"
  },
  {
    "codigo": 3154606,
    "nome": "Ribeirão das Neves",
    "uf": "MG"
  },
  {
    "codigo": 3154705,
    "nome": "Ribeirão Vermelho",
    "uf": "MG"
  },
  {
    "codigo": 3154804,
    "nome": "Rio Acima",
    "uf": "MG"
  },
  {
    "codigo": 3154903,
    "nome": "Rio Casca",
    "uf": "MG"
  },
  {
    "codigo": 3155009,
    "nome": "Rio Doce",
    "uf": "MG"
  },
  {
    "codigo": 3155108,
    "nome": "Rio do Prado",
    "uf": "MG"
  },
  {
    "codigo": 3155207,
    "nome": "Rio Espera",
    "uf": "MG"
  },
  {
    "codigo": 3155306,
    "nome": "Rio Manso",
    "uf": "MG"
  },
  {
    "codigo": 3155405,
    "nome": "Rio Novo",
    "uf": "MG"
  },
  {
    "codigo": 3155504,
    "nome": "Rio Paranaíba",
    "uf": "MG"
  },
  {
    "codigo": 3155603,
    "nome": "Rio Pardo de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3155702,
    "nome": "Rio Piracicaba",
    "uf": "MG"
  },
  {
    "codigo": 3155801,
    "nome": "Rio Pomba",
    "uf": "MG"
  },
  {
    "codigo": 3155900,
    "nome": "Rio Preto",
    "uf": "MG"
  },
  {
    "codigo": 3156007,
    "nome": "Rio Vermelho",
    "uf": "MG"
  },
  {
    "codigo": 3156106,
    "nome": "Ritápolis",
    "uf": "MG"
  },
  {
    "codigo": 3156205,
    "nome": "Rochedo de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3156304,
    "nome": "Rodeiro",
    "uf": "MG"
  },
  {
    "codigo": 3156403,
    "nome": "Romaria",
    "uf": "MG"
  },
  {
    "codigo": 3156452,
    "nome": "Rosário da Limeira",
    "uf": "MG"
  },
  {
    "codigo": 3156502,
    "nome": "Rubelita",
    "uf": "MG"
  },
  {
    "codigo": 3156601,
    "nome": "Rubim",
    "uf": "MG"
  },
  {
    "codigo": 3156700,
    "nome": "Sabará",
    "uf": "MG"
  },
  {
    "codigo": 3156809,
    "nome": "Sabinópolis",
    "uf": "MG"
  },
  {
    "codigo": 3156908,
    "nome": "Sacramento",
    "uf": "MG"
  },
  {
    "codigo": 3157005,
    "nome": "Salinas",
    "uf": "MG"
  },
  {
    "codigo": 3157104,
    "nome": "Salto da Divisa",
    "uf": "MG"
  },
  {
    "codigo": 3157203,
    "nome": "Santa Bárbara",
    "uf": "MG"
  },
  {
    "codigo": 3157252,
    "nome": "Santa Bárbara do Leste",
    "uf": "MG"
  },
  {
    "codigo": 3157278,
    "nome": "Santa Bárbara do Monte Verde",
    "uf": "MG"
  },
  {
    "codigo": 3157302,
    "nome": "Santa Bárbara do Tugúrio",
    "uf": "MG"
  },
  {
    "codigo": 3157336,
    "nome": "Santa Cruz de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3157377,
    "nome": "Santa Cruz de Salinas",
    "uf": "MG"
  },
  {
    "codigo": 3157401,
    "nome": "Santa Cruz do Escalvado",
    "uf": "MG"
  },
  {
    "codigo": 3157500,
    "nome": "Santa Efigênia de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3157609,
    "nome": "Santa Fé de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3157658,
    "nome": "Santa Helena de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3157708,
    "nome": "Santa Juliana",
    "uf": "MG"
  },
  {
    "codigo": 3157807,
    "nome": "Santa Luzia",
    "uf": "MG"
  },
  {
    "codigo": 3157906,
    "nome": "Santa Margarida",
    "uf": "MG"
  },
  {
    "codigo": 3158003,
    "nome": "Santa Maria de Itabira",
    "uf": "MG"
  },
  {
    "codigo": 3158102,
    "nome": "Santa Maria do Salto",
    "uf": "MG"
  },
  {
    "codigo": 3158201,
    "nome": "Santa Maria do Suaçuí",
    "uf": "MG"
  },
  {
    "codigo": 3158300,
    "nome": "Santana da Vargem",
    "uf": "MG"
  },
  {
    "codigo": 3158409,
    "nome": "Santana de Cataguases",
    "uf": "MG"
  },
  {
    "codigo": 3158508,
    "nome": "Santana de Pirapama",
    "uf": "MG"
  },
  {
    "codigo": 3158607,
    "nome": "Santana do Deserto",
    "uf": "MG"
  },
  {
    "codigo": 3158706,
    "nome": "Santana do Garambéu",
    "uf": "MG"
  },
  {
    "codigo": 3158805,
    "nome": "Santana do Jacaré",
    "uf": "MG"
  },
  {
    "codigo": 3158904,
    "nome": "Santana do Manhuaçu",
    "uf": "MG"
  },
  {
    "codigo": 3158953,
    "nome": "Santana do Paraíso",
    "uf": "MG"
  },
  {
    "codigo": 3159001,
    "nome": "Santana do Riacho",
    "uf": "MG"
  },
  {
    "codigo": 3159100,
    "nome": "Santana dos Montes",
    "uf": "MG"
  },
  {
    "codigo": 3159209,
    "nome": "Santa Rita de Caldas",
    "uf": "MG"
  },
  {
    "codigo": 3159308,
    "nome": "Santa Rita de Jacutinga",
    "uf": "MG"
  },
  {
    "codigo": 3159357,
    "nome": "Santa Rita de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3159407,
    "nome": "Santa Rita de Ibitipoca",
    "uf": "MG"
  },
  {
    "codigo": 3159506,
    "nome": "Santa Rita do Itueto",
    "uf": "MG"
  },
  {
    "codigo": 3159605,
    "nome": "Santa Rita do Sapucaí",
    "uf": "MG"
  },
  {
    "codigo": 3159704,
    "nome": "Santa Rosa da Serra",
    "uf": "MG"
  },
  {
    "codigo": 3159803,
    "nome": "Santa Vitória",
    "uf": "MG"
  },
  {
    "codigo": 3159902,
    "nome": "Santo Antônio do Amparo",
    "uf": "MG"
  },
  {
    "codigo": 3160009,
    "nome": "Santo Antônio do Aventureiro",
    "uf": "MG"
  },
  {
    "codigo": 3160108,
    "nome": "Santo Antônio do Grama",
    "uf": "MG"
  },
  {
    "codigo": 3160207,
    "nome": "Santo Antônio do Itambé",
    "uf": "MG"
  },
  {
    "codigo": 3160306,
    "nome": "Santo Antônio do Jacinto",
    "uf": "MG"
  },
  {
    "codigo": 3160405,
    "nome": "Santo Antônio do Monte",
    "uf": "MG"
  },
  {
    "codigo": 3160454,
    "nome": "Santo Antônio do Retiro",
    "uf": "MG"
  },
  {
    "codigo": 3160504,
    "nome": "Santo Antônio do Rio Abaixo",
    "uf": "MG"
  },
  {
    "codigo": 3160603,
    "nome": "Santo Hipólito",
    "uf": "MG"
  },
  {
    "codigo": 3160702,
    "nome": "Santos Dumont",
    "uf": "MG"
  },
  {
    "codigo": 3160801,
    "nome": "São Bento Abade",
    "uf": "MG"
  },
  {
    "codigo": 3160900,
    "nome": "São Brás do Suaçuí",
    "uf": "MG"
  },
  {
    "codigo": 3160959,
    "nome": "São Domingos das Dores",
    "uf": "MG"
  },
  {
    "codigo": 3161007,
    "nome": "São Domingos do Prata",
    "uf": "MG"
  },
  {
    "codigo": 3161056,
    "nome": "São Félix de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3161106,
    "nome": "São Francisco",
    "uf": "MG"
  },
  {
    "codigo": 3161205,
    "nome": "São Francisco de Paula",
    "uf": "MG"
  },
  {
    "codigo": 3161304,
    "nome": "São Francisco de Sales",
    "uf": "MG"
  },
  {
    "codigo": 3161403,
    "nome": "São Francisco do Glória",
    "uf": "MG"
  },
  {
    "codigo": 3161502,
    "nome": "São Geraldo",
    "uf": "MG"
  },
  {
    "codigo": 3161601,
    "nome": "São Geraldo da Piedade",
    "uf": "MG"
  },
  {
    "codigo": 3161650,
    "nome": "São Geraldo do Baixio",
    "uf": "MG"
  },
  {
    "codigo": 3161700,
    "nome": "São Gonçalo do Abaeté",
    "uf": "MG"
  },
  {
    "codigo": 3161809,
    "nome": "São Gonçalo do Pará",
    "uf": "MG"
  },
  {
    "codigo": 3161908,
    "nome": "São Gonçalo do Rio Abaixo",
    "uf": "MG"
  },
  {
    "codigo": 3162005,
    "nome": "São Gonçalo do Sapucaí",
    "uf": "MG"
  },
  {
    "codigo": 3162104,
    "nome": "São Gotardo",
    "uf": "MG"
  },
  {
    "codigo": 3162203,
    "nome": "São João Batista do Glória",
    "uf": "MG"
  },
  {
    "codigo": 3162252,
    "nome": "São João da Lagoa",
    "uf": "MG"
  },
  {
    "codigo": 3162302,
    "nome": "São João da Mata",
    "uf": "MG"
  },
  {
    "codigo": 3162401,
    "nome": "São João da Ponte",
    "uf": "MG"
  },
  {
    "codigo": 3162450,
    "nome": "São João das Missões",
    "uf": "MG"
  },
  {
    "codigo": 3162500,
    "nome": "São João del Rei",
    "uf": "MG"
  },
  {
    "codigo": 3162559,
    "nome": "São João do Manhuaçu",
    "uf": "MG"
  },
  {
    "codigo": 3162575,
    "nome": "São João do Manteninha",
    "uf": "MG"
  },
  {
    "codigo": 3162609,
    "nome": "São João do Oriente",
    "uf": "MG"
  },
  {
    "codigo": 3162658,
    "nome": "São João do Pacuí",
    "uf": "MG"
  },
  {
    "codigo": 3162708,
    "nome": "São João do Paraíso",
    "uf": "MG"
  },
  {
    "codigo": 3162807,
    "nome": "São João Evangelista",
    "uf": "MG"
  },
  {
    "codigo": 3162906,
    "nome": "São João Nepomuceno",
    "uf": "MG"
  },
  {
    "codigo": 3162922,
    "nome": "São Joaquim de Bicas",
    "uf": "MG"
  },
  {
    "codigo": 3162948,
    "nome": "São José da Barra",
    "uf": "MG"
  },
  {
    "codigo": 3162955,
    "nome": "São José da Lapa",
    "uf": "MG"
  },
  {
    "codigo": 3163003,
    "nome": "São José da Safira",
    "uf": "MG"
  },
  {
    "codigo": 3163102,
    "nome": "São José da Varginha",
    "uf": "MG"
  },
  {
    "codigo": 3163201,
    "nome": "São José do Alegre",
    "uf": "MG"
  },
  {
    "codigo": 3163300,
    "nome": "São José do Divino",
    "uf": "MG"
  },
  {
    "codigo": 3163409,
    "nome": "São José do Goiabal",
    "uf": "MG"
  },
  {
    "codigo": 3163508,
    "nome": "São José do Jacuri",
    "uf": "MG"
  },
  {
    "codigo": 3163607,
    "nome": "São José do Mantimento",
    "uf": "MG"
  },
  {
    "codigo": 3163706,
    "nome": "São Lourenço",
    "uf": "MG"
  },
  {
    "codigo": 3163805,
    "nome": "São Miguel do Anta",
    "uf": "MG"
  },
  {
    "codigo": 3163904,
    "nome": "São Pedro da União",
    "uf": "MG"
  },
  {
    "codigo": 3164001,
    "nome": "São Pedro dos Ferros",
    "uf": "MG"
  },
  {
    "codigo": 3164100,
    "nome": "São Pedro do Suaçuí",
    "uf": "MG"
  },
  {
    "codigo": 3164209,
    "nome": "São Romão",
    "uf": "MG"
  },
  {
    "codigo": 3164308,
    "nome": "São Roque de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3164407,
    "nome": "São Sebastião da Bela Vista",
    "uf": "MG"
  },
  {
    "codigo": 3164431,
    "nome": "São Sebastião da Vargem Alegre",
    "uf": "MG"
  },
  {
    "codigo": 3164472,
    "nome": "São Sebastião do Anta",
    "uf": "MG"
  },
  {
    "codigo": 3164506,
    "nome": "São Sebastião do Maranhão",
    "uf": "MG"
  },
  {
    "codigo": 3164605,
    "nome": "São Sebastião do Oeste",
    "uf": "MG"
  },
  {
    "codigo": 3164704,
    "nome": "São Sebastião do Paraíso",
    "uf": "MG"
  },
  {
    "codigo": 3164803,
    "nome": "São Sebastião do Rio Preto",
    "uf": "MG"
  },
  {
    "codigo": 3164902,
    "nome": "São Sebastião do Rio Verde",
    "uf": "MG"
  },
  {
    "codigo": 3165008,
    "nome": "São Tiago",
    "uf": "MG"
  },
  {
    "codigo": 3165107,
    "nome": "São Tomás de Aquino",
    "uf": "MG"
  },
  {
    "codigo": 3165206,
    "nome": "São Tomé das Letras",
    "uf": "MG"
  },
  {
    "codigo": 3165305,
    "nome": "São Vicente de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3165404,
    "nome": "Sapucaí-Mirim",
    "uf": "MG"
  },
  {
    "codigo": 3165503,
    "nome": "Sardoá",
    "uf": "MG"
  },
  {
    "codigo": 3165537,
    "nome": "Sarzedo",
    "uf": "MG"
  },
  {
    "codigo": 3165552,
    "nome": "Setubinha",
    "uf": "MG"
  },
  {
    "codigo": 3165560,
    "nome": "Sem-Peixe",
    "uf": "MG"
  },
  {
    "codigo": 3165578,
    "nome": "Senador Amaral",
    "uf": "MG"
  },
  {
    "codigo": 3165602,
    "nome": "Senador Cortes",
    "uf": "MG"
  },
  {
    "codigo": 3165701,
    "nome": "Senador Firmino",
    "uf": "MG"
  },
  {
    "codigo": 3165800,
    "nome": "Senador José Bento",
    "uf": "MG"
  },
  {
    "codigo": 3165909,
    "nome": "Senador Modestino Gonçalves",
    "uf": "MG"
  },
  {
    "codigo": 3166006,
    "nome": "Senhora de Oliveira",
    "uf": "MG"
  },
  {
    "codigo": 3166105,
    "nome": "Senhora do Porto",
    "uf": "MG"
  },
  {
    "codigo": 3166204,
    "nome": "Senhora dos Remédios",
    "uf": "MG"
  },
  {
    "codigo": 3166303,
    "nome": "Sericita",
    "uf": "MG"
  },
  {
    "codigo": 3166402,
    "nome": "Seritinga",
    "uf": "MG"
  },
  {
    "codigo": 3166501,
    "nome": "Serra Azul de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3166600,
    "nome": "Serra da Saudade",
    "uf": "MG"
  },
  {
    "codigo": 3166709,
    "nome": "Serra dos Aimorés",
    "uf": "MG"
  },
  {
    "codigo": 3166808,
    "nome": "Serra do Salitre",
    "uf": "MG"
  },
  {
    "codigo": 3166907,
    "nome": "Serrania",
    "uf": "MG"
  },
  {
    "codigo": 3166956,
    "nome": "Serranópolis de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3167004,
    "nome": "Serranos",
    "uf": "MG"
  },
  {
    "codigo": 3167103,
    "nome": "Serro",
    "uf": "MG"
  },
  {
    "codigo": 3167202,
    "nome": "Sete Lagoas",
    "uf": "MG"
  },
  {
    "codigo": 3167301,
    "nome": "Silveirânia",
    "uf": "MG"
  },
  {
    "codigo": 3167400,
    "nome": "Silvianópolis",
    "uf": "MG"
  },
  {
    "codigo": 3167509,
    "nome": "Simão Pereira",
    "uf": "MG"
  },
  {
    "codigo": 3167608,
    "nome": "Simonésia",
    "uf": "MG"
  },
  {
    "codigo": 3167707,
    "nome": "Sobrália",
    "uf": "MG"
  },
  {
    "codigo": 3167806,
    "nome": "Soledade de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3167905,
    "nome": "Tabuleiro",
    "uf": "MG"
  },
  {
    "codigo": 3168002,
    "nome": "Taiobeiras",
    "uf": "MG"
  },
  {
    "codigo": 3168051,
    "nome": "Taparuba",
    "uf": "MG"
  },
  {
    "codigo": 3168101,
    "nome": "Tapira",
    "uf": "MG"
  },
  {
    "codigo": 3168200,
    "nome": "Tapiraí",
    "uf": "MG"
  },
  {
    "codigo": 3168309,
    "nome": "Taquaraçu de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3168408,
    "nome": "Tarumirim",
    "uf": "MG"
  },
  {
    "codigo": 3168507,
    "nome": "Teixeiras",
    "uf": "MG"
  },
  {
    "codigo": 3168606,
    "nome": "Teófilo Otoni",
    "uf": "MG"
  },
  {
    "codigo": 3168705,
    "nome": "Timóteo",
    "uf": "MG"
  },
  {
    "codigo": 3168804,
    "nome": "Tiradentes",
    "uf": "MG"
  },
  {
    "codigo": 3168903,
    "nome": "Tiros",
    "uf": "MG"
  },
  {
    "codigo": 3169000,
    "nome": "Tocantins",
    "uf": "MG"
  },
  {
    "codigo": 3169059,
    "nome": "Tocos do Moji",
    "uf": "MG"
  },
  {
    "codigo": 3169109,
    "nome": "Toledo",
    "uf": "MG"
  },
  {
    "codigo": 3169208,
    "nome": "Tombos",
    "uf": "MG"
  },
  {
    "codigo": 3169307,
    "nome": "Três Corações",
    "uf": "MG"
  },
  {
    "codigo": 3169356,
    "nome": "Três Marias",
    "uf": "MG"
  },
  {
    "codigo": 3169406,
    "nome": "Três Pontas",
    "uf": "MG"
  },
  {
    "codigo": 3169505,
    "nome": "Tumiritinga",
    "uf": "MG"
  },
  {
    "codigo": 3169604,
    "nome": "Tupaciguara",
    "uf": "MG"
  },
  {
    "codigo": 3169703,
    "nome": "Turmalina",
    "uf": "MG"
  },
  {
    "codigo": 3169802,
    "nome": "Turvolândia",
    "uf": "MG"
  },
  {
    "codigo": 3169901,
    "nome": "Ubá",
    "uf": "MG"
  },
  {
    "codigo": 3170008,
    "nome": "Ubaí",
    "uf": "MG"
  },
  {
    "codigo": 3170057,
    "nome": "Ubaporanga",
    "uf": "MG"
  },
  {
    "codigo": 3170107,
    "nome": "Uberaba",
    "uf": "MG"
  },
  {
    "codigo": 3170206,
    "nome": "Uberlândia",
    "uf": "MG"
  },
  {
    "codigo": 3170305,
    "nome": "Umburatiba",
    "uf": "MG"
  },
  {
    "codigo": 3170404,
    "nome": "Unaí",
    "uf": "MG"
  },
  {
    "codigo": 3170438,
    "nome": "União de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3170479,
    "nome": "Uruana de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3170503,
    "nome": "Urucânia",
    "uf": "MG"
  },
  {
    "codigo": 3170529,
    "nome": "Urucuia",
    "uf": "MG"
  },
  {
    "codigo": 3170578,
    "nome": "Vargem Alegre",
    "uf": "MG"
  },
  {
    "codigo": 3170602,
    "nome": "Vargem Bonita",
    "uf": "MG"
  },
  {
    "codigo": 3170651,
    "nome": "Vargem Grande do Rio Pardo",
    "uf": "MG"
  },
  {
    "codigo": 3170701,
    "nome": "Varginha",
    "uf": "MG"
  },
  {
    "codigo": 3170750,
    "nome": "Varjão de Minas",
    "uf": "MG"
  },
  {
    "codigo": 3170800,
    "nome": "Várzea da Palma",
    "uf": "MG"
  },
  {
    "codigo": 3170909,
    "nome": "Varzelândia",
    "uf": "MG"
  },
  {
    "codigo": 3171006,
    "nome": "Vazante",
    "uf": "MG"
  },
  {
    "codigo": 3171030,
    "nome": "Verdelândia",
    "uf": "MG"
  },
  {
    "codigo": 3171071,
    "nome": "Veredinha",
    "uf": "MG"
  },
  {
    "codigo": 3171105,
    "nome": "Veríssimo",
    "uf": "MG"
  },
  {
    "codigo": 3171154,
    "nome": "Vermelho Novo",
    "uf": "MG"
  },
  {
    "codigo": 3171204,
    "nome": "Vespasiano",
    "uf": "MG"
  },
  {
    "codigo": 3171303,
    "nome": "Viçosa",
    "uf": "MG"
  },
  {
    "codigo": 3171402,
    "nome": "Vieiras",
    "uf": "MG"
  },
  {
    "codigo": 3171501,
    "nome": "Mathias Lobato",
    "uf": "MG"
  },
  {
    "codigo": 3171600,
    "nome": "Virgem da Lapa",
    "uf": "MG"
  },
  {
    "codigo": 3171709,
    "nome": "Virgínia",
    "uf": "MG"
  },
  {
    "codigo": 3171808,
    "nome": "Virginópolis",
    "uf": "MG"
  },
  {
    "codigo": 3171907,
    "nome": "Virgolândia",
    "uf": "MG"
  },
  {
    "codigo": 3172004,
    "nome": "Visconde do Rio Branco",
    "uf": "MG"
  },
  {
    "codigo": 3172103,
    "nome": "Volta Grande",
    "uf": "MG"
  },
  {
    "codigo": 3172202,
    "nome": "Wenceslau Braz",
    "uf": "MG"
  },
  {
    "codigo": 3200102,
    "nome": "Afonso Cláudio",
    "uf": "ES"
  },
  {
    "codigo": 3200136,
    "nome": "Águia Branca",
    "uf": "ES"
  },
  {
    "codigo": 3200169,
    "nome": "Água Doce do Norte",
    "uf": "ES"
  },
  {
    "codigo": 3200201,
    "nome": "Alegre",
    "uf": "ES"
  },
  {
    "codigo": 3200300,
    "nome": "Alfredo Chaves",
    "uf": "ES"
  },
  {
    "codigo": 3200359,
    "nome": "Alto Rio Novo",
    "uf": "ES"
  },
  {
    "codigo": 3200409,
    "nome": "Anchieta",
    "uf": "ES"
  },
  {
    "codigo": 3200508,
    "nome": "Apiacá",
    "uf": "ES"
  },
  {
    "codigo": 3200607,
    "nome": "Aracruz",
    "uf": "ES"
  },
  {
    "codigo": 3200706,
    "nome": "Atílio Vivácqua",
    "uf": "ES"
  },
  {
    "codigo": 3200805,
    "nome": "Baixo Guandu",
    "uf": "ES"
  },
  {
    "codigo": 3200904,
    "nome": "Barra de São Francisco",
    "uf": "ES"
  },
  {
    "codigo": 3201001,
    "nome": "Boa Esperança",
    "uf": "ES"
  },
  {
    "codigo": 3201100,
    "nome": "Bom Jesus do Norte",
    "uf": "ES"
  },
  {
    "codigo": 3201159,
    "nome": "Brejetuba",
    "uf": "ES"
  },
  {
    "codigo": 3201209,
    "nome": "Cachoeiro de Itapemirim",
    "uf": "ES"
  },
  {
    "codigo": 3201308,
    "nome": "Cariacica",
    "uf": "ES"
  },
  {
    "codigo": 3201407,
    "nome": "Castelo",
    "uf": "ES"
  },
  {
    "codigo": 3201506,
    "nome": "Colatina",
    "uf": "ES"
  },
  {
    "codigo": 3201605,
    "nome": "Conceição da Barra",
    "uf": "ES"
  },
  {
    "codigo": 3201704,
    "nome": "Conceição do Castelo",
    "uf": "ES"
  },
  {
    "codigo": 3201803,
    "nome": "Divino de São Lourenço",
    "uf": "ES"
  },
  {
    "codigo": 3201902,
    "nome": "Domingos Martins",
    "uf": "ES"
  },
  {
    "codigo": 3202009,
    "nome": "Dores do Rio Preto",
    "uf": "ES"
  },
  {
    "codigo": 3202108,
    "nome": "Ecoporanga",
    "uf": "ES"
  },
  {
    "codigo": 3202207,
    "nome": "Fundão",
    "uf": "ES"
  },
  {
    "codigo": 3202256,
    "nome": "Governador Lindenberg",
    "uf": "ES"
  },
  {
    "codigo": 3202306,
    "nome": "Guaçuí",
    "uf": "ES"
  },
  {
    "codigo": 3202405,
    "nome": "Guarapari",
    "uf": "ES"
  },
  {
    "codigo": 3202454,
    "nome": "Ibatiba",
    "uf": "ES"
  },
  {
    "codigo": 3202504,
    "nome": "Ibiraçu",
    "uf": "ES"
  },
  {
    "codigo": 3202553,
    "nome": "Ibitirama",
    "uf": "ES"
  },
  {
    "codigo": 3202603,
    "nome": "Iconha",
    "uf": "ES"
  },
  {
    "codigo": 3202652,
    "nome": "Irupi",
    "uf": "ES"
  },
  {
    "codigo": 3202702,
    "nome": "Itaguaçu",
    "uf": "ES"
  },
  {
    "codigo": 3202801,
    "nome": "Itapemirim",
    "uf": "ES"
  },
  {
    "codigo": 3202900,
    "nome": "Itarana",
    "uf": "ES"
  },
  {
    "codigo": 3203007,
    "nome": "Iúna",
    "uf": "ES"
  },
  {
    "codigo": 3203056,
    "nome": "Jaguaré",
    "uf": "ES"
  },
  {
    "codigo": 3203106,
    "nome": "Jerônimo Monteiro",
    "uf": "ES"
  },
  {
    "codigo": 3203130,
    "nome": "João Neiva",
    "uf": "ES"
  },
  {
    "codigo": 3203163,
    "nome": "Laranja da Terra",
    "uf": "ES"
  },
  {
    "codigo": 3203205,
    "nome": "Linhares",
    "uf": "ES"
  },
  {
    "codigo": 3203304,
    "nome": "Mantenópolis",
    "uf": "ES"
  },
  {
    "codigo": 3203320,
    "nome": "Marataízes",
    "uf": "ES"
  },
  {
    "codigo": 3203346,
    "nome": "Marechal Floriano",
    "uf": "ES"
  },
  {
    "codigo": 3203353,
    "nome": "Marilândia",
    "uf": "ES"
  },
  {
    "codigo": 3203403,
    "nome": "Mimoso do Sul",
    "uf": "ES"
  },
  {
    "codigo": 3203502,
    "nome": "Montanha",
    "uf": "ES"
  },
  {
    "codigo": 3203601,
    "nome": "Mucurici",
    "uf": "ES"
  },
  {
    "codigo": 3203700,
    "nome": "Muniz Freire",
    "uf": "ES"
  },
  {
    "codigo": 3203809,
    "nome": "Muqui",
    "uf": "ES"
  },
  {
    "codigo": 3203908,
    "nome": "Nova Venécia",
    "uf": "ES"
  },
  {
    "codigo": 3204005,
    "nome": "Pancas",
    "uf": "ES"
  },
  {
    "codigo": 3204054,
    "nome": "Pedro Canário",
    "uf": "ES"
  },
  {
    "codigo": 3204104,
    "nome": "Pinheiros",
    "uf": "ES"
  },
  {
    "codigo": 3204203,
    "nome": "Piúma",
    "uf": "ES"
  },
  {
    "codigo": 3204252,
    "nome": "Ponto Belo",
    "uf": "ES"
  },
  {
    "codigo": 3204302,
    "nome": "Presidente Kennedy",
    "uf": "ES"
  },
  {
    "codigo": 3204351,
    "nome": "Rio Bananal",
    "uf": "ES"
  },
  {
    "codigo": 3204401,
    "nome": "Rio Novo do Sul",
    "uf": "ES"
  },
  {
    "codigo": 3204500,
    "nome": "Santa Leopoldina",
    "uf": "ES"
  },
  {
    "codigo": 3204559,
    "nome": "Santa Maria de Jetibá",
    "uf": "ES"
  },
  {
    "codigo": 3204609,
    "nome": "Santa Teresa",
    "uf": "ES"
  },
  {
    "codigo": 3204658,
    "nome": "São Domingos do Norte",
    "uf": "ES"
  },
  {
    "codigo": 3204708,
    "nome": "São Gabriel da Palha",
    "uf": "ES"
  },
  {
    "codigo": 3204807,
    "nome": "São José do Calçado",
    "uf": "ES"
  },
  {
    "codigo": 3204906,
    "nome": "São Mateus",
    "uf": "ES"
  },
  {
    "codigo": 3204955,
    "nome": "São Roque do Canaã",
    "uf": "ES"
  },
  {
    "codigo": 3205002,
    "nome": "Serra",
    "uf": "ES"
  },
  {
    "codigo": 3205010,
    "nome": "Sooretama",
    "uf": "ES"
  },
  {
    "codigo": 3205036,
    "nome": "Vargem Alta",
    "uf": "ES"
  },
  {
    "codigo": 3205069,
    "nome": "Venda Nova do Imigrante",
    "uf": "ES"
  },
  {
    "codigo": 3205101,
    "nome": "Viana",
    "uf": "ES"
  },
  {
    "codigo": 3205150,
    "nome": "Vila Pavão",
    "uf": "ES"
  },
  {
    "codigo": 3205176,
    "nome": "Vila Valério",
    "uf": "ES"
  },
  {
    "codigo": 3205200,
    "nome": "Vila Velha",
    "uf": "ES"
  },
  {
    "codigo": 3205309,
    "nome": "Vitória",
    "uf": "ES"
  },
  {
    "codigo": 3300100,
    "nome": "Angra dos Reis",
    "uf": "RJ"
  },
  {
    "codigo": 3300159,
    "nome": "Aperibé",
    "uf": "RJ"
  },
  {
    "codigo": 3300209,
    "nome": "Araruama",
    "uf": "RJ"
  },
  {
    "codigo": 3300225,
    "nome": "Areal",
    "uf": "RJ"
  },
  {
    "codigo": 3300233,
    "nome": "Armação dos Búzios",
    "uf": "RJ"
  },
  {
    "codigo": 3300258,
    "nome": "Arraial do Cabo",
    "uf": "RJ"
  },
  {
    "codigo": 3300308,
    "nome": "Barra do Piraí",
    "uf": "RJ"
  },
  {
    "codigo": 3300407,
    "nome": "Barra Mansa",
    "uf": "RJ"
  },
  {
    "codigo": 3300456,
    "nome": "Belford Roxo",
    "uf": "RJ"
  },
  {
    "codigo": 3300506,
    "nome": "Bom Jardim",
    "uf": "RJ"
  },
  {
    "codigo": 3300605,
    "nome": "Bom Jesus do Itabapoana",
    "uf": "RJ"
  },
  {
    "codigo": 3300704,
    "nome": "Cabo Frio",
    "uf": "RJ"
  },
  {
    "codigo": 3300803,
    "nome": "Cachoeiras de Macacu",
    "uf": "RJ"
  },
  {
    "codigo": 3300902,
    "nome": "Cambuci",
    "uf": "RJ"
  },
  {
    "codigo": 3300936,
    "nome": "Carapebus",
    "uf": "RJ"
  },
  {
    "codigo": 3300951,
    "nome": "Comendador Levy Gasparian",
    "uf": "RJ"
  },
  {
    "codigo": 3301009,
    "nome": "Campos dos Goytacazes",
    "uf": "RJ"
  },
  {
    "codigo": 3301108,
    "nome": "Cantagalo",
    "uf": "RJ"
  },
  {
    "codigo": 3301157,
    "nome": "Cardoso Moreira",
    "uf": "RJ"
  },
  {
    "codigo": 3301207,
    "nome": "Carmo",
    "uf": "RJ"
  },
  {
    "codigo": 3301306,
    "nome": "Casimiro de Abreu",
    "uf": "RJ"
  },
  {
    "codigo": 3301405,
    "nome": "Conceição de Macabu",
    "uf": "RJ"
  },
  {
    "codigo": 3301504,
    "nome": "Cordeiro",
    "uf": "RJ"
  },
  {
    "codigo": 3301603,
    "nome": "Duas Barras",
    "uf": "RJ"
  },
  {
    "codigo": 3301702,
    "nome": "Duque de Caxias",
    "uf": "RJ"
  },
  {
    "codigo": 3301801,
    "nome": "Engenheiro Paulo de Frontin",
    "uf": "RJ"
  },
  {
    "codigo": 3301850,
    "nome": "Guapimirim",
    "uf": "RJ"
  },
  {
    "codigo": 3301876,
    "nome": "Iguaba Grande",
    "uf": "RJ"
  },
  {
    "codigo": 3301900,
    "nome": "Itaboraí",
    "uf": "RJ"
  },
  {
    "codigo": 3302007,
    "nome": "Itaguaí",
    "uf": "RJ"
  },
  {
    "codigo": 3302056,
    "nome": "Italva",
    "uf": "RJ"
  },
  {
    "codigo": 3302106,
    "nome": "Itaocara",
    "uf": "RJ"
  },
  {
    "codigo": 3302205,
    "nome": "Itaperuna",
    "uf": "RJ"
  },
  {
    "codigo": 3302254,
    "nome": "Itatiaia",
    "uf": "RJ"
  },
  {
    "codigo": 3302270,
    "nome": "Japeri",
    "uf": "RJ"
  },
  {
    "codigo": 3302304,
    "nome": "Laje do Muriaé",
    "uf": "RJ"
  },
  {
    "codigo": 3302403,
    "nome": "Macaé",
    "uf": "RJ"
  },
  {
    "codigo": 3302452,
    "nome": "Macuco",
    "uf": "RJ"
  },
  {
    "codigo": 3302502,
    "nome": "Magé",
    "uf": "RJ"
  },
  {
    "codigo": 3302601,
    "nome": "Mangaratiba",
    "uf": "RJ"
  },
  {
    "codigo": 3302700,
    "nome": "Maricá",
    "uf": "RJ"
  },
  {
    "codigo": 3302809,
    "nome": "Mendes",
    "uf": "RJ"
  },
  {
    "codigo": 3302858,
    "nome": "Mesquita",
    "uf": "RJ"
  },
  {
    "codigo": 3302908,
    "nome": "Miguel Pereira",
    "uf": "RJ"
  },
  {
    "codigo": 3303005,
    "nome": "Miracema",
    "uf": "RJ"
  },
  {
    "codigo": 3303104,
    "nome": "Natividade",
    "uf": "RJ"
  },
  {
    "codigo": 3303203,
    "nome": "Nilópolis",
    "uf": "RJ"
  },
  {
    "codigo": 3303302,
    "nome": "Niterói",
    "uf": "RJ"
  },
  {
    "codigo": 3303401,
    "nome": "Nova Friburgo",
    "uf": "RJ"
  },
  {
    "codigo": 3303500,
    "nome": "Nova Iguaçu",
    "uf": "RJ"
  },
  {
    "codigo": 3303609,
    "nome": "Paracambi",
    "uf": "RJ"
  },
  {
    "codigo": 3303708,
    "nome": "Paraíba do Sul",
    "uf": "RJ"
  },
  {
    "codigo": 3303807,
    "nome": "Paraty",
    "uf": "RJ"
  },
  {
    "codigo": 3303856,
    "nome": "Paty do Alferes",
    "uf": "RJ"
  },
  {
    "codigo": 3303906,
    "nome": "Petrópolis",
    "uf": "RJ"
  },
  {
    "codigo": 3303955,
    "nome": "Pinheiral",
    "uf": "RJ"
  },
  {
    "codigo": 3304003,
    "nome": "Piraí",
    "uf": "RJ"
  },
  {
    "codigo": 3304102,
    "nome": "Porciúncula",
    "uf": "RJ"
  },
  {
    "codigo": 3304110,
    "nome": "Porto Real",
    "uf": "RJ"
  },
  {
    "codigo": 3304128,
    "nome": "Quatis",
    "uf": "RJ"
  },
  {
    "codigo": 3304144,
    "nome": "Queimados",
    "uf": "RJ"
  },
  {
    "codigo": 3304151,
    "nome": "Quissamã",
    "uf": "RJ"
  },
  {
    "codigo": 3304201,
    "nome": "Resende",
    "uf": "RJ"
  },
  {
    "codigo": 3304300,
    "nome": "Rio Bonito",
    "uf": "RJ"
  },
  {
    "codigo": 3304409,
    "nome": "Rio Claro",
    "uf": "RJ"
  },
  {
    "codigo": 3304508,
    "nome": "Rio das Flores",
    "uf": "RJ"
  },
  {
    "codigo": 3304524,
    "nome": "Rio das Ostras",
    "uf": "RJ"
  },
  {
    "codigo": 3304557,
    "nome": "Rio de Janeiro",
    "uf": "RJ"
  },
  {
    "codigo": 3304607,
    "nome": "Santa Maria Madalena",
    "uf": "RJ"
  },
  {
    "codigo": 3304706,
    "nome": "Santo Antônio de Pádua",
    "uf": "RJ"
  },
  {
    "codigo": 3304755,
    "nome": "São Francisco de Itabapoana",
    "uf": "RJ"
  },
  {
    "codigo": 3304805,
    "nome": "São Fidélis",
    "uf": "RJ"
  },
  {
    "codigo": 3304904,
    "nome": "São Gonçalo",
    "uf": "RJ"
  },
  {
    "codigo": 3305000,
    "nome": "São João da Barra",
    "uf": "RJ"
  },
  {
    "codigo": 3305109,
    "nome": "São João de Meriti",
    "uf": "RJ"
  },
  {
    "codigo": 3305133,
    "nome": "São José de Ubá",
    "uf": "RJ"
  },
  {
    "codigo": 3305158,
    "nome": "São José do Vale do Rio Preto",
    "uf": "RJ"
  },
  {
    "codigo": 3305208,
    "nome": "São Pedro da Aldeia",
    "uf": "RJ"
  },
  {
    "codigo": 3305307,
    "nome": "São Sebastião do Alto",
    "uf": "RJ"
  },
  {
    "codigo": 3305406,
    "nome": "Sapucaia",
    "uf": "RJ"
  },
  {
    "codigo": 3305505,
    "nome": "Saquarema",
    "uf": "RJ"
  },
  {
    "codigo": 3305554,
    "nome": "Seropédica",
    "uf": "RJ"
  },
  {
    "codigo": 3305604,
    "nome": "Silva Jardim",
    "uf": "RJ"
  },
  {
    "codigo": 3305703,
    "nome": "Sumidouro",
    "uf": "RJ"
  },
  {
    "codigo": 3305752,
    "nome": "Tanguá",
    "uf": "RJ"
  },
  {
    "codigo": 3305802,
    "nome": "Teresópolis",
    "uf": "RJ"
  },
  {
    "codigo": 3305901,
    "nome": "Trajano de Moraes",
    "uf": "RJ"
  },
  {
    "codigo": 3306008,
    "nome": "Três Rios",
    "uf": "RJ"
  },
  {
    "codigo": 3306107,
    "nome": "Valença",
    "uf": "RJ"
  },
  {
    "codigo": 3306156,
    "nome": "Varre-Sai",
    "uf": "RJ"
  },
  {
    "codigo": 3306206,
    "nome": "Vassouras",
    "uf": "RJ"
  },
  {
    "codigo": 3306305,
    "nome": "Volta Redonda",
    "uf": "RJ"
  },
  {
    "codigo": 3500105,
    "nome": "Adamantina",
    "uf": "SP"
  },
  {
    "codigo": 3500204,
    "nome": "Adolfo",
    "uf": "SP"
  },
  {
    "codigo": 3500303,
    "nome": "Aguaí",
    "uf": "SP"
  },
  {
    "codigo": 3500402,
    "nome": "Águas da Prata",
    "uf": "SP"
  },
  {
    "codigo": 3500501,
    "nome": "Águas de Lindóia",
    "uf": "SP"
  },
  {
    "codigo": 3500550,
    "nome": "Águas de Santa Bárbara",
    "uf": "SP"
  },
  {
    "codigo": 3500600,
    "nome": "Águas de São Pedro",
    "uf": "SP"
  },
  {
    "codigo": 3500709,
    "nome": "Agudos",
    "uf": "SP"
  },
  {
    "codigo": 3500758,
    "nome": "Alambari",
    "uf": "SP"
  },
  {
    "codigo": 3500808,
    "nome": "Alfredo Marcondes",
    "uf": "SP"
  },
  {
    "codigo": 3500907,
    "nome": "Altair",
    "uf": "SP"
  },
  {
    "codigo": 3501004,
    "nome": "Altinópolis",
    "uf": "SP"
  },
  {
    "codigo": 3501103,
    "nome": "Alto Alegre",
    "uf": "SP"
  },
  {
    "codigo": 3501152,
    "nome": "Alumínio",
    "uf": "SP"
  },
  {
    "codigo": 3501202,
    "nome": "Álvares Florence",
    "uf": "SP"
  },
  {
    "codigo": 3501301,
    "nome": "Álvares Machado",
    "uf": "SP"
  },
  {
    "codigo": 3501400,
    "nome": "Álvaro de Carvalho",
    "uf": "SP"
  },
  {
    "codigo": 3501509,
    "nome": "Alvinlândia",
    "uf": "SP"
  },
  {
    "codigo": 3501608,
    "nome": "Americana",
    "uf": "SP"
  },
  {
    "codigo": 3501707,
    "nome": "Américo Brasiliense",
    "uf": "SP"
  },
  {
    "codigo": 3501806,
    "nome": "Américo de Campos",
    "uf": "SP"
  },
  {
    "codigo": 3501905,
    "nome": "Amparo",
    "uf": "SP"
  },
  {
    "codigo": 3502002,
    "nome": "Analândia",
    "uf": "SP"
  },
  {
    "codigo": 3502101,
    "nome": "Andradina",
    "uf": "SP"
  },
  {
    "codigo": 3502200,
    "nome": "Angatuba",
    "uf": "SP"
  },
  {
    "codigo": 3502309,
    "nome": "Anhembi",
    "uf": "SP"
  },
  {
    "codigo": 3502408,
    "nome": "Anhumas",
    "uf": "SP"
  },
  {
    "codigo": 3502507,
    "nome": "Aparecida",
    "uf": "SP"
  },
  {
    "codigo": 3502606,
    "nome": "Aparecida d'Oeste",
    "uf": "SP"
  },
  {
    "codigo": 3502705,
    "nome": "Apiaí",
    "uf": "SP"
  },
  {
    "codigo": 3502754,
    "nome": "Araçariguama",
    "uf": "SP"
  },
  {
    "codigo": 3502804,
    "nome": "Araçatuba",
    "uf": "SP"
  },
  {
    "codigo": 3502903,
    "nome": "Araçoiaba da Serra",
    "uf": "SP"
  },
  {
    "codigo": 3503000,
    "nome": "Aramina",
    "uf": "SP"
  },
  {
    "codigo": 3503109,
    "nome": "Arandu",
    "uf": "SP"
  },
  {
    "codigo": 3503158,
    "nome": "Arapeí",
    "uf": "SP"
  },
  {
    "codigo": 3503208,
    "nome": "Araraquara",
    "uf": "SP"
  },
  {
    "codigo": 3503307,
    "nome": "Araras",
    "uf": "SP"
  },
  {
    "codigo": 3503356,
    "nome": "Arco-Íris",
    "uf": "SP"
  },
  {
    "codigo": 3503406,
    "nome": "Arealva",
    "uf": "SP"
  },
  {
    "codigo": 3503505,
    "nome": "Areias",
    "uf": "SP"
  },
  {
    "codigo": 3503604,
    "nome": "Areiópolis",
    "uf": "SP"
  },
  {
    "codigo": 3503703,
    "nome": "Ariranha",
    "uf": "SP"
  },
  {
    "codigo": 3503802,
    "nome": "Artur Nogueira",
    "uf": "SP"
  },
  {
    "codigo": 3503901,
    "nome": "Arujá",
    "uf": "SP"
  },
  {
    "codigo": 3503950,
    "nome": "Aspásia",
    "uf": "SP"
  },
  {
    "codigo": 3504008,
    "nome": "Assis",
    "uf": "SP"
  },
  {
    "codigo": 3504107,
    "nome": "Atibaia",
    "uf": "SP"
  },
  {
    "codigo": 3504206,
    "nome": "Auriflama",
    "uf": "SP"
  },
  {
    "codigo": 3504305,
    "nome": "Avaí",
    "uf": "SP"
  },
  {
    "codigo": 3504404,
    "nome": "Avanhandava",
    "uf": "SP"
  },
  {
    "codigo": 3504503,
    "nome": "Avaré",
    "uf": "SP"
  },
  {
    "codigo": 3504602,
    "nome": "Bady Bassitt",
    "uf": "SP"
  },
  {
    "codigo": 3504701,
    "nome": "Balbinos",
    "uf": "SP"
  },
  {
    "codigo": 3504800,
    "nome": "Bálsamo",
    "uf": "SP"
  },
  {
    "codigo": 3504909,
    "nome": "Bananal",
    "uf": "SP"
  },
  {
    "codigo": 3505005,
    "nome": "Barão de Antonina",
    "uf": "SP"
  },
  {
    "codigo": 3505104,
    "nome": "Barbosa",
    "uf": "SP"
  },
  {
    "codigo": 3505203,
    "nome": "Bariri",
    "uf": "SP"
  },
  {
    "codigo": 3505302,
    "nome": "Barra Bonita",
    "uf": "SP"
  },
  {
    "codigo": 3505351,
    "nome": "Barra do Chapéu",
    "uf": "SP"
  },
  {
    "codigo": 3505401,
    "nome": "Barra do Turvo",
    "uf": "SP"
  },
  {
    "codigo": 3505500,
    "nome": "Barretos",
    "uf": "SP"
  },
  {
    "codigo": 3505609,
    "nome": "Barrinha",
    "uf": "SP"
  },
  {
    "codigo": 3505708,
    "nome": "Barueri",
    "uf": "SP"
  },
  {
    "codigo": 3505807,
    "nome": "Bastos",
    "uf": "SP"
  },
  {
    "codigo": 3505906,
    "nome": "Batatais",
    "uf": "SP"
  },
  {
    "codigo": 3506003,
    "nome": "Bauru",
    "uf": "SP"
  },
  {
    "codigo": 3506102,
    "nome": "Bebedouro",
    "uf": "SP"
  },
  {
    "codigo": 3506201,
    "nome": "Bento de Abreu",
    "uf": "SP"
  },
  {
    "codigo": 3506300,
    "nome": "Bernardino de Campos",
    "uf": "SP"
  },
  {
    "codigo": 3506359,
    "nome": "Bertioga",
    "uf": "SP"
  },
  {
    "codigo": 3506409,
    "nome": "Bilac",
    "uf": "SP"
  },
  {
    "codigo": 3506508,
    "nome": "Birigui",
    "uf": "SP"
  },
  {
    "codigo": 3506607,
    "nome": "Biritiba Mirim",
    "uf": "SP"
  },
  {
    "codigo": 3506706,
    "nome": "Boa Esperança do Sul",
    "uf": "SP"
  },
  {
    "codigo": 3506805,
    "nome": "Bocaina",
    "uf": "SP"
  },
  {
    "codigo": 3506904,
    "nome": "Bofete",
    "uf": "SP"
  },
  {
    "codigo": 3507001,
    "nome": "Boituva",
    "uf": "SP"
  },
  {
    "codigo": 3507100,
    "nome": "Bom Jesus dos Perdões",
    "uf": "SP"
  },
  {
    "codigo": 3507159,
    "nome": "Bom Sucesso de Itararé",
    "uf": "SP"
  },
  {
    "codigo": 3507209,
    "nome": "Borá",
    "uf": "SP"
  },
  {
    "codigo": 3507308,
    "nome": "Boracéia",
    "uf": "SP"
  },
  {
    "codigo": 3507407,
    "nome": "Borborema",
    "uf": "SP"
  },
  {
    "codigo": 3507456,
    "nome": "Borebi",
    "uf": "SP"
  },
  {
    "codigo": 3507506,
    "nome": "Botucatu",
    "uf": "SP"
  },
  {
    "codigo": 3507605,
    "nome": "Bragança Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3507704,
    "nome": "Braúna",
    "uf": "SP"
  },
  {
    "codigo": 3507753,
    "nome": "Brejo Alegre",
    "uf": "SP"
  },
  {
    "codigo": 3507803,
    "nome": "Brodowski",
    "uf": "SP"
  },
  {
    "codigo": 3507902,
    "nome": "Brotas",
    "uf": "SP"
  },
  {
    "codigo": 3508009,
    "nome": "Buri",
    "uf": "SP"
  },
  {
    "codigo": 3508108,
    "nome": "Buritama",
    "uf": "SP"
  },
  {
    "codigo": 3508207,
    "nome": "Buritizal",
    "uf": "SP"
  },
  {
    "codigo": 3508306,
    "nome": "Cabrália Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3508405,
    "nome": "Cabreúva",
    "uf": "SP"
  },
  {
    "codigo": 3508504,
    "nome": "Caçapava",
    "uf": "SP"
  },
  {
    "codigo": 3508603,
    "nome": "Cachoeira Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3508702,
    "nome": "Caconde",
    "uf": "SP"
  },
  {
    "codigo": 3508801,
    "nome": "Cafelândia",
    "uf": "SP"
  },
  {
    "codigo": 3508900,
    "nome": "Caiabu",
    "uf": "SP"
  },
  {
    "codigo": 3509007,
    "nome": "Caieiras",
    "uf": "SP"
  },
  {
    "codigo": 3509106,
    "nome": "Caiuá",
    "uf": "SP"
  },
  {
    "codigo": 3509205,
    "nome": "Cajamar",
    "uf": "SP"
  },
  {
    "codigo": 3509254,
    "nome": "Cajati",
    "uf": "SP"
  },
  {
    "codigo": 3509304,
    "nome": "Cajobi",
    "uf": "SP"
  },
  {
    "codigo": 3509403,
    "nome": "Cajuru",
    "uf": "SP"
  },
  {
    "codigo": 3509452,
    "nome": "Campina do Monte Alegre",
    "uf": "SP"
  },
  {
    "codigo": 3509502,
    "nome": "Campinas",
    "uf": "SP"
  },
  {
    "codigo": 3509601,
    "nome": "Campo Limpo Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3509700,
    "nome": "Campos do Jordão",
    "uf": "SP"
  },
  {
    "codigo": 3509809,
    "nome": "Campos Novos Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3509908,
    "nome": "Cananéia",
    "uf": "SP"
  },
  {
    "codigo": 3509957,
    "nome": "Canas",
    "uf": "SP"
  },
  {
    "codigo": 3510005,
    "nome": "Cândido Mota",
    "uf": "SP"
  },
  {
    "codigo": 3510104,
    "nome": "Cândido Rodrigues",
    "uf": "SP"
  },
  {
    "codigo": 3510153,
    "nome": "Canitar",
    "uf": "SP"
  },
  {
    "codigo": 3510203,
    "nome": "Capão Bonito",
    "uf": "SP"
  },
  {
    "codigo": 3510302,
    "nome": "Capela do Alto",
    "uf": "SP"
  },
  {
    "codigo": 3510401,
    "nome": "Capivari",
    "uf": "SP"
  },
  {
    "codigo": 3510500,
    "nome": "Caraguatatuba",
    "uf": "SP"
  },
  {
    "codigo": 3510609,
    "nome": "Carapicuíba",
    "uf": "SP"
  },
  {
    "codigo": 3510708,
    "nome": "Cardoso",
    "uf": "SP"
  },
  {
    "codigo": 3510807,
    "nome": "Casa Branca",
    "uf": "SP"
  },
  {
    "codigo": 3510906,
    "nome": "Cássia dos Coqueiros",
    "uf": "SP"
  },
  {
    "codigo": 3511003,
    "nome": "Castilho",
    "uf": "SP"
  },
  {
    "codigo": 3511102,
    "nome": "Catanduva",
    "uf": "SP"
  },
  {
    "codigo": 3511201,
    "nome": "Catiguá",
    "uf": "SP"
  },
  {
    "codigo": 3511300,
    "nome": "Cedral",
    "uf": "SP"
  },
  {
    "codigo": 3511409,
    "nome": "Cerqueira César",
    "uf": "SP"
  },
  {
    "codigo": 3511508,
    "nome": "Cerquilho",
    "uf": "SP"
  },
  {
    "codigo": 3511607,
    "nome": "Cesário Lange",
    "uf": "SP"
  },
  {
    "codigo": 3511706,
    "nome": "Charqueada",
    "uf": "SP"
  },
  {
    "codigo": 3511904,
    "nome": "Clementina",
    "uf": "SP"
  },
  {
    "codigo": 3512001,
    "nome": "Colina",
    "uf": "SP"
  },
  {
    "codigo": 3512100,
    "nome": "Colômbia",
    "uf": "SP"
  },
  {
    "codigo": 3512209,
    "nome": "Conchal",
    "uf": "SP"
  },
  {
    "codigo": 3512308,
    "nome": "Conchas",
    "uf": "SP"
  },
  {
    "codigo": 3512407,
    "nome": "Cordeirópolis",
    "uf": "SP"
  },
  {
    "codigo": 3512506,
    "nome": "Coroados",
    "uf": "SP"
  },
  {
    "codigo": 3512605,
    "nome": "Coronel Macedo",
    "uf": "SP"
  },
  {
    "codigo": 3512704,
    "nome": "Corumbataí",
    "uf": "SP"
  },
  {
    "codigo": 3512803,
    "nome": "Cosmópolis",
    "uf": "SP"
  },
  {
    "codigo": 3512902,
    "nome": "Cosmorama",
    "uf": "SP"
  },
  {
    "codigo": 3513009,
    "nome": "Cotia",
    "uf": "SP"
  },
  {
    "codigo": 3513108,
    "nome": "Cravinhos",
    "uf": "SP"
  },
  {
    "codigo": 3513207,
    "nome": "Cristais Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3513306,
    "nome": "Cruzália",
    "uf": "SP"
  },
  {
    "codigo": 3513405,
    "nome": "Cruzeiro",
    "uf": "SP"
  },
  {
    "codigo": 3513504,
    "nome": "Cubatão",
    "uf": "SP"
  },
  {
    "codigo": 3513603,
    "nome": "Cunha",
    "uf": "SP"
  },
  {
    "codigo": 3513702,
    "nome": "Descalvado",
    "uf": "SP"
  },
  {
    "codigo": 3513801,
    "nome": "Diadema",
    "uf": "SP"
  },
  {
    "codigo": 3513850,
    "nome": "Dirce Reis",
    "uf": "SP"
  },
  {
    "codigo": 3513900,
    "nome": "Divinolândia",
    "uf": "SP"
  },
  {
    "codigo": 3514007,
    "nome": "Dobrada",
    "uf": "SP"
  },
  {
    "codigo": 3514106,
    "nome": "Dois Córregos",
    "uf": "SP"
  },
  {
    "codigo": 3514205,
    "nome": "Dolcinópolis",
    "uf": "SP"
  },
  {
    "codigo": 3514304,
    "nome": "Dourado",
    "uf": "SP"
  },
  {
    "codigo": 3514403,
    "nome": "Dracena",
    "uf": "SP"
  },
  {
    "codigo": 3514502,
    "nome": "Duartina",
    "uf": "SP"
  },
  {
    "codigo": 3514601,
    "nome": "Dumont",
    "uf": "SP"
  },
  {
    "codigo": 3514700,
    "nome": "Echaporã",
    "uf": "SP"
  },
  {
    "codigo": 3514809,
    "nome": "Eldorado",
    "uf": "SP"
  },
  {
    "codigo": 3514908,
    "nome": "Elias Fausto",
    "uf": "SP"
  },
  {
    "codigo": 3514924,
    "nome": "Elisiário",
    "uf": "SP"
  },
  {
    "codigo": 3514957,
    "nome": "Embaúba",
    "uf": "SP"
  },
  {
    "codigo": 3515004,
    "nome": "Embu das Artes",
    "uf": "SP"
  },
  {
    "codigo": 3515103,
    "nome": "Embu-Guaçu",
    "uf": "SP"
  },
  {
    "codigo": 3515129,
    "nome": "Emilianópolis",
    "uf": "SP"
  },
  {
    "codigo": 3515152,
    "nome": "Engenheiro Coelho",
    "uf": "SP"
  },
  {
    "codigo": 3515186,
    "nome": "Espírito Santo do Pinhal",
    "uf": "SP"
  },
  {
    "codigo": 3515194,
    "nome": "Espírito Santo do Turvo",
    "uf": "SP"
  },
  {
    "codigo": 3515202,
    "nome": "Estrela d'Oeste",
    "uf": "SP"
  },
  {
    "codigo": 3515301,
    "nome": "Estrela do Norte",
    "uf": "SP"
  },
  {
    "codigo": 3515350,
    "nome": "Euclides da Cunha Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3515400,
    "nome": "Fartura",
    "uf": "SP"
  },
  {
    "codigo": 3515509,
    "nome": "Fernandópolis",
    "uf": "SP"
  },
  {
    "codigo": 3515608,
    "nome": "Fernando Prestes",
    "uf": "SP"
  },
  {
    "codigo": 3515657,
    "nome": "Fernão",
    "uf": "SP"
  },
  {
    "codigo": 3515707,
    "nome": "Ferraz de Vasconcelos",
    "uf": "SP"
  },
  {
    "codigo": 3515806,
    "nome": "Flora Rica",
    "uf": "SP"
  },
  {
    "codigo": 3515905,
    "nome": "Floreal",
    "uf": "SP"
  },
  {
    "codigo": 3516002,
    "nome": "Flórida Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3516101,
    "nome": "Florínea",
    "uf": "SP"
  },
  {
    "codigo": 3516200,
    "nome": "Franca",
    "uf": "SP"
  },
  {
    "codigo": 3516309,
    "nome": "Francisco Morato",
    "uf": "SP"
  },
  {
    "codigo": 3516408,
    "nome": "Franco da Rocha",
    "uf": "SP"
  },
  {
    "codigo": 3516507,
    "nome": "Gabriel Monteiro",
    "uf": "SP"
  },
  {
    "codigo": 3516606,
    "nome": "Gália",
    "uf": "SP"
  },
  {
    "codigo": 3516705,
    "nome": "Garça",
    "uf": "SP"
  },
  {
    "codigo": 3516804,
    "nome": "Gastão Vidigal",
    "uf": "SP"
  },
  {
    "codigo": 3516853,
    "nome": "Gavião Peixoto",
    "uf": "SP"
  },
  {
    "codigo": 3516903,
    "nome": "General Salgado",
    "uf": "SP"
  },
  {
    "codigo": 3517000,
    "nome": "Getulina",
    "uf": "SP"
  },
  {
    "codigo": 3517109,
    "nome": "Glicério",
    "uf": "SP"
  },
  {
    "codigo": 3517208,
    "nome": "Guaiçara",
    "uf": "SP"
  },
  {
    "codigo": 3517307,
    "nome": "Guaimbê",
    "uf": "SP"
  },
  {
    "codigo": 3517406,
    "nome": "Guaíra",
    "uf": "SP"
  },
  {
    "codigo": 3517505,
    "nome": "Guapiaçu",
    "uf": "SP"
  },
  {
    "codigo": 3517604,
    "nome": "Guapiara",
    "uf": "SP"
  },
  {
    "codigo": 3517703,
    "nome": "Guará",
    "uf": "SP"
  },
  {
    "codigo": 3517802,
    "nome": "Guaraçaí",
    "uf": "SP"
  },
  {
    "codigo": 3517901,
    "nome": "Guaraci",
    "uf": "SP"
  },
  {
    "codigo": 3518008,
    "nome": "Guarani d'Oeste",
    "uf": "SP"
  },
  {
    "codigo": 3518107,
    "nome": "Guarantã",
    "uf": "SP"
  },
  {
    "codigo": 3518206,
    "nome": "Guararapes",
    "uf": "SP"
  },
  {
    "codigo": 3518305,
    "nome": "Guararema",
    "uf": "SP"
  },
  {
    "codigo": 3518404,
    "nome": "Guaratinguetá",
    "uf": "SP"
  },
  {
    "codigo": 3518503,
    "nome": "Guareí",
    "uf": "SP"
  },
  {
    "codigo": 3518602,
    "nome": "Guariba",
    "uf": "SP"
  },
  {
    "codigo": 3518701,
    "nome": "Guarujá",
    "uf": "SP"
  },
  {
    "codigo": 3518800,
    "nome": "Guarulhos",
    "uf": "SP"
  },
  {
    "codigo": 3518859,
    "nome": "Guatapará",
    "uf": "SP"
  },
  {
    "codigo": 3518909,
    "nome": "Guzolândia",
    "uf": "SP"
  },
  {
    "codigo": 3519006,
    "nome": "Herculândia",
    "uf": "SP"
  },
  {
    "codigo": 3519055,
    "nome": "Holambra",
    "uf": "SP"
  },
  {
    "codigo": 3519071,
    "nome": "Hortolândia",
    "uf": "SP"
  },
  {
    "codigo": 3519105,
    "nome": "Iacanga",
    "uf": "SP"
  },
  {
    "codigo": 3519204,
    "nome": "Iacri",
    "uf": "SP"
  },
  {
    "codigo": 3519253,
    "nome": "Iaras",
    "uf": "SP"
  },
  {
    "codigo": 3519303,
    "nome": "Ibaté",
    "uf": "SP"
  },
  {
    "codigo": 3519402,
    "nome": "Ibirá",
    "uf": "SP"
  },
  {
    "codigo": 3519501,
    "nome": "Ibirarema",
    "uf": "SP"
  },
  {
    "codigo": 3519600,
    "nome": "Ibitinga",
    "uf": "SP"
  },
  {
    "codigo": 3519709,
    "nome": "Ibiúna",
    "uf": "SP"
  },
  {
    "codigo": 3519808,
    "nome": "Icém",
    "uf": "SP"
  },
  {
    "codigo": 3519907,
    "nome": "Iepê",
    "uf": "SP"
  },
  {
    "codigo": 3520004,
    "nome": "Igaraçu do Tietê",
    "uf": "SP"
  },
  {
    "codigo": 3520103,
    "nome": "Igarapava",
    "uf": "SP"
  },
  {
    "codigo": 3520202,
    "nome": "Igaratá",
    "uf": "SP"
  },
  {
    "codigo": 3520301,
    "nome": "Iguape",
    "uf": "SP"
  },
  {
    "codigo": 3520400,
    "nome": "Ilhabela",
    "uf": "SP"
  },
  {
    "codigo": 3520426,
    "nome": "Ilha Comprida",
    "uf": "SP"
  },
  {
    "codigo": 3520442,
    "nome": "Ilha Solteira",
    "uf": "SP"
  },
  {
    "codigo": 3520509,
    "nome": "Indaiatuba",
    "uf": "SP"
  },
  {
    "codigo": 3520608,
    "nome": "Indiana",
    "uf": "SP"
  },
  {
    "codigo": 3520707,
    "nome": "Indiaporã",
    "uf": "SP"
  },
  {
    "codigo": 3520806,
    "nome": "Inúbia Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3520905,
    "nome": "Ipaussu",
    "uf": "SP"
  },
  {
    "codigo": 3521002,
    "nome": "Iperó",
    "uf": "SP"
  },
  {
    "codigo": 3521101,
    "nome": "Ipeúna",
    "uf": "SP"
  },
  {
    "codigo": 3521150,
    "nome": "Ipiguá",
    "uf": "SP"
  },
  {
    "codigo": 3521200,
    "nome": "Iporanga",
    "uf": "SP"
  },
  {
    "codigo": 3521309,
    "nome": "Ipuã",
    "uf": "SP"
  },
  {
    "codigo": 3521408,
    "nome": "Iracemápolis",
    "uf": "SP"
  },
  {
    "codigo": 3521507,
    "nome": "Irapuã",
    "uf": "SP"
  },
  {
    "codigo": 3521606,
    "nome": "Irapuru",
    "uf": "SP"
  },
  {
    "codigo": 3521705,
    "nome": "Itaberá",
    "uf": "SP"
  },
  {
    "codigo": 3521804,
    "nome": "Itaí",
    "uf": "SP"
  },
  {
    "codigo": 3521903,
    "nome": "Itajobi",
    "uf": "SP"
  },
  {
    "codigo": 3522000,
    "nome": "Itaju",
    "uf": "SP"
  },
  {
    "codigo": 3522109,
    "nome": "Itanhaém",
    "uf": "SP"
  },
  {
    "codigo": 3522158,
    "nome": "Itaoca",
    "uf": "SP"
  },
  {
    "codigo": 3522208,
    "nome": "Itapecerica da Serra",
    "uf": "SP"
  },
  {
    "codigo": 3522307,
    "nome": "Itapetininga",
    "uf": "SP"
  },
  {
    "codigo": 3522406,
    "nome": "Itapeva",
    "uf": "SP"
  },
  {
    "codigo": 3522505,
    "nome": "Itapevi",
    "uf": "SP"
  },
  {
    "codigo": 3522604,
    "nome": "Itapira",
    "uf": "SP"
  },
  {
    "codigo": 3522653,
    "nome": "Itapirapuã Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3522703,
    "nome": "Itápolis",
    "uf": "SP"
  },
  {
    "codigo": 3522802,
    "nome": "Itaporanga",
    "uf": "SP"
  },
  {
    "codigo": 3522901,
    "nome": "Itapuí",
    "uf": "SP"
  },
  {
    "codigo": 3523008,
    "nome": "Itapura",
    "uf": "SP"
  },
  {
    "codigo": 3523107,
    "nome": "Itaquaquecetuba",
    "uf": "SP"
  },
  {
    "codigo": 3523206,
    "nome": "Itararé",
    "uf": "SP"
  },
  {
    "codigo": 3523305,
    "nome": "Itariri",
    "uf": "SP"
  },
  {
    "codigo": 3523404,
    "nome": "Itatiba",
    "uf": "SP"
  },
  {
    "codigo": 3523503,
    "nome": "Itatinga",
    "uf": "SP"
  },
  {
    "codigo": 3523602,
    "nome": "Itirapina",
    "uf": "SP"
  },
  {
    "codigo": 3523701,
    "nome": "Itirapuã",
    "uf": "SP"
  },
  {
    "codigo": 3523800,
    "nome": "Itobi",
    "uf": "SP"
  },
  {
    "codigo": 3523909,
    "nome": "Itu",
    "uf": "SP"
  },
  {
    "codigo": 3524006,
    "nome": "Itupeva",
    "uf": "SP"
  },
  {
    "codigo": 3524105,
    "nome": "Ituverava",
    "uf": "SP"
  },
  {
    "codigo": 3524204,
    "nome": "Jaborandi",
    "uf": "SP"
  },
  {
    "codigo": 3524303,
    "nome": "Jaboticabal",
    "uf": "SP"
  },
  {
    "codigo": 3524402,
    "nome": "Jacareí",
    "uf": "SP"
  },
  {
    "codigo": 3524501,
    "nome": "Jaci",
    "uf": "SP"
  },
  {
    "codigo": 3524600,
    "nome": "Jacupiranga",
    "uf": "SP"
  },
  {
    "codigo": 3524709,
    "nome": "Jaguariúna",
    "uf": "SP"
  },
  {
    "codigo": 3524808,
    "nome": "Jales",
    "uf": "SP"
  },
  {
    "codigo": 3524907,
    "nome": "Jambeiro",
    "uf": "SP"
  },
  {
    "codigo": 3525003,
    "nome": "Jandira",
    "uf": "SP"
  },
  {
    "codigo": 3525102,
    "nome": "Jardinópolis",
    "uf": "SP"
  },
  {
    "codigo": 3525201,
    "nome": "Jarinu",
    "uf": "SP"
  },
  {
    "codigo": 3525300,
    "nome": "Jaú",
    "uf": "SP"
  },
  {
    "codigo": 3525409,
    "nome": "Jeriquara",
    "uf": "SP"
  },
  {
    "codigo": 3525508,
    "nome": "Joanópolis",
    "uf": "SP"
  },
  {
    "codigo": 3525607,
    "nome": "João Ramalho",
    "uf": "SP"
  },
  {
    "codigo": 3525706,
    "nome": "José Bonifácio",
    "uf": "SP"
  },
  {
    "codigo": 3525805,
    "nome": "Júlio Mesquita",
    "uf": "SP"
  },
  {
    "codigo": 3525854,
    "nome": "Jumirim",
    "uf": "SP"
  },
  {
    "codigo": 3525904,
    "nome": "Jundiaí",
    "uf": "SP"
  },
  {
    "codigo": 3526001,
    "nome": "Junqueirópolis",
    "uf": "SP"
  },
  {
    "codigo": 3526100,
    "nome": "Juquiá",
    "uf": "SP"
  },
  {
    "codigo": 3526209,
    "nome": "Juquitiba",
    "uf": "SP"
  },
  {
    "codigo": 3526308,
    "nome": "Lagoinha",
    "uf": "SP"
  },
  {
    "codigo": 3526407,
    "nome": "Laranjal Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3526506,
    "nome": "Lavínia",
    "uf": "SP"
  },
  {
    "codigo": 3526605,
    "nome": "Lavrinhas",
    "uf": "SP"
  },
  {
    "codigo": 3526704,
    "nome": "Leme",
    "uf": "SP"
  },
  {
    "codigo": 3526803,
    "nome": "Lençóis Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3526902,
    "nome": "Limeira",
    "uf": "SP"
  },
  {
    "codigo": 3527009,
    "nome": "Lindóia",
    "uf": "SP"
  },
  {
    "codigo": 3527108,
    "nome": "Lins",
    "uf": "SP"
  },
  {
    "codigo": 3527207,
    "nome": "Lorena",
    "uf": "SP"
  },
  {
    "codigo": 3527256,
    "nome": "Lourdes",
    "uf": "SP"
  },
  {
    "codigo": 3527306,
    "nome": "Louveira",
    "uf": "SP"
  },
  {
    "codigo": 3527405,
    "nome": "Lucélia",
    "uf": "SP"
  },
  {
    "codigo": 3527504,
    "nome": "Lucianópolis",
    "uf": "SP"
  },
  {
    "codigo": 3527603,
    "nome": "Luís Antônio",
    "uf": "SP"
  },
  {
    "codigo": 3527702,
    "nome": "Luiziânia",
    "uf": "SP"
  },
  {
    "codigo": 3527801,
    "nome": "Lupércio",
    "uf": "SP"
  },
  {
    "codigo": 3527900,
    "nome": "Lutécia",
    "uf": "SP"
  },
  {
    "codigo": 3528007,
    "nome": "Macatuba",
    "uf": "SP"
  },
  {
    "codigo": 3528106,
    "nome": "Macaubal",
    "uf": "SP"
  },
  {
    "codigo": 3528205,
    "nome": "Macedônia",
    "uf": "SP"
  },
  {
    "codigo": 3528304,
    "nome": "Magda",
    "uf": "SP"
  },
  {
    "codigo": 3528403,
    "nome": "Mairinque",
    "uf": "SP"
  },
  {
    "codigo": 3528502,
    "nome": "Mairiporã",
    "uf": "SP"
  },
  {
    "codigo": 3528601,
    "nome": "Manduri",
    "uf": "SP"
  },
  {
    "codigo": 3528700,
    "nome": "Marabá Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3528809,
    "nome": "Maracaí",
    "uf": "SP"
  },
  {
    "codigo": 3528858,
    "nome": "Marapoama",
    "uf": "SP"
  },
  {
    "codigo": 3528908,
    "nome": "Mariápolis",
    "uf": "SP"
  },
  {
    "codigo": 3529005,
    "nome": "Marília",
    "uf": "SP"
  },
  {
    "codigo": 3529104,
    "nome": "Marinópolis",
    "uf": "SP"
  },
  {
    "codigo": 3529203,
    "nome": "Martinópolis",
    "uf": "SP"
  },
  {
    "codigo": 3529302,
    "nome": "Matão",
    "uf": "SP"
  },
  {
    "codigo": 3529401,
    "nome": "Mauá",
    "uf": "SP"
  },
  {
    "codigo": 3529500,
    "nome": "Mendonça",
    "uf": "SP"
  },
  {
    "codigo": 3529609,
    "nome": "Meridiano",
    "uf": "SP"
  },
  {
    "codigo": 3529658,
    "nome": "Mesópolis",
    "uf": "SP"
  },
  {
    "codigo": 3529708,
    "nome": "Miguelópolis",
    "uf": "SP"
  },
  {
    "codigo": 3529807,
    "nome": "Mineiros do Tietê",
    "uf": "SP"
  },
  {
    "codigo": 3529906,
    "nome": "Miracatu",
    "uf": "SP"
  },
  {
    "codigo": 3530003,
    "nome": "Mira Estrela",
    "uf": "SP"
  },
  {
    "codigo": 3530102,
    "nome": "Mirandópolis",
    "uf": "SP"
  },
  {
    "codigo": 3530201,
    "nome": "Mirante do Paranapanema",
    "uf": "SP"
  },
  {
    "codigo": 3530300,
    "nome": "Mirassol",
    "uf": "SP"
  },
  {
    "codigo": 3530409,
    "nome": "Mirassolândia",
    "uf": "SP"
  },
  {
    "codigo": 3530508,
    "nome": "Mococa",
    "uf": "SP"
  },
  {
    "codigo": 3530607,
    "nome": "Mogi das Cruzes",
    "uf": "SP"
  },
  {
    "codigo": 3530706,
    "nome": "Mogi Guaçu",
    "uf": "SP"
  },
  {
    "codigo": 3530805,
    "nome": "Mogi Mirim",
    "uf": "SP"
  },
  {
    "codigo": 3530904,
    "nome": "Mombuca",
    "uf": "SP"
  },
  {
    "codigo": 3531001,
    "nome": "Monções",
    "uf": "SP"
  },
  {
    "codigo": 3531100,
    "nome": "Mongaguá",
    "uf": "SP"
  },
  {
    "codigo": 3531209,
    "nome": "Monte Alegre do Sul",
    "uf": "SP"
  },
  {
    "codigo": 3531308,
    "nome": "Monte Alto",
    "uf": "SP"
  },
  {
    "codigo": 3531407,
    "nome": "Monte Aprazível",
    "uf": "SP"
  },
  {
    "codigo": 3531506,
    "nome": "Monte Azul Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3531605,
    "nome": "Monte Castelo",
    "uf": "SP"
  },
  {
    "codigo": 3531704,
    "nome": "Monteiro Lobato",
    "uf": "SP"
  },
  {
    "codigo": 3531803,
    "nome": "Monte Mor",
    "uf": "SP"
  },
  {
    "codigo": 3531902,
    "nome": "Morro Agudo",
    "uf": "SP"
  },
  {
    "codigo": 3532009,
    "nome": "Morungaba",
    "uf": "SP"
  },
  {
    "codigo": 3532058,
    "nome": "Motuca",
    "uf": "SP"
  },
  {
    "codigo": 3532108,
    "nome": "Murutinga do Sul",
    "uf": "SP"
  },
  {
    "codigo": 3532157,
    "nome": "Nantes",
    "uf": "SP"
  },
  {
    "codigo": 3532207,
    "nome": "Narandiba",
    "uf": "SP"
  },
  {
    "codigo": 3532306,
    "nome": "Natividade da Serra",
    "uf": "SP"
  },
  {
    "codigo": 3532405,
    "nome": "Nazaré Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3532504,
    "nome": "Neves Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3532603,
    "nome": "Nhandeara",
    "uf": "SP"
  },
  {
    "codigo": 3532702,
    "nome": "Nipoã",
    "uf": "SP"
  },
  {
    "codigo": 3532801,
    "nome": "Nova Aliança",
    "uf": "SP"
  },
  {
    "codigo": 3532827,
    "nome": "Nova Campina",
    "uf": "SP"
  },
  {
    "codigo": 3532843,
    "nome": "Nova Canaã Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3532868,
    "nome": "Nova Castilho",
    "uf": "SP"
  },
  {
    "codigo": 3532900,
    "nome": "Nova Europa",
    "uf": "SP"
  },
  {
    "codigo": 3533007,
    "nome": "Nova Granada",
    "uf": "SP"
  },
  {
    "codigo": 3533106,
    "nome": "Nova Guataporanga",
    "uf": "SP"
  },
  {
    "codigo": 3533205,
    "nome": "Nova Independência",
    "uf": "SP"
  },
  {
    "codigo": 3533254,
    "nome": "Novais",
    "uf": "SP"
  },
  {
    "codigo": 3533304,
    "nome": "Nova Luzitânia",
    "uf": "SP"
  },
  {
    "codigo": 3533403,
    "nome": "Nova Odessa",
    "uf": "SP"
  },
  {
    "codigo": 3533502,
    "nome": "Novo Horizonte",
    "uf": "SP"
  },
  {
    "codigo": 3533601,
    "nome": "Nuporanga",
    "uf": "SP"
  },
  {
    "codigo": 3533700,
    "nome": "Ocauçu",
    "uf": "SP"
  },
  {
    "codigo": 3533809,
    "nome": "Óleo",
    "uf": "SP"
  },
  {
    "codigo": 3533908,
    "nome": "Olímpia",
    "uf": "SP"
  },
  {
    "codigo": 3534005,
    "nome": "Onda Verde",
    "uf": "SP"
  },
  {
    "codigo": 3534104,
    "nome": "Oriente",
    "uf": "SP"
  },
  {
    "codigo": 3534203,
    "nome": "Orindiúva",
    "uf": "SP"
  },
  {
    "codigo": 3534302,
    "nome": "Orlândia",
    "uf": "SP"
  },
  {
    "codigo": 3534401,
    "nome": "Osasco",
    "uf": "SP"
  },
  {
    "codigo": 3534500,
    "nome": "Oscar Bressane",
    "uf": "SP"
  },
  {
    "codigo": 3534609,
    "nome": "Osvaldo Cruz",
    "uf": "SP"
  },
  {
    "codigo": 3534708,
    "nome": "Ourinhos",
    "uf": "SP"
  },
  {
    "codigo": 3534757,
    "nome": "Ouroeste",
    "uf": "SP"
  },
  {
    "codigo": 3534807,
    "nome": "Ouro Verde",
    "uf": "SP"
  },
  {
    "codigo": 3534906,
    "nome": "Pacaembu",
    "uf": "SP"
  },
  {
    "codigo": 3535002,
    "nome": "Palestina",
    "uf": "SP"
  },
  {
    "codigo": 3535101,
    "nome": "Palmares Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3535200,
    "nome": "Palmeira d'Oeste",
    "uf": "SP"
  },
  {
    "codigo": 3535309,
    "nome": "Palmital",
    "uf": "SP"
  },
  {
    "codigo": 3535408,
    "nome": "Panorama",
    "uf": "SP"
  },
  {
    "codigo": 3535507,
    "nome": "Paraguaçu Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3535606,
    "nome": "Paraibuna",
    "uf": "SP"
  },
  {
    "codigo": 3535705,
    "nome": "Paraíso",
    "uf": "SP"
  },
  {
    "codigo": 3535804,
    "nome": "Paranapanema",
    "uf": "SP"
  },
  {
    "codigo": 3535903,
    "nome": "Paranapuã",
    "uf": "SP"
  },
  {
    "codigo": 3536000,
    "nome": "Parapuã",
    "uf": "SP"
  },
  {
    "codigo": 3536109,
    "nome": "Pardinho",
    "uf": "SP"
  },
  {
    "codigo": 3536208,
    "nome": "Pariquera-Açu",
    "uf": "SP"
  },
  {
    "codigo": 3536257,
    "nome": "Parisi",
    "uf": "SP"
  },
  {
    "codigo": 3536307,
    "nome": "Patrocínio Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3536406,
    "nome": "Paulicéia",
    "uf": "SP"
  },
  {
    "codigo": 3536505,
    "nome": "Paulínia",
    "uf": "SP"
  },
  {
    "codigo": 3536570,
    "nome": "Paulistânia",
    "uf": "SP"
  },
  {
    "codigo": 3536604,
    "nome": "Paulo de Faria",
    "uf": "SP"
  },
  {
    "codigo": 3536703,
    "nome": "Pederneiras",
    "uf": "SP"
  },
  {
    "codigo": 3536802,
    "nome": "Pedra Bela",
    "uf": "SP"
  },
  {
    "codigo": 3536901,
    "nome": "Pedranópolis",
    "uf": "SP"
  },
  {
    "codigo": 3537008,
    "nome": "Pedregulho",
    "uf": "SP"
  },
  {
    "codigo": 3537107,
    "nome": "Pedreira",
    "uf": "SP"
  },
  {
    "codigo": 3537156,
    "nome": "Pedrinhas Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3537206,
    "nome": "Pedro de Toledo",
    "uf": "SP"
  },
  {
    "codigo": 3537305,
    "nome": "Penápolis",
    "uf": "SP"
  },
  {
    "codigo": 3537404,
    "nome": "Pereira Barreto",
    "uf": "SP"
  },
  {
    "codigo": 3537503,
    "nome": "Pereiras",
    "uf": "SP"
  },
  {
    "codigo": 3537602,
    "nome": "Peruíbe",
    "uf": "SP"
  },
  {
    "codigo": 3537701,
    "nome": "Piacatu",
    "uf": "SP"
  },
  {
    "codigo": 3537800,
    "nome": "Piedade",
    "uf": "SP"
  },
  {
    "codigo": 3537909,
    "nome": "Pilar do Sul",
    "uf": "SP"
  },
  {
    "codigo": 3538006,
    "nome": "Pindamonhangaba",
    "uf": "SP"
  },
  {
    "codigo": 3538105,
    "nome": "Pindorama",
    "uf": "SP"
  },
  {
    "codigo": 3538204,
    "nome": "Pinhalzinho",
    "uf": "SP"
  },
  {
    "codigo": 3538303,
    "nome": "Piquerobi",
    "uf": "SP"
  },
  {
    "codigo": 3538501,
    "nome": "Piquete",
    "uf": "SP"
  },
  {
    "codigo": 3538600,
    "nome": "Piracaia",
    "uf": "SP"
  },
  {
    "codigo": 3538709,
    "nome": "Piracicaba",
    "uf": "SP"
  },
  {
    "codigo": 3538808,
    "nome": "Piraju",
    "uf": "SP"
  },
  {
    "codigo": 3538907,
    "nome": "Pirajuí",
    "uf": "SP"
  },
  {
    "codigo": 3539004,
    "nome": "Pirangi",
    "uf": "SP"
  },
  {
    "codigo": 3539103,
    "nome": "Pirapora do Bom Jesus",
    "uf": "SP"
  },
  {
    "codigo": 3539202,
    "nome": "Pirapozinho",
    "uf": "SP"
  },
  {
    "codigo": 3539301,
    "nome": "Pirassununga",
    "uf": "SP"
  },
  {
    "codigo": 3539400,
    "nome": "Piratininga",
    "uf": "SP"
  },
  {
    "codigo": 3539509,
    "nome": "Pitangueiras",
    "uf": "SP"
  },
  {
    "codigo": 3539608,
    "nome": "Planalto",
    "uf": "SP"
  },
  {
    "codigo": 3539707,
    "nome": "Platina",
    "uf": "SP"
  },
  {
    "codigo": 3539806,
    "nome": "Poá",
    "uf": "SP"
  },
  {
    "codigo": 3539905,
    "nome": "Poloni",
    "uf": "SP"
  },
  {
    "codigo": 3540002,
    "nome": "Pompéia",
    "uf": "SP"
  },
  {
    "codigo": 3540101,
    "nome": "Pongaí",
    "uf": "SP"
  },
  {
    "codigo": 3540200,
    "nome": "Pontal",
    "uf": "SP"
  },
  {
    "codigo": 3540259,
    "nome": "Pontalinda",
    "uf": "SP"
  },
  {
    "codigo": 3540309,
    "nome": "Pontes Gestal",
    "uf": "SP"
  },
  {
    "codigo": 3540408,
    "nome": "Populina",
    "uf": "SP"
  },
  {
    "codigo": 3540507,
    "nome": "Porangaba",
    "uf": "SP"
  },
  {
    "codigo": 3540606,
    "nome": "Porto Feliz",
    "uf": "SP"
  },
  {
    "codigo": 3540705,
    "nome": "Porto Ferreira",
    "uf": "SP"
  },
  {
    "codigo": 3540754,
    "nome": "Potim",
    "uf": "SP"
  },
  {
    "codigo": 3540804,
    "nome": "Potirendaba",
    "uf": "SP"
  },
  {
    "codigo": 3540853,
    "nome": "Pracinha",
    "uf": "SP"
  },
  {
    "codigo": 3540903,
    "nome": "Pradópolis",
    "uf": "SP"
  },
  {
    "codigo": 3541000,
    "nome": "Praia Grande",
    "uf": "SP"
  },
  {
    "codigo": 3541059,
    "nome": "Pratânia",
    "uf": "SP"
  },
  {
    "codigo": 3541109,
    "nome": "Presidente Alves",
    "uf": "SP"
  },
  {
    "codigo": 3541208,
    "nome": "Presidente Bernardes",
    "uf": "SP"
  },
  {
    "codigo": 3541307,
    "nome": "Presidente Epitácio",
    "uf": "SP"
  },
  {
    "codigo": 3541406,
    "nome": "Presidente Prudente",
    "uf": "SP"
  },
  {
    "codigo": 3541505,
    "nome": "Presidente Venceslau",
    "uf": "SP"
  },
  {
    "codigo": 3541604,
    "nome": "Promissão",
    "uf": "SP"
  },
  {
    "codigo": 3541653,
    "nome": "Quadra",
    "uf": "SP"
  },
  {
    "codigo": 3541703,
    "nome": "Quatá",
    "uf": "SP"
  },
  {
    "codigo": 3541802,
    "nome": "Queiroz",
    "uf": "SP"
  },
  {
    "codigo": 3541901,
    "nome": "Queluz",
    "uf": "SP"
  },
  {
    "codigo": 3542008,
    "nome": "Quintana",
    "uf": "SP"
  },
  {
    "codigo": 3542107,
    "nome": "Rafard",
    "uf": "SP"
  },
  {
    "codigo": 3542206,
    "nome": "Rancharia",
    "uf": "SP"
  },
  {
    "codigo": 3542305,
    "nome": "Redenção da Serra",
    "uf": "SP"
  },
  {
    "codigo": 3542404,
    "nome": "Regente Feijó",
    "uf": "SP"
  },
  {
    "codigo": 3542503,
    "nome": "Reginópolis",
    "uf": "SP"
  },
  {
    "codigo": 3542602,
    "nome": "Registro",
    "uf": "SP"
  },
  {
    "codigo": 3542701,
    "nome": "Restinga",
    "uf": "SP"
  },
  {
    "codigo": 3542800,
    "nome": "Ribeira",
    "uf": "SP"
  },
  {
    "codigo": 3542909,
    "nome": "Ribeirão Bonito",
    "uf": "SP"
  },
  {
    "codigo": 3543006,
    "nome": "Ribeirão Branco",
    "uf": "SP"
  },
  {
    "codigo": 3543105,
    "nome": "Ribeirão Corrente",
    "uf": "SP"
  },
  {
    "codigo": 3543204,
    "nome": "Ribeirão do Sul",
    "uf": "SP"
  },
  {
    "codigo": 3543238,
    "nome": "Ribeirão dos Índios",
    "uf": "SP"
  },
  {
    "codigo": 3543253,
    "nome": "Ribeirão Grande",
    "uf": "SP"
  },
  {
    "codigo": 3543303,
    "nome": "Ribeirão Pires",
    "uf": "SP"
  },
  {
    "codigo": 3543402,
    "nome": "Ribeirão Preto",
    "uf": "SP"
  },
  {
    "codigo": 3543501,
    "nome": "Riversul",
    "uf": "SP"
  },
  {
    "codigo": 3543600,
    "nome": "Rifaina",
    "uf": "SP"
  },
  {
    "codigo": 3543709,
    "nome": "Rincão",
    "uf": "SP"
  },
  {
    "codigo": 3543808,
    "nome": "Rinópolis",
    "uf": "SP"
  },
  {
    "codigo": 3543907,
    "nome": "Rio Claro",
    "uf": "SP"
  },
  {
    "codigo": 3544004,
    "nome": "Rio das Pedras",
    "uf": "SP"
  },
  {
    "codigo": 3544103,
    "nome": "Rio Grande da Serra",
    "uf": "SP"
  },
  {
    "codigo": 3544202,
    "nome": "Riolândia",
    "uf": "SP"
  },
  {
    "codigo": 3544251,
    "nome": "Rosana",
    "uf": "SP"
  },
  {
    "codigo": 3544301,
    "nome": "Roseira",
    "uf": "SP"
  },
  {
    "codigo": 3544400,
    "nome": "Rubiácea",
    "uf": "SP"
  },
  {
    "codigo": 3544509,
    "nome": "Rubinéia",
    "uf": "SP"
  },
  {
    "codigo": 3544608,
    "nome": "Sabino",
    "uf": "SP"
  },
  {
    "codigo": 3544707,
    "nome": "Sagres",
    "uf": "SP"
  },
  {
    "codigo": 3544806,
    "nome": "Sales",
    "uf": "SP"
  },
  {
    "codigo": 3544905,
    "nome": "Sales Oliveira",
    "uf": "SP"
  },
  {
    "codigo": 3545001,
    "nome": "Salesópolis",
    "uf": "SP"
  },
  {
    "codigo": 3545100,
    "nome": "Salmourão",
    "uf": "SP"
  },
  {
    "codigo": 3545159,
    "nome": "Saltinho",
    "uf": "SP"
  },
  {
    "codigo": 3545209,
    "nome": "Salto",
    "uf": "SP"
  },
  {
    "codigo": 3545308,
    "nome": "Salto de Pirapora",
    "uf": "SP"
  },
  {
    "codigo": 3545407,
    "nome": "Salto Grande",
    "uf": "SP"
  },
  {
    "codigo": 3545506,
    "nome": "Sandovalina",
    "uf": "SP"
  },
  {
    "codigo": 3545605,
    "nome": "Santa Adélia",
    "uf": "SP"
  },
  {
    "codigo": 3545704,
    "nome": "Santa Albertina",
    "uf": "SP"
  },
  {
    "codigo": 3545803,
    "nome": "Santa Bárbara d'Oeste",
    "uf": "SP"
  },
  {
    "codigo": 3546009,
    "nome": "Santa Branca",
    "uf": "SP"
  },
  {
    "codigo": 3546108,
    "nome": "Santa Clara d'Oeste",
    "uf": "SP"
  },
  {
    "codigo": 3546207,
    "nome": "Santa Cruz da Conceição",
    "uf": "SP"
  },
  {
    "codigo": 3546256,
    "nome": "Santa Cruz da Esperança",
    "uf": "SP"
  },
  {
    "codigo": 3546306,
    "nome": "Santa Cruz das Palmeiras",
    "uf": "SP"
  },
  {
    "codigo": 3546405,
    "nome": "Santa Cruz do Rio Pardo",
    "uf": "SP"
  },
  {
    "codigo": 3546504,
    "nome": "Santa Ernestina",
    "uf": "SP"
  },
  {
    "codigo": 3546603,
    "nome": "Santa Fé do Sul",
    "uf": "SP"
  },
  {
    "codigo": 3546702,
    "nome": "Santa Gertrudes",
    "uf": "SP"
  },
  {
    "codigo": 3546801,
    "nome": "Santa Isabel",
    "uf": "SP"
  },
  {
    "codigo": 3546900,
    "nome": "Santa Lúcia",
    "uf": "SP"
  },
  {
    "codigo": 3547007,
    "nome": "Santa Maria da Serra",
    "uf": "SP"
  },
  {
    "codigo": 3547106,
    "nome": "Santa Mercedes",
    "uf": "SP"
  },
  {
    "codigo": 3547205,
    "nome": "Santana da Ponte Pensa",
    "uf": "SP"
  },
  {
    "codigo": 3547304,
    "nome": "Santana de Parnaíba",
    "uf": "SP"
  },
  {
    "codigo": 3547403,
    "nome": "Santa Rita d'Oeste",
    "uf": "SP"
  },
  {
    "codigo": 3547502,
    "nome": "Santa Rita do Passa Quatro",
    "uf": "SP"
  },
  {
    "codigo": 3547601,
    "nome": "Santa Rosa de Viterbo",
    "uf": "SP"
  },
  {
    "codigo": 3547650,
    "nome": "Santa Salete",
    "uf": "SP"
  },
  {
    "codigo": 3547700,
    "nome": "Santo Anastácio",
    "uf": "SP"
  },
  {
    "codigo": 3547809,
    "nome": "Santo André",
    "uf": "SP"
  },
  {
    "codigo": 3547908,
    "nome": "Santo Antônio da Alegria",
    "uf": "SP"
  },
  {
    "codigo": 3548005,
    "nome": "Santo Antônio de Posse",
    "uf": "SP"
  },
  {
    "codigo": 3548054,
    "nome": "Santo Antônio do Aracanguá",
    "uf": "SP"
  },
  {
    "codigo": 3548104,
    "nome": "Santo Antônio do Jardim",
    "uf": "SP"
  },
  {
    "codigo": 3548203,
    "nome": "Santo Antônio do Pinhal",
    "uf": "SP"
  },
  {
    "codigo": 3548302,
    "nome": "Santo Expedito",
    "uf": "SP"
  },
  {
    "codigo": 3548401,
    "nome": "Santópolis do Aguapeí",
    "uf": "SP"
  },
  {
    "codigo": 3548500,
    "nome": "Santos",
    "uf": "SP"
  },
  {
    "codigo": 3548609,
    "nome": "São Bento do Sapucaí",
    "uf": "SP"
  },
  {
    "codigo": 3548708,
    "nome": "São Bernardo do Campo",
    "uf": "SP"
  },
  {
    "codigo": 3548807,
    "nome": "São Caetano do Sul",
    "uf": "SP"
  },
  {
    "codigo": 3548906,
    "nome": "São Carlos",
    "uf": "SP"
  },
  {
    "codigo": 3549003,
    "nome": "São Francisco",
    "uf": "SP"
  },
  {
    "codigo": 3549102,
    "nome": "São João da Boa Vista",
    "uf": "SP"
  },
  {
    "codigo": 3549201,
    "nome": "São João das Duas Pontes",
    "uf": "SP"
  },
  {
    "codigo": 3549250,
    "nome": "São João de Iracema",
    "uf": "SP"
  },
  {
    "codigo": 3549300,
    "nome": "São João do Pau d'Alho",
    "uf": "SP"
  },
  {
    "codigo": 3549409,
    "nome": "São Joaquim da Barra",
    "uf": "SP"
  },
  {
    "codigo": 3549508,
    "nome": "São José da Bela Vista",
    "uf": "SP"
  },
  {
    "codigo": 3549607,
    "nome": "São José do Barreiro",
    "uf": "SP"
  },
  {
    "codigo": 3549706,
    "nome": "São José do Rio Pardo",
    "uf": "SP"
  },
  {
    "codigo": 3549805,
    "nome": "São José do Rio Preto",
    "uf": "SP"
  },
  {
    "codigo": 3549904,
    "nome": "São José dos Campos",
    "uf": "SP"
  },
  {
    "codigo": 3549953,
    "nome": "São Lourenço da Serra",
    "uf": "SP"
  },
  {
    "codigo": 3550001,
    "nome": "São Luiz do Paraitinga",
    "uf": "SP"
  },
  {
    "codigo": 3550100,
    "nome": "São Manuel",
    "uf": "SP"
  },
  {
    "codigo": 3550209,
    "nome": "São Miguel Arcanjo",
    "uf": "SP"
  },
  {
    "codigo": 3550308,
    "nome": "São Paulo",
    "uf": "SP"
  },
  {
    "codigo": 3550407,
    "nome": "São Pedro",
    "uf": "SP"
  },
  {
    "codigo": 3550506,
    "nome": "São Pedro do Turvo",
    "uf": "SP"
  },
  {
    "codigo": 3550605,
    "nome": "São Roque",
    "uf": "SP"
  },
  {
    "codigo": 3550704,
    "nome": "São Sebastião",
    "uf": "SP"
  },
  {
    "codigo": 3550803,
    "nome": "São Sebastião da Grama",
    "uf": "SP"
  },
  {
    "codigo": 3550902,
    "nome": "São Simão",
    "uf": "SP"
  },
  {
    "codigo": 3551009,
    "nome": "São Vicente",
    "uf": "SP"
  },
  {
    "codigo": 3551108,
    "nome": "Sarapuí",
    "uf": "SP"
  },
  {
    "codigo": 3551207,
    "nome": "Sarutaiá",
    "uf": "SP"
  },
  {
    "codigo": 3551306,
    "nome": "Sebastianópolis do Sul",
    "uf": "SP"
  },
  {
    "codigo": 3551405,
    "nome": "Serra Azul",
    "uf": "SP"
  },
  {
    "codigo": 3551504,
    "nome": "Serrana",
    "uf": "SP"
  },
  {
    "codigo": 3551603,
    "nome": "Serra Negra",
    "uf": "SP"
  },
  {
    "codigo": 3551702,
    "nome": "Sertãozinho",
    "uf": "SP"
  },
  {
    "codigo": 3551801,
    "nome": "Sete Barras",
    "uf": "SP"
  },
  {
    "codigo": 3551900,
    "nome": "Severínia",
    "uf": "SP"
  },
  {
    "codigo": 3552007,
    "nome": "Silveiras",
    "uf": "SP"
  },
  {
    "codigo": 3552106,
    "nome": "Socorro",
    "uf": "SP"
  },
  {
    "codigo": 3552205,
    "nome": "Sorocaba",
    "uf": "SP"
  },
  {
    "codigo": 3552304,
    "nome": "Sud Mennucci",
    "uf": "SP"
  },
  {
    "codigo": 3552403,
    "nome": "Sumaré",
    "uf": "SP"
  },
  {
    "codigo": 3552502,
    "nome": "Suzano",
    "uf": "SP"
  },
  {
    "codigo": 3552551,
    "nome": "Suzanápolis",
    "uf": "SP"
  },
  {
    "codigo": 3552601,
    "nome": "Tabapuã",
    "uf": "SP"
  },
  {
    "codigo": 3552700,
    "nome": "Tabatinga",
    "uf": "SP"
  },
  {
    "codigo": 3552809,
    "nome": "Taboão da Serra",
    "uf": "SP"
  },
  {
    "codigo": 3552908,
    "nome": "Taciba",
    "uf": "SP"
  },
  {
    "codigo": 3553005,
    "nome": "Taguaí",
    "uf": "SP"
  },
  {
    "codigo": 3553104,
    "nome": "Taiaçu",
    "uf": "SP"
  },
  {
    "codigo": 3553203,
    "nome": "Taiúva",
    "uf": "SP"
  },
  {
    "codigo": 3553302,
    "nome": "Tambaú",
    "uf": "SP"
  },
  {
    "codigo": 3553401,
    "nome": "Tanabi",
    "uf": "SP"
  },
  {
    "codigo": 3553500,
    "nome": "Tapiraí",
    "uf": "SP"
  },
  {
    "codigo": 3553609,
    "nome": "Tapiratiba",
    "uf": "SP"
  },
  {
    "codigo": 3553658,
    "nome": "Taquaral",
    "uf": "SP"
  },
  {
    "codigo": 3553708,
    "nome": "Taquaritinga",
    "uf": "SP"
  },
  {
    "codigo": 3553807,
    "nome": "Taquarituba",
    "uf": "SP"
  },
  {
    "codigo": 3553856,
    "nome": "Taquarivaí",
    "uf": "SP"
  },
  {
    "codigo": 3553906,
    "nome": "Tarabai",
    "uf": "SP"
  },
  {
    "codigo": 3553955,
    "nome": "Tarumã",
    "uf": "SP"
  },
  {
    "codigo": 3554003,
    "nome": "Tatuí",
    "uf": "SP"
  },
  {
    "codigo": 3554102,
    "nome": "Taubaté",
    "uf": "SP"
  },
  {
    "codigo": 3554201,
    "nome": "Tejupá",
    "uf": "SP"
  },
  {
    "codigo": 3554300,
    "nome": "Teodoro Sampaio",
    "uf": "SP"
  },
  {
    "codigo": 3554409,
    "nome": "Terra Roxa",
    "uf": "SP"
  },
  {
    "codigo": 3554508,
    "nome": "Tietê",
    "uf": "SP"
  },
  {
    "codigo": 3554607,
    "nome": "Timburi",
    "uf": "SP"
  },
  {
    "codigo": 3554656,
    "nome": "Torre de Pedra",
    "uf": "SP"
  },
  {
    "codigo": 3554706,
    "nome": "Torrinha",
    "uf": "SP"
  },
  {
    "codigo": 3554755,
    "nome": "Trabiju",
    "uf": "SP"
  },
  {
    "codigo": 3554805,
    "nome": "Tremembé",
    "uf": "SP"
  },
  {
    "codigo": 3554904,
    "nome": "Três Fronteiras",
    "uf": "SP"
  },
  {
    "codigo": 3554953,
    "nome": "Tuiuti",
    "uf": "SP"
  },
  {
    "codigo": 3555000,
    "nome": "Tupã",
    "uf": "SP"
  },
  {
    "codigo": 3555109,
    "nome": "Tupi Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3555208,
    "nome": "Turiúba",
    "uf": "SP"
  },
  {
    "codigo": 3555307,
    "nome": "Turmalina",
    "uf": "SP"
  },
  {
    "codigo": 3555356,
    "nome": "Ubarana",
    "uf": "SP"
  },
  {
    "codigo": 3555406,
    "nome": "Ubatuba",
    "uf": "SP"
  },
  {
    "codigo": 3555505,
    "nome": "Ubirajara",
    "uf": "SP"
  },
  {
    "codigo": 3555604,
    "nome": "Uchoa",
    "uf": "SP"
  },
  {
    "codigo": 3555703,
    "nome": "União Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3555802,
    "nome": "Urânia",
    "uf": "SP"
  },
  {
    "codigo": 3555901,
    "nome": "Uru",
    "uf": "SP"
  },
  {
    "codigo": 3556008,
    "nome": "Urupês",
    "uf": "SP"
  },
  {
    "codigo": 3556107,
    "nome": "Valentim Gentil",
    "uf": "SP"
  },
  {
    "codigo": 3556206,
    "nome": "Valinhos",
    "uf": "SP"
  },
  {
    "codigo": 3556305,
    "nome": "Valparaíso",
    "uf": "SP"
  },
  {
    "codigo": 3556354,
    "nome": "Vargem",
    "uf": "SP"
  },
  {
    "codigo": 3556404,
    "nome": "Vargem Grande do Sul",
    "uf": "SP"
  },
  {
    "codigo": 3556453,
    "nome": "Vargem Grande Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3556503,
    "nome": "Várzea Paulista",
    "uf": "SP"
  },
  {
    "codigo": 3556602,
    "nome": "Vera Cruz",
    "uf": "SP"
  },
  {
    "codigo": 3556701,
    "nome": "Vinhedo",
    "uf": "SP"
  },
  {
    "codigo": 3556800,
    "nome": "Viradouro",
    "uf": "SP"
  },
  {
    "codigo": 3556909,
    "nome": "Vista Alegre do Alto",
    "uf": "SP"
  },
  {
    "codigo": 3556958,
    "nome": "Vitória Brasil",
    "uf": "SP"
  },
  {
    "codigo": 3557006,
    "nome": "Votorantim",
    "uf": "SP"
  },
  {
    "codigo": 3557105,
    "nome": "Votuporanga",
    "uf": "SP"
  },
  {
    "codigo": 3557154,
    "nome": "Zacarias",
    "uf": "SP"
  },
  {
    "codigo": 3557204,
    "nome": "Chavantes",
    "uf": "SP"
  },
  {
    "codigo": 3557303,
    "nome": "Estiva Gerbi",
    "uf": "SP"
  },
  {
    "codigo": 4100103,
    "nome": "Abatiá",
    "uf": "PR"
  },
  {
    "codigo": 4100202,
    "nome": "Adrianópolis",
    "uf": "PR"
  },
  {
    "codigo": 4100301,
    "nome": "Agudos do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4100400,
    "nome": "Almirante Tamandaré",
    "uf": "PR"
  },
  {
    "codigo": 4100459,
    "nome": "Altamira do Paraná",
    "uf": "PR"
  },
  {
    "codigo": 4100509,
    "nome": "Altônia",
    "uf": "PR"
  },
  {
    "codigo": 4100608,
    "nome": "Alto Paraná",
    "uf": "PR"
  },
  {
    "codigo": 4100707,
    "nome": "Alto Piquiri",
    "uf": "PR"
  },
  {
    "codigo": 4100806,
    "nome": "Alvorada do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4100905,
    "nome": "Amaporã",
    "uf": "PR"
  },
  {
    "codigo": 4101002,
    "nome": "Ampére",
    "uf": "PR"
  },
  {
    "codigo": 4101051,
    "nome": "Anahy",
    "uf": "PR"
  },
  {
    "codigo": 4101101,
    "nome": "Andirá",
    "uf": "PR"
  },
  {
    "codigo": 4101150,
    "nome": "Ângulo",
    "uf": "PR"
  },
  {
    "codigo": 4101200,
    "nome": "Antonina",
    "uf": "PR"
  },
  {
    "codigo": 4101309,
    "nome": "Antônio Olinto",
    "uf": "PR"
  },
  {
    "codigo": 4101408,
    "nome": "Apucarana",
    "uf": "PR"
  },
  {
    "codigo": 4101507,
    "nome": "Arapongas",
    "uf": "PR"
  },
  {
    "codigo": 4101606,
    "nome": "Arapoti",
    "uf": "PR"
  },
  {
    "codigo": 4101655,
    "nome": "Arapuã",
    "uf": "PR"
  },
  {
    "codigo": 4101705,
    "nome": "Araruna",
    "uf": "PR"
  },
  {
    "codigo": 4101804,
    "nome": "Araucária",
    "uf": "PR"
  },
  {
    "codigo": 4101853,
    "nome": "Ariranha do Ivaí",
    "uf": "PR"
  },
  {
    "codigo": 4101903,
    "nome": "Assaí",
    "uf": "PR"
  },
  {
    "codigo": 4102000,
    "nome": "Assis Chateaubriand",
    "uf": "PR"
  },
  {
    "codigo": 4102109,
    "nome": "Astorga",
    "uf": "PR"
  },
  {
    "codigo": 4102208,
    "nome": "Atalaia",
    "uf": "PR"
  },
  {
    "codigo": 4102307,
    "nome": "Balsa Nova",
    "uf": "PR"
  },
  {
    "codigo": 4102406,
    "nome": "Bandeirantes",
    "uf": "PR"
  },
  {
    "codigo": 4102505,
    "nome": "Barbosa Ferraz",
    "uf": "PR"
  },
  {
    "codigo": 4102604,
    "nome": "Barracão",
    "uf": "PR"
  },
  {
    "codigo": 4102703,
    "nome": "Barra do Jacaré",
    "uf": "PR"
  },
  {
    "codigo": 4102752,
    "nome": "Bela Vista da Caroba",
    "uf": "PR"
  },
  {
    "codigo": 4102802,
    "nome": "Bela Vista do Paraíso",
    "uf": "PR"
  },
  {
    "codigo": 4102901,
    "nome": "Bituruna",
    "uf": "PR"
  },
  {
    "codigo": 4103008,
    "nome": "Boa Esperança",
    "uf": "PR"
  },
  {
    "codigo": 4103024,
    "nome": "Boa Esperança do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4103040,
    "nome": "Boa Ventura de São Roque",
    "uf": "PR"
  },
  {
    "codigo": 4103057,
    "nome": "Boa Vista da Aparecida",
    "uf": "PR"
  },
  {
    "codigo": 4103107,
    "nome": "Bocaiúva do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4103156,
    "nome": "Bom Jesus do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4103206,
    "nome": "Bom Sucesso",
    "uf": "PR"
  },
  {
    "codigo": 4103222,
    "nome": "Bom Sucesso do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4103305,
    "nome": "Borrazópolis",
    "uf": "PR"
  },
  {
    "codigo": 4103354,
    "nome": "Braganey",
    "uf": "PR"
  },
  {
    "codigo": 4103370,
    "nome": "Brasilândia do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4103404,
    "nome": "Cafeara",
    "uf": "PR"
  },
  {
    "codigo": 4103453,
    "nome": "Cafelândia",
    "uf": "PR"
  },
  {
    "codigo": 4103479,
    "nome": "Cafezal do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4103503,
    "nome": "Califórnia",
    "uf": "PR"
  },
  {
    "codigo": 4103602,
    "nome": "Cambará",
    "uf": "PR"
  },
  {
    "codigo": 4103701,
    "nome": "Cambé",
    "uf": "PR"
  },
  {
    "codigo": 4103800,
    "nome": "Cambira",
    "uf": "PR"
  },
  {
    "codigo": 4103909,
    "nome": "Campina da Lagoa",
    "uf": "PR"
  },
  {
    "codigo": 4103958,
    "nome": "Campina do Simão",
    "uf": "PR"
  },
  {
    "codigo": 4104006,
    "nome": "Campina Grande do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4104055,
    "nome": "Campo Bonito",
    "uf": "PR"
  },
  {
    "codigo": 4104105,
    "nome": "Campo do Tenente",
    "uf": "PR"
  },
  {
    "codigo": 4104204,
    "nome": "Campo Largo",
    "uf": "PR"
  },
  {
    "codigo": 4104253,
    "nome": "Campo Magro",
    "uf": "PR"
  },
  {
    "codigo": 4104303,
    "nome": "Campo Mourão",
    "uf": "PR"
  },
  {
    "codigo": 4104402,
    "nome": "Cândido de Abreu",
    "uf": "PR"
  },
  {
    "codigo": 4104428,
    "nome": "Candói",
    "uf": "PR"
  },
  {
    "codigo": 4104451,
    "nome": "Cantagalo",
    "uf": "PR"
  },
  {
    "codigo": 4104501,
    "nome": "Capanema",
    "uf": "PR"
  },
  {
    "codigo": 4104600,
    "nome": "Capitão Leônidas Marques",
    "uf": "PR"
  },
  {
    "codigo": 4104659,
    "nome": "Carambeí",
    "uf": "PR"
  },
  {
    "codigo": 4104709,
    "nome": "Carlópolis",
    "uf": "PR"
  },
  {
    "codigo": 4104808,
    "nome": "Cascavel",
    "uf": "PR"
  },
  {
    "codigo": 4104907,
    "nome": "Castro",
    "uf": "PR"
  },
  {
    "codigo": 4105003,
    "nome": "Catanduvas",
    "uf": "PR"
  },
  {
    "codigo": 4105102,
    "nome": "Centenário do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4105201,
    "nome": "Cerro Azul",
    "uf": "PR"
  },
  {
    "codigo": 4105300,
    "nome": "Céu Azul",
    "uf": "PR"
  },
  {
    "codigo": 4105409,
    "nome": "Chopinzinho",
    "uf": "PR"
  },
  {
    "codigo": 4105508,
    "nome": "Cianorte",
    "uf": "PR"
  },
  {
    "codigo": 4105607,
    "nome": "Cidade Gaúcha",
    "uf": "PR"
  },
  {
    "codigo": 4105706,
    "nome": "Clevelândia",
    "uf": "PR"
  },
  {
    "codigo": 4105805,
    "nome": "Colombo",
    "uf": "PR"
  },
  {
    "codigo": 4105904,
    "nome": "Colorado",
    "uf": "PR"
  },
  {
    "codigo": 4106001,
    "nome": "Congonhinhas",
    "uf": "PR"
  },
  {
    "codigo": 4106100,
    "nome": "Conselheiro Mairinck",
    "uf": "PR"
  },
  {
    "codigo": 4106209,
    "nome": "Contenda",
    "uf": "PR"
  },
  {
    "codigo": 4106308,
    "nome": "Corbélia",
    "uf": "PR"
  },
  {
    "codigo": 4106407,
    "nome": "Cornélio Procópio",
    "uf": "PR"
  },
  {
    "codigo": 4106456,
    "nome": "Coronel Domingos Soares",
    "uf": "PR"
  },
  {
    "codigo": 4106506,
    "nome": "Coronel Vivida",
    "uf": "PR"
  },
  {
    "codigo": 4106555,
    "nome": "Corumbataí do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4106571,
    "nome": "Cruzeiro do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4106605,
    "nome": "Cruzeiro do Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4106704,
    "nome": "Cruzeiro do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4106803,
    "nome": "Cruz Machado",
    "uf": "PR"
  },
  {
    "codigo": 4106852,
    "nome": "Cruzmaltina",
    "uf": "PR"
  },
  {
    "codigo": 4106902,
    "nome": "Curitiba",
    "uf": "PR"
  },
  {
    "codigo": 4107009,
    "nome": "Curiúva",
    "uf": "PR"
  },
  {
    "codigo": 4107108,
    "nome": "Diamante do Norte",
    "uf": "PR"
  },
  {
    "codigo": 4107124,
    "nome": "Diamante do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4107157,
    "nome": "Diamante D'Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4107207,
    "nome": "Dois Vizinhos",
    "uf": "PR"
  },
  {
    "codigo": 4107256,
    "nome": "Douradina",
    "uf": "PR"
  },
  {
    "codigo": 4107306,
    "nome": "Doutor Camargo",
    "uf": "PR"
  },
  {
    "codigo": 4107405,
    "nome": "Enéas Marques",
    "uf": "PR"
  },
  {
    "codigo": 4107504,
    "nome": "Engenheiro Beltrão",
    "uf": "PR"
  },
  {
    "codigo": 4107520,
    "nome": "Esperança Nova",
    "uf": "PR"
  },
  {
    "codigo": 4107538,
    "nome": "Entre Rios do Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4107546,
    "nome": "Espigão Alto do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4107553,
    "nome": "Farol",
    "uf": "PR"
  },
  {
    "codigo": 4107603,
    "nome": "Faxinal",
    "uf": "PR"
  },
  {
    "codigo": 4107652,
    "nome": "Fazenda Rio Grande",
    "uf": "PR"
  },
  {
    "codigo": 4107702,
    "nome": "Fênix",
    "uf": "PR"
  },
  {
    "codigo": 4107736,
    "nome": "Fernandes Pinheiro",
    "uf": "PR"
  },
  {
    "codigo": 4107751,
    "nome": "Figueira",
    "uf": "PR"
  },
  {
    "codigo": 4107801,
    "nome": "Floraí",
    "uf": "PR"
  },
  {
    "codigo": 4107850,
    "nome": "Flor da Serra do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4107900,
    "nome": "Floresta",
    "uf": "PR"
  },
  {
    "codigo": 4108007,
    "nome": "Florestópolis",
    "uf": "PR"
  },
  {
    "codigo": 4108106,
    "nome": "Flórida",
    "uf": "PR"
  },
  {
    "codigo": 4108205,
    "nome": "Formosa do Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4108304,
    "nome": "Foz do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4108320,
    "nome": "Francisco Alves",
    "uf": "PR"
  },
  {
    "codigo": 4108403,
    "nome": "Francisco Beltrão",
    "uf": "PR"
  },
  {
    "codigo": 4108452,
    "nome": "Foz do Jordão",
    "uf": "PR"
  },
  {
    "codigo": 4108502,
    "nome": "General Carneiro",
    "uf": "PR"
  },
  {
    "codigo": 4108551,
    "nome": "Godoy Moreira",
    "uf": "PR"
  },
  {
    "codigo": 4108601,
    "nome": "Goioerê",
    "uf": "PR"
  },
  {
    "codigo": 4108650,
    "nome": "Goioxim",
    "uf": "PR"
  },
  {
    "codigo": 4108700,
    "nome": "Grandes Rios",
    "uf": "PR"
  },
  {
    "codigo": 4108809,
    "nome": "Guaíra",
    "uf": "PR"
  },
  {
    "codigo": 4108908,
    "nome": "Guairaçá",
    "uf": "PR"
  },
  {
    "codigo": 4108957,
    "nome": "Guamiranga",
    "uf": "PR"
  },
  {
    "codigo": 4109005,
    "nome": "Guapirama",
    "uf": "PR"
  },
  {
    "codigo": 4109104,
    "nome": "Guaporema",
    "uf": "PR"
  },
  {
    "codigo": 4109203,
    "nome": "Guaraci",
    "uf": "PR"
  },
  {
    "codigo": 4109302,
    "nome": "Guaraniaçu",
    "uf": "PR"
  },
  {
    "codigo": 4109401,
    "nome": "Guarapuava",
    "uf": "PR"
  },
  {
    "codigo": 4109500,
    "nome": "Guaraqueçaba",
    "uf": "PR"
  },
  {
    "codigo": 4109609,
    "nome": "Guaratuba",
    "uf": "PR"
  },
  {
    "codigo": 4109658,
    "nome": "Honório Serpa",
    "uf": "PR"
  },
  {
    "codigo": 4109708,
    "nome": "Ibaiti",
    "uf": "PR"
  },
  {
    "codigo": 4109757,
    "nome": "Ibema",
    "uf": "PR"
  },
  {
    "codigo": 4109807,
    "nome": "Ibiporã",
    "uf": "PR"
  },
  {
    "codigo": 4109906,
    "nome": "Icaraíma",
    "uf": "PR"
  },
  {
    "codigo": 4110003,
    "nome": "Iguaraçu",
    "uf": "PR"
  },
  {
    "codigo": 4110052,
    "nome": "Iguatu",
    "uf": "PR"
  },
  {
    "codigo": 4110078,
    "nome": "Imbaú",
    "uf": "PR"
  },
  {
    "codigo": 4110102,
    "nome": "Imbituva",
    "uf": "PR"
  },
  {
    "codigo": 4110201,
    "nome": "Inácio Martins",
    "uf": "PR"
  },
  {
    "codigo": 4110300,
    "nome": "Inajá",
    "uf": "PR"
  },
  {
    "codigo": 4110409,
    "nome": "Indianópolis",
    "uf": "PR"
  },
  {
    "codigo": 4110508,
    "nome": "Ipiranga",
    "uf": "PR"
  },
  {
    "codigo": 4110607,
    "nome": "Iporã",
    "uf": "PR"
  },
  {
    "codigo": 4110656,
    "nome": "Iracema do Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4110706,
    "nome": "Irati",
    "uf": "PR"
  },
  {
    "codigo": 4110805,
    "nome": "Iretama",
    "uf": "PR"
  },
  {
    "codigo": 4110904,
    "nome": "Itaguajé",
    "uf": "PR"
  },
  {
    "codigo": 4110953,
    "nome": "Itaipulândia",
    "uf": "PR"
  },
  {
    "codigo": 4111001,
    "nome": "Itambaracá",
    "uf": "PR"
  },
  {
    "codigo": 4111100,
    "nome": "Itambé",
    "uf": "PR"
  },
  {
    "codigo": 4111209,
    "nome": "Itapejara d'Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4111258,
    "nome": "Itaperuçu",
    "uf": "PR"
  },
  {
    "codigo": 4111308,
    "nome": "Itaúna do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4111407,
    "nome": "Ivaí",
    "uf": "PR"
  },
  {
    "codigo": 4111506,
    "nome": "Ivaiporã",
    "uf": "PR"
  },
  {
    "codigo": 4111555,
    "nome": "Ivaté",
    "uf": "PR"
  },
  {
    "codigo": 4111605,
    "nome": "Ivatuba",
    "uf": "PR"
  },
  {
    "codigo": 4111704,
    "nome": "Jaboti",
    "uf": "PR"
  },
  {
    "codigo": 4111803,
    "nome": "Jacarezinho",
    "uf": "PR"
  },
  {
    "codigo": 4111902,
    "nome": "Jaguapitã",
    "uf": "PR"
  },
  {
    "codigo": 4112009,
    "nome": "Jaguariaíva",
    "uf": "PR"
  },
  {
    "codigo": 4112108,
    "nome": "Jandaia do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4112207,
    "nome": "Janiópolis",
    "uf": "PR"
  },
  {
    "codigo": 4112306,
    "nome": "Japira",
    "uf": "PR"
  },
  {
    "codigo": 4112405,
    "nome": "Japurá",
    "uf": "PR"
  },
  {
    "codigo": 4112504,
    "nome": "Jardim Alegre",
    "uf": "PR"
  },
  {
    "codigo": 4112603,
    "nome": "Jardim Olinda",
    "uf": "PR"
  },
  {
    "codigo": 4112702,
    "nome": "Jataizinho",
    "uf": "PR"
  },
  {
    "codigo": 4112751,
    "nome": "Jesuítas",
    "uf": "PR"
  },
  {
    "codigo": 4112801,
    "nome": "Joaquim Távora",
    "uf": "PR"
  },
  {
    "codigo": 4112900,
    "nome": "Jundiaí do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4112959,
    "nome": "Juranda",
    "uf": "PR"
  },
  {
    "codigo": 4113007,
    "nome": "Jussara",
    "uf": "PR"
  },
  {
    "codigo": 4113106,
    "nome": "Kaloré",
    "uf": "PR"
  },
  {
    "codigo": 4113205,
    "nome": "Lapa",
    "uf": "PR"
  },
  {
    "codigo": 4113254,
    "nome": "Laranjal",
    "uf": "PR"
  },
  {
    "codigo": 4113304,
    "nome": "Laranjeiras do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4113403,
    "nome": "Leópolis",
    "uf": "PR"
  },
  {
    "codigo": 4113429,
    "nome": "Lidianópolis",
    "uf": "PR"
  },
  {
    "codigo": 4113452,
    "nome": "Lindoeste",
    "uf": "PR"
  },
  {
    "codigo": 4113502,
    "nome": "Loanda",
    "uf": "PR"
  },
  {
    "codigo": 4113601,
    "nome": "Lobato",
    "uf": "PR"
  },
  {
    "codigo": 4113700,
    "nome": "Londrina",
    "uf": "PR"
  },
  {
    "codigo": 4113734,
    "nome": "Luiziana",
    "uf": "PR"
  },
  {
    "codigo": 4113759,
    "nome": "Lunardelli",
    "uf": "PR"
  },
  {
    "codigo": 4113809,
    "nome": "Lupionópolis",
    "uf": "PR"
  },
  {
    "codigo": 4113908,
    "nome": "Mallet",
    "uf": "PR"
  },
  {
    "codigo": 4114005,
    "nome": "Mamborê",
    "uf": "PR"
  },
  {
    "codigo": 4114104,
    "nome": "Mandaguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4114203,
    "nome": "Mandaguari",
    "uf": "PR"
  },
  {
    "codigo": 4114302,
    "nome": "Mandirituba",
    "uf": "PR"
  },
  {
    "codigo": 4114351,
    "nome": "Manfrinópolis",
    "uf": "PR"
  },
  {
    "codigo": 4114401,
    "nome": "Mangueirinha",
    "uf": "PR"
  },
  {
    "codigo": 4114500,
    "nome": "Manoel Ribas",
    "uf": "PR"
  },
  {
    "codigo": 4114609,
    "nome": "Marechal Cândido Rondon",
    "uf": "PR"
  },
  {
    "codigo": 4114708,
    "nome": "Maria Helena",
    "uf": "PR"
  },
  {
    "codigo": 4114807,
    "nome": "Marialva",
    "uf": "PR"
  },
  {
    "codigo": 4114906,
    "nome": "Marilândia do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4115002,
    "nome": "Marilena",
    "uf": "PR"
  },
  {
    "codigo": 4115101,
    "nome": "Mariluz",
    "uf": "PR"
  },
  {
    "codigo": 4115200,
    "nome": "Maringá",
    "uf": "PR"
  },
  {
    "codigo": 4115309,
    "nome": "Mariópolis",
    "uf": "PR"
  },
  {
    "codigo": 4115358,
    "nome": "Maripá",
    "uf": "PR"
  },
  {
    "codigo": 4115408,
    "nome": "Marmeleiro",
    "uf": "PR"
  },
  {
    "codigo": 4115457,
    "nome": "Marquinho",
    "uf": "PR"
  },
  {
    "codigo": 4115507,
    "nome": "Marumbi",
    "uf": "PR"
  },
  {
    "codigo": 4115606,
    "nome": "Matelândia",
    "uf": "PR"
  },
  {
    "codigo": 4115705,
    "nome": "Matinhos",
    "uf": "PR"
  },
  {
    "codigo": 4115739,
    "nome": "Mato Rico",
    "uf": "PR"
  },
  {
    "codigo": 4115754,
    "nome": "Mauá da Serra",
    "uf": "PR"
  },
  {
    "codigo": 4115804,
    "nome": "Medianeira",
    "uf": "PR"
  },
  {
    "codigo": 4115853,
    "nome": "Mercedes",
    "uf": "PR"
  },
  {
    "codigo": 4115903,
    "nome": "Mirador",
    "uf": "PR"
  },
  {
    "codigo": 4116000,
    "nome": "Miraselva",
    "uf": "PR"
  },
  {
    "codigo": 4116059,
    "nome": "Missal",
    "uf": "PR"
  },
  {
    "codigo": 4116109,
    "nome": "Moreira Sales",
    "uf": "PR"
  },
  {
    "codigo": 4116208,
    "nome": "Morretes",
    "uf": "PR"
  },
  {
    "codigo": 4116307,
    "nome": "Munhoz de Melo",
    "uf": "PR"
  },
  {
    "codigo": 4116406,
    "nome": "Nossa Senhora das Graças",
    "uf": "PR"
  },
  {
    "codigo": 4116505,
    "nome": "Nova Aliança do Ivaí",
    "uf": "PR"
  },
  {
    "codigo": 4116604,
    "nome": "Nova América da Colina",
    "uf": "PR"
  },
  {
    "codigo": 4116703,
    "nome": "Nova Aurora",
    "uf": "PR"
  },
  {
    "codigo": 4116802,
    "nome": "Nova Cantu",
    "uf": "PR"
  },
  {
    "codigo": 4116901,
    "nome": "Nova Esperança",
    "uf": "PR"
  },
  {
    "codigo": 4116950,
    "nome": "Nova Esperança do Sudoeste",
    "uf": "PR"
  },
  {
    "codigo": 4117008,
    "nome": "Nova Fátima",
    "uf": "PR"
  },
  {
    "codigo": 4117057,
    "nome": "Nova Laranjeiras",
    "uf": "PR"
  },
  {
    "codigo": 4117107,
    "nome": "Nova Londrina",
    "uf": "PR"
  },
  {
    "codigo": 4117206,
    "nome": "Nova Olímpia",
    "uf": "PR"
  },
  {
    "codigo": 4117214,
    "nome": "Nova Santa Bárbara",
    "uf": "PR"
  },
  {
    "codigo": 4117222,
    "nome": "Nova Santa Rosa",
    "uf": "PR"
  },
  {
    "codigo": 4117255,
    "nome": "Nova Prata do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4117271,
    "nome": "Nova Tebas",
    "uf": "PR"
  },
  {
    "codigo": 4117297,
    "nome": "Novo Itacolomi",
    "uf": "PR"
  },
  {
    "codigo": 4117305,
    "nome": "Ortigueira",
    "uf": "PR"
  },
  {
    "codigo": 4117404,
    "nome": "Ourizona",
    "uf": "PR"
  },
  {
    "codigo": 4117453,
    "nome": "Ouro Verde do Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4117503,
    "nome": "Paiçandu",
    "uf": "PR"
  },
  {
    "codigo": 4117602,
    "nome": "Palmas",
    "uf": "PR"
  },
  {
    "codigo": 4117701,
    "nome": "Palmeira",
    "uf": "PR"
  },
  {
    "codigo": 4117800,
    "nome": "Palmital",
    "uf": "PR"
  },
  {
    "codigo": 4117909,
    "nome": "Palotina",
    "uf": "PR"
  },
  {
    "codigo": 4118006,
    "nome": "Paraíso do Norte",
    "uf": "PR"
  },
  {
    "codigo": 4118105,
    "nome": "Paranacity",
    "uf": "PR"
  },
  {
    "codigo": 4118204,
    "nome": "Paranaguá",
    "uf": "PR"
  },
  {
    "codigo": 4118303,
    "nome": "Paranapoema",
    "uf": "PR"
  },
  {
    "codigo": 4118402,
    "nome": "Paranavaí",
    "uf": "PR"
  },
  {
    "codigo": 4118451,
    "nome": "Pato Bragado",
    "uf": "PR"
  },
  {
    "codigo": 4118501,
    "nome": "Pato Branco",
    "uf": "PR"
  },
  {
    "codigo": 4118600,
    "nome": "Paula Freitas",
    "uf": "PR"
  },
  {
    "codigo": 4118709,
    "nome": "Paulo Frontin",
    "uf": "PR"
  },
  {
    "codigo": 4118808,
    "nome": "Peabiru",
    "uf": "PR"
  },
  {
    "codigo": 4118857,
    "nome": "Perobal",
    "uf": "PR"
  },
  {
    "codigo": 4118907,
    "nome": "Pérola",
    "uf": "PR"
  },
  {
    "codigo": 4119004,
    "nome": "Pérola d'Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4119103,
    "nome": "Piên",
    "uf": "PR"
  },
  {
    "codigo": 4119152,
    "nome": "Pinhais",
    "uf": "PR"
  },
  {
    "codigo": 4119202,
    "nome": "Pinhalão",
    "uf": "PR"
  },
  {
    "codigo": 4119251,
    "nome": "Pinhal de São Bento",
    "uf": "PR"
  },
  {
    "codigo": 4119301,
    "nome": "Pinhão",
    "uf": "PR"
  },
  {
    "codigo": 4119400,
    "nome": "Piraí do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4119509,
    "nome": "Piraquara",
    "uf": "PR"
  },
  {
    "codigo": 4119608,
    "nome": "Pitanga",
    "uf": "PR"
  },
  {
    "codigo": 4119657,
    "nome": "Pitangueiras",
    "uf": "PR"
  },
  {
    "codigo": 4119707,
    "nome": "Planaltina do Paraná",
    "uf": "PR"
  },
  {
    "codigo": 4119806,
    "nome": "Planalto",
    "uf": "PR"
  },
  {
    "codigo": 4119905,
    "nome": "Ponta Grossa",
    "uf": "PR"
  },
  {
    "codigo": 4119954,
    "nome": "Pontal do Paraná",
    "uf": "PR"
  },
  {
    "codigo": 4120002,
    "nome": "Porecatu",
    "uf": "PR"
  },
  {
    "codigo": 4120101,
    "nome": "Porto Amazonas",
    "uf": "PR"
  },
  {
    "codigo": 4120150,
    "nome": "Porto Barreiro",
    "uf": "PR"
  },
  {
    "codigo": 4120200,
    "nome": "Porto Rico",
    "uf": "PR"
  },
  {
    "codigo": 4120309,
    "nome": "Porto Vitória",
    "uf": "PR"
  },
  {
    "codigo": 4120333,
    "nome": "Prado Ferreira",
    "uf": "PR"
  },
  {
    "codigo": 4120358,
    "nome": "Pranchita",
    "uf": "PR"
  },
  {
    "codigo": 4120408,
    "nome": "Presidente Castelo Branco",
    "uf": "PR"
  },
  {
    "codigo": 4120507,
    "nome": "Primeiro de Maio",
    "uf": "PR"
  },
  {
    "codigo": 4120606,
    "nome": "Prudentópolis",
    "uf": "PR"
  },
  {
    "codigo": 4120655,
    "nome": "Quarto Centenário",
    "uf": "PR"
  },
  {
    "codigo": 4120705,
    "nome": "Quatiguá",
    "uf": "PR"
  },
  {
    "codigo": 4120804,
    "nome": "Quatro Barras",
    "uf": "PR"
  },
  {
    "codigo": 4120853,
    "nome": "Quatro Pontes",
    "uf": "PR"
  },
  {
    "codigo": 4120903,
    "nome": "Quedas do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4121000,
    "nome": "Querência do Norte",
    "uf": "PR"
  },
  {
    "codigo": 4121109,
    "nome": "Quinta do Sol",
    "uf": "PR"
  },
  {
    "codigo": 4121208,
    "nome": "Quitandinha",
    "uf": "PR"
  },
  {
    "codigo": 4121257,
    "nome": "Ramilândia",
    "uf": "PR"
  },
  {
    "codigo": 4121307,
    "nome": "Rancho Alegre",
    "uf": "PR"
  },
  {
    "codigo": 4121356,
    "nome": "Rancho Alegre D'Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4121406,
    "nome": "Realeza",
    "uf": "PR"
  },
  {
    "codigo": 4121505,
    "nome": "Rebouças",
    "uf": "PR"
  },
  {
    "codigo": 4121604,
    "nome": "Renascença",
    "uf": "PR"
  },
  {
    "codigo": 4121703,
    "nome": "Reserva",
    "uf": "PR"
  },
  {
    "codigo": 4121752,
    "nome": "Reserva do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4121802,
    "nome": "Ribeirão Claro",
    "uf": "PR"
  },
  {
    "codigo": 4121901,
    "nome": "Ribeirão do Pinhal",
    "uf": "PR"
  },
  {
    "codigo": 4122008,
    "nome": "Rio Azul",
    "uf": "PR"
  },
  {
    "codigo": 4122107,
    "nome": "Rio Bom",
    "uf": "PR"
  },
  {
    "codigo": 4122156,
    "nome": "Rio Bonito do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4122172,
    "nome": "Rio Branco do Ivaí",
    "uf": "PR"
  },
  {
    "codigo": 4122206,
    "nome": "Rio Branco do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4122305,
    "nome": "Rio Negro",
    "uf": "PR"
  },
  {
    "codigo": 4122404,
    "nome": "Rolândia",
    "uf": "PR"
  },
  {
    "codigo": 4122503,
    "nome": "Roncador",
    "uf": "PR"
  },
  {
    "codigo": 4122602,
    "nome": "Rondon",
    "uf": "PR"
  },
  {
    "codigo": 4122651,
    "nome": "Rosário do Ivaí",
    "uf": "PR"
  },
  {
    "codigo": 4122701,
    "nome": "Sabáudia",
    "uf": "PR"
  },
  {
    "codigo": 4122800,
    "nome": "Salgado Filho",
    "uf": "PR"
  },
  {
    "codigo": 4122909,
    "nome": "Salto do Itararé",
    "uf": "PR"
  },
  {
    "codigo": 4123006,
    "nome": "Salto do Lontra",
    "uf": "PR"
  },
  {
    "codigo": 4123105,
    "nome": "Santa Amélia",
    "uf": "PR"
  },
  {
    "codigo": 4123204,
    "nome": "Santa Cecília do Pavão",
    "uf": "PR"
  },
  {
    "codigo": 4123303,
    "nome": "Santa Cruz de Monte Castelo",
    "uf": "PR"
  },
  {
    "codigo": 4123402,
    "nome": "Santa Fé",
    "uf": "PR"
  },
  {
    "codigo": 4123501,
    "nome": "Santa Helena",
    "uf": "PR"
  },
  {
    "codigo": 4123600,
    "nome": "Santa Inês",
    "uf": "PR"
  },
  {
    "codigo": 4123709,
    "nome": "Santa Isabel do Ivaí",
    "uf": "PR"
  },
  {
    "codigo": 4123808,
    "nome": "Santa Izabel do Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4123824,
    "nome": "Santa Lúcia",
    "uf": "PR"
  },
  {
    "codigo": 4123857,
    "nome": "Santa Maria do Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4123907,
    "nome": "Santa Mariana",
    "uf": "PR"
  },
  {
    "codigo": 4123956,
    "nome": "Santa Mônica",
    "uf": "PR"
  },
  {
    "codigo": 4124004,
    "nome": "Santana do Itararé",
    "uf": "PR"
  },
  {
    "codigo": 4124020,
    "nome": "Santa Tereza do Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4124053,
    "nome": "Santa Terezinha de Itaipu",
    "uf": "PR"
  },
  {
    "codigo": 4124103,
    "nome": "Santo Antônio da Platina",
    "uf": "PR"
  },
  {
    "codigo": 4124202,
    "nome": "Santo Antônio do Caiuá",
    "uf": "PR"
  },
  {
    "codigo": 4124301,
    "nome": "Santo Antônio do Paraíso",
    "uf": "PR"
  },
  {
    "codigo": 4124400,
    "nome": "Santo Antônio do Sudoeste",
    "uf": "PR"
  },
  {
    "codigo": 4124509,
    "nome": "Santo Inácio",
    "uf": "PR"
  },
  {
    "codigo": 4124608,
    "nome": "São Carlos do Ivaí",
    "uf": "PR"
  },
  {
    "codigo": 4124707,
    "nome": "São Jerônimo da Serra",
    "uf": "PR"
  },
  {
    "codigo": 4124806,
    "nome": "São João",
    "uf": "PR"
  },
  {
    "codigo": 4124905,
    "nome": "São João do Caiuá",
    "uf": "PR"
  },
  {
    "codigo": 4125001,
    "nome": "São João do Ivaí",
    "uf": "PR"
  },
  {
    "codigo": 4125100,
    "nome": "São João do Triunfo",
    "uf": "PR"
  },
  {
    "codigo": 4125209,
    "nome": "São Jorge d'Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4125308,
    "nome": "São Jorge do Ivaí",
    "uf": "PR"
  },
  {
    "codigo": 4125357,
    "nome": "São Jorge do Patrocínio",
    "uf": "PR"
  },
  {
    "codigo": 4125407,
    "nome": "São José da Boa Vista",
    "uf": "PR"
  },
  {
    "codigo": 4125456,
    "nome": "São José das Palmeiras",
    "uf": "PR"
  },
  {
    "codigo": 4125506,
    "nome": "São José dos Pinhais",
    "uf": "PR"
  },
  {
    "codigo": 4125555,
    "nome": "São Manoel do Paraná",
    "uf": "PR"
  },
  {
    "codigo": 4125605,
    "nome": "São Mateus do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4125704,
    "nome": "São Miguel do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4125753,
    "nome": "São Pedro do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4125803,
    "nome": "São Pedro do Ivaí",
    "uf": "PR"
  },
  {
    "codigo": 4125902,
    "nome": "São Pedro do Paraná",
    "uf": "PR"
  },
  {
    "codigo": 4126009,
    "nome": "São Sebastião da Amoreira",
    "uf": "PR"
  },
  {
    "codigo": 4126108,
    "nome": "São Tomé",
    "uf": "PR"
  },
  {
    "codigo": 4126207,
    "nome": "Sapopema",
    "uf": "PR"
  },
  {
    "codigo": 4126256,
    "nome": "Sarandi",
    "uf": "PR"
  },
  {
    "codigo": 4126272,
    "nome": "Saudade do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4126306,
    "nome": "Sengés",
    "uf": "PR"
  },
  {
    "codigo": 4126355,
    "nome": "Serranópolis do Iguaçu",
    "uf": "PR"
  },
  {
    "codigo": 4126405,
    "nome": "Sertaneja",
    "uf": "PR"
  },
  {
    "codigo": 4126504,
    "nome": "Sertanópolis",
    "uf": "PR"
  },
  {
    "codigo": 4126603,
    "nome": "Siqueira Campos",
    "uf": "PR"
  },
  {
    "codigo": 4126652,
    "nome": "Sulina",
    "uf": "PR"
  },
  {
    "codigo": 4126678,
    "nome": "Tamarana",
    "uf": "PR"
  },
  {
    "codigo": 4126702,
    "nome": "Tamboara",
    "uf": "PR"
  },
  {
    "codigo": 4126801,
    "nome": "Tapejara",
    "uf": "PR"
  },
  {
    "codigo": 4126900,
    "nome": "Tapira",
    "uf": "PR"
  },
  {
    "codigo": 4127007,
    "nome": "Teixeira Soares",
    "uf": "PR"
  },
  {
    "codigo": 4127106,
    "nome": "Telêmaco Borba",
    "uf": "PR"
  },
  {
    "codigo": 4127205,
    "nome": "Terra Boa",
    "uf": "PR"
  },
  {
    "codigo": 4127304,
    "nome": "Terra Rica",
    "uf": "PR"
  },
  {
    "codigo": 4127403,
    "nome": "Terra Roxa",
    "uf": "PR"
  },
  {
    "codigo": 4127502,
    "nome": "Tibagi",
    "uf": "PR"
  },
  {
    "codigo": 4127601,
    "nome": "Tijucas do Sul",
    "uf": "PR"
  },
  {
    "codigo": 4127700,
    "nome": "Toledo",
    "uf": "PR"
  },
  {
    "codigo": 4127809,
    "nome": "Tomazina",
    "uf": "PR"
  },
  {
    "codigo": 4127858,
    "nome": "Três Barras do Paraná",
    "uf": "PR"
  },
  {
    "codigo": 4127882,
    "nome": "Tunas do Paraná",
    "uf": "PR"
  },
  {
    "codigo": 4127908,
    "nome": "Tuneiras do Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4127957,
    "nome": "Tupãssi",
    "uf": "PR"
  },
  {
    "codigo": 4127965,
    "nome": "Turvo",
    "uf": "PR"
  },
  {
    "codigo": 4128005,
    "nome": "Ubiratã",
    "uf": "PR"
  },
  {
    "codigo": 4128104,
    "nome": "Umuarama",
    "uf": "PR"
  },
  {
    "codigo": 4128203,
    "nome": "União da Vitória",
    "uf": "PR"
  },
  {
    "codigo": 4128302,
    "nome": "Uniflor",
    "uf": "PR"
  },
  {
    "codigo": 4128401,
    "nome": "Uraí",
    "uf": "PR"
  },
  {
    "codigo": 4128500,
    "nome": "Wenceslau Braz",
    "uf": "PR"
  },
  {
    "codigo": 4128534,
    "nome": "Ventania",
    "uf": "PR"
  },
  {
    "codigo": 4128559,
    "nome": "Vera Cruz do Oeste",
    "uf": "PR"
  },
  {
    "codigo": 4128609,
    "nome": "Verê",
    "uf": "PR"
  },
  {
    "codigo": 4128625,
    "nome": "Alto Paraíso",
    "uf": "PR"
  },
  {
    "codigo": 4128633,
    "nome": "Doutor Ulysses",
    "uf": "PR"
  },
  {
    "codigo": 4128658,
    "nome": "Virmond",
    "uf": "PR"
  },
  {
    "codigo": 4128708,
    "nome": "Vitorino",
    "uf": "PR"
  },
  {
    "codigo": 4128807,
    "nome": "Xambrê",
    "uf": "PR"
  },
  {
    "codigo": 4200051,
    "nome": "Abdon Batista",
    "uf": "SC"
  },
  {
    "codigo": 4200101,
    "nome": "Abelardo Luz",
    "uf": "SC"
  },
  {
    "codigo": 4200200,
    "nome": "Agrolândia",
    "uf": "SC"
  },
  {
    "codigo": 4200309,
    "nome": "Agronômica",
    "uf": "SC"
  },
  {
    "codigo": 4200408,
    "nome": "Água Doce",
    "uf": "SC"
  },
  {
    "codigo": 4200507,
    "nome": "Águas de Chapecó",
    "uf": "SC"
  },
  {
    "codigo": 4200556,
    "nome": "Águas Frias",
    "uf": "SC"
  },
  {
    "codigo": 4200606,
    "nome": "Águas Mornas",
    "uf": "SC"
  },
  {
    "codigo": 4200705,
    "nome": "Alfredo Wagner",
    "uf": "SC"
  },
  {
    "codigo": 4200754,
    "nome": "Alto Bela Vista",
    "uf": "SC"
  },
  {
    "codigo": 4200804,
    "nome": "Anchieta",
    "uf": "SC"
  },
  {
    "codigo": 4200903,
    "nome": "Angelina",
    "uf": "SC"
  },
  {
    "codigo": 4201000,
    "nome": "Anita Garibaldi",
    "uf": "SC"
  },
  {
    "codigo": 4201109,
    "nome": "Anitápolis",
    "uf": "SC"
  },
  {
    "codigo": 4201208,
    "nome": "Antônio Carlos",
    "uf": "SC"
  },
  {
    "codigo": 4201257,
    "nome": "Apiúna",
    "uf": "SC"
  },
  {
    "codigo": 4201273,
    "nome": "Arabutã",
    "uf": "SC"
  },
  {
    "codigo": 4201307,
    "nome": "Araquari",
    "uf": "SC"
  },
  {
    "codigo": 4201406,
    "nome": "Araranguá",
    "uf": "SC"
  },
  {
    "codigo": 4201505,
    "nome": "Armazém",
    "uf": "SC"
  },
  {
    "codigo": 4201604,
    "nome": "Arroio Trinta",
    "uf": "SC"
  },
  {
    "codigo": 4201653,
    "nome": "Arvoredo",
    "uf": "SC"
  },
  {
    "codigo": 4201703,
    "nome": "Ascurra",
    "uf": "SC"
  },
  {
    "codigo": 4201802,
    "nome": "Atalanta",
    "uf": "SC"
  },
  {
    "codigo": 4201901,
    "nome": "Aurora",
    "uf": "SC"
  },
  {
    "codigo": 4201950,
    "nome": "Balneário Arroio do Silva",
    "uf": "SC"
  },
  {
    "codigo": 4202008,
    "nome": "Balneário Camboriú",
    "uf": "SC"
  },
  {
    "codigo": 4202057,
    "nome": "Balneário Barra do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4202073,
    "nome": "Balneário Gaivota",
    "uf": "SC"
  },
  {
    "codigo": 4202081,
    "nome": "Bandeirante",
    "uf": "SC"
  },
  {
    "codigo": 4202099,
    "nome": "Barra Bonita",
    "uf": "SC"
  },
  {
    "codigo": 4202107,
    "nome": "Barra Velha",
    "uf": "SC"
  },
  {
    "codigo": 4202131,
    "nome": "Bela Vista do Toldo",
    "uf": "SC"
  },
  {
    "codigo": 4202156,
    "nome": "Belmonte",
    "uf": "SC"
  },
  {
    "codigo": 4202206,
    "nome": "Benedito Novo",
    "uf": "SC"
  },
  {
    "codigo": 4202305,
    "nome": "Biguaçu",
    "uf": "SC"
  },
  {
    "codigo": 4202404,
    "nome": "Blumenau",
    "uf": "SC"
  },
  {
    "codigo": 4202438,
    "nome": "Bocaina do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4202453,
    "nome": "Bombinhas",
    "uf": "SC"
  },
  {
    "codigo": 4202503,
    "nome": "Bom Jardim da Serra",
    "uf": "SC"
  },
  {
    "codigo": 4202537,
    "nome": "Bom Jesus",
    "uf": "SC"
  },
  {
    "codigo": 4202578,
    "nome": "Bom Jesus do Oeste",
    "uf": "SC"
  },
  {
    "codigo": 4202602,
    "nome": "Bom Retiro",
    "uf": "SC"
  },
  {
    "codigo": 4202701,
    "nome": "Botuverá",
    "uf": "SC"
  },
  {
    "codigo": 4202800,
    "nome": "Braço do Norte",
    "uf": "SC"
  },
  {
    "codigo": 4202859,
    "nome": "Braço do Trombudo",
    "uf": "SC"
  },
  {
    "codigo": 4202875,
    "nome": "Brunópolis",
    "uf": "SC"
  },
  {
    "codigo": 4202909,
    "nome": "Brusque",
    "uf": "SC"
  },
  {
    "codigo": 4203006,
    "nome": "Caçador",
    "uf": "SC"
  },
  {
    "codigo": 4203105,
    "nome": "Caibi",
    "uf": "SC"
  },
  {
    "codigo": 4203154,
    "nome": "Calmon",
    "uf": "SC"
  },
  {
    "codigo": 4203204,
    "nome": "Camboriú",
    "uf": "SC"
  },
  {
    "codigo": 4203253,
    "nome": "Capão Alto",
    "uf": "SC"
  },
  {
    "codigo": 4203303,
    "nome": "Campo Alegre",
    "uf": "SC"
  },
  {
    "codigo": 4203402,
    "nome": "Campo Belo do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4203501,
    "nome": "Campo Erê",
    "uf": "SC"
  },
  {
    "codigo": 4203600,
    "nome": "Campos Novos",
    "uf": "SC"
  },
  {
    "codigo": 4203709,
    "nome": "Canelinha",
    "uf": "SC"
  },
  {
    "codigo": 4203808,
    "nome": "Canoinhas",
    "uf": "SC"
  },
  {
    "codigo": 4203907,
    "nome": "Capinzal",
    "uf": "SC"
  },
  {
    "codigo": 4203956,
    "nome": "Capivari de Baixo",
    "uf": "SC"
  },
  {
    "codigo": 4204004,
    "nome": "Catanduvas",
    "uf": "SC"
  },
  {
    "codigo": 4204103,
    "nome": "Caxambu do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4204152,
    "nome": "Celso Ramos",
    "uf": "SC"
  },
  {
    "codigo": 4204178,
    "nome": "Cerro Negro",
    "uf": "SC"
  },
  {
    "codigo": 4204194,
    "nome": "Chapadão do Lageado",
    "uf": "SC"
  },
  {
    "codigo": 4204202,
    "nome": "Chapecó",
    "uf": "SC"
  },
  {
    "codigo": 4204251,
    "nome": "Cocal do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4204301,
    "nome": "Concórdia",
    "uf": "SC"
  },
  {
    "codigo": 4204350,
    "nome": "Cordilheira Alta",
    "uf": "SC"
  },
  {
    "codigo": 4204400,
    "nome": "Coronel Freitas",
    "uf": "SC"
  },
  {
    "codigo": 4204459,
    "nome": "Coronel Martins",
    "uf": "SC"
  },
  {
    "codigo": 4204509,
    "nome": "Corupá",
    "uf": "SC"
  },
  {
    "codigo": 4204558,
    "nome": "Correia Pinto",
    "uf": "SC"
  },
  {
    "codigo": 4204608,
    "nome": "Criciúma",
    "uf": "SC"
  },
  {
    "codigo": 4204707,
    "nome": "Cunha Porã",
    "uf": "SC"
  },
  {
    "codigo": 4204756,
    "nome": "Cunhataí",
    "uf": "SC"
  },
  {
    "codigo": 4204806,
    "nome": "Curitibanos",
    "uf": "SC"
  },
  {
    "codigo": 4204905,
    "nome": "Descanso",
    "uf": "SC"
  },
  {
    "codigo": 4205001,
    "nome": "Dionísio Cerqueira",
    "uf": "SC"
  },
  {
    "codigo": 4205100,
    "nome": "Dona Emma",
    "uf": "SC"
  },
  {
    "codigo": 4205159,
    "nome": "Doutor Pedrinho",
    "uf": "SC"
  },
  {
    "codigo": 4205175,
    "nome": "Entre Rios",
    "uf": "SC"
  },
  {
    "codigo": 4205191,
    "nome": "Ermo",
    "uf": "SC"
  },
  {
    "codigo": 4205209,
    "nome": "Erval Velho",
    "uf": "SC"
  },
  {
    "codigo": 4205308,
    "nome": "Faxinal dos Guedes",
    "uf": "SC"
  },
  {
    "codigo": 4205357,
    "nome": "Flor do Sertão",
    "uf": "SC"
  },
  {
    "codigo": 4205407,
    "nome": "Florianópolis",
    "uf": "SC"
  },
  {
    "codigo": 4205431,
    "nome": "Formosa do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4205456,
    "nome": "Forquilhinha",
    "uf": "SC"
  },
  {
    "codigo": 4205506,
    "nome": "Fraiburgo",
    "uf": "SC"
  },
  {
    "codigo": 4205555,
    "nome": "Frei Rogério",
    "uf": "SC"
  },
  {
    "codigo": 4205605,
    "nome": "Galvão",
    "uf": "SC"
  },
  {
    "codigo": 4205704,
    "nome": "Garopaba",
    "uf": "SC"
  },
  {
    "codigo": 4205803,
    "nome": "Garuva",
    "uf": "SC"
  },
  {
    "codigo": 4205902,
    "nome": "Gaspar",
    "uf": "SC"
  },
  {
    "codigo": 4206009,
    "nome": "Governador Celso Ramos",
    "uf": "SC"
  },
  {
    "codigo": 4206108,
    "nome": "Grão-Pará",
    "uf": "SC"
  },
  {
    "codigo": 4206207,
    "nome": "Gravatal",
    "uf": "SC"
  },
  {
    "codigo": 4206306,
    "nome": "Guabiruba",
    "uf": "SC"
  },
  {
    "codigo": 4206405,
    "nome": "Guaraciaba",
    "uf": "SC"
  },
  {
    "codigo": 4206504,
    "nome": "Guaramirim",
    "uf": "SC"
  },
  {
    "codigo": 4206603,
    "nome": "Guarujá do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4206652,
    "nome": "Guatambú",
    "uf": "SC"
  },
  {
    "codigo": 4206702,
    "nome": "Herval d'Oeste",
    "uf": "SC"
  },
  {
    "codigo": 4206751,
    "nome": "Ibiam",
    "uf": "SC"
  },
  {
    "codigo": 4206801,
    "nome": "Ibicaré",
    "uf": "SC"
  },
  {
    "codigo": 4206900,
    "nome": "Ibirama",
    "uf": "SC"
  },
  {
    "codigo": 4207007,
    "nome": "Içara",
    "uf": "SC"
  },
  {
    "codigo": 4207106,
    "nome": "Ilhota",
    "uf": "SC"
  },
  {
    "codigo": 4207205,
    "nome": "Imaruí",
    "uf": "SC"
  },
  {
    "codigo": 4207304,
    "nome": "Imbituba",
    "uf": "SC"
  },
  {
    "codigo": 4207403,
    "nome": "Imbuia",
    "uf": "SC"
  },
  {
    "codigo": 4207502,
    "nome": "Indaial",
    "uf": "SC"
  },
  {
    "codigo": 4207577,
    "nome": "Iomerê",
    "uf": "SC"
  },
  {
    "codigo": 4207601,
    "nome": "Ipira",
    "uf": "SC"
  },
  {
    "codigo": 4207650,
    "nome": "Iporã do Oeste",
    "uf": "SC"
  },
  {
    "codigo": 4207684,
    "nome": "Ipuaçu",
    "uf": "SC"
  },
  {
    "codigo": 4207700,
    "nome": "Ipumirim",
    "uf": "SC"
  },
  {
    "codigo": 4207759,
    "nome": "Iraceminha",
    "uf": "SC"
  },
  {
    "codigo": 4207809,
    "nome": "Irani",
    "uf": "SC"
  },
  {
    "codigo": 4207858,
    "nome": "Irati",
    "uf": "SC"
  },
  {
    "codigo": 4207908,
    "nome": "Irineópolis",
    "uf": "SC"
  },
  {
    "codigo": 4208005,
    "nome": "Itá",
    "uf": "SC"
  },
  {
    "codigo": 4208104,
    "nome": "Itaiópolis",
    "uf": "SC"
  },
  {
    "codigo": 4208203,
    "nome": "Itajaí",
    "uf": "SC"
  },
  {
    "codigo": 4208302,
    "nome": "Itapema",
    "uf": "SC"
  },
  {
    "codigo": 4208401,
    "nome": "Itapiranga",
    "uf": "SC"
  },
  {
    "codigo": 4208450,
    "nome": "Itapoá",
    "uf": "SC"
  },
  {
    "codigo": 4208500,
    "nome": "Ituporanga",
    "uf": "SC"
  },
  {
    "codigo": 4208609,
    "nome": "Jaborá",
    "uf": "SC"
  },
  {
    "codigo": 4208708,
    "nome": "Jacinto Machado",
    "uf": "SC"
  },
  {
    "codigo": 4208807,
    "nome": "Jaguaruna",
    "uf": "SC"
  },
  {
    "codigo": 4208906,
    "nome": "Jaraguá do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4208955,
    "nome": "Jardinópolis",
    "uf": "SC"
  },
  {
    "codigo": 4209003,
    "nome": "Joaçaba",
    "uf": "SC"
  },
  {
    "codigo": 4209102,
    "nome": "Joinville",
    "uf": "SC"
  },
  {
    "codigo": 4209151,
    "nome": "José Boiteux",
    "uf": "SC"
  },
  {
    "codigo": 4209177,
    "nome": "Jupiá",
    "uf": "SC"
  },
  {
    "codigo": 4209201,
    "nome": "Lacerdópolis",
    "uf": "SC"
  },
  {
    "codigo": 4209300,
    "nome": "Lages",
    "uf": "SC"
  },
  {
    "codigo": 4209409,
    "nome": "Laguna",
    "uf": "SC"
  },
  {
    "codigo": 4209458,
    "nome": "Lajeado Grande",
    "uf": "SC"
  },
  {
    "codigo": 4209508,
    "nome": "Laurentino",
    "uf": "SC"
  },
  {
    "codigo": 4209607,
    "nome": "Lauro Müller",
    "uf": "SC"
  },
  {
    "codigo": 4209706,
    "nome": "Lebon Régis",
    "uf": "SC"
  },
  {
    "codigo": 4209805,
    "nome": "Leoberto Leal",
    "uf": "SC"
  },
  {
    "codigo": 4209854,
    "nome": "Lindóia do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4209904,
    "nome": "Lontras",
    "uf": "SC"
  },
  {
    "codigo": 4210001,
    "nome": "Luiz Alves",
    "uf": "SC"
  },
  {
    "codigo": 4210035,
    "nome": "Luzerna",
    "uf": "SC"
  },
  {
    "codigo": 4210050,
    "nome": "Macieira",
    "uf": "SC"
  },
  {
    "codigo": 4210100,
    "nome": "Mafra",
    "uf": "SC"
  },
  {
    "codigo": 4210209,
    "nome": "Major Gercino",
    "uf": "SC"
  },
  {
    "codigo": 4210308,
    "nome": "Major Vieira",
    "uf": "SC"
  },
  {
    "codigo": 4210407,
    "nome": "Maracajá",
    "uf": "SC"
  },
  {
    "codigo": 4210506,
    "nome": "Maravilha",
    "uf": "SC"
  },
  {
    "codigo": 4210555,
    "nome": "Marema",
    "uf": "SC"
  },
  {
    "codigo": 4210605,
    "nome": "Massaranduba",
    "uf": "SC"
  },
  {
    "codigo": 4210704,
    "nome": "Matos Costa",
    "uf": "SC"
  },
  {
    "codigo": 4210803,
    "nome": "Meleiro",
    "uf": "SC"
  },
  {
    "codigo": 4210852,
    "nome": "Mirim Doce",
    "uf": "SC"
  },
  {
    "codigo": 4210902,
    "nome": "Modelo",
    "uf": "SC"
  },
  {
    "codigo": 4211009,
    "nome": "Mondaí",
    "uf": "SC"
  },
  {
    "codigo": 4211058,
    "nome": "Monte Carlo",
    "uf": "SC"
  },
  {
    "codigo": 4211108,
    "nome": "Monte Castelo",
    "uf": "SC"
  },
  {
    "codigo": 4211207,
    "nome": "Morro da Fumaça",
    "uf": "SC"
  },
  {
    "codigo": 4211256,
    "nome": "Morro Grande",
    "uf": "SC"
  },
  {
    "codigo": 4211306,
    "nome": "Navegantes",
    "uf": "SC"
  },
  {
    "codigo": 4211405,
    "nome": "Nova Erechim",
    "uf": "SC"
  },
  {
    "codigo": 4211454,
    "nome": "Nova Itaberaba",
    "uf": "SC"
  },
  {
    "codigo": 4211504,
    "nome": "Nova Trento",
    "uf": "SC"
  },
  {
    "codigo": 4211603,
    "nome": "Nova Veneza",
    "uf": "SC"
  },
  {
    "codigo": 4211652,
    "nome": "Novo Horizonte",
    "uf": "SC"
  },
  {
    "codigo": 4211702,
    "nome": "Orleans",
    "uf": "SC"
  },
  {
    "codigo": 4211751,
    "nome": "Otacílio Costa",
    "uf": "SC"
  },
  {
    "codigo": 4211801,
    "nome": "Ouro",
    "uf": "SC"
  },
  {
    "codigo": 4211850,
    "nome": "Ouro Verde",
    "uf": "SC"
  },
  {
    "codigo": 4211876,
    "nome": "Paial",
    "uf": "SC"
  },
  {
    "codigo": 4211892,
    "nome": "Painel",
    "uf": "SC"
  },
  {
    "codigo": 4211900,
    "nome": "Palhoça",
    "uf": "SC"
  },
  {
    "codigo": 4212007,
    "nome": "Palma Sola",
    "uf": "SC"
  },
  {
    "codigo": 4212056,
    "nome": "Palmeira",
    "uf": "SC"
  },
  {
    "codigo": 4212106,
    "nome": "Palmitos",
    "uf": "SC"
  },
  {
    "codigo": 4212205,
    "nome": "Papanduva",
    "uf": "SC"
  },
  {
    "codigo": 4212239,
    "nome": "Paraíso",
    "uf": "SC"
  },
  {
    "codigo": 4212254,
    "nome": "Passo de Torres",
    "uf": "SC"
  },
  {
    "codigo": 4212270,
    "nome": "Passos Maia",
    "uf": "SC"
  },
  {
    "codigo": 4212304,
    "nome": "Paulo Lopes",
    "uf": "SC"
  },
  {
    "codigo": 4212403,
    "nome": "Pedras Grandes",
    "uf": "SC"
  },
  {
    "codigo": 4212502,
    "nome": "Penha",
    "uf": "SC"
  },
  {
    "codigo": 4212601,
    "nome": "Peritiba",
    "uf": "SC"
  },
  {
    "codigo": 4212650,
    "nome": "Pescaria Brava",
    "uf": "SC"
  },
  {
    "codigo": 4212700,
    "nome": "Petrolândia",
    "uf": "SC"
  },
  {
    "codigo": 4212809,
    "nome": "Balneário Piçarras",
    "uf": "SC"
  },
  {
    "codigo": 4212908,
    "nome": "Pinhalzinho",
    "uf": "SC"
  },
  {
    "codigo": 4213005,
    "nome": "Pinheiro Preto",
    "uf": "SC"
  },
  {
    "codigo": 4213104,
    "nome": "Piratuba",
    "uf": "SC"
  },
  {
    "codigo": 4213153,
    "nome": "Planalto Alegre",
    "uf": "SC"
  },
  {
    "codigo": 4213203,
    "nome": "Pomerode",
    "uf": "SC"
  },
  {
    "codigo": 4213302,
    "nome": "Ponte Alta",
    "uf": "SC"
  },
  {
    "codigo": 4213351,
    "nome": "Ponte Alta do Norte",
    "uf": "SC"
  },
  {
    "codigo": 4213401,
    "nome": "Ponte Serrada",
    "uf": "SC"
  },
  {
    "codigo": 4213500,
    "nome": "Porto Belo",
    "uf": "SC"
  },
  {
    "codigo": 4213609,
    "nome": "Porto União",
    "uf": "SC"
  },
  {
    "codigo": 4213708,
    "nome": "Pouso Redondo",
    "uf": "SC"
  },
  {
    "codigo": 4213807,
    "nome": "Praia Grande",
    "uf": "SC"
  },
  {
    "codigo": 4213906,
    "nome": "Presidente Castello Branco",
    "uf": "SC"
  },
  {
    "codigo": 4214003,
    "nome": "Presidente Getúlio",
    "uf": "SC"
  },
  {
    "codigo": 4214102,
    "nome": "Presidente Nereu",
    "uf": "SC"
  },
  {
    "codigo": 4214151,
    "nome": "Princesa",
    "uf": "SC"
  },
  {
    "codigo": 4214201,
    "nome": "Quilombo",
    "uf": "SC"
  },
  {
    "codigo": 4214300,
    "nome": "Rancho Queimado",
    "uf": "SC"
  },
  {
    "codigo": 4214409,
    "nome": "Rio das Antas",
    "uf": "SC"
  },
  {
    "codigo": 4214508,
    "nome": "Rio do Campo",
    "uf": "SC"
  },
  {
    "codigo": 4214607,
    "nome": "Rio do Oeste",
    "uf": "SC"
  },
  {
    "codigo": 4214706,
    "nome": "Rio dos Cedros",
    "uf": "SC"
  },
  {
    "codigo": 4214805,
    "nome": "Rio do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4214904,
    "nome": "Rio Fortuna",
    "uf": "SC"
  },
  {
    "codigo": 4215000,
    "nome": "Rio Negrinho",
    "uf": "SC"
  },
  {
    "codigo": 4215059,
    "nome": "Rio Rufino",
    "uf": "SC"
  },
  {
    "codigo": 4215075,
    "nome": "Riqueza",
    "uf": "SC"
  },
  {
    "codigo": 4215109,
    "nome": "Rodeio",
    "uf": "SC"
  },
  {
    "codigo": 4215208,
    "nome": "Romelândia",
    "uf": "SC"
  },
  {
    "codigo": 4215307,
    "nome": "Salete",
    "uf": "SC"
  },
  {
    "codigo": 4215356,
    "nome": "Saltinho",
    "uf": "SC"
  },
  {
    "codigo": 4215406,
    "nome": "Salto Veloso",
    "uf": "SC"
  },
  {
    "codigo": 4215455,
    "nome": "Sangão",
    "uf": "SC"
  },
  {
    "codigo": 4215505,
    "nome": "Santa Cecília",
    "uf": "SC"
  },
  {
    "codigo": 4215554,
    "nome": "Santa Helena",
    "uf": "SC"
  },
  {
    "codigo": 4215604,
    "nome": "Santa Rosa de Lima",
    "uf": "SC"
  },
  {
    "codigo": 4215653,
    "nome": "Santa Rosa do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4215679,
    "nome": "Santa Terezinha",
    "uf": "SC"
  },
  {
    "codigo": 4215687,
    "nome": "Santa Terezinha do Progresso",
    "uf": "SC"
  },
  {
    "codigo": 4215695,
    "nome": "Santiago do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4215703,
    "nome": "Santo Amaro da Imperatriz",
    "uf": "SC"
  },
  {
    "codigo": 4215752,
    "nome": "São Bernardino",
    "uf": "SC"
  },
  {
    "codigo": 4215802,
    "nome": "São Bento do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4215901,
    "nome": "São Bonifácio",
    "uf": "SC"
  },
  {
    "codigo": 4216008,
    "nome": "São Carlos",
    "uf": "SC"
  },
  {
    "codigo": 4216057,
    "nome": "São Cristóvão do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4216107,
    "nome": "São Domingos",
    "uf": "SC"
  },
  {
    "codigo": 4216206,
    "nome": "São Francisco do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4216255,
    "nome": "São João do Oeste",
    "uf": "SC"
  },
  {
    "codigo": 4216305,
    "nome": "São João Batista",
    "uf": "SC"
  },
  {
    "codigo": 4216354,
    "nome": "São João do Itaperiú",
    "uf": "SC"
  },
  {
    "codigo": 4216404,
    "nome": "São João do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4216503,
    "nome": "São Joaquim",
    "uf": "SC"
  },
  {
    "codigo": 4216602,
    "nome": "São José",
    "uf": "SC"
  },
  {
    "codigo": 4216701,
    "nome": "São José do Cedro",
    "uf": "SC"
  },
  {
    "codigo": 4216800,
    "nome": "São José do Cerrito",
    "uf": "SC"
  },
  {
    "codigo": 4216909,
    "nome": "São Lourenço do Oeste",
    "uf": "SC"
  },
  {
    "codigo": 4217006,
    "nome": "São Ludgero",
    "uf": "SC"
  },
  {
    "codigo": 4217105,
    "nome": "São Martinho",
    "uf": "SC"
  },
  {
    "codigo": 4217154,
    "nome": "São Miguel da Boa Vista",
    "uf": "SC"
  },
  {
    "codigo": 4217204,
    "nome": "São Miguel do Oeste",
    "uf": "SC"
  },
  {
    "codigo": 4217253,
    "nome": "São Pedro de Alcântara",
    "uf": "SC"
  },
  {
    "codigo": 4217303,
    "nome": "Saudades",
    "uf": "SC"
  },
  {
    "codigo": 4217402,
    "nome": "Schroeder",
    "uf": "SC"
  },
  {
    "codigo": 4217501,
    "nome": "Seara",
    "uf": "SC"
  },
  {
    "codigo": 4217550,
    "nome": "Serra Alta",
    "uf": "SC"
  },
  {
    "codigo": 4217600,
    "nome": "Siderópolis",
    "uf": "SC"
  },
  {
    "codigo": 4217709,
    "nome": "Sombrio",
    "uf": "SC"
  },
  {
    "codigo": 4217758,
    "nome": "Sul Brasil",
    "uf": "SC"
  },
  {
    "codigo": 4217808,
    "nome": "Taió",
    "uf": "SC"
  },
  {
    "codigo": 4217907,
    "nome": "Tangará",
    "uf": "SC"
  },
  {
    "codigo": 4217956,
    "nome": "Tigrinhos",
    "uf": "SC"
  },
  {
    "codigo": 4218004,
    "nome": "Tijucas",
    "uf": "SC"
  },
  {
    "codigo": 4218103,
    "nome": "Timbé do Sul",
    "uf": "SC"
  },
  {
    "codigo": 4218202,
    "nome": "Timbó",
    "uf": "SC"
  },
  {
    "codigo": 4218251,
    "nome": "Timbó Grande",
    "uf": "SC"
  },
  {
    "codigo": 4218301,
    "nome": "Três Barras",
    "uf": "SC"
  },
  {
    "codigo": 4218350,
    "nome": "Treviso",
    "uf": "SC"
  },
  {
    "codigo": 4218400,
    "nome": "Treze de Maio",
    "uf": "SC"
  },
  {
    "codigo": 4218509,
    "nome": "Treze Tílias",
    "uf": "SC"
  },
  {
    "codigo": 4218608,
    "nome": "Trombudo Central",
    "uf": "SC"
  },
  {
    "codigo": 4218707,
    "nome": "Tubarão",
    "uf": "SC"
  },
  {
    "codigo": 4218756,
    "nome": "Tunápolis",
    "uf": "SC"
  },
  {
    "codigo": 4218806,
    "nome": "Turvo",
    "uf": "SC"
  },
  {
    "codigo": 4218855,
    "nome": "União do Oeste",
    "uf": "SC"
  },
  {
    "codigo": 4218905,
    "nome": "Urubici",
    "uf": "SC"
  },
  {
    "codigo": 4218954,
    "nome": "Urupema",
    "uf": "SC"
  },
  {
    "codigo": 4219002,
    "nome": "Urussanga",
    "uf": "SC"
  },
  {
    "codigo": 4219101,
    "nome": "Vargeão",
    "uf": "SC"
  },
  {
    "codigo": 4219150,
    "nome": "Vargem",
    "uf": "SC"
  },
  {
    "codigo": 4219176,
    "nome": "Vargem Bonita",
    "uf": "SC"
  },
  {
    "codigo": 4219200,
    "nome": "Vidal Ramos",
    "uf": "SC"
  },
  {
    "codigo": 4219309,
    "nome": "Videira",
    "uf": "SC"
  },
  {
    "codigo": 4219358,
    "nome": "Vitor Meireles",
    "uf": "SC"
  },
  {
    "codigo": 4219408,
    "nome": "Witmarsum",
    "uf": "SC"
  },
  {
    "codigo": 4219507,
    "nome": "Xanxerê",
    "uf": "SC"
  },
  {
    "codigo": 4219606,
    "nome": "Xavantina",
    "uf": "SC"
  },
  {
    "codigo": 4219705,
    "nome": "Xaxim",
    "uf": "SC"
  },
  {
    "codigo": 4219853,
    "nome": "Zortéa",
    "uf": "SC"
  },
  {
    "codigo": 4220000,
    "nome": "Balneário Rincão",
    "uf": "SC"
  },
  {
    "codigo": 4300034,
    "nome": "Aceguá",
    "uf": "RS"
  },
  {
    "codigo": 4300059,
    "nome": "Água Santa",
    "uf": "RS"
  },
  {
    "codigo": 4300109,
    "nome": "Agudo",
    "uf": "RS"
  },
  {
    "codigo": 4300208,
    "nome": "Ajuricaba",
    "uf": "RS"
  },
  {
    "codigo": 4300307,
    "nome": "Alecrim",
    "uf": "RS"
  },
  {
    "codigo": 4300406,
    "nome": "Alegrete",
    "uf": "RS"
  },
  {
    "codigo": 4300455,
    "nome": "Alegria",
    "uf": "RS"
  },
  {
    "codigo": 4300471,
    "nome": "Almirante Tamandaré do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4300505,
    "nome": "Alpestre",
    "uf": "RS"
  },
  {
    "codigo": 4300554,
    "nome": "Alto Alegre",
    "uf": "RS"
  },
  {
    "codigo": 4300570,
    "nome": "Alto Feliz",
    "uf": "RS"
  },
  {
    "codigo": 4300604,
    "nome": "Alvorada",
    "uf": "RS"
  },
  {
    "codigo": 4300638,
    "nome": "Amaral Ferrador",
    "uf": "RS"
  },
  {
    "codigo": 4300646,
    "nome": "Ametista do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4300661,
    "nome": "André da Rocha",
    "uf": "RS"
  },
  {
    "codigo": 4300703,
    "nome": "Anta Gorda",
    "uf": "RS"
  },
  {
    "codigo": 4300802,
    "nome": "Antônio Prado",
    "uf": "RS"
  },
  {
    "codigo": 4300851,
    "nome": "Arambaré",
    "uf": "RS"
  },
  {
    "codigo": 4300877,
    "nome": "Araricá",
    "uf": "RS"
  },
  {
    "codigo": 4300901,
    "nome": "Aratiba",
    "uf": "RS"
  },
  {
    "codigo": 4301008,
    "nome": "Arroio do Meio",
    "uf": "RS"
  },
  {
    "codigo": 4301057,
    "nome": "Arroio do Sal",
    "uf": "RS"
  },
  {
    "codigo": 4301073,
    "nome": "Arroio do Padre",
    "uf": "RS"
  },
  {
    "codigo": 4301107,
    "nome": "Arroio dos Ratos",
    "uf": "RS"
  },
  {
    "codigo": 4301206,
    "nome": "Arroio do Tigre",
    "uf": "RS"
  },
  {
    "codigo": 4301305,
    "nome": "Arroio Grande",
    "uf": "RS"
  },
  {
    "codigo": 4301404,
    "nome": "Arvorezinha",
    "uf": "RS"
  },
  {
    "codigo": 4301503,
    "nome": "Augusto Pestana",
    "uf": "RS"
  },
  {
    "codigo": 4301552,
    "nome": "Áurea",
    "uf": "RS"
  },
  {
    "codigo": 4301602,
    "nome": "Bagé",
    "uf": "RS"
  },
  {
    "codigo": 4301636,
    "nome": "Balneário Pinhal",
    "uf": "RS"
  },
  {
    "codigo": 4301651,
    "nome": "Barão",
    "uf": "RS"
  },
  {
    "codigo": 4301701,
    "nome": "Barão de Cotegipe",
    "uf": "RS"
  },
  {
    "codigo": 4301750,
    "nome": "Barão do Triunfo",
    "uf": "RS"
  },
  {
    "codigo": 4301800,
    "nome": "Barracão",
    "uf": "RS"
  },
  {
    "codigo": 4301859,
    "nome": "Barra do Guarita",
    "uf": "RS"
  },
  {
    "codigo": 4301875,
    "nome": "Barra do Quaraí",
    "uf": "RS"
  },
  {
    "codigo": 4301909,
    "nome": "Barra do Ribeiro",
    "uf": "RS"
  },
  {
    "codigo": 4301925,
    "nome": "Barra do Rio Azul",
    "uf": "RS"
  },
  {
    "codigo": 4301958,
    "nome": "Barra Funda",
    "uf": "RS"
  },
  {
    "codigo": 4302006,
    "nome": "Barros Cassal",
    "uf": "RS"
  },
  {
    "codigo": 4302055,
    "nome": "Benjamin Constant do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4302105,
    "nome": "Bento Gonçalves",
    "uf": "RS"
  },
  {
    "codigo": 4302154,
    "nome": "Boa Vista das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4302204,
    "nome": "Boa Vista do Buricá",
    "uf": "RS"
  },
  {
    "codigo": 4302220,
    "nome": "Boa Vista do Cadeado",
    "uf": "RS"
  },
  {
    "codigo": 4302238,
    "nome": "Boa Vista do Incra",
    "uf": "RS"
  },
  {
    "codigo": 4302253,
    "nome": "Boa Vista do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4302303,
    "nome": "Bom Jesus",
    "uf": "RS"
  },
  {
    "codigo": 4302352,
    "nome": "Bom Princípio",
    "uf": "RS"
  },
  {
    "codigo": 4302378,
    "nome": "Bom Progresso",
    "uf": "RS"
  },
  {
    "codigo": 4302402,
    "nome": "Bom Retiro do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4302451,
    "nome": "Boqueirão do Leão",
    "uf": "RS"
  },
  {
    "codigo": 4302501,
    "nome": "Bossoroca",
    "uf": "RS"
  },
  {
    "codigo": 4302584,
    "nome": "Bozano",
    "uf": "RS"
  },
  {
    "codigo": 4302600,
    "nome": "Braga",
    "uf": "RS"
  },
  {
    "codigo": 4302659,
    "nome": "Brochier",
    "uf": "RS"
  },
  {
    "codigo": 4302709,
    "nome": "Butiá",
    "uf": "RS"
  },
  {
    "codigo": 4302808,
    "nome": "Caçapava do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4302907,
    "nome": "Cacequi",
    "uf": "RS"
  },
  {
    "codigo": 4303004,
    "nome": "Cachoeira do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4303103,
    "nome": "Cachoeirinha",
    "uf": "RS"
  },
  {
    "codigo": 4303202,
    "nome": "Cacique Doble",
    "uf": "RS"
  },
  {
    "codigo": 4303301,
    "nome": "Caibaté",
    "uf": "RS"
  },
  {
    "codigo": 4303400,
    "nome": "Caiçara",
    "uf": "RS"
  },
  {
    "codigo": 4303509,
    "nome": "Camaquã",
    "uf": "RS"
  },
  {
    "codigo": 4303558,
    "nome": "Camargo",
    "uf": "RS"
  },
  {
    "codigo": 4303608,
    "nome": "Cambará do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4303673,
    "nome": "Campestre da Serra",
    "uf": "RS"
  },
  {
    "codigo": 4303707,
    "nome": "Campina das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4303806,
    "nome": "Campinas do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4303905,
    "nome": "Campo Bom",
    "uf": "RS"
  },
  {
    "codigo": 4304002,
    "nome": "Campo Novo",
    "uf": "RS"
  },
  {
    "codigo": 4304101,
    "nome": "Campos Borges",
    "uf": "RS"
  },
  {
    "codigo": 4304200,
    "nome": "Candelária",
    "uf": "RS"
  },
  {
    "codigo": 4304309,
    "nome": "Cândido Godói",
    "uf": "RS"
  },
  {
    "codigo": 4304358,
    "nome": "Candiota",
    "uf": "RS"
  },
  {
    "codigo": 4304408,
    "nome": "Canela",
    "uf": "RS"
  },
  {
    "codigo": 4304507,
    "nome": "Canguçu",
    "uf": "RS"
  },
  {
    "codigo": 4304606,
    "nome": "Canoas",
    "uf": "RS"
  },
  {
    "codigo": 4304614,
    "nome": "Canudos do Vale",
    "uf": "RS"
  },
  {
    "codigo": 4304622,
    "nome": "Capão Bonito do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4304630,
    "nome": "Capão da Canoa",
    "uf": "RS"
  },
  {
    "codigo": 4304655,
    "nome": "Capão do Cipó",
    "uf": "RS"
  },
  {
    "codigo": 4304663,
    "nome": "Capão do Leão",
    "uf": "RS"
  },
  {
    "codigo": 4304671,
    "nome": "Capivari do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4304689,
    "nome": "Capela de Santana",
    "uf": "RS"
  },
  {
    "codigo": 4304697,
    "nome": "Capitão",
    "uf": "RS"
  },
  {
    "codigo": 4304705,
    "nome": "Carazinho",
    "uf": "RS"
  },
  {
    "codigo": 4304713,
    "nome": "Caraá",
    "uf": "RS"
  },
  {
    "codigo": 4304804,
    "nome": "Carlos Barbosa",
    "uf": "RS"
  },
  {
    "codigo": 4304853,
    "nome": "Carlos Gomes",
    "uf": "RS"
  },
  {
    "codigo": 4304903,
    "nome": "Casca",
    "uf": "RS"
  },
  {
    "codigo": 4304952,
    "nome": "Caseiros",
    "uf": "RS"
  },
  {
    "codigo": 4305009,
    "nome": "Catuípe",
    "uf": "RS"
  },
  {
    "codigo": 4305108,
    "nome": "Caxias do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4305116,
    "nome": "Centenário",
    "uf": "RS"
  },
  {
    "codigo": 4305124,
    "nome": "Cerrito",
    "uf": "RS"
  },
  {
    "codigo": 4305132,
    "nome": "Cerro Branco",
    "uf": "RS"
  },
  {
    "codigo": 4305157,
    "nome": "Cerro Grande",
    "uf": "RS"
  },
  {
    "codigo": 4305173,
    "nome": "Cerro Grande do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4305207,
    "nome": "Cerro Largo",
    "uf": "RS"
  },
  {
    "codigo": 4305306,
    "nome": "Chapada",
    "uf": "RS"
  },
  {
    "codigo": 4305355,
    "nome": "Charqueadas",
    "uf": "RS"
  },
  {
    "codigo": 4305371,
    "nome": "Charrua",
    "uf": "RS"
  },
  {
    "codigo": 4305405,
    "nome": "Chiapetta",
    "uf": "RS"
  },
  {
    "codigo": 4305439,
    "nome": "Chuí",
    "uf": "RS"
  },
  {
    "codigo": 4305447,
    "nome": "Chuvisca",
    "uf": "RS"
  },
  {
    "codigo": 4305454,
    "nome": "Cidreira",
    "uf": "RS"
  },
  {
    "codigo": 4305504,
    "nome": "Ciríaco",
    "uf": "RS"
  },
  {
    "codigo": 4305587,
    "nome": "Colinas",
    "uf": "RS"
  },
  {
    "codigo": 4305603,
    "nome": "Colorado",
    "uf": "RS"
  },
  {
    "codigo": 4305702,
    "nome": "Condor",
    "uf": "RS"
  },
  {
    "codigo": 4305801,
    "nome": "Constantina",
    "uf": "RS"
  },
  {
    "codigo": 4305835,
    "nome": "Coqueiro Baixo",
    "uf": "RS"
  },
  {
    "codigo": 4305850,
    "nome": "Coqueiros do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4305871,
    "nome": "Coronel Barros",
    "uf": "RS"
  },
  {
    "codigo": 4305900,
    "nome": "Coronel Bicaco",
    "uf": "RS"
  },
  {
    "codigo": 4305934,
    "nome": "Coronel Pilar",
    "uf": "RS"
  },
  {
    "codigo": 4305959,
    "nome": "Cotiporã",
    "uf": "RS"
  },
  {
    "codigo": 4305975,
    "nome": "Coxilha",
    "uf": "RS"
  },
  {
    "codigo": 4306007,
    "nome": "Crissiumal",
    "uf": "RS"
  },
  {
    "codigo": 4306056,
    "nome": "Cristal",
    "uf": "RS"
  },
  {
    "codigo": 4306072,
    "nome": "Cristal do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4306106,
    "nome": "Cruz Alta",
    "uf": "RS"
  },
  {
    "codigo": 4306130,
    "nome": "Cruzaltense",
    "uf": "RS"
  },
  {
    "codigo": 4306205,
    "nome": "Cruzeiro do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4306304,
    "nome": "David Canabarro",
    "uf": "RS"
  },
  {
    "codigo": 4306320,
    "nome": "Derrubadas",
    "uf": "RS"
  },
  {
    "codigo": 4306353,
    "nome": "Dezesseis de Novembro",
    "uf": "RS"
  },
  {
    "codigo": 4306379,
    "nome": "Dilermando de Aguiar",
    "uf": "RS"
  },
  {
    "codigo": 4306403,
    "nome": "Dois Irmãos",
    "uf": "RS"
  },
  {
    "codigo": 4306429,
    "nome": "Dois Irmãos das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4306452,
    "nome": "Dois Lajeados",
    "uf": "RS"
  },
  {
    "codigo": 4306502,
    "nome": "Dom Feliciano",
    "uf": "RS"
  },
  {
    "codigo": 4306551,
    "nome": "Dom Pedro de Alcântara",
    "uf": "RS"
  },
  {
    "codigo": 4306601,
    "nome": "Dom Pedrito",
    "uf": "RS"
  },
  {
    "codigo": 4306700,
    "nome": "Dona Francisca",
    "uf": "RS"
  },
  {
    "codigo": 4306734,
    "nome": "Doutor Maurício Cardoso",
    "uf": "RS"
  },
  {
    "codigo": 4306759,
    "nome": "Doutor Ricardo",
    "uf": "RS"
  },
  {
    "codigo": 4306767,
    "nome": "Eldorado do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4306809,
    "nome": "Encantado",
    "uf": "RS"
  },
  {
    "codigo": 4306908,
    "nome": "Encruzilhada do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4306924,
    "nome": "Engenho Velho",
    "uf": "RS"
  },
  {
    "codigo": 4306932,
    "nome": "Entre-Ijuís",
    "uf": "RS"
  },
  {
    "codigo": 4306957,
    "nome": "Entre Rios do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4306973,
    "nome": "Erebango",
    "uf": "RS"
  },
  {
    "codigo": 4307005,
    "nome": "Erechim",
    "uf": "RS"
  },
  {
    "codigo": 4307054,
    "nome": "Ernestina",
    "uf": "RS"
  },
  {
    "codigo": 4307104,
    "nome": "Herval",
    "uf": "RS"
  },
  {
    "codigo": 4307203,
    "nome": "Erval Grande",
    "uf": "RS"
  },
  {
    "codigo": 4307302,
    "nome": "Erval Seco",
    "uf": "RS"
  },
  {
    "codigo": 4307401,
    "nome": "Esmeralda",
    "uf": "RS"
  },
  {
    "codigo": 4307450,
    "nome": "Esperança do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4307500,
    "nome": "Espumoso",
    "uf": "RS"
  },
  {
    "codigo": 4307559,
    "nome": "Estação",
    "uf": "RS"
  },
  {
    "codigo": 4307609,
    "nome": "Estância Velha",
    "uf": "RS"
  },
  {
    "codigo": 4307708,
    "nome": "Esteio",
    "uf": "RS"
  },
  {
    "codigo": 4307807,
    "nome": "Estrela",
    "uf": "RS"
  },
  {
    "codigo": 4307815,
    "nome": "Estrela Velha",
    "uf": "RS"
  },
  {
    "codigo": 4307831,
    "nome": "Eugênio de Castro",
    "uf": "RS"
  },
  {
    "codigo": 4307864,
    "nome": "Fagundes Varela",
    "uf": "RS"
  },
  {
    "codigo": 4307906,
    "nome": "Farroupilha",
    "uf": "RS"
  },
  {
    "codigo": 4308003,
    "nome": "Faxinal do Soturno",
    "uf": "RS"
  },
  {
    "codigo": 4308052,
    "nome": "Faxinalzinho",
    "uf": "RS"
  },
  {
    "codigo": 4308078,
    "nome": "Fazenda Vilanova",
    "uf": "RS"
  },
  {
    "codigo": 4308102,
    "nome": "Feliz",
    "uf": "RS"
  },
  {
    "codigo": 4308201,
    "nome": "Flores da Cunha",
    "uf": "RS"
  },
  {
    "codigo": 4308250,
    "nome": "Floriano Peixoto",
    "uf": "RS"
  },
  {
    "codigo": 4308300,
    "nome": "Fontoura Xavier",
    "uf": "RS"
  },
  {
    "codigo": 4308409,
    "nome": "Formigueiro",
    "uf": "RS"
  },
  {
    "codigo": 4308433,
    "nome": "Forquetinha",
    "uf": "RS"
  },
  {
    "codigo": 4308458,
    "nome": "Fortaleza dos Valos",
    "uf": "RS"
  },
  {
    "codigo": 4308508,
    "nome": "Frederico Westphalen",
    "uf": "RS"
  },
  {
    "codigo": 4308607,
    "nome": "Garibaldi",
    "uf": "RS"
  },
  {
    "codigo": 4308656,
    "nome": "Garruchos",
    "uf": "RS"
  },
  {
    "codigo": 4308706,
    "nome": "Gaurama",
    "uf": "RS"
  },
  {
    "codigo": 4308805,
    "nome": "General Câmara",
    "uf": "RS"
  },
  {
    "codigo": 4308854,
    "nome": "Gentil",
    "uf": "RS"
  },
  {
    "codigo": 4308904,
    "nome": "Getúlio Vargas",
    "uf": "RS"
  },
  {
    "codigo": 4309001,
    "nome": "Giruá",
    "uf": "RS"
  },
  {
    "codigo": 4309050,
    "nome": "Glorinha",
    "uf": "RS"
  },
  {
    "codigo": 4309100,
    "nome": "Gramado",
    "uf": "RS"
  },
  {
    "codigo": 4309126,
    "nome": "Gramado dos Loureiros",
    "uf": "RS"
  },
  {
    "codigo": 4309159,
    "nome": "Gramado Xavier",
    "uf": "RS"
  },
  {
    "codigo": 4309209,
    "nome": "Gravataí",
    "uf": "RS"
  },
  {
    "codigo": 4309258,
    "nome": "Guabiju",
    "uf": "RS"
  },
  {
    "codigo": 4309308,
    "nome": "Guaíba",
    "uf": "RS"
  },
  {
    "codigo": 4309407,
    "nome": "Guaporé",
    "uf": "RS"
  },
  {
    "codigo": 4309506,
    "nome": "Guarani das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4309555,
    "nome": "Harmonia",
    "uf": "RS"
  },
  {
    "codigo": 4309571,
    "nome": "Herveiras",
    "uf": "RS"
  },
  {
    "codigo": 4309605,
    "nome": "Horizontina",
    "uf": "RS"
  },
  {
    "codigo": 4309654,
    "nome": "Hulha Negra",
    "uf": "RS"
  },
  {
    "codigo": 4309704,
    "nome": "Humaitá",
    "uf": "RS"
  },
  {
    "codigo": 4309753,
    "nome": "Ibarama",
    "uf": "RS"
  },
  {
    "codigo": 4309803,
    "nome": "Ibiaçá",
    "uf": "RS"
  },
  {
    "codigo": 4309902,
    "nome": "Ibiraiaras",
    "uf": "RS"
  },
  {
    "codigo": 4309951,
    "nome": "Ibirapuitã",
    "uf": "RS"
  },
  {
    "codigo": 4310009,
    "nome": "Ibirubá",
    "uf": "RS"
  },
  {
    "codigo": 4310108,
    "nome": "Igrejinha",
    "uf": "RS"
  },
  {
    "codigo": 4310207,
    "nome": "Ijuí",
    "uf": "RS"
  },
  {
    "codigo": 4310306,
    "nome": "Ilópolis",
    "uf": "RS"
  },
  {
    "codigo": 4310330,
    "nome": "Imbé",
    "uf": "RS"
  },
  {
    "codigo": 4310363,
    "nome": "Imigrante",
    "uf": "RS"
  },
  {
    "codigo": 4310405,
    "nome": "Independência",
    "uf": "RS"
  },
  {
    "codigo": 4310413,
    "nome": "Inhacorá",
    "uf": "RS"
  },
  {
    "codigo": 4310439,
    "nome": "Ipê",
    "uf": "RS"
  },
  {
    "codigo": 4310462,
    "nome": "Ipiranga do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4310504,
    "nome": "Iraí",
    "uf": "RS"
  },
  {
    "codigo": 4310538,
    "nome": "Itaara",
    "uf": "RS"
  },
  {
    "codigo": 4310553,
    "nome": "Itacurubi",
    "uf": "RS"
  },
  {
    "codigo": 4310579,
    "nome": "Itapuca",
    "uf": "RS"
  },
  {
    "codigo": 4310603,
    "nome": "Itaqui",
    "uf": "RS"
  },
  {
    "codigo": 4310652,
    "nome": "Itati",
    "uf": "RS"
  },
  {
    "codigo": 4310702,
    "nome": "Itatiba do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4310751,
    "nome": "Ivorá",
    "uf": "RS"
  },
  {
    "codigo": 4310801,
    "nome": "Ivoti",
    "uf": "RS"
  },
  {
    "codigo": 4310850,
    "nome": "Jaboticaba",
    "uf": "RS"
  },
  {
    "codigo": 4310876,
    "nome": "Jacuizinho",
    "uf": "RS"
  },
  {
    "codigo": 4310900,
    "nome": "Jacutinga",
    "uf": "RS"
  },
  {
    "codigo": 4311007,
    "nome": "Jaguarão",
    "uf": "RS"
  },
  {
    "codigo": 4311106,
    "nome": "Jaguari",
    "uf": "RS"
  },
  {
    "codigo": 4311122,
    "nome": "Jaquirana",
    "uf": "RS"
  },
  {
    "codigo": 4311130,
    "nome": "Jari",
    "uf": "RS"
  },
  {
    "codigo": 4311155,
    "nome": "Jóia",
    "uf": "RS"
  },
  {
    "codigo": 4311205,
    "nome": "Júlio de Castilhos",
    "uf": "RS"
  },
  {
    "codigo": 4311239,
    "nome": "Lagoa Bonita do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4311254,
    "nome": "Lagoão",
    "uf": "RS"
  },
  {
    "codigo": 4311270,
    "nome": "Lagoa dos Três Cantos",
    "uf": "RS"
  },
  {
    "codigo": 4311304,
    "nome": "Lagoa Vermelha",
    "uf": "RS"
  },
  {
    "codigo": 4311403,
    "nome": "Lajeado",
    "uf": "RS"
  },
  {
    "codigo": 4311429,
    "nome": "Lajeado do Bugre",
    "uf": "RS"
  },
  {
    "codigo": 4311502,
    "nome": "Lavras do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4311601,
    "nome": "Liberato Salzano",
    "uf": "RS"
  },
  {
    "codigo": 4311627,
    "nome": "Lindolfo Collor",
    "uf": "RS"
  },
  {
    "codigo": 4311643,
    "nome": "Linha Nova",
    "uf": "RS"
  },
  {
    "codigo": 4311700,
    "nome": "Machadinho",
    "uf": "RS"
  },
  {
    "codigo": 4311718,
    "nome": "Maçambará",
    "uf": "RS"
  },
  {
    "codigo": 4311734,
    "nome": "Mampituba",
    "uf": "RS"
  },
  {
    "codigo": 4311759,
    "nome": "Manoel Viana",
    "uf": "RS"
  },
  {
    "codigo": 4311775,
    "nome": "Maquiné",
    "uf": "RS"
  },
  {
    "codigo": 4311791,
    "nome": "Maratá",
    "uf": "RS"
  },
  {
    "codigo": 4311809,
    "nome": "Marau",
    "uf": "RS"
  },
  {
    "codigo": 4311908,
    "nome": "Marcelino Ramos",
    "uf": "RS"
  },
  {
    "codigo": 4311981,
    "nome": "Mariana Pimentel",
    "uf": "RS"
  },
  {
    "codigo": 4312005,
    "nome": "Mariano Moro",
    "uf": "RS"
  },
  {
    "codigo": 4312054,
    "nome": "Marques de Souza",
    "uf": "RS"
  },
  {
    "codigo": 4312104,
    "nome": "Mata",
    "uf": "RS"
  },
  {
    "codigo": 4312138,
    "nome": "Mato Castelhano",
    "uf": "RS"
  },
  {
    "codigo": 4312153,
    "nome": "Mato Leitão",
    "uf": "RS"
  },
  {
    "codigo": 4312179,
    "nome": "Mato Queimado",
    "uf": "RS"
  },
  {
    "codigo": 4312203,
    "nome": "Maximiliano de Almeida",
    "uf": "RS"
  },
  {
    "codigo": 4312252,
    "nome": "Minas do Leão",
    "uf": "RS"
  },
  {
    "codigo": 4312302,
    "nome": "Miraguaí",
    "uf": "RS"
  },
  {
    "codigo": 4312351,
    "nome": "Montauri",
    "uf": "RS"
  },
  {
    "codigo": 4312377,
    "nome": "Monte Alegre dos Campos",
    "uf": "RS"
  },
  {
    "codigo": 4312385,
    "nome": "Monte Belo do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4312401,
    "nome": "Montenegro",
    "uf": "RS"
  },
  {
    "codigo": 4312427,
    "nome": "Mormaço",
    "uf": "RS"
  },
  {
    "codigo": 4312443,
    "nome": "Morrinhos do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4312450,
    "nome": "Morro Redondo",
    "uf": "RS"
  },
  {
    "codigo": 4312476,
    "nome": "Morro Reuter",
    "uf": "RS"
  },
  {
    "codigo": 4312500,
    "nome": "Mostardas",
    "uf": "RS"
  },
  {
    "codigo": 4312609,
    "nome": "Muçum",
    "uf": "RS"
  },
  {
    "codigo": 4312617,
    "nome": "Muitos Capões",
    "uf": "RS"
  },
  {
    "codigo": 4312625,
    "nome": "Muliterno",
    "uf": "RS"
  },
  {
    "codigo": 4312658,
    "nome": "Não-Me-Toque",
    "uf": "RS"
  },
  {
    "codigo": 4312674,
    "nome": "Nicolau Vergueiro",
    "uf": "RS"
  },
  {
    "codigo": 4312708,
    "nome": "Nonoai",
    "uf": "RS"
  },
  {
    "codigo": 4312757,
    "nome": "Nova Alvorada",
    "uf": "RS"
  },
  {
    "codigo": 4312807,
    "nome": "Nova Araçá",
    "uf": "RS"
  },
  {
    "codigo": 4312906,
    "nome": "Nova Bassano",
    "uf": "RS"
  },
  {
    "codigo": 4312955,
    "nome": "Nova Boa Vista",
    "uf": "RS"
  },
  {
    "codigo": 4313003,
    "nome": "Nova Bréscia",
    "uf": "RS"
  },
  {
    "codigo": 4313011,
    "nome": "Nova Candelária",
    "uf": "RS"
  },
  {
    "codigo": 4313037,
    "nome": "Nova Esperança do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4313060,
    "nome": "Nova Hartz",
    "uf": "RS"
  },
  {
    "codigo": 4313086,
    "nome": "Nova Pádua",
    "uf": "RS"
  },
  {
    "codigo": 4313102,
    "nome": "Nova Palma",
    "uf": "RS"
  },
  {
    "codigo": 4313201,
    "nome": "Nova Petrópolis",
    "uf": "RS"
  },
  {
    "codigo": 4313300,
    "nome": "Nova Prata",
    "uf": "RS"
  },
  {
    "codigo": 4313334,
    "nome": "Nova Ramada",
    "uf": "RS"
  },
  {
    "codigo": 4313359,
    "nome": "Nova Roma do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4313375,
    "nome": "Nova Santa Rita",
    "uf": "RS"
  },
  {
    "codigo": 4313391,
    "nome": "Novo Cabrais",
    "uf": "RS"
  },
  {
    "codigo": 4313409,
    "nome": "Novo Hamburgo",
    "uf": "RS"
  },
  {
    "codigo": 4313425,
    "nome": "Novo Machado",
    "uf": "RS"
  },
  {
    "codigo": 4313441,
    "nome": "Novo Tiradentes",
    "uf": "RS"
  },
  {
    "codigo": 4313466,
    "nome": "Novo Xingu",
    "uf": "RS"
  },
  {
    "codigo": 4313490,
    "nome": "Novo Barreiro",
    "uf": "RS"
  },
  {
    "codigo": 4313508,
    "nome": "Osório",
    "uf": "RS"
  },
  {
    "codigo": 4313607,
    "nome": "Paim Filho",
    "uf": "RS"
  },
  {
    "codigo": 4313656,
    "nome": "Palmares do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4313706,
    "nome": "Palmeira das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4313805,
    "nome": "Palmitinho",
    "uf": "RS"
  },
  {
    "codigo": 4313904,
    "nome": "Panambi",
    "uf": "RS"
  },
  {
    "codigo": 4313953,
    "nome": "Pantano Grande",
    "uf": "RS"
  },
  {
    "codigo": 4314001,
    "nome": "Paraí",
    "uf": "RS"
  },
  {
    "codigo": 4314027,
    "nome": "Paraíso do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4314035,
    "nome": "Pareci Novo",
    "uf": "RS"
  },
  {
    "codigo": 4314050,
    "nome": "Parobé",
    "uf": "RS"
  },
  {
    "codigo": 4314068,
    "nome": "Passa Sete",
    "uf": "RS"
  },
  {
    "codigo": 4314076,
    "nome": "Passo do Sobrado",
    "uf": "RS"
  },
  {
    "codigo": 4314100,
    "nome": "Passo Fundo",
    "uf": "RS"
  },
  {
    "codigo": 4314134,
    "nome": "Paulo Bento",
    "uf": "RS"
  },
  {
    "codigo": 4314159,
    "nome": "Paverama",
    "uf": "RS"
  },
  {
    "codigo": 4314175,
    "nome": "Pedras Altas",
    "uf": "RS"
  },
  {
    "codigo": 4314209,
    "nome": "Pedro Osório",
    "uf": "RS"
  },
  {
    "codigo": 4314308,
    "nome": "Pejuçara",
    "uf": "RS"
  },
  {
    "codigo": 4314407,
    "nome": "Pelotas",
    "uf": "RS"
  },
  {
    "codigo": 4314423,
    "nome": "Picada Café",
    "uf": "RS"
  },
  {
    "codigo": 4314456,
    "nome": "Pinhal",
    "uf": "RS"
  },
  {
    "codigo": 4314464,
    "nome": "Pinhal da Serra",
    "uf": "RS"
  },
  {
    "codigo": 4314472,
    "nome": "Pinhal Grande",
    "uf": "RS"
  },
  {
    "codigo": 4314498,
    "nome": "Pinheirinho do Vale",
    "uf": "RS"
  },
  {
    "codigo": 4314506,
    "nome": "Pinheiro Machado",
    "uf": "RS"
  },
  {
    "codigo": 4314548,
    "nome": "Pinto Bandeira",
    "uf": "RS"
  },
  {
    "codigo": 4314555,
    "nome": "Pirapó",
    "uf": "RS"
  },
  {
    "codigo": 4314605,
    "nome": "Piratini",
    "uf": "RS"
  },
  {
    "codigo": 4314704,
    "nome": "Planalto",
    "uf": "RS"
  },
  {
    "codigo": 4314753,
    "nome": "Poço das Antas",
    "uf": "RS"
  },
  {
    "codigo": 4314779,
    "nome": "Pontão",
    "uf": "RS"
  },
  {
    "codigo": 4314787,
    "nome": "Ponte Preta",
    "uf": "RS"
  },
  {
    "codigo": 4314803,
    "nome": "Portão",
    "uf": "RS"
  },
  {
    "codigo": 4314902,
    "nome": "Porto Alegre",
    "uf": "RS"
  },
  {
    "codigo": 4315008,
    "nome": "Porto Lucena",
    "uf": "RS"
  },
  {
    "codigo": 4315057,
    "nome": "Porto Mauá",
    "uf": "RS"
  },
  {
    "codigo": 4315073,
    "nome": "Porto Vera Cruz",
    "uf": "RS"
  },
  {
    "codigo": 4315107,
    "nome": "Porto Xavier",
    "uf": "RS"
  },
  {
    "codigo": 4315131,
    "nome": "Pouso Novo",
    "uf": "RS"
  },
  {
    "codigo": 4315149,
    "nome": "Presidente Lucena",
    "uf": "RS"
  },
  {
    "codigo": 4315156,
    "nome": "Progresso",
    "uf": "RS"
  },
  {
    "codigo": 4315172,
    "nome": "Protásio Alves",
    "uf": "RS"
  },
  {
    "codigo": 4315206,
    "nome": "Putinga",
    "uf": "RS"
  },
  {
    "codigo": 4315305,
    "nome": "Quaraí",
    "uf": "RS"
  },
  {
    "codigo": 4315313,
    "nome": "Quatro Irmãos",
    "uf": "RS"
  },
  {
    "codigo": 4315321,
    "nome": "Quevedos",
    "uf": "RS"
  },
  {
    "codigo": 4315354,
    "nome": "Quinze de Novembro",
    "uf": "RS"
  },
  {
    "codigo": 4315404,
    "nome": "Redentora",
    "uf": "RS"
  },
  {
    "codigo": 4315453,
    "nome": "Relvado",
    "uf": "RS"
  },
  {
    "codigo": 4315503,
    "nome": "Restinga Sêca",
    "uf": "RS"
  },
  {
    "codigo": 4315552,
    "nome": "Rio dos Índios",
    "uf": "RS"
  },
  {
    "codigo": 4315602,
    "nome": "Rio Grande",
    "uf": "RS"
  },
  {
    "codigo": 4315701,
    "nome": "Rio Pardo",
    "uf": "RS"
  },
  {
    "codigo": 4315750,
    "nome": "Riozinho",
    "uf": "RS"
  },
  {
    "codigo": 4315800,
    "nome": "Roca Sales",
    "uf": "RS"
  },
  {
    "codigo": 4315909,
    "nome": "Rodeio Bonito",
    "uf": "RS"
  },
  {
    "codigo": 4315958,
    "nome": "Rolador",
    "uf": "RS"
  },
  {
    "codigo": 4316006,
    "nome": "Rolante",
    "uf": "RS"
  },
  {
    "codigo": 4316105,
    "nome": "Ronda Alta",
    "uf": "RS"
  },
  {
    "codigo": 4316204,
    "nome": "Rondinha",
    "uf": "RS"
  },
  {
    "codigo": 4316303,
    "nome": "Roque Gonzales",
    "uf": "RS"
  },
  {
    "codigo": 4316402,
    "nome": "Rosário do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4316428,
    "nome": "Sagrada Família",
    "uf": "RS"
  },
  {
    "codigo": 4316436,
    "nome": "Saldanha Marinho",
    "uf": "RS"
  },
  {
    "codigo": 4316451,
    "nome": "Salto do Jacuí",
    "uf": "RS"
  },
  {
    "codigo": 4316477,
    "nome": "Salvador das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4316501,
    "nome": "Salvador do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4316600,
    "nome": "Sananduva",
    "uf": "RS"
  },
  {
    "codigo": 4316709,
    "nome": "Santa Bárbara do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4316733,
    "nome": "Santa Cecília do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4316758,
    "nome": "Santa Clara do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4316808,
    "nome": "Santa Cruz do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4316907,
    "nome": "Santa Maria",
    "uf": "RS"
  },
  {
    "codigo": 4316956,
    "nome": "Santa Maria do Herval",
    "uf": "RS"
  },
  {
    "codigo": 4316972,
    "nome": "Santa Margarida do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4317004,
    "nome": "Santana da Boa Vista",
    "uf": "RS"
  },
  {
    "codigo": 4317103,
    "nome": "Sant'Ana do Livramento",
    "uf": "RS"
  },
  {
    "codigo": 4317202,
    "nome": "Santa Rosa",
    "uf": "RS"
  },
  {
    "codigo": 4317251,
    "nome": "Santa Tereza",
    "uf": "RS"
  },
  {
    "codigo": 4317301,
    "nome": "Santa Vitória do Palmar",
    "uf": "RS"
  },
  {
    "codigo": 4317400,
    "nome": "Santiago",
    "uf": "RS"
  },
  {
    "codigo": 4317509,
    "nome": "Santo Ângelo",
    "uf": "RS"
  },
  {
    "codigo": 4317558,
    "nome": "Santo Antônio do Palma",
    "uf": "RS"
  },
  {
    "codigo": 4317608,
    "nome": "Santo Antônio da Patrulha",
    "uf": "RS"
  },
  {
    "codigo": 4317707,
    "nome": "Santo Antônio das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4317756,
    "nome": "Santo Antônio do Planalto",
    "uf": "RS"
  },
  {
    "codigo": 4317806,
    "nome": "Santo Augusto",
    "uf": "RS"
  },
  {
    "codigo": 4317905,
    "nome": "Santo Cristo",
    "uf": "RS"
  },
  {
    "codigo": 4317954,
    "nome": "Santo Expedito do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4318002,
    "nome": "São Borja",
    "uf": "RS"
  },
  {
    "codigo": 4318051,
    "nome": "São Domingos do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4318101,
    "nome": "São Francisco de Assis",
    "uf": "RS"
  },
  {
    "codigo": 4318200,
    "nome": "São Francisco de Paula",
    "uf": "RS"
  },
  {
    "codigo": 4318309,
    "nome": "São Gabriel",
    "uf": "RS"
  },
  {
    "codigo": 4318408,
    "nome": "São Jerônimo",
    "uf": "RS"
  },
  {
    "codigo": 4318424,
    "nome": "São João da Urtiga",
    "uf": "RS"
  },
  {
    "codigo": 4318432,
    "nome": "São João do Polêsine",
    "uf": "RS"
  },
  {
    "codigo": 4318440,
    "nome": "São Jorge",
    "uf": "RS"
  },
  {
    "codigo": 4318457,
    "nome": "São José das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4318465,
    "nome": "São José do Herval",
    "uf": "RS"
  },
  {
    "codigo": 4318481,
    "nome": "São José do Hortêncio",
    "uf": "RS"
  },
  {
    "codigo": 4318499,
    "nome": "São José do Inhacorá",
    "uf": "RS"
  },
  {
    "codigo": 4318507,
    "nome": "São José do Norte",
    "uf": "RS"
  },
  {
    "codigo": 4318606,
    "nome": "São José do Ouro",
    "uf": "RS"
  },
  {
    "codigo": 4318614,
    "nome": "São José do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4318622,
    "nome": "São José dos Ausentes",
    "uf": "RS"
  },
  {
    "codigo": 4318705,
    "nome": "São Leopoldo",
    "uf": "RS"
  },
  {
    "codigo": 4318804,
    "nome": "São Lourenço do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4318903,
    "nome": "São Luiz Gonzaga",
    "uf": "RS"
  },
  {
    "codigo": 4319000,
    "nome": "São Marcos",
    "uf": "RS"
  },
  {
    "codigo": 4319109,
    "nome": "São Martinho",
    "uf": "RS"
  },
  {
    "codigo": 4319125,
    "nome": "São Martinho da Serra",
    "uf": "RS"
  },
  {
    "codigo": 4319158,
    "nome": "São Miguel das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4319208,
    "nome": "São Nicolau",
    "uf": "RS"
  },
  {
    "codigo": 4319307,
    "nome": "São Paulo das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4319356,
    "nome": "São Pedro da Serra",
    "uf": "RS"
  },
  {
    "codigo": 4319364,
    "nome": "São Pedro das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4319372,
    "nome": "São Pedro do Butiá",
    "uf": "RS"
  },
  {
    "codigo": 4319406,
    "nome": "São Pedro do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4319505,
    "nome": "São Sebastião do Caí",
    "uf": "RS"
  },
  {
    "codigo": 4319604,
    "nome": "São Sepé",
    "uf": "RS"
  },
  {
    "codigo": 4319703,
    "nome": "São Valentim",
    "uf": "RS"
  },
  {
    "codigo": 4319711,
    "nome": "São Valentim do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4319737,
    "nome": "São Valério do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4319752,
    "nome": "São Vendelino",
    "uf": "RS"
  },
  {
    "codigo": 4319802,
    "nome": "São Vicente do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4319901,
    "nome": "Sapiranga",
    "uf": "RS"
  },
  {
    "codigo": 4320008,
    "nome": "Sapucaia do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4320107,
    "nome": "Sarandi",
    "uf": "RS"
  },
  {
    "codigo": 4320206,
    "nome": "Seberi",
    "uf": "RS"
  },
  {
    "codigo": 4320230,
    "nome": "Sede Nova",
    "uf": "RS"
  },
  {
    "codigo": 4320263,
    "nome": "Segredo",
    "uf": "RS"
  },
  {
    "codigo": 4320305,
    "nome": "Selbach",
    "uf": "RS"
  },
  {
    "codigo": 4320321,
    "nome": "Senador Salgado Filho",
    "uf": "RS"
  },
  {
    "codigo": 4320354,
    "nome": "Sentinela do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4320404,
    "nome": "Serafina Corrêa",
    "uf": "RS"
  },
  {
    "codigo": 4320453,
    "nome": "Sério",
    "uf": "RS"
  },
  {
    "codigo": 4320503,
    "nome": "Sertão",
    "uf": "RS"
  },
  {
    "codigo": 4320552,
    "nome": "Sertão Santana",
    "uf": "RS"
  },
  {
    "codigo": 4320578,
    "nome": "Sete de Setembro",
    "uf": "RS"
  },
  {
    "codigo": 4320602,
    "nome": "Severiano de Almeida",
    "uf": "RS"
  },
  {
    "codigo": 4320651,
    "nome": "Silveira Martins",
    "uf": "RS"
  },
  {
    "codigo": 4320677,
    "nome": "Sinimbu",
    "uf": "RS"
  },
  {
    "codigo": 4320701,
    "nome": "Sobradinho",
    "uf": "RS"
  },
  {
    "codigo": 4320800,
    "nome": "Soledade",
    "uf": "RS"
  },
  {
    "codigo": 4320859,
    "nome": "Tabaí",
    "uf": "RS"
  },
  {
    "codigo": 4320909,
    "nome": "Tapejara",
    "uf": "RS"
  },
  {
    "codigo": 4321006,
    "nome": "Tapera",
    "uf": "RS"
  },
  {
    "codigo": 4321105,
    "nome": "Tapes",
    "uf": "RS"
  },
  {
    "codigo": 4321204,
    "nome": "Taquara",
    "uf": "RS"
  },
  {
    "codigo": 4321303,
    "nome": "Taquari",
    "uf": "RS"
  },
  {
    "codigo": 4321329,
    "nome": "Taquaruçu do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4321352,
    "nome": "Tavares",
    "uf": "RS"
  },
  {
    "codigo": 4321402,
    "nome": "Tenente Portela",
    "uf": "RS"
  },
  {
    "codigo": 4321436,
    "nome": "Terra de Areia",
    "uf": "RS"
  },
  {
    "codigo": 4321451,
    "nome": "Teutônia",
    "uf": "RS"
  },
  {
    "codigo": 4321469,
    "nome": "Tio Hugo",
    "uf": "RS"
  },
  {
    "codigo": 4321477,
    "nome": "Tiradentes do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4321493,
    "nome": "Toropi",
    "uf": "RS"
  },
  {
    "codigo": 4321501,
    "nome": "Torres",
    "uf": "RS"
  },
  {
    "codigo": 4321600,
    "nome": "Tramandaí",
    "uf": "RS"
  },
  {
    "codigo": 4321626,
    "nome": "Travesseiro",
    "uf": "RS"
  },
  {
    "codigo": 4321634,
    "nome": "Três Arroios",
    "uf": "RS"
  },
  {
    "codigo": 4321667,
    "nome": "Três Cachoeiras",
    "uf": "RS"
  },
  {
    "codigo": 4321709,
    "nome": "Três Coroas",
    "uf": "RS"
  },
  {
    "codigo": 4321808,
    "nome": "Três de Maio",
    "uf": "RS"
  },
  {
    "codigo": 4321832,
    "nome": "Três Forquilhas",
    "uf": "RS"
  },
  {
    "codigo": 4321857,
    "nome": "Três Palmeiras",
    "uf": "RS"
  },
  {
    "codigo": 4321907,
    "nome": "Três Passos",
    "uf": "RS"
  },
  {
    "codigo": 4321956,
    "nome": "Trindade do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4322004,
    "nome": "Triunfo",
    "uf": "RS"
  },
  {
    "codigo": 4322103,
    "nome": "Tucunduva",
    "uf": "RS"
  },
  {
    "codigo": 4322152,
    "nome": "Tunas",
    "uf": "RS"
  },
  {
    "codigo": 4322186,
    "nome": "Tupanci do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4322202,
    "nome": "Tupanciretã",
    "uf": "RS"
  },
  {
    "codigo": 4322251,
    "nome": "Tupandi",
    "uf": "RS"
  },
  {
    "codigo": 4322301,
    "nome": "Tuparendi",
    "uf": "RS"
  },
  {
    "codigo": 4322327,
    "nome": "Turuçu",
    "uf": "RS"
  },
  {
    "codigo": 4322343,
    "nome": "Ubiretama",
    "uf": "RS"
  },
  {
    "codigo": 4322350,
    "nome": "União da Serra",
    "uf": "RS"
  },
  {
    "codigo": 4322376,
    "nome": "Unistalda",
    "uf": "RS"
  },
  {
    "codigo": 4322400,
    "nome": "Uruguaiana",
    "uf": "RS"
  },
  {
    "codigo": 4322509,
    "nome": "Vacaria",
    "uf": "RS"
  },
  {
    "codigo": 4322525,
    "nome": "Vale Verde",
    "uf": "RS"
  },
  {
    "codigo": 4322533,
    "nome": "Vale do Sol",
    "uf": "RS"
  },
  {
    "codigo": 4322541,
    "nome": "Vale Real",
    "uf": "RS"
  },
  {
    "codigo": 4322558,
    "nome": "Vanini",
    "uf": "RS"
  },
  {
    "codigo": 4322608,
    "nome": "Venâncio Aires",
    "uf": "RS"
  },
  {
    "codigo": 4322707,
    "nome": "Vera Cruz",
    "uf": "RS"
  },
  {
    "codigo": 4322806,
    "nome": "Veranópolis",
    "uf": "RS"
  },
  {
    "codigo": 4322855,
    "nome": "Vespasiano Corrêa",
    "uf": "RS"
  },
  {
    "codigo": 4322905,
    "nome": "Viadutos",
    "uf": "RS"
  },
  {
    "codigo": 4323002,
    "nome": "Viamão",
    "uf": "RS"
  },
  {
    "codigo": 4323101,
    "nome": "Vicente Dutra",
    "uf": "RS"
  },
  {
    "codigo": 4323200,
    "nome": "Victor Graeff",
    "uf": "RS"
  },
  {
    "codigo": 4323309,
    "nome": "Vila Flores",
    "uf": "RS"
  },
  {
    "codigo": 4323358,
    "nome": "Vila Lângaro",
    "uf": "RS"
  },
  {
    "codigo": 4323408,
    "nome": "Vila Maria",
    "uf": "RS"
  },
  {
    "codigo": 4323457,
    "nome": "Vila Nova do Sul",
    "uf": "RS"
  },
  {
    "codigo": 4323507,
    "nome": "Vista Alegre",
    "uf": "RS"
  },
  {
    "codigo": 4323606,
    "nome": "Vista Alegre do Prata",
    "uf": "RS"
  },
  {
    "codigo": 4323705,
    "nome": "Vista Gaúcha",
    "uf": "RS"
  },
  {
    "codigo": 4323754,
    "nome": "Vitória das Missões",
    "uf": "RS"
  },
  {
    "codigo": 4323770,
    "nome": "Westfália",
    "uf": "RS"
  },
  {
    "codigo": 4323804,
    "nome": "Xangri-lá",
    "uf": "RS"
  },
  {
    "codigo": 5000203,
    "nome": "Água Clara",
    "uf": "MS"
  },
  {
    "codigo": 5000252,
    "nome": "Alcinópolis",
    "uf": "MS"
  },
  {
    "codigo": 5000609,
    "nome": "Amambai",
    "uf": "MS"
  },
  {
    "codigo": 5000708,
    "nome": "Anastácio",
    "uf": "MS"
  },
  {
    "codigo": 5000807,
    "nome": "Anaurilândia",
    "uf": "MS"
  },
  {
    "codigo": 5000856,
    "nome": "Angélica",
    "uf": "MS"
  },
  {
    "codigo": 5000906,
    "nome": "Antônio João",
    "uf": "MS"
  },
  {
    "codigo": 5001003,
    "nome": "Aparecida do Taboado",
    "uf": "MS"
  },
  {
    "codigo": 5001102,
    "nome": "Aquidauana",
    "uf": "MS"
  },
  {
    "codigo": 5001243,
    "nome": "Aral Moreira",
    "uf": "MS"
  },
  {
    "codigo": 5001508,
    "nome": "Bandeirantes",
    "uf": "MS"
  },
  {
    "codigo": 5001904,
    "nome": "Bataguassu",
    "uf": "MS"
  },
  {
    "codigo": 5002001,
    "nome": "Batayporã",
    "uf": "MS"
  },
  {
    "codigo": 5002100,
    "nome": "Bela Vista",
    "uf": "MS"
  },
  {
    "codigo": 5002159,
    "nome": "Bodoquena",
    "uf": "MS"
  },
  {
    "codigo": 5002209,
    "nome": "Bonito",
    "uf": "MS"
  },
  {
    "codigo": 5002308,
    "nome": "Brasilândia",
    "uf": "MS"
  },
  {
    "codigo": 5002407,
    "nome": "Caarapó",
    "uf": "MS"
  },
  {
    "codigo": 5002605,
    "nome": "Camapuã",
    "uf": "MS"
  },
  {
    "codigo": 5002704,
    "nome": "Campo Grande",
    "uf": "MS"
  },
  {
    "codigo": 5002803,
    "nome": "Caracol",
    "uf": "MS"
  },
  {
    "codigo": 5002902,
    "nome": "Cassilândia",
    "uf": "MS"
  },
  {
    "codigo": 5002951,
    "nome": "Chapadão do Sul",
    "uf": "MS"
  },
  {
    "codigo": 5003108,
    "nome": "Corguinho",
    "uf": "MS"
  },
  {
    "codigo": 5003157,
    "nome": "Coronel Sapucaia",
    "uf": "MS"
  },
  {
    "codigo": 5003207,
    "nome": "Corumbá",
    "uf": "MS"
  },
  {
    "codigo": 5003256,
    "nome": "Costa Rica",
    "uf": "MS"
  },
  {
    "codigo": 5003306,
    "nome": "Coxim",
    "uf": "MS"
  },
  {
    "codigo": 5003454,
    "nome": "Deodápolis",
    "uf": "MS"
  },
  {
    "codigo": 5003488,
    "nome": "Dois Irmãos do Buriti",
    "uf": "MS"
  },
  {
    "codigo": 5003504,
    "nome": "Douradina",
    "uf": "MS"
  },
  {
    "codigo": 5003702,
    "nome": "Dourados",
    "uf": "MS"
  },
  {
    "codigo": 5003751,
    "nome": "Eldorado",
    "uf": "MS"
  },
  {
    "codigo": 5003801,
    "nome": "Fátima do Sul",
    "uf": "MS"
  },
  {
    "codigo": 5003900,
    "nome": "Figueirão",
    "uf": "MS"
  },
  {
    "codigo": 5004007,
    "nome": "Glória de Dourados",
    "uf": "MS"
  },
  {
    "codigo": 5004106,
    "nome": "Guia Lopes da Laguna",
    "uf": "MS"
  },
  {
    "codigo": 5004304,
    "nome": "Iguatemi",
    "uf": "MS"
  },
  {
    "codigo": 5004403,
    "nome": "Inocência",
    "uf": "MS"
  },
  {
    "codigo": 5004502,
    "nome": "Itaporã",
    "uf": "MS"
  },
  {
    "codigo": 5004601,
    "nome": "Itaquiraí",
    "uf": "MS"
  },
  {
    "codigo": 5004700,
    "nome": "Ivinhema",
    "uf": "MS"
  },
  {
    "codigo": 5004809,
    "nome": "Japorã",
    "uf": "MS"
  },
  {
    "codigo": 5004908,
    "nome": "Jaraguari",
    "uf": "MS"
  },
  {
    "codigo": 5005004,
    "nome": "Jardim",
    "uf": "MS"
  },
  {
    "codigo": 5005103,
    "nome": "Jateí",
    "uf": "MS"
  },
  {
    "codigo": 5005152,
    "nome": "Juti",
    "uf": "MS"
  },
  {
    "codigo": 5005202,
    "nome": "Ladário",
    "uf": "MS"
  },
  {
    "codigo": 5005251,
    "nome": "Laguna Carapã",
    "uf": "MS"
  },
  {
    "codigo": 5005400,
    "nome": "Maracaju",
    "uf": "MS"
  },
  {
    "codigo": 5005608,
    "nome": "Miranda",
    "uf": "MS"
  },
  {
    "codigo": 5005681,
    "nome": "Mundo Novo",
    "uf": "MS"
  },
  {
    "codigo": 5005707,
    "nome": "Naviraí",
    "uf": "MS"
  },
  {
    "codigo": 5005806,
    "nome": "Nioaque",
    "uf": "MS"
  },
  {
    "codigo": 5006002,
    "nome": "Nova Alvorada do Sul",
    "uf": "MS"
  },
  {
    "codigo": 5006200,
    "nome": "Nova Andradina",
    "uf": "MS"
  },
  {
    "codigo": 5006259,
    "nome": "Novo Horizonte do Sul",
    "uf": "MS"
  },
  {
    "codigo": 5006275,
    "nome": "Paraíso das Águas",
    "uf": "MS"
  },
  {
    "codigo": 5006309,
    "nome": "Paranaíba",
    "uf": "MS"
  },
  {
    "codigo": 5006358,
    "nome": "Paranhos",
    "uf": "MS"
  },
  {
    "codigo": 5006408,
    "nome": "Pedro Gomes",
    "uf": "MS"
  },
  {
    "codigo": 5006606,
    "nome": "Ponta Porã",
    "uf": "MS"
  },
  {
    "codigo": 5006903,
    "nome": "Porto Murtinho",
    "uf": "MS"
  },
  {
    "codigo": 5007109,
    "nome": "Ribas do Rio Pardo",
    "uf": "MS"
  },
  {
    "codigo": 5007208,
    "nome": "Rio Brilhante",
    "uf": "MS"
  },
  {
    "codigo": 5007307,
    "nome": "Rio Negro",
    "uf": "MS"
  },
  {
    "codigo": 5007406,
    "nome": "Rio Verde de Mato Grosso",
    "uf": "MS"
  },
  {
    "codigo": 5007505,
    "nome": "Rochedo",
    "uf": "MS"
  },
  {
    "codigo": 5007554,
    "nome": "Santa Rita do Pardo",
    "uf": "MS"
  },
  {
    "codigo": 5007695,
    "nome": "São Gabriel do Oeste",
    "uf": "MS"
  },
  {
    "codigo": 5007703,
    "nome": "Sete Quedas",
    "uf": "MS"
  },
  {
    "codigo": 5007802,
    "nome": "Selvíria",
    "uf": "MS"
  },
  {
    "codigo": 5007901,
    "nome": "Sidrolândia",
    "uf": "MS"
  },
  {
    "codigo": 5007935,
    "nome": "Sonora",
    "uf": "MS"
  },
  {
    "codigo": 5007950,
    "nome": "Tacuru",
    "uf": "MS"
  },
  {
    "codigo": 5007976,
    "nome": "Taquarussu",
    "uf": "MS"
  },
  {
    "codigo": 5008008,
    "nome": "Terenos",
    "uf": "MS"
  },
  {
    "codigo": 5008305,
    "nome": "Três Lagoas",
    "uf": "MS"
  },
  {
    "codigo": 5008404,
    "nome": "Vicentina",
    "uf": "MS"
  },
  {
    "codigo": 5100102,
    "nome": "Acorizal",
    "uf": "MT"
  },
  {
    "codigo": 5100201,
    "nome": "Água Boa",
    "uf": "MT"
  },
  {
    "codigo": 5100250,
    "nome": "Alta Floresta",
    "uf": "MT"
  },
  {
    "codigo": 5100300,
    "nome": "Alto Araguaia",
    "uf": "MT"
  },
  {
    "codigo": 5100359,
    "nome": "Alto Boa Vista",
    "uf": "MT"
  },
  {
    "codigo": 5100409,
    "nome": "Alto Garças",
    "uf": "MT"
  },
  {
    "codigo": 5100508,
    "nome": "Alto Paraguai",
    "uf": "MT"
  },
  {
    "codigo": 5100607,
    "nome": "Alto Taquari",
    "uf": "MT"
  },
  {
    "codigo": 5100805,
    "nome": "Apiacás",
    "uf": "MT"
  },
  {
    "codigo": 5101001,
    "nome": "Araguaiana",
    "uf": "MT"
  },
  {
    "codigo": 5101209,
    "nome": "Araguainha",
    "uf": "MT"
  },
  {
    "codigo": 5101258,
    "nome": "Araputanga",
    "uf": "MT"
  },
  {
    "codigo": 5101308,
    "nome": "Arenápolis",
    "uf": "MT"
  },
  {
    "codigo": 5101407,
    "nome": "Aripuanã",
    "uf": "MT"
  },
  {
    "codigo": 5101605,
    "nome": "Barão de Melgaço",
    "uf": "MT"
  },
  {
    "codigo": 5101704,
    "nome": "Barra do Bugres",
    "uf": "MT"
  },
  {
    "codigo": 5101803,
    "nome": "Barra do Garças",
    "uf": "MT"
  },
  {
    "codigo": 5101837,
    "nome": "Boa Esperança do Norte",
    "uf": "MT"
  },
  {
    "codigo": 5101852,
    "nome": "Bom Jesus do Araguaia",
    "uf": "MT"
  },
  {
    "codigo": 5101902,
    "nome": "Brasnorte",
    "uf": "MT"
  },
  {
    "codigo": 5102504,
    "nome": "Cáceres",
    "uf": "MT"
  },
  {
    "codigo": 5102603,
    "nome": "Campinápolis",
    "uf": "MT"
  },
  {
    "codigo": 5102637,
    "nome": "Campo Novo do Parecis",
    "uf": "MT"
  },
  {
    "codigo": 5102678,
    "nome": "Campo Verde",
    "uf": "MT"
  },
  {
    "codigo": 5102686,
    "nome": "Campos de Júlio",
    "uf": "MT"
  },
  {
    "codigo": 5102694,
    "nome": "Canabrava do Norte",
    "uf": "MT"
  },
  {
    "codigo": 5102702,
    "nome": "Canarana",
    "uf": "MT"
  },
  {
    "codigo": 5102793,
    "nome": "Carlinda",
    "uf": "MT"
  },
  {
    "codigo": 5102850,
    "nome": "Castanheira",
    "uf": "MT"
  },
  {
    "codigo": 5103007,
    "nome": "Chapada dos Guimarães",
    "uf": "MT"
  },
  {
    "codigo": 5103056,
    "nome": "Cláudia",
    "uf": "MT"
  },
  {
    "codigo": 5103106,
    "nome": "Cocalinho",
    "uf": "MT"
  },
  {
    "codigo": 5103205,
    "nome": "Colíder",
    "uf": "MT"
  },
  {
    "codigo": 5103254,
    "nome": "Colniza",
    "uf": "MT"
  },
  {
    "codigo": 5103304,
    "nome": "Comodoro",
    "uf": "MT"
  },
  {
    "codigo": 5103353,
    "nome": "Confresa",
    "uf": "MT"
  },
  {
    "codigo": 5103361,
    "nome": "Conquista D'Oeste",
    "uf": "MT"
  },
  {
    "codigo": 5103379,
    "nome": "Cotriguaçu",
    "uf": "MT"
  },
  {
    "codigo": 5103403,
    "nome": "Cuiabá",
    "uf": "MT"
  },
  {
    "codigo": 5103437,
    "nome": "Curvelândia",
    "uf": "MT"
  },
  {
    "codigo": 5103452,
    "nome": "Denise",
    "uf": "MT"
  },
  {
    "codigo": 5103502,
    "nome": "Diamantino",
    "uf": "MT"
  },
  {
    "codigo": 5103601,
    "nome": "Dom Aquino",
    "uf": "MT"
  },
  {
    "codigo": 5103700,
    "nome": "Feliz Natal",
    "uf": "MT"
  },
  {
    "codigo": 5103809,
    "nome": "Figueirópolis D'Oeste",
    "uf": "MT"
  },
  {
    "codigo": 5103858,
    "nome": "Gaúcha do Norte",
    "uf": "MT"
  },
  {
    "codigo": 5103908,
    "nome": "General Carneiro",
    "uf": "MT"
  },
  {
    "codigo": 5103957,
    "nome": "Glória D'Oeste",
    "uf": "MT"
  },
  {
    "codigo": 5104104,
    "nome": "Guarantã do Norte",
    "uf": "MT"
  },
  {
    "codigo": 5104203,
    "nome": "Guiratinga",
    "uf": "MT"
  },
  {
    "codigo": 5104500,
    "nome": "Indiavaí",
    "uf": "MT"
  },
  {
    "codigo": 5104526,
    "nome": "Ipiranga do Norte",
    "uf": "MT"
  },
  {
    "codigo": 5104542,
    "nome": "Itanhangá",
    "uf": "MT"
  },
  {
    "codigo": 5104559,
    "nome": "Itaúba",
    "uf": "MT"
  },
  {
    "codigo": 5104609,
    "nome": "Itiquira",
    "uf": "MT"
  },
  {
    "codigo": 5104807,
    "nome": "Jaciara",
    "uf": "MT"
  },
  {
    "codigo": 5104906,
    "nome": "Jangada",
    "uf": "MT"
  },
  {
    "codigo": 5105002,
    "nome": "Jauru",
    "uf": "MT"
  },
  {
    "codigo": 5105101,
    "nome": "Juara",
    "uf": "MT"
  },
  {
    "codigo": 5105150,
    "nome": "Juína",
    "uf": "MT"
  },
  {
    "codigo": 5105176,
    "nome": "Juruena",
    "uf": "MT"
  },
  {
    "codigo": 5105200,
    "nome": "Juscimeira",
    "uf": "MT"
  },
  {
    "codigo": 5105234,
    "nome": "Lambari D'Oeste",
    "uf": "MT"
  },
  {
    "codigo": 5105259,
    "nome": "Lucas do Rio Verde",
    "uf": "MT"
  },
  {
    "codigo": 5105309,
    "nome": "Luciara",
    "uf": "MT"
  },
  {
    "codigo": 5105507,
    "nome": "Vila Bela da Santíssima Trindade",
    "uf": "MT"
  },
  {
    "codigo": 5105580,
    "nome": "Marcelândia",
    "uf": "MT"
  },
  {
    "codigo": 5105606,
    "nome": "Matupá",
    "uf": "MT"
  },
  {
    "codigo": 5105622,
    "nome": "Mirassol d'Oeste",
    "uf": "MT"
  },
  {
    "codigo": 5105903,
    "nome": "Nobres",
    "uf": "MT"
  },
  {
    "codigo": 5106000,
    "nome": "Nortelândia",
    "uf": "MT"
  },
  {
    "codigo": 5106109,
    "nome": "Nossa Senhora do Livramento",
    "uf": "MT"
  },
  {
    "codigo": 5106158,
    "nome": "Nova Bandeirantes",
    "uf": "MT"
  },
  {
    "codigo": 5106174,
    "nome": "Nova Nazaré",
    "uf": "MT"
  },
  {
    "codigo": 5106182,
    "nome": "Nova Lacerda",
    "uf": "MT"
  },
  {
    "codigo": 5106190,
    "nome": "Nova Santa Helena",
    "uf": "MT"
  },
  {
    "codigo": 5106208,
    "nome": "Nova Brasilândia",
    "uf": "MT"
  },
  {
    "codigo": 5106216,
    "nome": "Nova Canaã do Norte",
    "uf": "MT"
  },
  {
    "codigo": 5106224,
    "nome": "Nova Mutum",
    "uf": "MT"
  },
  {
    "codigo": 5106232,
    "nome": "Nova Olímpia",
    "uf": "MT"
  },
  {
    "codigo": 5106240,
    "nome": "Nova Ubiratã",
    "uf": "MT"
  },
  {
    "codigo": 5106257,
    "nome": "Nova Xavantina",
    "uf": "MT"
  },
  {
    "codigo": 5106265,
    "nome": "Novo Mundo",
    "uf": "MT"
  },
  {
    "codigo": 5106273,
    "nome": "Novo Horizonte do Norte",
    "uf": "MT"
  },
  {
    "codigo": 5106281,
    "nome": "Novo São Joaquim",
    "uf": "MT"
  },
  {
    "codigo": 5106299,
    "nome": "Paranaíta",
    "uf": "MT"
  },
  {
    "codigo": 5106307,
    "nome": "Paranatinga",
    "uf": "MT"
  },
  {
    "codigo": 5106315,
    "nome": "Novo Santo Antônio",
    "uf": "MT"
  },
  {
    "codigo": 5106372,
    "nome": "Pedra Preta",
    "uf": "MT"
  },
  {
    "codigo": 5106422,
    "nome": "Peixoto de Azevedo",
    "uf": "MT"
  },
  {
    "codigo": 5106455,
    "nome": "Planalto da Serra",
    "uf": "MT"
  },
  {
    "codigo": 5106505,
    "nome": "Poconé",
    "uf": "MT"
  },
  {
    "codigo": 5106653,
    "nome": "Pontal do Araguaia",
    "uf": "MT"
  },
  {
    "codigo": 5106703,
    "nome": "Ponte Branca",
    "uf": "MT"
  },
  {
    "codigo": 5106752,
    "nome": "Pontes e Lacerda",
    "uf": "MT"
  },
  {
    "codigo": 5106778,
    "nome": "Porto Alegre do Norte",
    "uf": "MT"
  },
  {
    "codigo": 5106802,
    "nome": "Porto dos Gaúchos",
    "uf": "MT"
  },
  {
    "codigo": 5106828,
    "nome": "Porto Esperidião",
    "uf": "MT"
  },
  {
    "codigo": 5106851,
    "nome": "Porto Estrela",
    "uf": "MT"
  },
  {
    "codigo": 5107008,
    "nome": "Poxoréu",
    "uf": "MT"
  },
  {
    "codigo": 5107040,
    "nome": "Primavera do Leste",
    "uf": "MT"
  },
  {
    "codigo": 5107065,
    "nome": "Querência",
    "uf": "MT"
  },
  {
    "codigo": 5107107,
    "nome": "São José dos Quatro Marcos",
    "uf": "MT"
  },
  {
    "codigo": 5107156,
    "nome": "Reserva do Cabaçal",
    "uf": "MT"
  },
  {
    "codigo": 5107180,
    "nome": "Ribeirão Cascalheira",
    "uf": "MT"
  },
  {
    "codigo": 5107198,
    "nome": "Ribeirãozinho",
    "uf": "MT"
  },
  {
    "codigo": 5107206,
    "nome": "Rio Branco",
    "uf": "MT"
  },
  {
    "codigo": 5107248,
    "nome": "Santa Carmem",
    "uf": "MT"
  },
  {
    "codigo": 5107263,
    "nome": "Santo Afonso",
    "uf": "MT"
  },
  {
    "codigo": 5107297,
    "nome": "São José do Povo",
    "uf": "MT"
  },
  {
    "codigo": 5107305,
    "nome": "São José do Rio Claro",
    "uf": "MT"
  },
  {
    "codigo": 5107354,
    "nome": "São José do Xingu",
    "uf": "MT"
  },
  {
    "codigo": 5107404,
    "nome": "São Pedro da Cipa",
    "uf": "MT"
  },
  {
    "codigo": 5107578,
    "nome": "Rondolândia",
    "uf": "MT"
  },
  {
    "codigo": 5107602,
    "nome": "Rondonópolis",
    "uf": "MT"
  },
  {
    "codigo": 5107701,
    "nome": "Rosário Oeste",
    "uf": "MT"
  },
  {
    "codigo": 5107743,
    "nome": "Santa Cruz do Xingu",
    "uf": "MT"
  },
  {
    "codigo": 5107750,
    "nome": "Salto do Céu",
    "uf": "MT"
  },
  {
    "codigo": 5107768,
    "nome": "Santa Rita do Trivelato",
    "uf": "MT"
  },
  {
    "codigo": 5107776,
    "nome": "Santa Terezinha",
    "uf": "MT"
  },
  {
    "codigo": 5107792,
    "nome": "Santo Antônio do Leste",
    "uf": "MT"
  },
  {
    "codigo": 5107800,
    "nome": "Santo Antônio de Leverger",
    "uf": "MT"
  },
  {
    "codigo": 5107859,
    "nome": "São Félix do Araguaia",
    "uf": "MT"
  },
  {
    "codigo": 5107875,
    "nome": "Sapezal",
    "uf": "MT"
  },
  {
    "codigo": 5107883,
    "nome": "Serra Nova Dourada",
    "uf": "MT"
  },
  {
    "codigo": 5107909,
    "nome": "Sinop",
    "uf": "MT"
  },
  {
    "codigo": 5107925,
    "nome": "Sorriso",
    "uf": "MT"
  },
  {
    "codigo": 5107941,
    "nome": "Tabaporã",
    "uf": "MT"
  },
  {
    "codigo": 5107958,
    "nome": "Tangará da Serra",
    "uf": "MT"
  },
  {
    "codigo": 5108006,
    "nome": "Tapurah",
    "uf": "MT"
  },
  {
    "codigo": 5108055,
    "nome": "Terra Nova do Norte",
    "uf": "MT"
  },
  {
    "codigo": 5108105,
    "nome": "Tesouro",
    "uf": "MT"
  },
  {
    "codigo": 5108204,
    "nome": "Torixoréu",
    "uf": "MT"
  },
  {
    "codigo": 5108303,
    "nome": "União do Sul",
    "uf": "MT"
  },
  {
    "codigo": 5108352,
    "nome": "Vale de São Domingos",
    "uf": "MT"
  },
  {
    "codigo": 5108402,
    "nome": "Várzea Grande",
    "uf": "MT"
  },
  {
    "codigo": 5108501,
    "nome": "Vera",
    "uf": "MT"
  },
  {
    "codigo": 5108600,
    "nome": "Vila Rica",
    "uf": "MT"
  },
  {
    "codigo": 5108808,
    "nome": "Nova Guarita",
    "uf": "MT"
  },
  {
    "codigo": 5108857,
    "nome": "Nova Marilândia",
    "uf": "MT"
  },
  {
    "codigo": 5108907,
    "nome": "Nova Maringá",
    "uf": "MT"
  },
  {
    "codigo": 5108956,
    "nome": "Nova Monte Verde",
    "uf": "MT"
  },
  {
    "codigo": 5200050,
    "nome": "Abadia de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5200100,
    "nome": "Abadiânia",
    "uf": "GO"
  },
  {
    "codigo": 5200134,
    "nome": "Acreúna",
    "uf": "GO"
  },
  {
    "codigo": 5200159,
    "nome": "Adelândia",
    "uf": "GO"
  },
  {
    "codigo": 5200175,
    "nome": "Água Fria de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5200209,
    "nome": "Água Limpa",
    "uf": "GO"
  },
  {
    "codigo": 5200258,
    "nome": "Águas Lindas de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5200308,
    "nome": "Alexânia",
    "uf": "GO"
  },
  {
    "codigo": 5200506,
    "nome": "Aloândia",
    "uf": "GO"
  },
  {
    "codigo": 5200555,
    "nome": "Alto Horizonte",
    "uf": "GO"
  },
  {
    "codigo": 5200605,
    "nome": "Alto Paraíso de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5200803,
    "nome": "Alvorada do Norte",
    "uf": "GO"
  },
  {
    "codigo": 5200829,
    "nome": "Amaralina",
    "uf": "GO"
  },
  {
    "codigo": 5200852,
    "nome": "Americano do Brasil",
    "uf": "GO"
  },
  {
    "codigo": 5200902,
    "nome": "Amorinópolis",
    "uf": "GO"
  },
  {
    "codigo": 5201108,
    "nome": "Anápolis",
    "uf": "GO"
  },
  {
    "codigo": 5201207,
    "nome": "Anhanguera",
    "uf": "GO"
  },
  {
    "codigo": 5201306,
    "nome": "Anicuns",
    "uf": "GO"
  },
  {
    "codigo": 5201405,
    "nome": "Aparecida de Goiânia",
    "uf": "GO"
  },
  {
    "codigo": 5201454,
    "nome": "Aparecida do Rio Doce",
    "uf": "GO"
  },
  {
    "codigo": 5201504,
    "nome": "Aporé",
    "uf": "GO"
  },
  {
    "codigo": 5201603,
    "nome": "Araçu",
    "uf": "GO"
  },
  {
    "codigo": 5201702,
    "nome": "Aragarças",
    "uf": "GO"
  },
  {
    "codigo": 5201801,
    "nome": "Aragoiânia",
    "uf": "GO"
  },
  {
    "codigo": 5202155,
    "nome": "Araguapaz",
    "uf": "GO"
  },
  {
    "codigo": 5202353,
    "nome": "Arenópolis",
    "uf": "GO"
  },
  {
    "codigo": 5202502,
    "nome": "Aruanã",
    "uf": "GO"
  },
  {
    "codigo": 5202601,
    "nome": "Aurilândia",
    "uf": "GO"
  },
  {
    "codigo": 5202809,
    "nome": "Avelinópolis",
    "uf": "GO"
  },
  {
    "codigo": 5203104,
    "nome": "Baliza",
    "uf": "GO"
  },
  {
    "codigo": 5203203,
    "nome": "Barro Alto",
    "uf": "GO"
  },
  {
    "codigo": 5203302,
    "nome": "Bela Vista de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5203401,
    "nome": "Bom Jardim de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5203500,
    "nome": "Bom Jesus de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5203559,
    "nome": "Bonfinópolis",
    "uf": "GO"
  },
  {
    "codigo": 5203575,
    "nome": "Bonópolis",
    "uf": "GO"
  },
  {
    "codigo": 5203609,
    "nome": "Brazabrantes",
    "uf": "GO"
  },
  {
    "codigo": 5203807,
    "nome": "Britânia",
    "uf": "GO"
  },
  {
    "codigo": 5203906,
    "nome": "Buriti Alegre",
    "uf": "GO"
  },
  {
    "codigo": 5203939,
    "nome": "Buriti de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5203962,
    "nome": "Buritinópolis",
    "uf": "GO"
  },
  {
    "codigo": 5204003,
    "nome": "Cabeceiras",
    "uf": "GO"
  },
  {
    "codigo": 5204102,
    "nome": "Cachoeira Alta",
    "uf": "GO"
  },
  {
    "codigo": 5204201,
    "nome": "Cachoeira de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5204250,
    "nome": "Cachoeira Dourada",
    "uf": "GO"
  },
  {
    "codigo": 5204300,
    "nome": "Caçu",
    "uf": "GO"
  },
  {
    "codigo": 5204409,
    "nome": "Caiapônia",
    "uf": "GO"
  },
  {
    "codigo": 5204508,
    "nome": "Caldas Novas",
    "uf": "GO"
  },
  {
    "codigo": 5204557,
    "nome": "Caldazinha",
    "uf": "GO"
  },
  {
    "codigo": 5204607,
    "nome": "Campestre de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5204656,
    "nome": "Campinaçu",
    "uf": "GO"
  },
  {
    "codigo": 5204706,
    "nome": "Campinorte",
    "uf": "GO"
  },
  {
    "codigo": 5204805,
    "nome": "Campo Alegre de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5204854,
    "nome": "Campo Limpo de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5204904,
    "nome": "Campos Belos",
    "uf": "GO"
  },
  {
    "codigo": 5204953,
    "nome": "Campos Verdes",
    "uf": "GO"
  },
  {
    "codigo": 5205000,
    "nome": "Carmo do Rio Verde",
    "uf": "GO"
  },
  {
    "codigo": 5205059,
    "nome": "Castelândia",
    "uf": "GO"
  },
  {
    "codigo": 5205109,
    "nome": "Catalão",
    "uf": "GO"
  },
  {
    "codigo": 5205208,
    "nome": "Caturaí",
    "uf": "GO"
  },
  {
    "codigo": 5205307,
    "nome": "Cavalcante",
    "uf": "GO"
  },
  {
    "codigo": 5205406,
    "nome": "Ceres",
    "uf": "GO"
  },
  {
    "codigo": 5205455,
    "nome": "Cezarina",
    "uf": "GO"
  },
  {
    "codigo": 5205471,
    "nome": "Chapadão do Céu",
    "uf": "GO"
  },
  {
    "codigo": 5205497,
    "nome": "Cidade Ocidental",
    "uf": "GO"
  },
  {
    "codigo": 5205513,
    "nome": "Cocalzinho de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5205521,
    "nome": "Colinas do Sul",
    "uf": "GO"
  },
  {
    "codigo": 5205703,
    "nome": "Córrego do Ouro",
    "uf": "GO"
  },
  {
    "codigo": 5205802,
    "nome": "Corumbá de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5205901,
    "nome": "Corumbaíba",
    "uf": "GO"
  },
  {
    "codigo": 5206206,
    "nome": "Cristalina",
    "uf": "GO"
  },
  {
    "codigo": 5206305,
    "nome": "Cristianópolis",
    "uf": "GO"
  },
  {
    "codigo": 5206404,
    "nome": "Crixás",
    "uf": "GO"
  },
  {
    "codigo": 5206503,
    "nome": "Cromínia",
    "uf": "GO"
  },
  {
    "codigo": 5206602,
    "nome": "Cumari",
    "uf": "GO"
  },
  {
    "codigo": 5206701,
    "nome": "Damianópolis",
    "uf": "GO"
  },
  {
    "codigo": 5206800,
    "nome": "Damolândia",
    "uf": "GO"
  },
  {
    "codigo": 5206909,
    "nome": "Davinópolis",
    "uf": "GO"
  },
  {
    "codigo": 5207105,
    "nome": "Diorama",
    "uf": "GO"
  },
  {
    "codigo": 5207253,
    "nome": "Doverlândia",
    "uf": "GO"
  },
  {
    "codigo": 5207352,
    "nome": "Edealina",
    "uf": "GO"
  },
  {
    "codigo": 5207402,
    "nome": "Edéia",
    "uf": "GO"
  },
  {
    "codigo": 5207501,
    "nome": "Estrela do Norte",
    "uf": "GO"
  },
  {
    "codigo": 5207535,
    "nome": "Faina",
    "uf": "GO"
  },
  {
    "codigo": 5207600,
    "nome": "Fazenda Nova",
    "uf": "GO"
  },
  {
    "codigo": 5207808,
    "nome": "Firminópolis",
    "uf": "GO"
  },
  {
    "codigo": 5207907,
    "nome": "Flores de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5208004,
    "nome": "Formosa",
    "uf": "GO"
  },
  {
    "codigo": 5208103,
    "nome": "Formoso",
    "uf": "GO"
  },
  {
    "codigo": 5208152,
    "nome": "Gameleira de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5208301,
    "nome": "Divinópolis de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5208400,
    "nome": "Goianápolis",
    "uf": "GO"
  },
  {
    "codigo": 5208509,
    "nome": "Goiandira",
    "uf": "GO"
  },
  {
    "codigo": 5208608,
    "nome": "Goianésia",
    "uf": "GO"
  },
  {
    "codigo": 5208707,
    "nome": "Goiânia",
    "uf": "GO"
  },
  {
    "codigo": 5208806,
    "nome": "Goianira",
    "uf": "GO"
  },
  {
    "codigo": 5208905,
    "nome": "Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5209101,
    "nome": "Goiatuba",
    "uf": "GO"
  },
  {
    "codigo": 5209150,
    "nome": "Gouvelândia",
    "uf": "GO"
  },
  {
    "codigo": 5209200,
    "nome": "Guapó",
    "uf": "GO"
  },
  {
    "codigo": 5209291,
    "nome": "Guaraíta",
    "uf": "GO"
  },
  {
    "codigo": 5209408,
    "nome": "Guarani de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5209457,
    "nome": "Guarinos",
    "uf": "GO"
  },
  {
    "codigo": 5209606,
    "nome": "Heitoraí",
    "uf": "GO"
  },
  {
    "codigo": 5209705,
    "nome": "Hidrolândia",
    "uf": "GO"
  },
  {
    "codigo": 5209804,
    "nome": "Hidrolina",
    "uf": "GO"
  },
  {
    "codigo": 5209903,
    "nome": "Iaciara",
    "uf": "GO"
  },
  {
    "codigo": 5209937,
    "nome": "Inaciolândia",
    "uf": "GO"
  },
  {
    "codigo": 5209952,
    "nome": "Indiara",
    "uf": "GO"
  },
  {
    "codigo": 5210000,
    "nome": "Inhumas",
    "uf": "GO"
  },
  {
    "codigo": 5210109,
    "nome": "Ipameri",
    "uf": "GO"
  },
  {
    "codigo": 5210158,
    "nome": "Ipiranga de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5210208,
    "nome": "Iporá",
    "uf": "GO"
  },
  {
    "codigo": 5210307,
    "nome": "Israelândia",
    "uf": "GO"
  },
  {
    "codigo": 5210406,
    "nome": "Itaberaí",
    "uf": "GO"
  },
  {
    "codigo": 5210562,
    "nome": "Itaguari",
    "uf": "GO"
  },
  {
    "codigo": 5210604,
    "nome": "Itaguaru",
    "uf": "GO"
  },
  {
    "codigo": 5210802,
    "nome": "Itajá",
    "uf": "GO"
  },
  {
    "codigo": 5210901,
    "nome": "Itapaci",
    "uf": "GO"
  },
  {
    "codigo": 5211008,
    "nome": "Itapirapuã",
    "uf": "GO"
  },
  {
    "codigo": 5211206,
    "nome": "Itapuranga",
    "uf": "GO"
  },
  {
    "codigo": 5211305,
    "nome": "Itarumã",
    "uf": "GO"
  },
  {
    "codigo": 5211404,
    "nome": "Itauçu",
    "uf": "GO"
  },
  {
    "codigo": 5211503,
    "nome": "Itumbiara",
    "uf": "GO"
  },
  {
    "codigo": 5211602,
    "nome": "Ivolândia",
    "uf": "GO"
  },
  {
    "codigo": 5211701,
    "nome": "Jandaia",
    "uf": "GO"
  },
  {
    "codigo": 5211800,
    "nome": "Jaraguá",
    "uf": "GO"
  },
  {
    "codigo": 5211909,
    "nome": "Jataí",
    "uf": "GO"
  },
  {
    "codigo": 5212006,
    "nome": "Jaupaci",
    "uf": "GO"
  },
  {
    "codigo": 5212055,
    "nome": "Jesúpolis",
    "uf": "GO"
  },
  {
    "codigo": 5212105,
    "nome": "Joviânia",
    "uf": "GO"
  },
  {
    "codigo": 5212204,
    "nome": "Jussara",
    "uf": "GO"
  },
  {
    "codigo": 5212253,
    "nome": "Lagoa Santa",
    "uf": "GO"
  },
  {
    "codigo": 5212303,
    "nome": "Leopoldo de Bulhões",
    "uf": "GO"
  },
  {
    "codigo": 5212501,
    "nome": "Luziânia",
    "uf": "GO"
  },
  {
    "codigo": 5212600,
    "nome": "Mairipotaba",
    "uf": "GO"
  },
  {
    "codigo": 5212709,
    "nome": "Mambaí",
    "uf": "GO"
  },
  {
    "codigo": 5212808,
    "nome": "Mara Rosa",
    "uf": "GO"
  },
  {
    "codigo": 5212907,
    "nome": "Marzagão",
    "uf": "GO"
  },
  {
    "codigo": 5212956,
    "nome": "Matrinchã",
    "uf": "GO"
  },
  {
    "codigo": 5213004,
    "nome": "Maurilândia",
    "uf": "GO"
  },
  {
    "codigo": 5213053,
    "nome": "Mimoso de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5213087,
    "nome": "Minaçu",
    "uf": "GO"
  },
  {
    "codigo": 5213103,
    "nome": "Mineiros",
    "uf": "GO"
  },
  {
    "codigo": 5213400,
    "nome": "Moiporá",
    "uf": "GO"
  },
  {
    "codigo": 5213509,
    "nome": "Monte Alegre de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5213707,
    "nome": "Montes Claros de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5213756,
    "nome": "Montividiu",
    "uf": "GO"
  },
  {
    "codigo": 5213772,
    "nome": "Montividiu do Norte",
    "uf": "GO"
  },
  {
    "codigo": 5213806,
    "nome": "Morrinhos",
    "uf": "GO"
  },
  {
    "codigo": 5213855,
    "nome": "Morro Agudo de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5213905,
    "nome": "Mossâmedes",
    "uf": "GO"
  },
  {
    "codigo": 5214002,
    "nome": "Mozarlândia",
    "uf": "GO"
  },
  {
    "codigo": 5214051,
    "nome": "Mundo Novo",
    "uf": "GO"
  },
  {
    "codigo": 5214101,
    "nome": "Mutunópolis",
    "uf": "GO"
  },
  {
    "codigo": 5214408,
    "nome": "Nazário",
    "uf": "GO"
  },
  {
    "codigo": 5214507,
    "nome": "Nerópolis",
    "uf": "GO"
  },
  {
    "codigo": 5214606,
    "nome": "Niquelândia",
    "uf": "GO"
  },
  {
    "codigo": 5214705,
    "nome": "Nova América",
    "uf": "GO"
  },
  {
    "codigo": 5214804,
    "nome": "Nova Aurora",
    "uf": "GO"
  },
  {
    "codigo": 5214838,
    "nome": "Nova Crixás",
    "uf": "GO"
  },
  {
    "codigo": 5214861,
    "nome": "Nova Glória",
    "uf": "GO"
  },
  {
    "codigo": 5214879,
    "nome": "Nova Iguaçu de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5214903,
    "nome": "Nova Roma",
    "uf": "GO"
  },
  {
    "codigo": 5215009,
    "nome": "Nova Veneza",
    "uf": "GO"
  },
  {
    "codigo": 5215207,
    "nome": "Novo Brasil",
    "uf": "GO"
  },
  {
    "codigo": 5215231,
    "nome": "Novo Gama",
    "uf": "GO"
  },
  {
    "codigo": 5215256,
    "nome": "Novo Planalto",
    "uf": "GO"
  },
  {
    "codigo": 5215306,
    "nome": "Orizona",
    "uf": "GO"
  },
  {
    "codigo": 5215405,
    "nome": "Ouro Verde de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5215504,
    "nome": "Ouvidor",
    "uf": "GO"
  },
  {
    "codigo": 5215603,
    "nome": "Padre Bernardo",
    "uf": "GO"
  },
  {
    "codigo": 5215652,
    "nome": "Palestina de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5215702,
    "nome": "Palmeiras de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5215801,
    "nome": "Palmelo",
    "uf": "GO"
  },
  {
    "codigo": 5215900,
    "nome": "Palminópolis",
    "uf": "GO"
  },
  {
    "codigo": 5216007,
    "nome": "Panamá",
    "uf": "GO"
  },
  {
    "codigo": 5216304,
    "nome": "Paranaiguara",
    "uf": "GO"
  },
  {
    "codigo": 5216403,
    "nome": "Paraúna",
    "uf": "GO"
  },
  {
    "codigo": 5216452,
    "nome": "Perolândia",
    "uf": "GO"
  },
  {
    "codigo": 5216809,
    "nome": "Petrolina de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5216908,
    "nome": "Pilar de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5217104,
    "nome": "Piracanjuba",
    "uf": "GO"
  },
  {
    "codigo": 5217203,
    "nome": "Piranhas",
    "uf": "GO"
  },
  {
    "codigo": 5217302,
    "nome": "Pirenópolis",
    "uf": "GO"
  },
  {
    "codigo": 5217401,
    "nome": "Pires do Rio",
    "uf": "GO"
  },
  {
    "codigo": 5217609,
    "nome": "Planaltina",
    "uf": "GO"
  },
  {
    "codigo": 5217708,
    "nome": "Pontalina",
    "uf": "GO"
  },
  {
    "codigo": 5218003,
    "nome": "Porangatu",
    "uf": "GO"
  },
  {
    "codigo": 5218052,
    "nome": "Porteirão",
    "uf": "GO"
  },
  {
    "codigo": 5218102,
    "nome": "Portelândia",
    "uf": "GO"
  },
  {
    "codigo": 5218300,
    "nome": "Posse",
    "uf": "GO"
  },
  {
    "codigo": 5218391,
    "nome": "Professor Jamil",
    "uf": "GO"
  },
  {
    "codigo": 5218508,
    "nome": "Quirinópolis",
    "uf": "GO"
  },
  {
    "codigo": 5218607,
    "nome": "Rialma",
    "uf": "GO"
  },
  {
    "codigo": 5218706,
    "nome": "Rianápolis",
    "uf": "GO"
  },
  {
    "codigo": 5218789,
    "nome": "Rio Quente",
    "uf": "GO"
  },
  {
    "codigo": 5218805,
    "nome": "Rio Verde",
    "uf": "GO"
  },
  {
    "codigo": 5218904,
    "nome": "Rubiataba",
    "uf": "GO"
  },
  {
    "codigo": 5219001,
    "nome": "Sanclerlândia",
    "uf": "GO"
  },
  {
    "codigo": 5219100,
    "nome": "Santa Bárbara de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5219209,
    "nome": "Santa Cruz de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5219258,
    "nome": "Santa Fé de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5219308,
    "nome": "Santa Helena de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5219357,
    "nome": "Santa Isabel",
    "uf": "GO"
  },
  {
    "codigo": 5219407,
    "nome": "Santa Rita do Araguaia",
    "uf": "GO"
  },
  {
    "codigo": 5219456,
    "nome": "Santa Rita do Novo Destino",
    "uf": "GO"
  },
  {
    "codigo": 5219506,
    "nome": "Santa Rosa de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5219605,
    "nome": "Santa Tereza de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5219704,
    "nome": "Santa Terezinha de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5219712,
    "nome": "Santo Antônio da Barra",
    "uf": "GO"
  },
  {
    "codigo": 5219738,
    "nome": "Santo Antônio de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5219753,
    "nome": "Santo Antônio do Descoberto",
    "uf": "GO"
  },
  {
    "codigo": 5219803,
    "nome": "São Domingos",
    "uf": "GO"
  },
  {
    "codigo": 5219902,
    "nome": "São Francisco de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5220009,
    "nome": "São João d'Aliança",
    "uf": "GO"
  },
  {
    "codigo": 5220058,
    "nome": "São João da Paraúna",
    "uf": "GO"
  },
  {
    "codigo": 5220108,
    "nome": "São Luís de Montes Belos",
    "uf": "GO"
  },
  {
    "codigo": 5220157,
    "nome": "São Luiz do Norte",
    "uf": "GO"
  },
  {
    "codigo": 5220207,
    "nome": "São Miguel do Araguaia",
    "uf": "GO"
  },
  {
    "codigo": 5220264,
    "nome": "São Miguel do Passa Quatro",
    "uf": "GO"
  },
  {
    "codigo": 5220280,
    "nome": "São Patrício",
    "uf": "GO"
  },
  {
    "codigo": 5220405,
    "nome": "São Simão",
    "uf": "GO"
  },
  {
    "codigo": 5220454,
    "nome": "Senador Canedo",
    "uf": "GO"
  },
  {
    "codigo": 5220504,
    "nome": "Serranópolis",
    "uf": "GO"
  },
  {
    "codigo": 5220603,
    "nome": "Silvânia",
    "uf": "GO"
  },
  {
    "codigo": 5220686,
    "nome": "Simolândia",
    "uf": "GO"
  },
  {
    "codigo": 5220702,
    "nome": "Sítio d'Abadia",
    "uf": "GO"
  },
  {
    "codigo": 5221007,
    "nome": "Taquaral de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5221080,
    "nome": "Teresina de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5221197,
    "nome": "Terezópolis de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5221304,
    "nome": "Três Ranchos",
    "uf": "GO"
  },
  {
    "codigo": 5221403,
    "nome": "Trindade",
    "uf": "GO"
  },
  {
    "codigo": 5221452,
    "nome": "Trombas",
    "uf": "GO"
  },
  {
    "codigo": 5221502,
    "nome": "Turvânia",
    "uf": "GO"
  },
  {
    "codigo": 5221551,
    "nome": "Turvelândia",
    "uf": "GO"
  },
  {
    "codigo": 5221577,
    "nome": "Uirapuru",
    "uf": "GO"
  },
  {
    "codigo": 5221601,
    "nome": "Uruaçu",
    "uf": "GO"
  },
  {
    "codigo": 5221700,
    "nome": "Uruana",
    "uf": "GO"
  },
  {
    "codigo": 5221809,
    "nome": "Urutaí",
    "uf": "GO"
  },
  {
    "codigo": 5221858,
    "nome": "Valparaíso de Goiás",
    "uf": "GO"
  },
  {
    "codigo": 5221908,
    "nome": "Varjão",
    "uf": "GO"
  },
  {
    "codigo": 5222005,
    "nome": "Vianópolis",
    "uf": "GO"
  },
  {
    "codigo": 5222054,
    "nome": "Vicentinópolis",
    "uf": "GO"
  },
  {
    "codigo": 5222203,
    "nome": "Vila Boa",
    "uf": "GO"
  },
  {
    "codigo": 5222302,
    "nome": "Vila Propício",
    "uf": "GO"
  },
  {
    "codigo": 5300108,
    "nome": "Brasília",
    "uf": "DF"
  }
]
